// Copyright 2011 Google Inc. All Rights Reserved.
(function () {
    var l,
        aa = function (a) {
            var b = 0;
            return function () {
                return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
            };
        },
        ba =
            typeof Object.defineProperties == "function"
                ? Object.defineProperty
                : function (a, b, c) {
                      if (a == Array.prototype || a == Object.prototype) return a;
                      a[b] = c.value;
                      return a;
                  },
        da = function (a) {
            a = ["object" == typeof globalThis && globalThis, a, "object" == typeof window && window, "object" == typeof self && self, "object" == typeof global && global];
            for (var b = 0; b < a.length; ++b) {
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        },
        ea = da(this),
        r = function (a, b) {
            if (b)
                a: {
                    var c = ea;
                    a = a.split(".");
                    for (var d = 0; d < a.length - 1; d++) {
                        var e = a[d];
                        if (!(e in c)) break a;
                        c = c[e];
                    }
                    a = a[a.length - 1];
                    d = c[a];
                    b = b(d);
                    b != d && b != null && ba(c, a, { configurable: !0, writable: !0, value: b });
                }
        };
    r("Symbol", function (a) {
        if (a) return a;
        var b = function (f, g) {
            this.g = f;
            ba(this, "description", { configurable: !0, writable: !0, value: g });
        };
        b.prototype.toString = function () {
            return this.g;
        };
        var c = "jscomp_symbol_" + ((Math.random() * 1e9) >>> 0) + "_",
            d = 0,
            e = function (f) {
                if (this instanceof e) throw new TypeError("Symbol is not a constructor");
                return new b(c + (f || "") + "_" + d++, f);
            };
        return e;
    });
    r("Symbol.iterator", function (a) {
        if (a) return a;
        a = Symbol("Symbol.iterator");
        for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
            var d = ea[b[c]];
            typeof d === "function" &&
                typeof d.prototype[a] != "function" &&
                ba(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function () {
                        return ha(aa(this));
                    },
                });
        }
        return a;
    });
    var ha = function (a) {
            a = { next: a };
            a[Symbol.iterator] = function () {
                return this;
            };
            return a;
        },
        ka = function (a) {
            return ia(a, a);
        },
        ia = function (a, b) {
            a.raw = b;
            Object.freeze && (Object.freeze(a), Object.freeze(b));
            return a;
        },
        w = function (a) {
            var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if (typeof a.length == "number") return { next: aa(a) };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        },
        la = function (a) {
            if (!(a instanceof Array)) {
                a = w(a);
                for (var b, c = []; !(b = a.next()).done; ) c.push(b.value);
                a = c;
            }
            return a;
        },
        ma = function (a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        },
        na =
            typeof Object.assign == "function"
                ? Object.assign
                : function (a, b) {
                      for (var c = 1; c < arguments.length; c++) {
                          var d = arguments[c];
                          if (d) for (var e in d) ma(d, e) && (a[e] = d[e]);
                      }
                      return a;
                  };
    r("Object.assign", function (a) {
        return a || na;
    });
    var oa =
            typeof Object.create == "function"
                ? Object.create
                : function (a) {
                      var b = function () {};
                      b.prototype = a;
                      return new b();
                  },
        pa = (function () {
            function a() {
                function c() {}
                new c();
                Reflect.construct(c, [], function () {});
                return new c() instanceof c;
            }
            if (typeof Reflect != "undefined" && Reflect.construct) {
                if (a()) return Reflect.construct;
                var b = Reflect.construct;
                return function (c, d, e) {
                    c = b(c, d);
                    e && Reflect.setPrototypeOf(c, e.prototype);
                    return c;
                };
            }
            return function (c, d, e) {
                e === void 0 && (e = c);
                e = oa(e.prototype || Object.prototype);
                return Function.prototype.apply.call(c, e, d) || e;
            };
        })(),
        qa;
    if (typeof Object.setPrototypeOf == "function") qa = Object.setPrototypeOf;
    else {
        var sa;
        a: {
            var ua = { a: !0 },
                va = {};
            try {
                va.__proto__ = ua;
                sa = va.a;
                break a;
            } catch (a) {}
            sa = !1;
        }
        qa = sa
            ? function (a, b) {
                  a.__proto__ = b;
                  if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                  return a;
              }
            : null;
    }
    var wa = qa,
        x = function (a, b) {
            a.prototype = oa(b.prototype);
            a.prototype.constructor = a;
            if (wa) wa(a, b);
            else
                for (var c in b)
                    if (c != "prototype")
                        if (Object.defineProperties) {
                            var d = Object.getOwnPropertyDescriptor(b, c);
                            d && Object.defineProperty(a, c, d);
                        } else a[c] = b[c];
            a.Ia = b.prototype;
        },
        xa = function () {
            this.B = !1;
            this.o = null;
            this.j = void 0;
            this.g = 1;
            this.J = this.l = 0;
            this.A = null;
        },
        ya = function (a) {
            if (a.B) throw new TypeError("Generator is already running");
            a.B = !0;
        };
    xa.prototype.C = function (a) {
        this.j = a;
    };
    var za = function (a, b) {
        a.A = { He: b, Jg: !0 };
        a.g = a.l || a.J;
    };
    xa.prototype.return = function (a) {
        this.A = { return: a };
        this.g = this.J;
    };
    var Aa = function (a, b, c) {
            a.g = c;
            return { value: b };
        },
        Ca = function (a) {
            a.g = 0;
            a.l = 0;
        },
        Da = function (a) {
            a.l = 0;
            var b = a.A.He;
            a.A = null;
            return b;
        },
        Ea = function (a) {
            this.g = new xa();
            this.j = a;
        },
        Ha = function (a, b) {
            ya(a.g);
            var c = a.g.o;
            if (c)
                return Fa(
                    a,
                    "return" in c
                        ? c["return"]
                        : function (d) {
                              return { value: d, done: !0 };
                          },
                    b,
                    a.g.return
                );
            a.g.return(b);
            return Ga(a);
        },
        Fa = function (a, b, c, d) {
            try {
                var e = b.call(a.g.o, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return (a.g.B = !1), e;
                var f = e.value;
            } catch (g) {
                return (a.g.o = null), za(a.g, g), Ga(a);
            }
            a.g.o = null;
            d.call(a.g, f);
            return Ga(a);
        },
        Ga = function (a) {
            for (; a.g.g; )
                try {
                    var b = a.j(a.g);
                    if (b) return (a.g.B = !1), { value: b.value, done: !1 };
                } catch (c) {
                    (a.g.j = void 0), za(a.g, c);
                }
            a.g.B = !1;
            if (a.g.A) {
                b = a.g.A;
                a.g.A = null;
                if (b.Jg) throw b.He;
                return { value: b.return, done: !0 };
            }
            return { value: void 0, done: !0 };
        },
        Ia = function (a) {
            this.next = function (b) {
                ya(a.g);
                a.g.o ? (b = Fa(a, a.g.o.next, b, a.g.C)) : (a.g.C(b), (b = Ga(a)));
                return b;
            };
            this.throw = function (b) {
                ya(a.g);
                a.g.o ? (b = Fa(a, a.g.o["throw"], b, a.g.C)) : (za(a.g, b), (b = Ga(a)));
                return b;
            };
            this.return = function (b) {
                return Ha(a, b);
            };
            this[Symbol.iterator] = function () {
                return this;
            };
        },
        Ka = function (a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function (d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        },
        La = function (a) {
            return Ka(new Ia(new Ea(a)));
        },
        Ma = function () {
            for (var a = Number(this), b = [], c = a; c < arguments.length; c++) b[c - a] = arguments[c];
            return b;
        };
    r("Reflect", function (a) {
        return a ? a : {};
    });
    r("Reflect.construct", function () {
        return pa;
    });
    r("Reflect.setPrototypeOf", function (a) {
        return a
            ? a
            : wa
            ? function (b, c) {
                  try {
                      return wa(b, c), !0;
                  } catch (d) {
                      return !1;
                  }
              }
            : null;
    });
    r("Promise", function (a) {
        function b() {
            this.g = null;
        }
        function c(g) {
            return g instanceof e
                ? g
                : new e(function (h) {
                      h(g);
                  });
        }
        if (a) return a;
        b.prototype.j = function (g) {
            if (this.g == null) {
                this.g = [];
                var h = this;
                this.l(function () {
                    h.A();
                });
            }
            this.g.push(g);
        };
        var d = ea.setTimeout;
        b.prototype.l = function (g) {
            d(g, 0);
        };
        b.prototype.A = function () {
            for (; this.g && this.g.length; ) {
                var g = this.g;
                this.g = [];
                for (var h = 0; h < g.length; ++h) {
                    var k = g[h];
                    g[h] = null;
                    try {
                        k();
                    } catch (m) {
                        this.o(m);
                    }
                }
            }
            this.g = null;
        };
        b.prototype.o = function (g) {
            this.l(function () {
                throw g;
            });
        };
        var e = function (g) {
            this.g = 0;
            this.l = void 0;
            this.j = [];
            this.C = !1;
            var h = this.o();
            try {
                g(h.resolve, h.reject);
            } catch (k) {
                h.reject(k);
            }
        };
        e.prototype.o = function () {
            function g(m) {
                return function (n) {
                    k || ((k = !0), m.call(h, n));
                };
            }
            var h = this,
                k = !1;
            return { resolve: g(this.I), reject: g(this.A) };
        };
        e.prototype.I = function (g) {
            if (g === this) this.A(new TypeError("A Promise cannot resolve to itself"));
            else if (g instanceof e) this.M(g);
            else {
                a: switch (typeof g) {
                    case "object":
                        var h = g != null;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.G(g) : this.B(g);
            }
        };
        e.prototype.G = function (g) {
            var h = void 0;
            try {
                h = g.then;
            } catch (k) {
                this.A(k);
                return;
            }
            typeof h == "function" ? this.P(h, g) : this.B(g);
        };
        e.prototype.A = function (g) {
            this.J(2, g);
        };
        e.prototype.B = function (g) {
            this.J(1, g);
        };
        e.prototype.J = function (g, h) {
            if (this.g != 0) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.g);
            this.g = g;
            this.l = h;
            this.g === 2 && this.K();
            this.L();
        };
        e.prototype.K = function () {
            var g = this;
            d(function () {
                if (g.D()) {
                    var h = ea.console;
                    typeof h !== "undefined" && h.error(g.l);
                }
            }, 1);
        };
        e.prototype.D = function () {
            if (this.C) return !1;
            var g = ea.CustomEvent,
                h = ea.Event,
                k = ea.dispatchEvent;
            if (typeof k === "undefined") return !0;
            typeof g === "function"
                ? (g = new g("unhandledrejection", { cancelable: !0 }))
                : typeof h === "function"
                ? (g = new h("unhandledrejection", { cancelable: !0 }))
                : ((g = ea.document.createEvent("CustomEvent")), g.initCustomEvent("unhandledrejection", !1, !0, g));
            g.promise = this;
            g.reason = this.l;
            return k(g);
        };
        e.prototype.L = function () {
            if (this.j != null) {
                for (var g = 0; g < this.j.length; ++g) f.j(this.j[g]);
                this.j = null;
            }
        };
        var f = new b();
        e.prototype.M = function (g) {
            var h = this.o();
            g.Ac(h.resolve, h.reject);
        };
        e.prototype.P = function (g, h) {
            var k = this.o();
            try {
                g.call(h, k.resolve, k.reject);
            } catch (m) {
                k.reject(m);
            }
        };
        e.prototype.then = function (g, h) {
            function k(q, t) {
                return typeof q == "function"
                    ? function (u) {
                          try {
                              m(q(u));
                          } catch (v) {
                              n(v);
                          }
                      }
                    : t;
            }
            var m,
                n,
                p = new e(function (q, t) {
                    m = q;
                    n = t;
                });
            this.Ac(k(g, m), k(h, n));
            return p;
        };
        e.prototype.catch = function (g) {
            return this.then(void 0, g);
        };
        e.prototype.Ac = function (g, h) {
            function k() {
                switch (m.g) {
                    case 1:
                        g(m.l);
                        break;
                    case 2:
                        h(m.l);
                        break;
                    default:
                        throw Error("Unexpected state: " + m.g);
                }
            }
            var m = this;
            this.j == null ? f.j(k) : this.j.push(k);
            this.C = !0;
        };
        e.resolve = c;
        e.reject = function (g) {
            return new e(function (h, k) {
                k(g);
            });
        };
        e.race = function (g) {
            return new e(function (h, k) {
                for (var m = w(g), n = m.next(); !n.done; n = m.next()) c(n.value).Ac(h, k);
            });
        };
        e.all = function (g) {
            var h = w(g),
                k = h.next();
            return k.done
                ? c([])
                : new e(function (m, n) {
                      function p(u) {
                          return function (v) {
                              q[u] = v;
                              t--;
                              t == 0 && m(q);
                          };
                      }
                      var q = [],
                          t = 0;
                      do q.push(void 0), t++, c(k.value).Ac(p(q.length - 1), n), (k = h.next());
                      while (!k.done);
                  });
        };
        return e;
    });
    r("Object.setPrototypeOf", function (a) {
        return a || wa;
    });
    r("Symbol.dispose", function (a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    r("Array.prototype.find", function (a) {
        return a
            ? a
            : function (b, c) {
                  a: {
                      var d = this;
                      d instanceof String && (d = String(d));
                      for (var e = d.length, f = 0; f < e; f++) {
                          var g = d[f];
                          if (b.call(c, g, f, d)) {
                              b = g;
                              break a;
                          }
                      }
                      b = void 0;
                  }
                  return b;
              };
    });
    r("WeakMap", function (a) {
        function b() {}
        function c(k) {
            var m = typeof k;
            return (m === "object" && k !== null) || m === "function";
        }
        function d(k) {
            if (!ma(k, f)) {
                var m = new b();
                ba(k, f, { value: m });
            }
        }
        function e(k) {
            var m = Object[k];
            m &&
                (Object[k] = function (n) {
                    if (n instanceof b) return n;
                    Object.isExtensible(n) && d(n);
                    return m(n);
                });
        }
        if (
            (function () {
                if (!a || !Object.seal) return !1;
                try {
                    var k = Object.seal({}),
                        m = Object.seal({}),
                        n = new a([
                            [k, 2],
                            [m, 3],
                        ]);
                    if (n.get(k) != 2 || n.get(m) != 3) return !1;
                    n.delete(k);
                    n.set(m, 4);
                    return !n.has(k) && n.get(m) == 4;
                } catch (p) {
                    return !1;
                }
            })()
        )
            return a;
        var f = "$jscomp_hidden_" + Math.random();
        e("freeze");
        e("preventExtensions");
        e("seal");
        var g = 0,
            h = function (k) {
                this.g = (g += Math.random() + 1).toString();
                if (k) {
                    k = w(k);
                    for (var m; !(m = k.next()).done; ) (m = m.value), this.set(m[0], m[1]);
                }
            };
        h.prototype.set = function (k, m) {
            if (!c(k)) throw Error("Invalid WeakMap key");
            d(k);
            if (!ma(k, f)) throw Error("WeakMap key fail: " + k);
            k[f][this.g] = m;
            return this;
        };
        h.prototype.get = function (k) {
            return c(k) && ma(k, f) ? k[f][this.g] : void 0;
        };
        h.prototype.has = function (k) {
            return c(k) && ma(k, f) && ma(k[f], this.g);
        };
        h.prototype.delete = function (k) {
            return c(k) && ma(k, f) && ma(k[f], this.g) ? delete k[f][this.g] : !1;
        };
        return h;
    });
    r("Map", function (a) {
        if (
            (function () {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var h = Object.seal({ x: 4 }),
                        k = new a(w([[h, "s"]]));
                    if (k.get(h) != "s" || k.size != 1 || k.get({ x: 4 }) || k.set({ x: 4 }, "t") != k || k.size != 2) return !1;
                    var m = k.entries(),
                        n = m.next();
                    if (n.done || n.value[0] != h || n.value[1] != "s") return !1;
                    n = m.next();
                    return n.done || n.value[0].x != 4 || n.value[1] != "t" || !m.next().done ? !1 : !0;
                } catch (p) {
                    return !1;
                }
            })()
        )
            return a;
        var b = new WeakMap(),
            c = function (h) {
                this[0] = {};
                this[1] = f();
                this.size = 0;
                if (h) {
                    h = w(h);
                    for (var k; !(k = h.next()).done; ) (k = k.value), this.set(k[0], k[1]);
                }
            };
        c.prototype.set = function (h, k) {
            h = h === 0 ? 0 : h;
            var m = d(this, h);
            m.list || (m.list = this[0][m.id] = []);
            m.pa ? (m.pa.value = k) : ((m.pa = { next: this[1], Ya: this[1].Ya, head: this[1], key: h, value: k }), m.list.push(m.pa), (this[1].Ya.next = m.pa), (this[1].Ya = m.pa), this.size++);
            return this;
        };
        c.prototype.delete = function (h) {
            h = d(this, h);
            return h.pa && h.list ? (h.list.splice(h.index, 1), h.list.length || delete this[0][h.id], (h.pa.Ya.next = h.pa.next), (h.pa.next.Ya = h.pa.Ya), (h.pa.head = null), this.size--, !0) : !1;
        };
        c.prototype.clear = function () {
            this[0] = {};
            this[1] = this[1].Ya = f();
            this.size = 0;
        };
        c.prototype.has = function (h) {
            return !!d(this, h).pa;
        };
        c.prototype.get = function (h) {
            return (h = d(this, h).pa) && h.value;
        };
        c.prototype.entries = function () {
            return e(this, function (h) {
                return [h.key, h.value];
            });
        };
        c.prototype.keys = function () {
            return e(this, function (h) {
                return h.key;
            });
        };
        c.prototype.values = function () {
            return e(this, function (h) {
                return h.value;
            });
        };
        c.prototype.forEach = function (h, k) {
            for (var m = this.entries(), n; !(n = m.next()).done; ) (n = n.value), h.call(k, n[1], n[0], this);
        };
        c.prototype[Symbol.iterator] = c.prototype.entries;
        var d = function (h, k) {
                var m = k && typeof k;
                m == "object" || m == "function" ? (b.has(k) ? (m = b.get(k)) : ((m = "" + ++g), b.set(k, m))) : (m = "p_" + k);
                var n = h[0][m];
                if (n && ma(h[0], m))
                    for (h = 0; h < n.length; h++) {
                        var p = n[h];
                        if ((k !== k && p.key !== p.key) || k === p.key) return { id: m, list: n, index: h, pa: p };
                    }
                return { id: m, list: n, index: -1, pa: void 0 };
            },
            e = function (h, k) {
                var m = h[1];
                return ha(function () {
                    if (m) {
                        for (; m.head != h[1]; ) m = m.Ya;
                        for (; m.next != m.head; ) return (m = m.next), { done: !1, value: k(m) };
                        m = null;
                    }
                    return { done: !0, value: void 0 };
                });
            },
            f = function () {
                var h = {};
                return (h.Ya = h.next = h.head = h);
            },
            g = 0;
        return c;
    });
    r("Set", function (a) {
        if (
            (function () {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var c = Object.seal({ x: 4 }),
                        d = new a(w([c]));
                    if (!d.has(c) || d.size != 1 || d.add(c) != d || d.size != 1 || d.add({ x: 4 }) != d || d.size != 2) return !1;
                    var e = d.entries(),
                        f = e.next();
                    if (f.done || f.value[0] != c || f.value[1] != c) return !1;
                    f = e.next();
                    return f.done || f.value[0] == c || f.value[0].x != 4 || f.value[1] != f.value[0] ? !1 : e.next().done;
                } catch (g) {
                    return !1;
                }
            })()
        )
            return a;
        var b = function (c) {
            this.g = new Map();
            if (c) {
                c = w(c);
                for (var d; !(d = c.next()).done; ) this.add(d.value);
            }
            this.size = this.g.size;
        };
        b.prototype.add = function (c) {
            c = c === 0 ? 0 : c;
            this.g.set(c, c);
            this.size = this.g.size;
            return this;
        };
        b.prototype.delete = function (c) {
            c = this.g.delete(c);
            this.size = this.g.size;
            return c;
        };
        b.prototype.clear = function () {
            this.g.clear();
            this.size = 0;
        };
        b.prototype.has = function (c) {
            return this.g.has(c);
        };
        b.prototype.entries = function () {
            return this.g.entries();
        };
        b.prototype.values = function () {
            return this.g.values();
        };
        b.prototype.keys = b.prototype.values;
        b.prototype[Symbol.iterator] = b.prototype.values;
        b.prototype.forEach = function (c, d) {
            var e = this;
            this.g.forEach(function (f) {
                return c.call(d, f, f, e);
            });
        };
        return b;
    });
    r("Object.values", function (a) {
        return a
            ? a
            : function (b) {
                  var c = [],
                      d;
                  for (d in b) ma(b, d) && c.push(b[d]);
                  return c;
              };
    });
    r("Object.is", function (a) {
        return a
            ? a
            : function (b, c) {
                  return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
              };
    });
    r("Array.prototype.includes", function (a) {
        return a
            ? a
            : function (b, c) {
                  var d = this;
                  d instanceof String && (d = String(d));
                  var e = d.length;
                  c = c || 0;
                  for (c < 0 && (c = Math.max(c + e, 0)); c < e; c++) {
                      var f = d[c];
                      if (f === b || Object.is(f, b)) return !0;
                  }
                  return !1;
              };
    });
    var Oa = function (a, b, c) {
        if (a == null) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
        if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
        return a + "";
    };
    r("String.prototype.includes", function (a) {
        return a
            ? a
            : function (b, c) {
                  return Oa(this, b, "includes").indexOf(b, c || 0) !== -1;
              };
    });
    r("Array.from", function (a) {
        return a
            ? a
            : function (b, c, d) {
                  c =
                      c != null
                          ? c
                          : function (h) {
                                return h;
                            };
                  var e = [],
                      f = typeof Symbol != "undefined" && Symbol.iterator && b[Symbol.iterator];
                  if (typeof f == "function") {
                      b = f.call(b);
                      for (var g = 0; !(f = b.next()).done; ) e.push(c.call(d, f.value, g++));
                  } else for (f = b.length, g = 0; g < f; g++) e.push(c.call(d, b[g], g));
                  return e;
              };
    });
    r("Object.entries", function (a) {
        return a
            ? a
            : function (b) {
                  var c = [],
                      d;
                  for (d in b) ma(b, d) && c.push([d, b[d]]);
                  return c;
              };
    });
    r("Number.isFinite", function (a) {
        return a
            ? a
            : function (b) {
                  return typeof b !== "number" ? !1 : !isNaN(b) && b !== Infinity && b !== -Infinity;
              };
    });
    r("Number.MAX_SAFE_INTEGER", function () {
        return 9007199254740991;
    });
    r("Number.MIN_SAFE_INTEGER", function () {
        return -9007199254740991;
    });
    r("Number.isInteger", function (a) {
        return a
            ? a
            : function (b) {
                  return Number.isFinite(b) ? b === Math.floor(b) : !1;
              };
    });
    r("Number.isSafeInteger", function (a) {
        return a
            ? a
            : function (b) {
                  return Number.isInteger(b) && Math.abs(b) <= Number.MAX_SAFE_INTEGER;
              };
    });
    r("String.prototype.startsWith", function (a) {
        return a
            ? a
            : function (b, c) {
                  var d = Oa(this, b, "startsWith");
                  b += "";
                  var e = d.length,
                      f = b.length;
                  c = Math.max(0, Math.min(c | 0, d.length));
                  for (var g = 0; g < f && c < e; ) if (d[c++] != b[g++]) return !1;
                  return g >= f;
              };
    });
    var Pa = function (a, b) {
        a instanceof String && (a += "");
        var c = 0,
            d = !1,
            e = {
                next: function () {
                    if (!d && c < a.length) {
                        var f = c++;
                        return { value: b(f, a[f]), done: !1 };
                    }
                    d = !0;
                    return { done: !0, value: void 0 };
                },
            };
        e[Symbol.iterator] = function () {
            return e;
        };
        return e;
    };
    r("Array.prototype.entries", function (a) {
        return a
            ? a
            : function () {
                  return Pa(this, function (b, c) {
                      return [b, c];
                  });
              };
    });
    r("Math.imul", function (a) {
        return a
            ? a
            : function (b, c) {
                  b = Number(b);
                  c = Number(c);
                  var d = b & 65535,
                      e = c & 65535;
                  return (d * e + (((((b >>> 16) & 65535) * e + d * ((c >>> 16) & 65535)) << 16) >>> 0)) | 0;
              };
    });
    r("globalThis", function (a) {
        return a || ea;
    });
    r("Math.trunc", function (a) {
        return a
            ? a
            : function (b) {
                  b = Number(b);
                  if (isNaN(b) || b === Infinity || b === -Infinity || b === 0) return b;
                  var c = Math.floor(Math.abs(b));
                  return b < 0 ? -c : c;
              };
    });
    r("Number.isNaN", function (a) {
        return a
            ? a
            : function (b) {
                  return typeof b === "number" && isNaN(b);
              };
    });
    r("Array.prototype.keys", function (a) {
        return a
            ? a
            : function () {
                  return Pa(this, function (b) {
                      return b;
                  });
              };
    });
    r("Array.prototype.values", function (a) {
        return a
            ? a
            : function () {
                  return Pa(this, function (b, c) {
                      return c;
                  });
              };
    });
    r("Object.fromEntries", function (a) {
        return a
            ? a
            : function (b) {
                  var c = {};
                  if (!(Symbol.iterator in b)) throw new TypeError("" + b + " is not iterable");
                  b = b[Symbol.iterator].call(b);
                  for (var d = b.next(); !d.done; d = b.next()) {
                      d = d.value;
                      if (Object(d) !== d) throw new TypeError("iterable for fromEntries should yield objects");
                      c[d[0]] = d[1];
                  }
                  return c;
              };
    });
    r("String.prototype.repeat", function (a) {
        return a
            ? a
            : function (b) {
                  var c = Oa(this, null, "repeat");
                  if (b < 0 || b > 1342177279) throw new RangeError("Invalid count value");
                  b |= 0;
                  for (var d = ""; b; ) if ((b & 1 && (d += c), (b >>>= 1))) c += c;
                  return d;
              };
    });
    var Ra = function (a, b) {
        a = a !== void 0 ? String(a) : " ";
        return b > 0 && a ? a.repeat(Math.ceil(b / a.length)).substring(0, b) : "";
    };
    r("String.prototype.padStart", function (a) {
        return a
            ? a
            : function (b, c) {
                  var d = Oa(this, null, "padStart");
                  return Ra(c, b - d.length) + d;
              };
    });
    r("String.prototype.padEnd", function (a) {
        return a
            ? a
            : function (b, c) {
                  var d = Oa(this, null, "padStart");
                  return d + Ra(c, b - d.length);
              };
    }); /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
    var Sa = Sa || {},
        y = this || self,
        z = function (a, b, c) {
            a = a.split(".");
            c = c || y;
            a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
            for (var d; a.length && (d = a.shift()); ) a.length || b === void 0 ? (c[d] && c[d] !== Object.prototype[d] ? (c = c[d]) : (c = c[d] = {})) : (c[d] = b);
        },
        Ua = function (a, b) {
            var c = Ta("CLOSURE_FLAGS");
            a = c && c[a];
            return a != null ? a : b;
        },
        Ta = function (a, b) {
            a = a.split(".");
            b = b || y;
            for (var c = 0; c < a.length; c++) if (((b = b[a[c]]), b == null)) return null;
            return b;
        },
        Wa = function (a) {
            var b = typeof a;
            return b != "object" ? b : a ? (Array.isArray(a) ? "array" : b) : "null";
        },
        Xa = function (a) {
            var b = Wa(a);
            return b == "array" || (b == "object" && typeof a.length == "number");
        },
        Ya = function (a) {
            var b = typeof a;
            return (b == "object" && a != null) || b == "function";
        },
        ab = function (a) {
            return (Object.prototype.hasOwnProperty.call(a, Za) && a[Za]) || (a[Za] = ++$a);
        },
        bb = function (a) {
            a !== null && "removeAttribute" in a && a.removeAttribute(Za);
            try {
                delete a[Za];
            } catch (b) {}
        },
        Za = "closure_uid_" + ((Math.random() * 1e9) >>> 0),
        $a = 0,
        cb = function (a, b, c) {
            return a.call.apply(a.bind, arguments);
        },
        fb = function (a, b, c) {
            if (!a) throw Error();
            if (arguments.length > 2) {
                var d = Array.prototype.slice.call(arguments, 2);
                return function () {
                    var e = Array.prototype.slice.call(arguments);
                    Array.prototype.unshift.apply(e, d);
                    return a.apply(b, e);
                };
            }
            return function () {
                return a.apply(b, arguments);
            };
        },
        gb = function (a, b, c) {
            gb = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? cb : fb;
            return gb.apply(null, arguments);
        },
        ib = function (a, b) {
            var c = Array.prototype.slice.call(arguments, 1);
            return function () {
                var d = c.slice();
                d.push.apply(d, arguments);
                return a.apply(this, d);
            };
        },
        jb = function (a, b) {
            function c() {}
            c.prototype = b.prototype;
            a.Ia = b.prototype;
            a.prototype = new c();
            a.prototype.constructor = a;
            a.cj = function (d, e, f) {
                for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) g[h - 2] = arguments[h];
                return b.prototype[e].apply(d, g);
            };
        };
    function kb(a, b) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, kb);
        else {
            var c = Error().stack;
            c && (this.stack = c);
        }
        a && (this.message = String(a));
        b !== void 0 && (this.cause = b);
    }
    jb(kb, Error);
    kb.prototype.name = "CustomError";
    var nb;
    var ob,
        pb = typeof String.prototype.isWellFormed === "function",
        qb = typeof TextEncoder !== "undefined";
    function tb(a) {
        var b = !1;
        b = b === void 0 ? !1 : b;
        if (qb) {
            if (b && (pb ? !a.isWellFormed() : /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(a))) throw Error("Found an unpaired surrogate");
            a = (ob || (ob = new TextEncoder())).encode(a);
        } else {
            for (var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++) {
                var f = a.charCodeAt(e);
                if (f < 128) d[c++] = f;
                else {
                    if (f < 2048) d[c++] = (f >> 6) | 192;
                    else {
                        if (f >= 55296 && f <= 57343) {
                            if (f <= 56319 && e < a.length) {
                                var g = a.charCodeAt(++e);
                                if (g >= 56320 && g <= 57343) {
                                    f = (f - 55296) * 1024 + g - 56320 + 65536;
                                    d[c++] = (f >> 18) | 240;
                                    d[c++] = ((f >> 12) & 63) | 128;
                                    d[c++] = ((f >> 6) & 63) | 128;
                                    d[c++] = (f & 63) | 128;
                                    continue;
                                } else e--;
                            }
                            if (b) throw Error("Found an unpaired surrogate");
                            f = 65533;
                        }
                        d[c++] = (f >> 12) | 224;
                        d[c++] = ((f >> 6) & 63) | 128;
                    }
                    d[c++] = (f & 63) | 128;
                }
            }
            a = c === d.length ? d : d.subarray(0, c);
        }
        return a;
    }
    function ub(a) {
        y.setTimeout(function () {
            throw a;
        }, 0);
    }
    var vb = function (a, b) {
            var c = a.length - b.length;
            return c >= 0 && a.indexOf(b, c) == c;
        },
        wb = function (a) {
            return /^[\s\xa0]*$/.test(a);
        },
        xb = String.prototype.trim
            ? function (a) {
                  return a.trim();
              }
            : function (a) {
                  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
              },
        yb = function (a, b) {
            return a.indexOf(b) != -1;
        },
        zb = function (a, b) {
            return yb(a.toLowerCase(), b.toLowerCase());
        },
        Cb = function (a, b) {
            var c = 0;
            a = xb(String(a)).split(".");
            b = xb(String(b)).split(".");
            for (var d = Math.max(a.length, b.length), e = 0; c == 0 && e < d; e++) {
                var f = a[e] || "",
                    g = b[e] || "";
                do {
                    f = /(\d*)(\D*)(.*)/.exec(f) || ["", "", "", ""];
                    g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
                    if (f[0].length == 0 && g[0].length == 0) break;
                    c = Bb(f[1].length == 0 ? 0 : parseInt(f[1], 10), g[1].length == 0 ? 0 : parseInt(g[1], 10)) || Bb(f[2].length == 0, g[2].length == 0) || Bb(f[2], g[2]);
                    f = f[3];
                    g = g[3];
                } while (c == 0);
            }
            return c;
        },
        Bb = function (a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        };
    var Db = Ua(610401301, !1),
        Eb = Ua(653718497, Ua(1, !0)),
        Fb = Ua(660014094, !1);
    function Gb() {
        var a = y.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    var Hb,
        Ib = y.navigator;
    Hb = Ib ? Ib.userAgentData || null : null;
    function Jb(a) {
        return Db
            ? Hb
                ? Hb.brands.some(function (b) {
                      return (b = b.brand) && yb(b, a);
                  })
                : !1
            : !1;
    }
    function A(a) {
        return yb(Gb(), a);
    }
    function Kb() {
        return Db ? !!Hb && Hb.brands.length > 0 : !1;
    }
    function Lb() {
        return Kb() ? !1 : A("Opera");
    }
    function Mb() {
        return Kb() ? !1 : A("Trident") || A("MSIE");
    }
    function Nb() {
        return A("Firefox") || A("FxiOS");
    }
    function Ob() {
        return A("Safari") && !(Pb() || (Kb() ? 0 : A("Coast")) || Lb() || (Kb() ? 0 : A("Edge")) || (Kb() ? Jb("Microsoft Edge") : A("Edg/")) || (Kb() ? Jb("Opera") : A("OPR")) || Nb() || A("Silk") || A("Android"));
    }
    function Pb() {
        return Kb() ? Jb("Chromium") : ((A("Chrome") || A("CriOS")) && !(Kb() ? 0 : A("Edge"))) || A("Silk");
    }
    function Qb() {
        return Db && Hb && Hb.platform ? Hb.platform === "Android" : A("Android");
    }
    function Rb() {
        return A("iPhone") && !A("iPod") && !A("iPad");
    }
    var Sb = function (a, b) {
            if (typeof a === "string") return typeof b !== "string" || b.length != 1 ? -1 : a.indexOf(b, 0);
            for (var c = 0; c < a.length; c++) if (c in a && a[c] === b) return c;
            return -1;
        },
        Tb = function (a, b) {
            for (var c = a.length, d = typeof a === "string" ? a.split("") : a, e = 0; e < c; e++) e in d && b.call(void 0, d[e], e, a);
        };
    function Ub(a, b) {
        for (var c = typeof a === "string" ? a.split("") : a, d = a.length - 1; d >= 0; --d) d in c && b.call(void 0, c[d], d, a);
    }
    var Vb = function (a, b) {
            for (var c = a.length, d = [], e = 0, f = typeof a === "string" ? a.split("") : a, g = 0; g < c; g++)
                if (g in f) {
                    var h = f[g];
                    b.call(void 0, h, g, a) && (d[e++] = h);
                }
            return d;
        },
        Wb = function (a, b) {
            for (var c = a.length, d = Array(c), e = typeof a === "string" ? a.split("") : a, f = 0; f < c; f++) f in e && (d[f] = b.call(void 0, e[f], f, a));
            return d;
        },
        Xb = function (a, b, c) {
            var d = c;
            Tb(a, function (e, f) {
                d = b.call(void 0, d, e, f, a);
            });
            return d;
        },
        Yb = function (a, b) {
            for (var c = a.length, d = typeof a === "string" ? a.split("") : a, e = 0; e < c; e++) if (e in d && b.call(void 0, d[e], e, a)) return !0;
            return !1;
        };
    function Zb(a, b) {
        b = $b(a, b);
        return b < 0 ? null : typeof a === "string" ? a.charAt(b) : a[b];
    }
    function $b(a, b) {
        for (var c = a.length, d = typeof a === "string" ? a.split("") : a, e = 0; e < c; e++) if (e in d && b.call(void 0, d[e], e, a)) return e;
        return -1;
    }
    function ac(a, b) {
        b = bc(a, b);
        return b < 0 ? null : typeof a === "string" ? a.charAt(b) : a[b];
    }
    function bc(a, b) {
        for (var c = typeof a === "string" ? a.split("") : a, d = a.length - 1; d >= 0; d--) if (d in c && b.call(void 0, c[d], d, a)) return d;
        return -1;
    }
    function cc(a, b) {
        return Sb(a, b) >= 0;
    }
    function dc(a, b) {
        b = Sb(a, b);
        var c;
        (c = b >= 0) && ec(a, b);
        return c;
    }
    function ec(a, b) {
        return Array.prototype.splice.call(a, b, 1).length == 1;
    }
    function fc(a, b) {
        var c = 0;
        Ub(a, function (d, e) {
            b.call(void 0, d, e, a) && ec(a, e) && c++;
        });
    }
    function gc(a) {
        return Array.prototype.concat.apply([], arguments);
    }
    function hc(a) {
        var b = a.length;
        if (b > 0) {
            for (var c = Array(b), d = 0; d < b; d++) c[d] = a[d];
            return c;
        }
        return [];
    }
    function ic(a) {
        for (var b = 0, c = 0, d = {}; c < a.length; ) {
            var e = a[c++],
                f = Ya(e) ? "o" + ab(e) : (typeof e).charAt(0) + e;
            Object.prototype.hasOwnProperty.call(d, f) || ((d[f] = !0), (a[b++] = e));
        }
        a.length = b;
    }
    function jc(a, b) {
        a.sort(b || kc);
    }
    function kc(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    function lc(a) {
        for (var b = [], c = 0; c < a; c++) b[c] = "";
        return b;
    }
    var mc = function (a) {
        mc[" "](a);
        return a;
    };
    mc[" "] = function () {};
    var nc = function (a, b) {
            try {
                return mc(a[b]), !0;
            } catch (c) {}
            return !1;
        },
        pc = function (a) {
            var b = oc;
            return Object.prototype.hasOwnProperty.call(b, 8) ? b[8] : (b[8] = a(8));
        };
    var qc = Lb(),
        rc = Mb(),
        sc = A("Edge"),
        tc = A("Gecko") && !(zb(Gb(), "WebKit") && !A("Edge")) && !(A("Trident") || A("MSIE")) && !A("Edge"),
        vc = zb(Gb(), "WebKit") && !A("Edge"),
        wc = Db && Hb && Hb.platform ? Hb.platform === "macOS" : A("Macintosh"),
        xc = Qb(),
        yc = Rb(),
        zc = A("iPad"),
        Ac = A("iPod"),
        Bc = Rb() || A("iPad") || A("iPod"),
        Cc;
    a: {
        var Dc = "",
            Ec = (function () {
                var a = Gb();
                if (tc) return /rv:([^\);]+)(\)|;)/.exec(a);
                if (sc) return /Edge\/([\d\.]+)/.exec(a);
                if (rc) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
                if (vc) return /WebKit\/(\S+)/.exec(a);
                if (qc) return /(?:Version)[ \/]?(\S+)/.exec(a);
            })();
        Ec && (Dc = Ec ? Ec[1] : "");
        if (rc) {
            var Fc,
                Gc = y.document;
            Fc = Gc ? Gc.documentMode : void 0;
            if (Fc != null && Fc > parseFloat(Dc)) {
                Cc = String(Fc);
                break a;
            }
        }
        Cc = Dc;
    }
    var Hc = Cc,
        oc = {},
        Ic = function () {
            return pc(function () {
                return Cb(Hc, 8) >= 0;
            });
        };
    var Jc = Nb(),
        Nc = A("Android") && !(Pb() || Nb() || Lb() || A("Silk")),
        Oc = Pb();
    Ob();
    var Pc = {},
        Qc = null,
        Sc = function (a, b) {
            b === void 0 && (b = 0);
            Rc();
            b = Pc[b];
            for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, f = 0; e < a.length - 2; e += 3) {
                var g = a[e],
                    h = a[e + 1],
                    k = a[e + 2],
                    m = b[g >> 2];
                g = b[((g & 3) << 4) | (h >> 4)];
                h = b[((h & 15) << 2) | (k >> 6)];
                k = b[k & 63];
                c[f++] = "" + m + g + h + k;
            }
            m = 0;
            k = d;
            switch (a.length - e) {
                case 2:
                    (m = a[e + 1]), (k = b[(m & 15) << 2] || d);
                case 1:
                    (a = a[e]), (c[f] = "" + b[a >> 2] + b[((a & 3) << 4) | (m >> 4)] + k + d);
            }
            return c.join("");
        },
        Uc = function (a) {
            var b = [];
            Tc(a, function (c) {
                b.push(c);
            });
            return b;
        },
        Tc = function (a, b) {
            function c(k) {
                for (; d < a.length; ) {
                    var m = a.charAt(d++),
                        n = Qc[m];
                    if (n != null) return n;
                    if (!wb(m)) throw Error("Unknown base64 encoding at char: " + m);
                }
                return k;
            }
            Rc();
            for (var d = 0; ; ) {
                var e = c(-1),
                    f = c(0),
                    g = c(64),
                    h = c(64);
                if (h === 64 && e === -1) break;
                b((e << 2) | (f >> 4));
                g != 64 && (b(((f << 4) & 240) | (g >> 2)), h != 64 && b(((g << 6) & 192) | h));
            }
        },
        Rc = function () {
            if (!Qc) {
                Qc = {};
                for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; c < 5; c++) {
                    var d = a.concat(b[c].split(""));
                    Pc[c] = d;
                    for (var e = 0; e < d.length; e++) {
                        var f = d[e];
                        Qc[f] === void 0 && (Qc[f] = e);
                    }
                }
            }
        };
    var Vc = typeof Uint8Array !== "undefined",
        Wc = !rc && typeof btoa === "function";
    var Xc = function (a, b) {
        a.__closure__error__context__984382 || (a.__closure__error__context__984382 = {});
        a.__closure__error__context__984382.severity = b;
    };
    var Yc;
    function Zc() {
        var a = Error();
        Xc(a, "incident");
        ub(a);
    }
    function $c(a) {
        a = Error(a);
        Xc(a, "warning");
        return a;
    }
    function ad() {
        return typeof BigInt === "function";
    }
    function bd(a) {
        return Array.prototype.slice.call(a);
    }
    var cd = typeof Symbol === "function" && typeof Symbol() === "symbol";
    function dd(a) {
        return typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol() : a;
    }
    var ed = dd(),
        fd = dd("0di"),
        gd = dd("2ex"),
        hd = dd("1oa"),
        id = dd("0dg");
    var jd = cd
            ? function (a, b) {
                  a[ed] |= b;
              }
            : function (a, b) {
                  a.Da !== void 0 ? (a.Da |= b) : Object.defineProperties(a, { Da: { value: b, configurable: !0, writable: !0, enumerable: !1 } });
              },
        kd = cd
            ? function (a, b) {
                  a[ed] &= ~b;
              }
            : function (a, b) {
                  a.Da !== void 0 && (a.Da &= ~b);
              },
        ld = cd
            ? function (a) {
                  return a[ed] | 0;
              }
            : function (a) {
                  return a.Da | 0;
              },
        md = cd
            ? function (a) {
                  return a[ed];
              }
            : function (a) {
                  return a.Da;
              },
        nd = cd
            ? function (a, b) {
                  a[ed] = b;
              }
            : function (a, b) {
                  a.Da !== void 0 ? (a.Da = b) : Object.defineProperties(a, { Da: { value: b, configurable: !0, writable: !0, enumerable: !1 } });
              };
    function od(a) {
        jd(a, 34);
        return a;
    }
    function pd(a) {
        jd(a, 32);
        return a;
    }
    function qd(a, b) {
        nd(b, (a | 0) & -14591);
    }
    function rd(a, b) {
        nd(b, (a | 34) & -14557);
    }
    var sd = {},
        td = {};
    function ud(a) {
        return !(!a || typeof a !== "object" || a.Ng !== td);
    }
    function vd(a) {
        return a !== null && typeof a === "object" && !Array.isArray(a) && a.constructor === Object;
    }
    function wd(a) {
        return !Array.isArray(a) || a.length ? !1 : ld(a) & 1 ? !0 : !1;
    }
    var xd,
        yd = [];
    nd(yd, 55);
    xd = Object.freeze(yd);
    function zd(a) {
        if (a & 2) throw Error();
    }
    var Ad = function (a, b, c) {
        this.l = 0;
        this.g = a;
        this.j = b;
        this.o = c;
    };
    Ad.prototype.next = function () {
        if (this.l < this.g.length) {
            var a = this.g[this.l++];
            return { done: !1, value: this.j ? this.j.call(this.o, a) : a };
        }
        return { done: !0, value: void 0 };
    };
    Ad.prototype[Symbol.iterator] = function () {
        return new Ad(this.g, this.j, this.o);
    };
    var Bd = Object.freeze({});
    Object.freeze({});
    var Cd = Object.freeze({});
    function Dd(a) {
        a.mj = !0;
        return a;
    }
    var Ed = Dd(function (a) {
            return typeof a === "number";
        }),
        Fd = Dd(function (a) {
            return typeof a === "string";
        }),
        Gd = Dd(function (a) {
            return typeof a === "boolean";
        }),
        Hd = Dd(function (a) {
            return !!a && (typeof a === "object" || typeof a === "function");
        });
    function Id(a) {
        a.Kg = !0;
        return a;
    }
    var Jd = typeof y.BigInt === "function" && typeof y.BigInt(0) === "bigint";
    function Kd(a) {
        var b = a;
        if (Fd(b)) {
            if (!/^\s*(?:-?[1-9]\d*|0)?\s*$/.test(b)) throw Error(String(b));
        } else if (Ed(b) && !Number.isSafeInteger(b)) throw Error(String(b));
        return Jd ? BigInt(a) : (a = Gd(a) ? (a ? "1" : "0") : Fd(a) ? a.trim() || "0" : String(a));
    }
    var Qd = Dd(function (a) {
            return Jd ? a >= Ld && a <= Md : a[0] === "-" ? Nd(a, Od) : Nd(a, Pd);
        }),
        Od = Number.MIN_SAFE_INTEGER.toString(),
        Ld = Jd ? BigInt(Number.MIN_SAFE_INTEGER) : void 0,
        Pd = Number.MAX_SAFE_INTEGER.toString(),
        Md = Jd ? BigInt(Number.MAX_SAFE_INTEGER) : void 0;
    function Nd(a, b) {
        if (a.length > b.length) return !1;
        if (a.length < b.length || a === b) return !0;
        for (var c = 0; c < a.length; c++) {
            var d = a[c],
                e = b[c];
            if (d > e) return !1;
            if (d < e) return !0;
        }
    }
    var Rd = 0,
        Sd = 0,
        Td;
    function Ud(a) {
        var b = a >>> 0;
        Rd = b;
        Sd = ((a - b) / 4294967296) >>> 0;
    }
    function Vd(a) {
        if (a < 0) {
            Ud(0 - a);
            var b = w(Wd(Rd, Sd));
            a = b.next().value;
            b = b.next().value;
            Rd = a >>> 0;
            Sd = b >>> 0;
        } else Ud(a);
    }
    function Xd(a, b) {
        b >>>= 0;
        a >>>= 0;
        if (b <= 2097151) var c = "" + (4294967296 * b + a);
        else
            ad()
                ? (c = "" + ((BigInt(b) << BigInt(32)) | BigInt(a)))
                : ((c = ((a >>> 24) | (b << 8)) & 16777215),
                  (b = (b >> 16) & 65535),
                  (a = (a & 16777215) + c * 6777216 + b * 6710656),
                  (c += b * 8147497),
                  (b *= 2),
                  a >= 1e7 && ((c += (a / 1e7) >>> 0), (a %= 1e7)),
                  c >= 1e7 && ((b += (c / 1e7) >>> 0), (c %= 1e7)),
                  (c = b + Yd(c) + Yd(a)));
        return c;
    }
    function Yd(a) {
        a = String(a);
        return "0000000".slice(a.length) + a;
    }
    function Zd() {
        var a = Rd,
            b = Sd;
        b & 2147483648 ? (ad() ? (a = "" + ((BigInt(b | 0) << BigInt(32)) | BigInt(a >>> 0))) : ((b = w(Wd(a, b))), (a = b.next().value), (b = b.next().value), (a = "-" + Xd(a, b)))) : (a = Xd(a, b));
        return a;
    }
    function $d(a) {
        if (a.length < 16) Vd(Number(a));
        else if (ad()) (a = BigInt(a)), (Rd = Number(a & BigInt(4294967295)) >>> 0), (Sd = Number((a >> BigInt(32)) & BigInt(4294967295)));
        else {
            var b = +(a[0] === "-");
            Sd = Rd = 0;
            for (var c = a.length, d = 0 + b, e = ((c - b) % 6) + b; e <= c; d = e, e += 6) (d = Number(a.slice(d, e))), (Sd *= 1e6), (Rd = Rd * 1e6 + d), Rd >= 4294967296 && ((Sd += Math.trunc(Rd / 4294967296)), (Sd >>>= 0), (Rd >>>= 0));
            b && ((b = w(Wd(Rd, Sd))), (a = b.next().value), (b = b.next().value), (Rd = a), (Sd = b));
        }
    }
    function Wd(a, b) {
        b = ~b;
        a ? (a = ~a + 1) : (b += 1);
        return [a, b];
    }
    function ae(a) {
        if (a == null || typeof a === "number") return a;
        if (a === "NaN" || a === "Infinity" || a === "-Infinity") return Number(a);
    }
    function be(a) {
        if (typeof a !== "boolean") throw Error("Expected boolean but got " + Wa(a) + ": " + a);
        return a;
    }
    function ce(a) {
        if (a == null || typeof a === "boolean") return a;
        if (typeof a === "number") return !!a;
    }
    var de = /^-?([1-9][0-9]*|0)(\.[0-9]+)?$/;
    function ee(a) {
        var b = typeof a;
        switch (b) {
            case "bigint":
                return !0;
            case "number":
                return Number.isFinite(a);
        }
        return b !== "string" ? !1 : de.test(a);
    }
    function fe(a) {
        if (!Number.isFinite(a)) throw $c("enum");
        return a | 0;
    }
    function ge(a) {
        return a == null ? a : fe(a);
    }
    function he(a) {
        return a == null ? a : Number.isFinite(a) ? a | 0 : void 0;
    }
    function ie(a) {
        if (typeof a !== "number") throw $c("int32");
        if (!Number.isFinite(a)) throw $c("int32");
        return a | 0;
    }
    function je(a) {
        if (a == null) return a;
        if (typeof a === "string") {
            if (!a) return;
            a = +a;
        }
        if (typeof a === "number") return Number.isFinite(a) ? a | 0 : void 0;
    }
    function le(a) {
        if (a == null) return a;
        if (typeof a === "string") {
            if (!a) return;
            a = +a;
        }
        if (typeof a === "number") return Number.isFinite(a) ? a >>> 0 : void 0;
    }
    function me(a) {
        var b = 0;
        b = b === void 0 ? 0 : b;
        if (!ee(a)) throw $c("int64");
        var c = typeof a;
        switch (b) {
            case 4096:
                switch (c) {
                    case "string":
                        return ne(a);
                    case "bigint":
                        return String(BigInt.asIntN(64, a));
                    default:
                        return oe(a);
                }
            case 8192:
                switch (c) {
                    case "string":
                        return (b = Math.trunc(Number(a))), Number.isSafeInteger(b) ? (a = Kd(b)) : ((b = a.indexOf(".")), b !== -1 && (a = a.substring(0, b)), (a = ad() ? Kd(BigInt.asIntN(64, BigInt(a))) : Kd(pe(a)))), a;
                    case "bigint":
                        return Kd(BigInt.asIntN(64, a));
                    default:
                        return Kd(qe(a));
                }
            case 0:
                switch (c) {
                    case "string":
                        return ne(a);
                    case "bigint":
                        return Kd(BigInt.asIntN(64, a));
                    default:
                        return qe(a);
                }
            default:
                throw Error("Unknown format requested type for int64");
        }
    }
    function re(a) {
        return a == null ? a : me(a);
    }
    function se(a) {
        return a[0] === "-" ? !1 : a.length < 20 ? !0 : a.length === 20 && Number(a.substring(0, 6)) < 184467;
    }
    function te(a) {
        return a[0] === "-" ? (a.length < 20 ? !0 : a.length === 20 && Number(a.substring(0, 7)) > -922337) : a.length < 19 ? !0 : a.length === 19 && Number(a.substring(0, 6)) < 922337;
    }
    function ue(a) {
        if (a < 0) {
            Vd(a);
            var b = Xd(Rd, Sd);
            a = Number(b);
            return Number.isSafeInteger(a) ? a : b;
        }
        if (se(String(a))) return a;
        Vd(a);
        return Sd * 4294967296 + (Rd >>> 0);
    }
    function pe(a) {
        if (te(a)) return a;
        $d(a);
        return Zd();
    }
    function qe(a) {
        a = Math.trunc(a);
        if (!Number.isSafeInteger(a)) {
            Vd(a);
            var b = Rd,
                c = Sd;
            if ((a = c & 2147483648)) (b = (~b + 1) >>> 0), (c = ~c >>> 0), b == 0 && (c = (c + 1) >>> 0);
            b = c * 4294967296 + (b >>> 0);
            a = a ? -b : b;
        }
        return a;
    }
    function oe(a) {
        a = Math.trunc(a);
        if (Number.isSafeInteger(a)) a = String(a);
        else {
            var b = String(a);
            te(b) ? (a = b) : (Vd(a), (a = Zd()));
        }
        return a;
    }
    function ne(a) {
        var b = Math.trunc(Number(a));
        if (Number.isSafeInteger(b)) return String(b);
        b = a.indexOf(".");
        b !== -1 && (a = a.substring(0, b));
        return pe(a);
    }
    function ve(a) {
        if (a == null) return a;
        var b = typeof a;
        if (b === "bigint") return String(BigInt.asIntN(64, a));
        if (ee(a)) {
            if (b === "string") return ne(a);
            if (b === "number") return qe(a);
        }
    }
    function we(a) {
        if (a == null) return a;
        var b = typeof a;
        if (b === "bigint") return String(BigInt.asUintN(64, a));
        if (ee(a)) {
            if (b === "string") return (b = Math.trunc(Number(a))), Number.isSafeInteger(b) && b >= 0 ? (a = String(b)) : ((b = a.indexOf(".")), b !== -1 && (a = a.substring(0, b)), se(a) || ($d(a), (a = Xd(Rd, Sd)))), a;
            if (b === "number") return (a = Math.trunc(a)), a >= 0 && Number.isSafeInteger(a) ? a : ue(a);
        }
    }
    function xe(a) {
        if (typeof a !== "string") throw Error();
        return a;
    }
    function ye(a) {
        if (a != null && typeof a !== "string") throw Error();
        return a;
    }
    function ze(a) {
        return a == null || typeof a === "string" ? a : void 0;
    }
    function Ae(a, b, c, d) {
        if (a != null && typeof a === "object" && a.Pd === sd) return a;
        if (!Array.isArray(a)) return c ? (d & 2 ? Be(b) : new b()) : void 0;
        var e = (c = ld(a));
        e === 0 && (e |= d & 32);
        e |= d & 2;
        e !== c && nd(a, e);
        return new b(a);
    }
    function Be(a) {
        var b = a[fd];
        if (b) return b;
        b = new a();
        od(b.F);
        return (a[fd] = b);
    }
    function Ce(a, b, c) {
        if (b) return be(a);
        var d;
        return (d = ce(a)) != null ? d : c ? !1 : void 0;
    }
    function De(a, b, c) {
        if (b) return xe(a);
        var d;
        return (d = ze(a)) != null ? d : c ? "" : void 0;
    }
    var Le = function (a) {
        Ee === void 0 && (Ee = typeof Proxy === "function" ? Fe(Proxy) : null);
        if (!Ee || !Ge()) return a;
        var b = He(a);
        if (b) return b;
        if (Math.random() > 0.01) return a;
        Ie(a);
        b = new Ee(a, {
            set: function (c, d, e) {
                Je();
                c[d] = e;
                return !0;
            },
        });
        Ke(a, b);
        return b;
    };
    function Je() {
        Zc();
    }
    var Me = void 0,
        Ne = void 0,
        He = function (a) {
            var b;
            return (b = Me) == null ? void 0 : b.get(a);
        },
        Oe = function (a) {
            var b;
            return ((b = Ne) == null ? void 0 : b.get(a)) || a;
        };
    function Ke(a, b) {
        (Me || (Me = new Pe())).set(a, b);
        (Ne || (Ne = new Pe())).set(b, a);
    }
    var Ee = void 0,
        Pe = void 0;
    function Ge() {
        Pe === void 0 && (Pe = typeof WeakMap === "function" ? Fe(WeakMap) : null);
        return Pe;
    }
    function Fe(a) {
        try {
            return a.toString().indexOf("[native code]") !== -1 ? a : null;
        } catch (b) {
            return null;
        }
    }
    var Qe = void 0;
    function Ie(a) {
        if (Qe === void 0) {
            var b = new Ee([], {});
            Qe = Array.prototype.concat.call([], b).length === 1;
        }
        Qe && typeof Symbol === "function" && Symbol.isConcatSpreadable && (a[Symbol.isConcatSpreadable] = !0);
    }
    var Ve = function (a, b, c) {
            if (Eb && Ge()) {
                if (Re(a, b)) {
                    if (c) return;
                } else if (Math.random() > 0.01) return;
                var d = a.length;
                c = { length: d };
                for (var e = 0; e < Math.min(d, 10); e++) {
                    if (d <= 10) var f = e;
                    else {
                        f = d / 10;
                        var g = Math.floor(e * f);
                        f = g + Math.floor(Math.random() * (Math.floor((e + 1) * f) - g));
                    }
                    c[f] = a[f];
                }
                Se(a, c) ? ((d = Te || (Te = new Pe())), (e = d.get(b)), e || ((e = new Pe()), d.set(b, e)), e.set(a, c)) : (Zc(), Ue(a, b));
            }
        },
        Xe = function (a, b) {
            var c = Re(a, b);
            c && !Se(a, c) && (We(), Ue(a, b));
        };
    function Se(a, b) {
        if (a.length !== b.length) return !1;
        for (var c in b) {
            var d = Number(c),
                e;
            if ((e = Number.isInteger(d))) (e = a[d]), (d = b[d]), (e = !(Number.isNaN(e) ? Number.isNaN(d) : e === d));
            if (e) return !1;
        }
        return !0;
    }
    var Ye = function (a) {
        var b;
        if (a && (b = Te) != null && b.has(a) && (b = a.F))
            for (var c = 0; c < b.length; c++) {
                var d = b[c];
                if (c === b.length - 1 && vd(d))
                    for (var e in d) {
                        var f = d[e];
                        Array.isArray(f) && Xe(f, a);
                    }
                else Array.isArray(d) && Xe(d, a);
            }
    };
    function We() {
        Zc();
    }
    var Te = void 0;
    function Re(a, b) {
        var c, d;
        return (c = Te) == null ? void 0 : (d = c.get(b)) == null ? void 0 : d.get(a);
    }
    var Ue = function (a, b) {
        var c, d;
        (c = Te) == null || (d = c.get(b)) == null || d.delete(a);
    };
    var Ze;
    function $e(a, b) {
        Ze = b;
        a = new a(b);
        Ze = void 0;
        return a;
    }
    var af, bf;
    function cf(a) {
        switch (typeof a) {
            case "boolean":
                return af || (af = [0, void 0, !0]);
            case "number":
                return a > 0 ? void 0 : a === 0 ? bf || (bf = [0, void 0]) : [-a, void 0];
            case "string":
                return [0, a];
            case "object":
                return a;
        }
    }
    function B(a, b, c) {
        a == null && (a = Ze);
        Ze = void 0;
        if (a == null) {
            var d = 96;
            c ? ((a = [c]), (d |= 512)) : (a = []);
            b && (d = (d & -33521665) | ((b & 1023) << 15));
        } else {
            if (!Array.isArray(a)) throw Error("narr");
            d = ld(a);
            if (d & 2048) throw Error("farr");
            if (d & 64) return a;
            d |= 64;
            if (c && ((d |= 512), c !== a[0])) throw Error("mid");
            a: {
                c = a;
                var e = c.length;
                if (e) {
                    var f = e - 1;
                    if (vd(c[f])) {
                        d |= 256;
                        b = f - (+!!(d & 512) - 1);
                        if (b >= 1024) throw Error("pvtlmt");
                        d = (d & -33521665) | ((b & 1023) << 15);
                        break a;
                    }
                }
                if (b) {
                    b = Math.max(b, e - (+!!(d & 512) - 1));
                    if (b > 1024) throw Error("spvt");
                    d = (d & -33521665) | ((b & 1023) << 15);
                }
            }
        }
        nd(a, d);
        return a;
    }
    var df = {},
        ef = (function () {
            try {
                var a = function () {
                    return pa(Map, [], this.constructor);
                };
                x(a, Map);
                mc(new a());
                return !1;
            } catch (b) {
                return !0;
            }
        })(),
        ff = function () {
            this.g = new Map();
        };
    l = ff.prototype;
    l.get = function (a) {
        return this.g.get(a);
    };
    l.set = function (a, b) {
        this.g.set(a, b);
        this.size = this.g.size;
        return this;
    };
    l.delete = function (a) {
        a = this.g.delete(a);
        this.size = this.g.size;
        return a;
    };
    l.clear = function () {
        this.g.clear();
        this.size = this.g.size;
    };
    l.has = function (a) {
        return this.g.has(a);
    };
    l.entries = function () {
        return this.g.entries();
    };
    l.keys = function () {
        return this.g.keys();
    };
    l.values = function () {
        return this.g.values();
    };
    l.forEach = function (a, b) {
        return this.g.forEach(a, b);
    };
    ff.prototype[Symbol.iterator] = function () {
        return this.entries();
    };
    var gf = (function () {
        if (ef) return Object.setPrototypeOf(ff.prototype, Map.prototype), Object.defineProperties(ff.prototype, { size: { value: 0, configurable: !0, enumerable: !0, writable: !0 } }), ff;
        var a = function () {
            return pa(Map, [], this.constructor);
        };
        x(a, Map);
        return a;
    })();
    function hf(a) {
        return a;
    }
    var kf = function (a, b, c, d) {
        c = c === void 0 ? hf : c;
        d = d === void 0 ? hf : d;
        var e = gf.call(this) || this;
        var f = ld(a);
        f |= 64;
        nd(a, f);
        e.Pb = f;
        e.nd = b;
        e.ac = c;
        e.ne = e.nd ? jf : d;
        for (var g = 0; g < a.length; g++) {
            var h = a[g],
                k = c(h[0], !1, !0),
                m = h[1];
            b ? m === void 0 && (m = null) : (m = d(h[1], !1, !0, void 0, void 0, f));
            gf.prototype.set.call(e, k, m);
        }
        return e;
    };
    x(kf, gf);
    var lf = function (a) {
            if (a.Pb & 2) throw Error("Cannot mutate an immutable Map");
        },
        of = function (a, b) {
            b = b === void 0 ? mf : b;
            if (a.size !== 0) return nf(a, b);
        },
        nf = function (a, b) {
            b = b === void 0 ? mf : b;
            var c = [];
            a = gf.prototype.entries.call(a);
            for (var d; !(d = a.next()).done; ) (d = d.value), (d[0] = b(d[0])), (d[1] = b(d[1])), c.push(d);
            return c;
        };
    l = kf.prototype;
    l.clear = function () {
        lf(this);
        gf.prototype.clear.call(this);
    };
    l.delete = function (a) {
        lf(this);
        return gf.prototype.delete.call(this, this.ac(a, !0, !1));
    };
    l.entries = function () {
        var a = Array.from(gf.prototype.keys.call(this));
        return new Ad(a, pf, this);
    };
    l.keys = function () {
        return gf.prototype.keys.call(this);
    };
    l.values = function () {
        var a = Array.from(gf.prototype.keys.call(this));
        return new Ad(a, kf.prototype.get, this);
    };
    l.forEach = function (a, b) {
        var c = this;
        gf.prototype.forEach.call(this, function (d, e) {
            a.call(b, c.get(e), e, c);
        });
    };
    l.set = function (a, b) {
        lf(this);
        a = this.ac(a, !0, !1);
        return a == null ? this : b == null ? (gf.prototype.delete.call(this, a), this) : gf.prototype.set.call(this, a, this.ne(b, !0, !0, this.nd, !1, this.Pb));
    };
    l.has = function (a) {
        return gf.prototype.has.call(this, this.ac(a, !1, !1));
    };
    l.get = function (a) {
        a = this.ac(a, !1, !1);
        var b = gf.prototype.get.call(this, a);
        if (b !== void 0) {
            var c = this.nd;
            return c ? ((c = this.ne(b, !1, !0, c, this.eg, this.Pb)), c !== b && gf.prototype.set.call(this, a, c), c) : b;
        }
    };
    kf.prototype[Symbol.iterator] = function () {
        return this.entries();
    };
    kf.prototype.toJSON = void 0;
    kf.prototype.Ng = td;
    function jf(a, b, c, d, e, f) {
        a = Ae(a, d, c, f);
        e && (a = qf(a));
        return a;
    }
    function mf(a) {
        return a;
    }
    function pf(a) {
        return [a, this.get(a)];
    }
    var rf;
    function sf() {
        return rf || (rf = new kf(od([]), void 0, void 0, void 0, df));
    }
    function tf(a, b) {
        return uf(b);
    }
    function uf(a) {
        switch (typeof a) {
            case "number":
                return isFinite(a) ? a : String(a);
            case "bigint":
                return Qd(a) ? Number(a) : String(a);
            case "boolean":
                return a ? 1 : 0;
            case "object":
                if (a)
                    if (Array.isArray(a)) {
                        if (wd(a)) return;
                    } else {
                        if (Vc && a != null && a instanceof Uint8Array) {
                            if (Wc) {
                                for (var b = "", c = 0, d = a.length - 10240; c < d; ) b += String.fromCharCode.apply(null, a.subarray(c, (c += 10240)));
                                b += String.fromCharCode.apply(null, c ? a.subarray(c) : a);
                                a = btoa(b);
                            } else a = Sc(a);
                            return a;
                        }
                        if (a instanceof kf) return of(a);
                    }
        }
        return a;
    }
    function vf(a, b, c) {
        a = bd(a);
        var d = a.length,
            e = b & 256 ? a[d - 1] : void 0;
        d += e ? -1 : 0;
        for (b = b & 512 ? 1 : 0; b < d; b++) a[b] = c(a[b]);
        if (e) {
            b = a[b] = {};
            for (var f in e) b[f] = c(e[f]);
        }
        return a;
    }
    function wf(a, b, c, d, e) {
        if (a != null) {
            if (Array.isArray(a)) a = wd(a) ? void 0 : e && ld(a) & 2 ? a : xf(a, b, c, d !== void 0, e);
            else if (vd(a)) {
                var f = {},
                    g;
                for (g in a) f[g] = wf(a[g], b, c, d, e);
                a = f;
            } else a = b(a, d);
            return a;
        }
    }
    function xf(a, b, c, d, e) {
        var f = d || c ? ld(a) : 0;
        d = d ? !!(f & 32) : void 0;
        a = bd(a);
        for (var g = 0; g < a.length; g++) a[g] = wf(a[g], b, c, d, e);
        c && c(f, a);
        return a;
    }
    function yf(a) {
        return wf(a, zf, void 0, void 0, !1);
    }
    function zf(a) {
        return a.Pd === sd ? a.toJSON() : a instanceof kf ? of(a, yf) : uf(a);
    }
    function Af(a, b, c) {
        c = c === void 0 ? rd : c;
        if (a != null) {
            if (Vc && a instanceof Uint8Array) return b ? a : new Uint8Array(a);
            if (Array.isArray(a)) {
                var d = ld(a);
                if (d & 2) return a;
                b && (b = d === 0 || (!!(d & 32) && !(d & 64 || !(d & 16))));
                return b ? (nd(a, (d | 34) & -12293), a) : xf(a, Af, d & 4 ? rd : c, !0, !0);
            }
            a.Pd === sd ? ((c = a.F), (d = md(c)), (a = d & 2 ? a : Bf(a, c, d, !0))) : a instanceof kf && !(a.Pb & 2) && ((c = od(nf(a, Af))), (a = new kf(c, a.nd, a.ac, a.ne)));
            return a;
        }
    }
    function Bf(a, b, c, d) {
        Ye(a);
        return $e(a.constructor, Cf(b, c, d));
    }
    function Cf(a, b, c) {
        var d = c || b & 2 ? rd : qd,
            e = !!(b & 32);
        a = vf(a, b, function (f) {
            return Af(f, e, d);
        });
        jd(a, 32 | (c ? 2 : 0));
        return a;
    }
    function qf(a) {
        var b = a.F,
            c = md(b);
        return c & 2 ? Bf(a, b, c, !1) : a;
    }
    function Df(a, b, c, d) {
        if (!(4 & b)) return !0;
        if (c == null) return !1;
        !d && c === 0 && (4096 & b || 8192 & b) && (a.constructor[id] = (a.constructor[id] | 0) + 1) < 5 && Zc();
        return c === 0 ? !1 : !(c & b);
    }
    var Ff = function (a, b) {
        a = a.F;
        return Ef(a, md(a), b);
    };
    function Gf(a, b, c, d) {
        b = d + (+!!(b & 512) - 1);
        if (!(b < 0 || b >= a.length || b >= c)) return a[b];
    }
    var Ef = function (a, b, c, d) {
            if (c === -1) return null;
            var e = (b >> 15) & 1023 || 536870912;
            if (c >= e) {
                if (b & 256) return a[a.length - 1][c];
            } else {
                var f = a.length;
                if (d && b & 256 && ((d = a[f - 1][c]), d != null)) {
                    if (Gf(a, b, e, c) && gd != null) {
                        var g;
                        a = (g = Yc) != null ? g : (Yc = {});
                        g = a[gd] || 0;
                        g >= 4 || ((a[gd] = g + 1), Zc());
                    }
                    return d;
                }
                return Gf(a, b, e, c);
            }
        },
        If = function (a, b, c) {
            var d = a.F,
                e = md(d);
            zd(e);
            Hf(d, e, b, c);
            return a;
        };
    function Hf(a, b, c, d) {
        var e = (b >> 15) & 1023 || 536870912;
        if (c >= e) {
            var f = b;
            if (b & 256) var g = a[a.length - 1];
            else {
                if (d == null) return f;
                g = a[e + (+!!(b & 512) - 1)] = {};
                f |= 256;
            }
            g[c] = d;
            c < e && (a[c + (+!!(b & 512) - 1)] = void 0);
            f !== b && nd(a, f);
            return f;
        }
        a[c + (+!!(b & 512) - 1)] = d;
        b & 256 && ((a = a[a.length - 1]), c in a && delete a[c]);
        return b;
    }
    var Jf = function (a) {
        return a === Bd ? 2 : 5;
    };
    function Kf(a, b, c, d, e, f) {
        var g = a.F,
            h = md(g);
        d = 2 & h ? 1 : d;
        f = !!f;
        e = Lf(g, h, b, e);
        var k = ld(e),
            m = e;
        Xe(m, a);
        (d !== 2 && d !== 1) || Ue(m, a);
        if (Df(a, k, void 0, f)) {
            4 & k && ((e = bd(e)), (k = Mf(k, h)), (h = Hf(g, h, b, e)));
            for (var n = (m = 0); m < e.length; m++) {
                var p = c(e[m]);
                p != null && (e[n++] = p);
            }
            n < m && (e.length = n);
            k = Nf(k, h);
            k = (k | 20) & -4097;
            k &= -8193;
            nd(e, k);
            2 & k && Object.freeze(e);
        }
        if (d === 1 || (d === 4 && 32 & k)) Of(k) || ((a = k), (k |= 2), k !== a && nd(e, k), Object.freeze(e));
        else if (
            ((c = d !== 5 ? !1 : !!(32 & k) || Of(k) || !!He(e)), (d === 2 || c) && Of(k) && ((e = bd(e)), (k = Mf(k, h)), (k = Pf(k, h, f)), nd(e, k), (h = Hf(g, h, b, e))), Of(k) || ((b = k), (k = Pf(k, h, f)), k !== b && nd(e, k)), c)
        ) {
            var q = Le(e);
            Ve(e, a, !0);
        } else if (d === 2 && !f) {
            var t;
            (t = Me) == null || t.delete(e);
        }
        return q || e;
    }
    function Lf(a, b, c, d) {
        a = Ef(a, b, c, d);
        return Array.isArray(a) ? a : xd;
    }
    function Nf(a, b) {
        a === 0 && (a = Mf(a, b));
        return a | 1;
    }
    function Of(a) {
        return (!!(2 & a) && !!(4 & a)) || !!(2048 & a);
    }
    function Qf(a, b, c, d, e, f) {
        var g = b & 2;
        a: {
            var h = c,
                k = b & 2;
            c = !1;
            if (h == null) {
                if (k) {
                    a = sf();
                    break a;
                }
                h = [];
            } else if (h.constructor === kf) {
                if ((h.Pb & 2) == 0 || k) {
                    a = h;
                    break a;
                }
                h = nf(h);
            } else Array.isArray(h) ? (c = !!(ld(h) & 2)) : (h = []);
            if (k) {
                if (!h.length) {
                    a = sf();
                    break a;
                }
                c || ((c = !0), od(h));
            } else if (c) {
                c = !1;
                k = bd(h);
                for (h = 0; h < k.length; h++) {
                    var m = (k[h] = bd(k[h]));
                    Array.isArray(m[1]) && (m[1] = od(m[1]));
                }
                h = k;
            }
            c || (ld(h) & 64 ? kd(h, 32) : 32 & b && pd(h));
            f = new kf(h, e, De, f);
            Hf(a, b, d, f);
            a = f;
        }
        !g && e && (a.eg = !0);
        return a;
    }
    function Rf(a, b, c) {
        a = a.F;
        var d = md(a);
        return Qf(a, d, Ef(a, d, b), b, void 0, c);
    }
    function Sf(a) {
        var b = Tf;
        a = a.F;
        var c = md(a);
        return Qf(a, c, Ef(a, c, 24), 24, b);
    }
    function Uf(a, b, c, d) {
        var e = a.F,
            f = md(e);
        zd(f);
        if (c == null) return Hf(e, f, b), a;
        c = Oe(c);
        var g = ld(c),
            h = g,
            k = !!(2 & g) || Object.isFrozen(c),
            m = !k && (void 0 === Cd || !1);
        if (Df(a, g)) {
            g = 21;
            k && ((c = bd(c)), (h = 0), (g = Mf(g, f)), (g = Pf(g, f, !0)));
            for (var n = 0; n < c.length; n++) c[n] = d(c[n]);
        }
        m ? ((c = bd(c)), (h = 0), (g = Mf(g, f)), (g = Pf(g, f, !0))) : k || Ve(c, a);
        g !== h && nd(c, g);
        Hf(e, f, b, c);
        return a;
    }
    function Vf(a, b, c, d) {
        var e = a.F,
            f = md(e);
        zd(f);
        Hf(e, f, b, (d === "0" ? Number(c) === 0 : c === d) ? void 0 : c);
        return a;
    }
    var Yf = function (a, b, c, d) {
            var e = a.F,
                f = md(e);
            zd(f);
            if (d == null) {
                var g = Wf(e);
                if (Xf(g, e, f, c) === b) g.set(c, 0);
                else return a;
            } else {
                g = Wf(e);
                var h = Xf(g, e, f, c);
                h !== b && (h && (f = Hf(e, f, h)), g.set(c, b));
            }
            Hf(e, f, b, d);
            return a;
        },
        $f = function (a, b, c) {
            return Zf(a, b) === c ? c : -1;
        },
        Zf = function (a, b) {
            a = a.F;
            return Xf(Wf(a), a, md(a), b);
        };
    function Wf(a) {
        if (cd) {
            var b;
            return (b = a[hd]) != null ? b : (a[hd] = new Map());
        }
        if (hd in a) return a[hd];
        b = new Map();
        Object.defineProperty(a, hd, { value: b });
        return b;
    }
    function Xf(a, b, c, d) {
        var e = a.get(d);
        if (e != null) return e;
        for (var f = (e = 0); f < d.length; f++) {
            var g = d[f];
            Ef(b, c, g) != null && (e !== 0 && (c = Hf(b, c, e)), (e = g));
        }
        a.set(d, e);
        return e;
    }
    var bg = function (a) {
        var b = ag;
        a = a.F;
        var c = md(a);
        zd(c);
        var d = Ef(a, c, 4);
        b = qf(Ae(d, b, !0, c));
        d !== b && Hf(a, c, 4, b);
        return b;
    };
    function cg(a, b, c) {
        var d = !1;
        a = a.F;
        var e = md(a);
        d = Ef(a, e, c, d);
        b = Ae(d, b, !1, e);
        b !== d && b != null && Hf(a, e, c, b);
        return b;
    }
    var dg = function (a, b, c) {
            return (a = cg(a, b, c)) ? a : Be(b);
        },
        eg = function (a, b, c) {
            b = cg(a, b, c);
            if (b == null) return b;
            a = a.F;
            var d = md(a);
            if (!(d & 2)) {
                var e = qf(b);
                e !== b && ((b = e), Hf(a, d, c, b));
            }
            return b;
        };
    function fg(a, b, c, d, e, f, g) {
        var h = a.F,
            k = !!(2 & b);
        e = k ? 1 : e;
        f = !!f;
        g && (g = !k);
        k = Lf(h, b, d);
        var m = ld(k),
            n = k;
        Xe(n, a);
        (e !== 2 && e !== 1) || Ue(n, a);
        n = !!(4 & m);
        if (!n) {
            m = Nf(m, b);
            var p = k,
                q = b,
                t = !!(2 & m);
            t && (q |= 2);
            for (var u = !t, v = !0, E = 0, P = 0; E < p.length; E++) {
                var S = Ae(p[E], c, !1, q);
                if (S instanceof c) {
                    if (!t) {
                        var ca = !!(ld(S.F) & 2);
                        u && (u = !ca);
                        v && (v = ca);
                    }
                    p[P++] = S;
                }
            }
            P < E && (p.length = P);
            m |= 4;
            m = v ? m | 16 : m & -17;
            m = u ? m | 8 : m & -9;
            nd(p, m);
            t && Object.freeze(p);
        }
        if (g && !(8 & m || (!k.length && (e === 1 || (e === 4 && 32 & m))))) {
            Of(m) ? ((k = bd(k)), (m = Mf(m, b)), (b = Hf(h, b, d, k))) : Ue(k, a);
            c = k;
            g = m;
            for (p = 0; p < c.length; p++) (m = c[p]), (q = qf(m)), m !== q && (c[p] = q);
            g |= 8;
            g = c.length ? g & -17 : g | 16;
            nd(c, g);
            m = g;
        }
        if (e === 1 || (e === 4 && 32 & m)) Of(m) || ((a = m), (m |= !k.length || (16 & m && (!n || 32 & m)) ? 2 : 2048), m !== a && nd(k, m), Object.freeze(k));
        else if (
            ((n = e !== 5 ? !1 : !!(32 & m) || Of(m) || !!He(k)), (e === 2 || n) && Of(m) && ((k = bd(k)), (m = Mf(m, b)), (m = Pf(m, b, f)), nd(k, m), (b = Hf(h, b, d, k))), Of(m) || ((d = m), (m = Pf(m, b, f)), m !== d && nd(k, m)), n)
        ) {
            var Qa = Le(k);
            Ve(k, a, !0);
        } else if (e === 2 && !f) {
            var ra;
            (ra = Me) == null || ra.delete(k);
        }
        return Qa || k;
    }
    var gg = function (a, b, c, d) {
            var e = md(a.F);
            return fg(a, e, b, c, d, !1, !(2 & e));
        },
        C = function (a, b, c) {
            c == null && (c = void 0);
            return If(a, b, c);
        },
        hg = function (a, b, c, d) {
            d == null && (d = void 0);
            return Yf(a, b, c, d);
        },
        ig = function (a, b, c) {
            var d = a.F,
                e = md(d);
            zd(e);
            if (c == null) return Hf(d, e, b), a;
            c = Oe(c);
            for (var f = ld(c), g = f, h = !!(2 & f) || !!(2048 & f), k = h || Object.isFrozen(c), m = !k && (void 0 === Cd || !1), n = !0, p = !0, q = 0; q < c.length; q++) {
                var t = c[q];
                h || ((t = !!(ld(t.F) & 2)), n && (n = !t), p && (p = t));
            }
            h || ((f |= 5), (f = n ? f | 8 : f & -9), (f = p ? f | 16 : f & -17));
            m || (k && f !== g) ? ((c = bd(c)), (g = 0), (f = Mf(f, e)), (f = Pf(f, e, !0))) : k || Ve(c, a);
            f !== g && nd(c, f);
            Hf(d, e, b, c);
            return a;
        };
    function Mf(a, b) {
        a = (2 & b ? a | 2 : a & -3) | 32;
        return (a &= -2049);
    }
    function Pf(a, b, c) {
        (32 & b && c) || (a &= -33);
        return a;
    }
    function jg(a, b, c, d, e) {
        zd(md(a.F));
        a = e(a, b, 2, void 0, !0);
        b = ld(a);
        b = 4 & b ? (4096 & b ? 4096 : 8192 & b ? 8192 : 0) : void 0;
        b = b != null ? b : 0;
        if (Array.isArray(d)) {
            d = Oe(d);
            e = d.length;
            for (var f = 0; f < e; f++) a.push(c(d[f], b));
        } else for (d = w(d), e = d.next(); !e.done; e = d.next()) a.push(c(e.value, b));
    }
    function kg(a, b, c, d) {
        var e = md(a.F);
        zd(e);
        a = fg(a, e, c, b, 2, !0);
        c = d != null ? d : new c();
        a.push(c);
        ld(c.F) & 2 ? kd(a, 8) : kd(a, 16);
        return c;
    }
    var lg = function (a, b, c, d) {
            kg(a, b, c, d);
            return a;
        },
        mg = function (a, b) {
            a = Ff(a, b);
            a != null && (typeof a === "bigint" ? (Qd(a) ? (a = Number(a)) : ((a = BigInt.asIntN(64, a)), (a = Qd(a) ? Number(a) : String(a)))) : (a = ee(a) ? (typeof a === "number" ? qe(a) : ne(a)) : void 0));
            return a;
        };
    function ng(a, b) {
        return a != null ? a : b;
    }
    var og = function (a, b) {
            return ze(Ff(a, b));
        },
        pg = function (a, b) {
            var c = c === void 0 ? !1 : c;
            return ng(ce(Ff(a, b)), c);
        },
        qg = function (a, b) {
            var c = c === void 0 ? 0 : c;
            return ng(je(Ff(a, b)), c);
        },
        rg = function (a, b) {
            var c = c === void 0 ? 0 : c;
            return ng(le(Ff(a, b)), c);
        },
        sg = function (a, b) {
            var c = c === void 0 ? 0 : c;
            return ng(mg(a, b), c);
        },
        tg = function (a, b) {
            var c = c === void 0 ? 0 : c;
            a = a.F;
            var d = md(a),
                e = Ef(a, d, b),
                f = ae(e);
            f != null && f !== e && Hf(a, d, b, f);
            return ng(f, c);
        },
        D = function (a, b) {
            var c = c === void 0 ? "" : c;
            return ng(og(a, b), c);
        },
        F = function (a, b) {
            var c = 0;
            c = c === void 0 ? 0 : c;
            return ng(he(Ff(a, b)), c);
        },
        ug = function (a, b) {
            var c = c === void 0 ? "0" : c;
            a = Ff(a, b);
            b = !0;
            b = b === void 0 ? !1 : b;
            var d = typeof a;
            a = a == null ? a : d === "bigint" ? String(BigInt.asIntN(64, a)) : ee(a) ? (d === "string" ? ne(a) : b ? oe(a) : qe(a)) : void 0;
            return ng(a, c);
        },
        vg = function (a, b) {
            return Kf(a, b, je, Jf());
        },
        wg = function (a, b, c, d, e) {
            return Kf(a, b, ze, c, d, e);
        },
        xg = function (a, b, c, d, e) {
            return Kf(a, b, he, c, d, e);
        },
        yg = function (a, b, c) {
            return F(a, $f(a, c, b));
        },
        zg = function (a, b, c) {
            return If(a, b, c == null ? c : be(c));
        },
        Ag = function (a, b, c) {
            return Vf(a, b, c == null ? c : be(c), !1);
        },
        Bg = function (a, b, c) {
            return If(a, b, c == null ? c : ie(c));
        },
        Cg = function (a, b, c) {
            return Vf(a, b, c == null ? c : ie(c), 0);
        },
        Dg = function (a, b, c) {
            return Vf(a, b, re(c), "0");
        },
        Eg = function (a, b, c) {
            return If(a, b, ye(c));
        },
        Fg = function (a, b, c) {
            return If(a, b, ge(c));
        },
        G = function (a, b, c) {
            return Vf(a, b, ge(c), 0);
        };
    var Gg,
        H = function (a, b, c) {
            this.F = B(a, b, c);
        };
    H.prototype.toJSON = function () {
        return Hg(this);
    };
    var Ig = function (a) {
        try {
            return (Gg = !0), JSON.stringify(Hg(a), tf);
        } finally {
            Gg = !1;
        }
    };
    H.prototype.Pd = sd;
    H.prototype.toString = function () {
        try {
            return (Gg = !0), Hg(this).toString();
        } finally {
            Gg = !1;
        }
    };
    function Hg(a) {
        Ye(a);
        a = Gg ? a.F : xf(a.F, zf, void 0, void 0, !1);
        var b = !Gg,
            c = a.length;
        if (c) {
            var d = a[c - 1],
                e = vd(d);
            e ? c-- : (d = void 0);
            var f = a;
            if (e) {
                b: {
                    var g = d;
                    var h;
                    var k = !1;
                    if (g)
                        for (var m in g)
                            if (isNaN(+m)) (e = void 0), (((e = h) != null ? e : (h = {}))[m] = g[m]);
                            else if (((e = g[m]), Array.isArray(e) && (wd(e) || (ud(e) && e.size === 0)) && (e = null), e == null && (k = !0), e != null)) {
                                var n = void 0;
                                ((n = h) != null ? n : (h = {}))[m] = e;
                            }
                    k || (h = g);
                    if (h)
                        for (var p in h) {
                            k = h;
                            break b;
                        }
                    k = null;
                }
                g = k == null ? d != null : k !== d;
            }
            for (; c > 0; c--) {
                h = f[c - 1];
                if (!(h == null || wd(h) || (ud(h) && h.size === 0))) break;
                var q = !0;
            }
            if (f !== a || g || q) {
                if (!b) f = Array.prototype.slice.call(f, 0, c);
                else if (q || g || k) f.length = c;
                k && f.push(k);
            }
            q = f;
        } else q = a;
        return q;
    }
    var Jg = function (a, b) {
            this.j = a >>> 0;
            this.g = b >>> 0;
        },
        Lg = function (a) {
            if (!a) return Kg || (Kg = new Jg(0, 0));
            if (!/^\d+$/.test(a)) return null;
            $d(a);
            return new Jg(Rd, Sd);
        },
        Kg,
        Mg = function (a, b) {
            this.j = a >>> 0;
            this.g = b >>> 0;
        },
        Og = function (a) {
            if (!a) return Ng || (Ng = new Mg(0, 0));
            if (!/^-?\d+$/.test(a)) return null;
            $d(a);
            return new Mg(Rd, Sd);
        },
        Ng;
    var Pg = function () {
        this.g = [];
    };
    Pg.prototype.length = function () {
        return this.g.length;
    };
    Pg.prototype.end = function () {
        var a = this.g;
        this.g = [];
        return a;
    };
    var Qg = function (a, b, c) {
            for (; c > 0 || b > 127; ) a.g.push((b & 127) | 128), (b = ((b >>> 7) | (c << 25)) >>> 0), (c >>>= 7);
            a.g.push(b);
        },
        Rg = function (a, b) {
            for (; b > 127; ) a.g.push((b & 127) | 128), (b >>>= 7);
            a.g.push(b);
        },
        Sg = function (a, b) {
            if (b >= 0) Rg(a, b);
            else {
                for (var c = 0; c < 9; c++) a.g.push((b & 127) | 128), (b >>= 7);
                a.g.push(1);
            }
        },
        Tg = function (a, b) {
            a.g.push((b >>> 0) & 255);
            a.g.push((b >>> 8) & 255);
            a.g.push((b >>> 16) & 255);
            a.g.push((b >>> 24) & 255);
        };
    var Ug = function () {
            this.l = [];
            this.j = 0;
            this.g = new Pg();
        },
        Vg = function (a, b) {
            b.length !== 0 && (a.l.push(b), (a.j += b.length));
        },
        Xg = function (a, b) {
            Wg(a, b, 2);
            b = a.g.end();
            Vg(a, b);
            b.push(a.j);
            return b;
        },
        Yg = function (a, b) {
            var c = b.pop();
            for (c = a.j + a.g.length() - c; c > 127; ) b.push((c & 127) | 128), (c >>>= 7), a.j++;
            b.push(c);
            a.j++;
        },
        Wg = function (a, b, c) {
            Rg(a.g, b * 8 + c);
        },
        Zg = function (a, b, c) {
            Wg(a, b, 2);
            Rg(a.g, c.length);
            Vg(a, a.g.end());
            Vg(a, c);
        };
    var $g = function (a, b) {
        this.g = a;
        this.sf = b;
    };
    function ah(a, b) {
        if (Array.isArray(b)) {
            var c = ld(b);
            if (c & 4) return b;
            for (var d = 0, e = 0; d < b.length; d++) {
                var f = a(b[d]);
                f != null && (b[e++] = f);
            }
            e < d && (b.length = e);
            nd(b, (c | 5) & -12289);
            c & 2 && Object.freeze(b);
            return b;
        }
    }
    function bh(a, b, c) {
        a[b] = c;
    }
    var ch = Symbol();
    function dh(a) {
        var b = a[ch];
        if (!b) {
            var c = eh(a);
            b = function (d, e) {
                return fh(d, e, c);
            };
            a[ch] = b;
        }
        return b;
    }
    var gh = Symbol();
    function hh(a) {
        return a.g;
    }
    function ih(a, b) {
        var c,
            d,
            e = a.g;
        return function (f, g, h) {
            return e(f, g, h, d || (d = eh(b).g), c || (c = dh(b)));
        };
    }
    function eh(a) {
        var b = a[gh];
        if (b) return b;
        b = a[gh] = {};
        var c = hh,
            d = ih;
        var e = e === void 0 ? bh : e;
        b.g = cf(a[0]);
        var f = 0,
            g = a[++f];
        g && g.constructor === Object && ((b.Ed = g), (g = a[++f]), typeof g === "function" && ((b.l = g), (b.j = a[++f]), (g = a[++f])));
        for (var h = {}; Array.isArray(g) && typeof g[0] === "number" && g[0] > 0; ) {
            for (var k = 0; k < g.length; k++) h[g[k]] = g;
            g = a[++f];
        }
        for (k = 1; g !== void 0; ) {
            typeof g === "number" && ((k += g), (g = a[++f]));
            var m = void 0;
            if (g instanceof $g) var n = g;
            else (n = jh), f--;
            if (n.sf) {
                g = a[++f];
                m = a;
                var p = f;
                typeof g == "function" && ((g = g()), (m[p] = g));
                m = g;
            }
            g = a[++f];
            p = k + 1;
            typeof g === "number" && g < 0 && ((p -= g), (g = a[++f]));
            for (; k < p; k++) {
                var q = h[k];
                e(b, k, m ? d(n, m, q) : c(n, q));
            }
        }
        return b;
    }
    function kh(a, b) {
        var c = a[b];
        if (c) return c;
        if ((c = a.Ed)) {
            var d = c[b];
            if (d) {
                d = Array.isArray(d) ? (d[0] instanceof $g ? d : [lh, d]) : [d, void 0];
                var e = d[0].g;
                d = d[1];
                var f;
                c = (f = c.g) == null ? void 0 : f[b];
                if (!Fb || c) {
                    if (d) {
                        var g = dh(d),
                            h = eh(d).g;
                        c = (f = a.j)
                            ? f(h, g)
                            : function (k, m, n) {
                                  return e(k, m, n, h, g);
                              };
                    } else c = e;
                    return (a[b] = c);
                }
            }
        }
    }
    function fh(a, b, c) {
        for (var d = md(a), e = +!!(d & 512) - 1, f = a.length, g = f + (d & 256 ? -1 : 0), h = d & 512 ? 1 : 0; h < g; h++) {
            var k = a[h];
            if (k != null) {
                var m = h - e,
                    n = kh(c, m);
                if (n) {
                    var p = c.Ed,
                        q = void 0,
                        t = void 0,
                        u = void 0;
                    (q = p) == null || !q[m] || ((t = p) == null ? 0 : (u = t.g) == null ? 0 : u[m]) || (mh++ < 5 && Zc());
                    n(b, k, m);
                }
            }
        }
        if (d & 256) {
            a = a[f - 1];
            for (var v in a)
                if (((d = +v), !Number.isNaN(d) && ((e = a[v]), e != null && (f = kh(c, d)))))
                    (g = c.Ed), (m = k = h = void 0), (h = g) == null || !h[d] || ((k = g) == null ? 0 : (m = k.g) == null ? 0 : m[d]) || (mh++ < 5 && Zc()), f(b, e, d);
        }
    }
    function nh(a) {
        return new $g(a, !1);
    }
    var mh = 0;
    function oh(a, b, c) {
        b = ve(b);
        if (b != null) {
            switch (typeof b) {
                case "string":
                    Og(b);
            }
            if (b != null)
                switch ((Wg(a, c, 0), typeof b)) {
                    case "number":
                        a = a.g;
                        Vd(b);
                        Qg(a, Rd, Sd);
                        break;
                    case "bigint":
                        c = BigInt.asUintN(64, b);
                        c = new Mg(Number(c & BigInt(4294967295)), Number(c >> BigInt(32)));
                        Qg(a.g, c.j, c.g);
                        break;
                    default:
                        (c = Og(b)), Qg(a.g, c.j, c.g);
                }
        }
    }
    function ph(a, b, c) {
        b = je(b);
        b != null && b != null && (Wg(a, c, 0), Sg(a.g, b));
    }
    function qh(a, b, c, d, e) {
        b instanceof H ? (Ye(b), (b = b.F)) : Array.isArray(b) ? ((b = B(b, d[0], d[1])), jd(b, 16384)) : (b = void 0);
        b != null && ((c = Xg(a, c)), e(b, a), Yg(a, c));
    }
    var rh = nh(function (a, b, c) {
            b = ae(b);
            b != null && (Wg(a, c, 1), (a = a.g), (c = Td || (Td = new DataView(new ArrayBuffer(8)))), c.setFloat64(0, +b, !0), (Rd = c.getUint32(0, !0)), (Sd = c.getUint32(4, !0)), Tg(a, Rd), Tg(a, Sd));
        }),
        sh = nh(function (a, b, c) {
            b = ae(b);
            b != null && (Wg(a, c, 5), (a = a.g), (c = Td || (Td = new DataView(new ArrayBuffer(8)))), c.setFloat32(0, +b, !0), (Sd = 0), (Rd = c.getUint32(0, !0)), Tg(a, Rd));
        }),
        th = nh(oh),
        uh = nh(oh),
        vh = nh(function (a, b, c) {
            b = we(b);
            if (b != null) {
                switch (typeof b) {
                    case "string":
                        Lg(b);
                }
                if (b != null)
                    switch ((Wg(a, c, 0), typeof b)) {
                        case "number":
                            a = a.g;
                            Vd(b);
                            Qg(a, Rd, Sd);
                            break;
                        case "bigint":
                            c = BigInt.asUintN(64, b);
                            c = new Jg(Number(c & BigInt(4294967295)), Number(c >> BigInt(32)));
                            Qg(a.g, c.j, c.g);
                            break;
                        default:
                            (c = Lg(b)), Qg(a.g, c.j, c.g);
                    }
            }
        }),
        wh = nh(ph),
        xh = nh(ph),
        yh = nh(function (a, b, c) {
            b = ce(b);
            b != null && (Wg(a, c, 0), a.g.g.push(b ? 1 : 0));
        }),
        zh = nh(function (a, b, c) {
            b = ze(b);
            b != null && Zg(a, c, tb(b));
        }),
        Ah;
    Ah = new $g(function (a, b, c) {
        b = ah(ze, b);
        if (b != null)
            for (var d = 0; d < b.length; d++) {
                var e = a,
                    f = c,
                    g = b[d];
                g != null && Zg(e, f, tb(g));
            }
    }, !1);
    var lh = new $g(qh, !0),
        jh = new $g(qh, !0),
        Bh;
    Bh = new $g(function (a, b, c, d, e) {
        if (Array.isArray(b)) for (var f = 0; f < b.length; f++) qh(a, b[f], c, d, e);
    }, !0);
    var Ch = nh(function (a, b, c) {
            b = le(b);
            b != null && b != null && (Wg(a, c, 0), Rg(a.g, b));
        }),
        Dh = nh(function (a, b, c) {
            b = je(b);
            b != null && ((b = parseInt(b, 10)), Wg(a, c, 0), Sg(a.g, b));
        }),
        Eh;
    Eh = new $g(function (a, b, c) {
        b = ah(je, b);
        if (b != null && b.length) {
            c = Xg(a, c);
            for (var d = 0; d < b.length; d++) Sg(a.g, b[d]);
            Yg(a, c);
        }
    }, !1);
    function Fh(a) {
        return function () {
            Ye(this);
            var b = new Ug();
            fh(this.F, b, eh(a));
            Vg(b, b.g.end());
            for (var c = new Uint8Array(b.j), d = b.l, e = d.length, f = 0, g = 0; g < e; g++) {
                var h = d[g];
                c.set(h, f);
                f += h.length;
            }
            b.l = [c];
            return c;
        };
    }
    function Gh(a) {
        return function (b) {
            if (b == null || b == "") b = new a();
            else {
                b = JSON.parse(b);
                if (!Array.isArray(b)) throw Error("dnarr");
                b = $e(a, pd(b));
            }
            return b;
        };
    }
    var Hh = function (a) {
        this.F = B(a);
    };
    x(Hh, H);
    var Ih = function (a, b, c) {
            c = c === void 0 ? {} : c;
            this.error = a;
            this.context = b.context;
            this.msg = b.message || "";
            this.id = b.id || "jserror";
            this.meta = c;
        },
        Jh = function (a) {
            return !!(a.error && a.meta && a.id);
        };
    var Kh = function () {},
        Lh = function (a) {
            var b = !1,
                c;
            return function () {
                b || ((c = a()), (b = !0));
                return c;
            };
        },
        Mh = function (a) {
            var b = a;
            return function () {
                if (b) {
                    var c = b;
                    b = null;
                    c();
                }
            };
        },
        Nh = function (a) {
            var b = 0,
                c = !1,
                d = [],
                e = function () {
                    b = 0;
                    c && ((c = !1), f());
                },
                f = function () {
                    b = y.setTimeout(e, 1e3);
                    var g = d;
                    d = [];
                    a.apply(void 0, g);
                };
            return function (g) {
                d = arguments;
                b ? (c = !0) : f();
            };
        };
    var Oh = Lh(function () {
        var a = !1;
        try {
            var b = Object.defineProperty({}, "passive", {
                get: function () {
                    a = !0;
                },
            });
            y.addEventListener("test", null, b);
        } catch (c) {}
        return a;
    });
    function Ph(a) {
        return a ? (a.passive && Oh() ? a : a.capture || !1) : !1;
    }
    var Qh = function (a, b, c, d) {
            return a.addEventListener ? (a.addEventListener(b, c, Ph(d)), !0) : !1;
        },
        Rh = function (a, b, c) {
            a.removeEventListener && a.removeEventListener(b, c, Ph());
        }; /*

 Copyright Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
    var Sh = globalThis.trustedTypes,
        Th;
    function Uh() {
        var a = null;
        if (!Sh) return a;
        try {
            var b = function (c) {
                return c;
            };
            a = Sh.createPolicy("goog#html", { createHTML: b, createScript: b, createScriptURL: b });
        } catch (c) {}
        return a;
    }
    function Vh() {
        Th === void 0 && (Th = Uh());
        return Th;
    }
    var Wh = function (a) {
        this.g = a;
    };
    Wh.prototype.toString = function () {
        return this.g + "";
    };
    function di(a) {
        var b = Vh();
        return new Wh(b ? b.createScriptURL(a) : a);
    }
    var ei = function (a) {
        this.g = a;
    };
    ei.prototype.toString = function () {
        return this.g;
    };
    var fi = new ei("about:invalid#zClosurez");
    var gi = function (a) {
        this.Mg = a;
    };
    function hi(a) {
        return new gi(function (b) {
            return b.substr(0, a.length + 1).toLowerCase() === a + ":";
        });
    }
    var ii = [
        hi("data"),
        hi("http"),
        hi("https"),
        hi("mailto"),
        hi("ftp"),
        new gi(function (a) {
            return /^[^:]*([/?#]|$)/.test(a);
        }),
    ];
    function ji(a) {
        if (typeof MediaSource !== "undefined" && a instanceof MediaSource) return new ei(URL.createObjectURL(a));
        var b = a.type.match(/^([^;]+)(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i);
        if (
            (b == null ? void 0 : b.length) !== 2 ||
            !(
                /^image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon|heic|heif|avif|x-ms-bmp)$/i.test(b[1]) ||
                /^video\/(?:mpeg|mp4|ogg|webm|x-matroska|quicktime|x-ms-wmv)$/i.test(b[1]) ||
                /^audio\/(?:3gpp2|3gpp|aac|amr|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)$/i.test(b[1]) ||
                /^font\/\w+/i.test(b[1])
            )
        )
            throw Error("");
        return new ei(URL.createObjectURL(a));
    }
    var ki = /^\s*(?!javascript:)(?:[\w+.-]+:|[^:/?#]*(?:[/?#]|$))/i;
    var li = function (a) {
        this.g = a;
    };
    li.prototype.toString = function () {
        return this.g + "";
    };
    function mi(a) {
        if (a instanceof li) return a.g;
        throw Error("");
    }
    var ni = function (a) {
        this.g = a;
    };
    ni.prototype.toString = function () {
        return this.g;
    };
    function oi(a) {
        var b = Ma.apply(1, arguments);
        if (b.length === 0) return di(a[0]);
        for (var c = a[0], d = 0; d < b.length; d++) c += encodeURIComponent(b[d]) + a[d + 1];
        return di(c);
    }
    function pi(a) {
        for (var b = Ma.apply(1, arguments), c = a[0], d = 0; d < a.length - 1; d++) c += String(b[d]) + a[d + 1];
        if (/[<>]/.test(c)) throw Error("Forbidden characters in style string: " + c);
        return new ni(c);
    }
    var qi = function (a, b) {
        this.x = a !== void 0 ? a : 0;
        this.y = b !== void 0 ? b : 0;
    };
    qi.prototype.ceil = function () {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    };
    qi.prototype.floor = function () {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    };
    qi.prototype.round = function () {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    };
    qi.prototype.scale = function (a, b) {
        this.x *= a;
        this.y *= typeof b === "number" ? b : a;
        return this;
    };
    var ri = function (a, b) {
            this.width = a;
            this.height = b;
        },
        si = function (a, b) {
            return a == b ? !0 : a && b ? a.width == b.width && a.height == b.height : !1;
        };
    l = ri.prototype;
    l.aspectRatio = function () {
        return this.width / this.height;
    };
    l.isEmpty = function () {
        return !(this.width * this.height);
    };
    l.ceil = function () {
        this.width = Math.ceil(this.width);
        this.height = Math.ceil(this.height);
        return this;
    };
    l.floor = function () {
        this.width = Math.floor(this.width);
        this.height = Math.floor(this.height);
        return this;
    };
    l.round = function () {
        this.width = Math.round(this.width);
        this.height = Math.round(this.height);
        return this;
    };
    l.scale = function (a, b) {
        this.width *= a;
        this.height *= typeof b === "number" ? b : a;
        return this;
    };
    function ti(a, b, c) {
        for (var d in a) b.call(c, a[d], d, a);
    }
    function ui(a, b) {
        var c = {},
            d;
        for (d in a) b.call(void 0, a[d], d, a) && (c[d] = a[d]);
        return c;
    }
    function vi(a) {
        var b = wi,
            c;
        for (c in b) if (!a.call(void 0, b[c], c, b)) return !1;
        return !0;
    }
    function xi(a) {
        var b = [],
            c = 0,
            d;
        for (d in a) b[c++] = a[d];
        return b;
    }
    function yi(a) {
        var b = [],
            c = 0,
            d;
        for (d in a) b[c++] = d;
        return b;
    }
    function zi(a, b) {
        var c = Xa(b),
            d = c ? b : arguments;
        for (c = c ? 0 : 1; c < d.length; c++) {
            if (a == null) return;
            a = a[d[c]];
        }
        return a;
    }
    function Ai(a, b) {
        return a !== null && b in a;
    }
    function Bi(a, b) {
        for (var c in a) if (a[c] == b) return !0;
        return !1;
    }
    function Ci(a) {
        var b = Di,
            c;
        for (c in b) if (a.call(void 0, b[c], c, b)) return c;
    }
    function Ei(a) {
        for (var b in a) return !1;
        return !0;
    }
    function Fi(a) {
        for (var b in a) delete a[b];
    }
    function Gi(a, b, c) {
        return a !== null && b in a ? a[b] : c;
    }
    var Hi = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Ii(a, b) {
        for (var c, d, e = 1; e < arguments.length; e++) {
            d = arguments[e];
            for (c in d) a[c] = d[c];
            for (var f = 0; f < Hi.length; f++) (c = Hi[f]), Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ji(a, b) {
        if (a.nodeType === 1) {
            var c = a.tagName;
            if (c === "SCRIPT" || c === "STYLE") throw Error("");
        }
        a.innerHTML = mi(b);
    }
    function Ki(a, b) {
        if (b instanceof Wh) b = b.g;
        else throw Error("");
        a.src = b;
        var c, d;
        (c = (b = (d = (c = ((a.ownerDocument && a.ownerDocument.defaultView) || window).document).querySelector) == null ? void 0 : d.call(c, "script[nonce]")) ? b.nonce || b.getAttribute("nonce") || "" : "") && a.setAttribute("nonce", c);
    }
    var Li = function (a) {
        var b = [],
            c = [],
            d = {},
            e = function (f, g) {
                var h = g + "  ";
                try {
                    if (f === void 0) b.push("undefined");
                    else if (f === null) b.push("NULL");
                    else if (typeof f === "string") b.push('"' + f.replace(/\n/g, "\n" + g) + '"');
                    else if (typeof f === "function") b.push(String(f).replace(/\n/g, "\n" + g));
                    else if (Ya(f)) {
                        f[Za] || c.push(f);
                        var k = ab(f);
                        if (d[k]) b.push("*** reference loop detected (id=" + k + ") ***");
                        else {
                            d[k] = !0;
                            b.push("{");
                            for (var m in f) typeof f[m] !== "function" && (b.push("\n"), b.push(h), b.push(m + " = "), e(f[m], h));
                            b.push("\n" + g + "}");
                            delete d[k];
                        }
                    } else b.push(f);
                } catch (n) {
                    b.push("*** " + n + " ***");
                }
            };
        e(a, "");
        for (a = 0; a < c.length; a++) bb(c[a]);
        return b.join("");
    };
    function Mi(a, b) {
        a.write(mi(b));
    }
    var Ni = function (a) {
            return decodeURIComponent(a.replace(/\+/g, " "));
        },
        Oi = function (a, b) {
            a.length > b && (a = a.substring(0, b - 3) + "...");
            return a;
        },
        Pi = String.prototype.repeat
            ? function (a, b) {
                  return a.repeat(b);
              }
            : function (a, b) {
                  return Array(b + 1).join(a);
              },
        Qi = function (a) {
            return a == null ? "" : String(a);
        },
        Ri = (Math.random() * 2147483648) | 0,
        Si = function (a) {
            return String(a).replace(/\-([a-z])/g, function (b, c) {
                return c.toUpperCase();
            });
        },
        Ti = function () {
            return "googleAvInapp".replace(/([A-Z])/g, "-$1").toLowerCase();
        },
        Ui = function (a) {
            return a.replace(RegExp("(^|[\\s]+)([a-z])", "g"), function (b, c, d) {
                return c + d.toUpperCase();
            });
        },
        Vi = function (a) {
            isFinite(a) && (a = String(a));
            return typeof a === "string" ? (/^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10)) : NaN;
        };
    var Yi = function (a) {
            return a ? new Wi(Xi(a)) : nb || (nb = new Wi());
        },
        Zi = function (a) {
            var b = document;
            return typeof a === "string" ? b.getElementById(a) : a;
        },
        aj = function (a, b) {
            ti(b, function (c, d) {
                d == "style"
                    ? (a.style.cssText = c)
                    : d == "class"
                    ? (a.className = c)
                    : d == "for"
                    ? (a.htmlFor = c)
                    : $i.hasOwnProperty(d)
                    ? a.setAttribute($i[d], c)
                    : d.lastIndexOf("aria-", 0) == 0 || d.lastIndexOf("data-", 0) == 0
                    ? a.setAttribute(d, c)
                    : (a[d] = c);
            });
        },
        $i = {
            cellpadding: "cellPadding",
            cellspacing: "cellSpacing",
            colspan: "colSpan",
            frameborder: "frameBorder",
            height: "height",
            maxlength: "maxLength",
            nonce: "nonce",
            role: "role",
            rowspan: "rowSpan",
            type: "type",
            usemap: "useMap",
            valign: "vAlign",
            width: "width",
        },
        bj = function (a) {
            a = a.document;
            a = a.compatMode == "CSS1Compat" ? a.documentElement : a.body;
            return new ri(a.clientWidth, a.clientHeight);
        },
        cj = function (a) {
            var b = a.scrollingElement ? a.scrollingElement : vc || a.compatMode != "CSS1Compat" ? a.body || a.documentElement : a.documentElement;
            a = a.defaultView;
            return new qi(a.pageXOffset || b.scrollLeft, a.pageYOffset || b.scrollTop);
        },
        dj = function (a) {
            return a ? a.defaultView : window;
        },
        gj = function (a, b, c) {
            var d = arguments,
                e = document,
                f = d[1],
                g = ej(e, String(d[0]));
            f && (typeof f === "string" ? (g.className = f) : Array.isArray(f) ? (g.className = f.join(" ")) : aj(g, f));
            d.length > 2 && fj(e, g, d, 2);
            return g;
        },
        fj = function (a, b, c, d) {
            function e(h) {
                h && b.appendChild(typeof h === "string" ? a.createTextNode(h) : h);
            }
            for (; d < c.length; d++) {
                var f = c[d];
                if (!Xa(f) || (Ya(f) && f.nodeType > 0)) e(f);
                else {
                    a: {
                        if (f && typeof f.length == "number") {
                            if (Ya(f)) {
                                var g = typeof f.item == "function" || typeof f.item == "string";
                                break a;
                            }
                            if (typeof f === "function") {
                                g = typeof f.item == "function";
                                break a;
                            }
                        }
                        g = !1;
                    }
                    Tb(g ? hc(f) : f, e);
                }
            }
        },
        ej = function (a, b) {
            b = String(b);
            a.contentType === "application/xhtml+xml" && (b = b.toLowerCase());
            return a.createElement(b);
        },
        hj = function (a) {
            a && a.parentNode && a.parentNode.removeChild(a);
        },
        ij = function (a, b) {
            if (!a || !b) return !1;
            if (a.contains && b.nodeType == 1) return a == b || a.contains(b);
            if (typeof a.compareDocumentPosition != "undefined") return a == b || !!(a.compareDocumentPosition(b) & 16);
            for (; b && a != b; ) b = b.parentNode;
            return b == a;
        },
        Xi = function (a) {
            return a.nodeType == 9 ? a : a.ownerDocument || a.document;
        },
        jj = function (a) {
            try {
                return a.contentWindow || (a.contentDocument ? dj(a.contentDocument) : null);
            } catch (b) {}
            return null;
        },
        kj = function (a, b) {
            a && (a = a.parentNode);
            for (var c = 0; a; ) {
                if (b(a)) return a;
                a = a.parentNode;
                c++;
            }
            return null;
        },
        Wi = function (a) {
            this.g = a || y.document || document;
        };
    l = Wi.prototype;
    l.getElementsByTagName = function (a, b) {
        return (b || this.g).getElementsByTagName(String(a));
    };
    l.appendChild = function (a, b) {
        a.appendChild(b);
    };
    l.append = function (a, b) {
        fj(Xi(a), a, arguments, 1);
    };
    l.canHaveChildren = function (a) {
        if (a.nodeType != 1) return !1;
        switch (a.tagName) {
            case "APPLET":
            case "AREA":
            case "BASE":
            case "BR":
            case "COL":
            case "COMMAND":
            case "EMBED":
            case "FRAME":
            case "HR":
            case "IMG":
            case "INPUT":
            case "IFRAME":
            case "ISINDEX":
            case "KEYGEN":
            case "LINK":
            case "NOFRAMES":
            case "NOSCRIPT":
            case "META":
            case "OBJECT":
            case "PARAM":
            case "SCRIPT":
            case "SOURCE":
            case "STYLE":
            case "TRACK":
            case "WBR":
                return !1;
        }
        return !0;
    };
    l.contains = ij;
    var mj = function () {
            return Db && Hb ? Hb.mobile : !lj() && (A("iPod") || A("iPhone") || A("Android") || A("IEMobile"));
        },
        lj = function () {
            return Db && Hb ? !Hb.mobile && (A("iPad") || A("Android") || A("Silk")) : A("iPad") || (A("Android") && !A("Mobile")) || A("Silk");
        };
    var nj = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$"),
        oj = function (a) {
            var b = a.match(nj);
            a = b[1];
            var c = b[3];
            b = b[4];
            var d = "";
            a && (d += a + ":");
            c && ((d = d + "//" + c), b && (d += ":" + b));
            return d;
        },
        pj = function (a, b) {
            if (a) {
                a = a.split("&");
                for (var c = 0; c < a.length; c++) {
                    var d = a[c].indexOf("="),
                        e = null;
                    if (d >= 0) {
                        var f = a[c].substring(0, d);
                        e = a[c].substring(d + 1);
                    } else f = a[c];
                    b(f, e ? Ni(e) : "");
                }
            }
        },
        qj = /#|$/,
        rj = function (a, b) {
            var c = a.search(qj);
            a: {
                var d = 0;
                for (var e = b.length; (d = a.indexOf(b, d)) >= 0 && d < c; ) {
                    var f = a.charCodeAt(d - 1);
                    if (f == 38 || f == 63) if (((f = a.charCodeAt(d + e)), !f || f == 61 || f == 38 || f == 35)) break a;
                    d += e + 1;
                }
                d = -1;
            }
            if (d < 0) return null;
            e = a.indexOf("&", d);
            if (e < 0 || e > c) e = c;
            d += b.length + 1;
            return Ni(a.slice(d, e !== -1 ? e : 0));
        };
    var sj = function (a) {
            try {
                return !!a && a.location.href != null && nc(a, "foo");
            } catch (b) {
                return !1;
            }
        },
        uj = function (a) {
            var b = b === void 0 ? !1 : b;
            var c = c === void 0 ? y : c;
            for (var d = 0; c && d++ < 40 && ((!b && !sj(c)) || !a(c)); ) c = tj(c);
        },
        vj = function () {
            var a = window;
            uj(function (b) {
                a = b;
                return !1;
            });
            return a;
        },
        tj = function (a) {
            try {
                var b = a.parent;
                if (b && b != a) return b;
            } catch (c) {}
            return null;
        },
        wj = function () {
            var a = window;
            return sj(a.top) ? a.top : null;
        },
        xj = function () {
            if (!globalThis.crypto) return Math.random();
            try {
                var a = new Uint32Array(1);
                globalThis.crypto.getRandomValues(a);
                return a[0] / 65536 / 65536;
            } catch (b) {
                return Math.random();
            }
        },
        yj = function (a, b) {
            if (a) for (var c in a) Object.prototype.hasOwnProperty.call(a, c) && b(a[c], c, a);
        },
        zj = function (a) {
            var b = a.length;
            if (b == 0) return 0;
            for (var c = 305419896, d = 0; d < b; d++) c ^= ((c << 5) + (c >> 2) + a.charCodeAt(d)) & 4294967295;
            return c > 0 ? c : 4294967296 + c;
        };
    function Aj(a) {
        var b, c;
        return (c = (b = /https?:\/\/[^\/]+/.exec(a)) == null ? void 0 : b[0]) != null ? c : "";
    }
    var Bj = function () {
            var a = y;
            try {
                for (var b = null; b != a; b = a, a = a.parent)
                    switch (a.location.protocol) {
                        case "https:":
                            return !0;
                        case "file:":
                            return !0;
                        case "http:":
                            return !1;
                    }
            } catch (c) {}
            return !0;
        },
        Cj = function (a) {
            a = a && a.toString && a.toString();
            return typeof a === "string" && yb(a, "[native code]");
        },
        Dj = function (a, b) {
            try {
                return !(!a.frames || !a.frames[b]);
            } catch (c) {
                return !1;
            }
        },
        Ej = function (a, b) {
            for (var c = 0; c < 50; ++c) {
                if (Dj(a, b)) return a;
                if (!(a = tj(a))) break;
            }
            return null;
        },
        Fj = Lh(function () {
            return mj() ? 2 : lj() ? 1 : 0;
        }),
        Gj = function () {
            var a = window;
            if (typeof a.goog_pvsid !== "number")
                try {
                    var b = Object,
                        c = b.defineProperty,
                        d = void 0;
                    d = d === void 0 ? Math.random : d;
                    var e = Math.floor(d() * 4503599627370496);
                    c.call(b, a, "goog_pvsid", { value: e, configurable: !1 });
                } catch (f) {}
            return Number(a.goog_pvsid) || -1;
        },
        Hj = function (a, b) {
            b = b === void 0 ? document : b;
            return b.createElement(String(a).toLowerCase());
        },
        Ij = function (a) {
            for (var b = a; a && a != a.parent; ) (a = a.parent), sj(a) && (b = a);
            return b;
        };
    var Kj = function (a, b, c, d, e) {
        Jj(a, b, c === void 0 ? null : c, d === void 0 ? !1 : d, e === void 0 ? !1 : e);
    };
    function Jj(a, b, c, d, e) {
        e = e === void 0 ? !1 : e;
        a.google_image_requests || (a.google_image_requests = []);
        var f = Hj("IMG", a.document);
        if (c || d) {
            var g = function (h) {
                c && c(h);
                d && dc(a.google_image_requests, f);
                Rh(f, "load", g);
                Rh(f, "error", g);
            };
            Qh(f, "load", g);
            Qh(f, "error", g);
        }
        e && (f.attributionSrc = "");
        f.src = b;
        a.google_image_requests.push(f);
    }
    var Mj = function (a, b) {
            var c = c === void 0 ? !1 : c;
            var d = "https://pagead2.googlesyndication.com/pagead/gen_204?id=" + b;
            yj(a, function (e, f) {
                if (e || e === 0) d += "&" + f + "=" + encodeURIComponent("" + e);
            });
            Lj(d, c);
        },
        Lj = function (a, b) {
            var c = window;
            b = b === void 0 ? !1 : b;
            var d = d === void 0 ? !1 : d;
            c.fetch
                ? ((b = { keepalive: !0, credentials: "include", redirect: "follow", method: "get", mode: "no-cors" }),
                  d &&
                      ((b.mode = "cors"),
                      "setAttributionReporting" in XMLHttpRequest.prototype ? (b.attributionReporting = { eventSourceEligible: "true", triggerEligible: "false" }) : (b.headers = { "Attribution-Reporting-Eligible": "event-source" })),
                  c.fetch(a, b))
                : Kj(c, a, void 0, b, d);
        };
    function Nj(a, b) {
        try {
            var c = function (d) {
                var e = {};
                return [((e[d.nf] = d.Pe), e)];
            };
            return JSON.stringify([
                a
                    .filter(function (d) {
                        return d.Md;
                    })
                    .map(c),
                Hg(b),
                a
                    .filter(function (d) {
                        return !d.Md;
                    })
                    .map(c),
            ]);
        } catch (d) {
            return Oj(d, b), "";
        }
    }
    function Oj(a, b) {
        try {
            var c = a instanceof Error ? a : Error(String(a)),
                d = c.toString();
            c.name && d.indexOf(c.name) == -1 && (d += ": " + c.name);
            c.message && d.indexOf(c.message) == -1 && (d += ": " + c.message);
            if (c.stack)
                a: {
                    var e = c.stack;
                    a = d;
                    try {
                        e.indexOf(a) == -1 && (e = a + "\n" + e);
                        for (var f; e != f; ) (f = e), (e = e.replace(RegExp("((https?:/..*/)[^/:]*:\\d+(?:.|\n)*)\\2"), "$1"));
                        d = e.replace(RegExp("\n *", "g"), "\n");
                        break a;
                    } catch (g) {
                        d = a;
                        break a;
                    }
                    d = void 0;
                }
            Mj({ m: d, b: F(b, 1) || null, v: D(b, 2) || null }, "rcs_internal");
        } catch (g) {}
    }
    var Pj = function (a, b) {
        var c = new Hh();
        a = G(c, 1, a);
        b = Vf(a, 2, ye(b), "");
        a = b.F;
        c = md(a);
        this.l = c & 2 ? b : Bf(b, a, c, !0);
    };
    var Qj = function (a) {
        this.F = B(a);
    };
    x(Qj, H);
    var Rj = [1, 2, 3];
    var Sj = function (a) {
        this.F = B(a);
    };
    x(Sj, H);
    var Tj = [2, 4];
    var Uj = function (a) {
        this.F = B(a);
    };
    x(Uj, H);
    var Vj = function (a) {
        this.F = B(a);
    };
    x(Vj, H);
    var Wj = function (a) {
        this.F = B(a);
    };
    x(Wj, H);
    var Xj = function (a, b) {
            return G(a, 1, b);
        },
        Yj = function (a, b) {
            return G(a, 2, b);
        };
    var Zj = function (a) {
        this.F = B(a);
    };
    x(Zj, H);
    var ak = [1, 2];
    var bk = function (a) {
        this.F = B(a);
    };
    x(bk, H);
    var ck = function (a, b) {
            return C(a, 1, b);
        },
        dk = function (a, b) {
            return ig(a, 2, b);
        },
        ek = function (a, b) {
            return Uf(a, 4, b, ie);
        },
        fk = function (a, b) {
            return ig(a, 5, b);
        },
        gk = function (a, b) {
            return G(a, 6, b);
        };
    var hk = function (a) {
        this.F = B(a);
    };
    x(hk, H);
    var ik = [1, 2, 3, 4, 6];
    var jk = function (a) {
        this.F = B(a);
    };
    x(jk, H);
    var kk = function (a) {
        this.F = B(a);
    };
    x(kk, H);
    var lk = [2, 3, 4];
    var mk = function (a) {
        this.F = B(a);
    };
    x(mk, H);
    var nk = [3, 4, 5],
        ok = [6, 7];
    var pk = function (a) {
        this.F = B(a);
    };
    x(pk, H);
    var qk = [4, 5];
    var rk = function (a) {
        this.F = B(a);
    };
    x(rk, H);
    var tk = function (a) {
            var b = new rk();
            return hg(b, 4, sk, a);
        },
        sk = [4, 5, 7, 8, 9];
    var uk = function (a) {
        this.F = B(a);
    };
    x(uk, H);
    var vk = function (a) {
        this.F = B(a);
    };
    x(vk, H);
    var wk = function (a) {
        this.F = B(a);
    };
    x(wk, H);
    var xk = function (a) {
        this.F = B(a);
    };
    x(xk, H);
    xk.prototype.jb = function () {
        return eg(this, vk, 1);
    };
    xk.prototype.getSize = function () {
        return eg(this, wk, 2);
    };
    xk.prototype.getDuration = function () {
        return eg(this, uk, 3);
    };
    var yk = function (a) {
        this.F = B(a);
    };
    x(yk, H);
    var zk = function (a) {
        this.F = B(a);
    };
    x(zk, H);
    var Ak = function (a) {
        this.F = B(a);
    };
    x(Ak, H);
    var Bk = function (a) {
        this.F = B(a);
    };
    x(Bk, H);
    Bk.prototype.getEscapedQemQueryId = function () {
        return D(this, 4);
    };
    var Ck = function (a) {
        this.F = B(a);
    };
    x(Ck, H);
    var Dk = function (a) {
        this.F = B(a);
    };
    x(Dk, H);
    Dk.prototype.getEscapedQemQueryId = function () {
        return D(this, 2);
    };
    var Fk = function (a) {
            this.g = a;
            this.nh = new Ek(this.g);
        },
        Ek = function (a) {
            this.g = a;
            this.rh = new Gk(this.g);
        },
        Gk = function (a) {
            this.g = a;
            this.cg = new Hk(this.g);
        },
        Hk = function (a) {
            this.g = a;
        },
        Ik = function (a, b) {
            a = a.g;
            var c = a.I;
            var d = new Uj();
            d = Vf(d, 1, ye("SOomke"), "");
            var e = new Qj();
            e = Yf(e, 1, Rj, ye(b.rd));
            d = lg(d, 4, Qj, e);
            e = new Qj();
            e = Yf(e, 1, Rj, ye(b.status));
            d = lg(d, 4, Qj, e);
            e = new Sj();
            b = Yf(e, 2, Tj, re(Math.round(b.he)));
            b = C(d, 3, b);
            c.call(a, b);
        },
        Jk = function () {
            Pj.apply(this, arguments);
            this.Pg = new Fk(this);
        };
    x(Jk, Pj);
    var Kk = function () {
        Jk.apply(this, arguments);
    };
    x(Kk, Jk);
    Kk.prototype.fd = function () {
        this.B.apply(
            this,
            la(
                Ma.apply(0, arguments).map(function (a) {
                    return { Md: !0, nf: 4, Pe: Hg(a) };
                })
            )
        );
    };
    Kk.prototype.I = function () {
        this.B.apply(
            this,
            la(
                Ma.apply(0, arguments).map(function (a) {
                    return { Md: !1, nf: 1, Pe: Hg(a) };
                })
            )
        );
    };
    var Lk = function (a, b) {
        if (globalThis.fetch) globalThis.fetch(a, { method: "POST", body: b, keepalive: b.length < 65536, credentials: "omit", mode: "no-cors", redirect: "follow" }).catch(function () {});
        else {
            var c = new XMLHttpRequest();
            c.open("POST", a, !0);
            c.send(b);
        }
    };
    var Mk = function (a, b, c, d, e, f, g, h) {
        Kk.call(this, a, b);
        this.D = c;
        this.L = d;
        this.G = e;
        this.C = f;
        this.J = g;
        this.o = h;
        this.g = [];
        this.j = null;
        this.A = !1;
    };
    x(Mk, Kk);
    var Nk = function (a) {
        a.j !== null && (clearTimeout(a.j), (a.j = null));
        if (a.g.length) {
            var b = Nj(a.g, a.l);
            a.L(a.D + "?e=1", b);
            a.g = [];
        }
    };
    Mk.prototype.B = function () {
        var a = Ma.apply(0, arguments),
            b = this;
        try {
            this.J && Nj(this.g.concat(a), this.l).length >= 65536 && Nk(this),
                this.o &&
                    !this.A &&
                    ((this.A = !0),
                    this.o.g(function () {
                        Nk(b);
                    })),
                this.g.push.apply(this.g, la(a)),
                this.g.length >= this.C && Nk(this),
                this.g.length &&
                    this.j === null &&
                    (this.j = setTimeout(function () {
                        Nk(b);
                    }, this.G));
        } catch (c) {
            Oj(c, this.l);
        }
    };
    var Ok = function (a, b, c, d, e, f) {
        Mk.call(this, a, b, "https://pagead2.googlesyndication.com/pagead/ping", Lk, c === void 0 ? 1e3 : c, d === void 0 ? 100 : d, (e === void 0 ? !1 : e) && !!globalThis.fetch, f);
    };
    x(Ok, Mk);
    var I = function (a, b, c, d) {
        this.top = a;
        this.right = b;
        this.bottom = c;
        this.left = d;
    };
    I.prototype.getWidth = function () {
        return this.right - this.left;
    };
    I.prototype.getHeight = function () {
        return this.bottom - this.top;
    };
    var Pk = function (a) {
        return new I(a.top, a.right, a.bottom, a.left);
    };
    l = I.prototype;
    l.contains = function (a) {
        return this && a ? (a instanceof I ? a.left >= this.left && a.right <= this.right && a.top >= this.top && a.bottom <= this.bottom : a.x >= this.left && a.x <= this.right && a.y >= this.top && a.y <= this.bottom) : !1;
    };
    l.expand = function (a, b, c, d) {
        Ya(a) ? ((this.top -= a.top), (this.right += a.right), (this.bottom += a.bottom), (this.left -= a.left)) : ((this.top -= a), (this.right += Number(b)), (this.bottom += Number(c)), (this.left -= Number(d)));
        return this;
    };
    l.ceil = function () {
        this.top = Math.ceil(this.top);
        this.right = Math.ceil(this.right);
        this.bottom = Math.ceil(this.bottom);
        this.left = Math.ceil(this.left);
        return this;
    };
    l.floor = function () {
        this.top = Math.floor(this.top);
        this.right = Math.floor(this.right);
        this.bottom = Math.floor(this.bottom);
        this.left = Math.floor(this.left);
        return this;
    };
    l.round = function () {
        this.top = Math.round(this.top);
        this.right = Math.round(this.right);
        this.bottom = Math.round(this.bottom);
        this.left = Math.round(this.left);
        return this;
    };
    var Qk = function (a, b, c) {
        b instanceof qi ? ((a.left += b.x), (a.right += b.x), (a.top += b.y), (a.bottom += b.y)) : ((a.left += b), (a.right += b), typeof c === "number" && ((a.top += c), (a.bottom += c)));
        return a;
    };
    I.prototype.scale = function (a, b) {
        b = typeof b === "number" ? b : a;
        this.left *= a;
        this.right *= a;
        this.top *= b;
        this.bottom *= b;
        return this;
    };
    var Rk = function (a, b, c, d) {
            this.left = a;
            this.top = b;
            this.width = c;
            this.height = d;
        },
        Sk = function (a) {
            return new I(a.top, a.left + a.width, a.top + a.height, a.left);
        };
    l = Rk.prototype;
    l.contains = function (a) {
        return a instanceof qi
            ? a.x >= this.left && a.x <= this.left + this.width && a.y >= this.top && a.y <= this.top + this.height
            : this.left <= a.left && this.left + this.width >= a.left + a.width && this.top <= a.top && this.top + this.height >= a.top + a.height;
    };
    l.getSize = function () {
        return new ri(this.width, this.height);
    };
    l.ceil = function () {
        this.left = Math.ceil(this.left);
        this.top = Math.ceil(this.top);
        this.width = Math.ceil(this.width);
        this.height = Math.ceil(this.height);
        return this;
    };
    l.floor = function () {
        this.left = Math.floor(this.left);
        this.top = Math.floor(this.top);
        this.width = Math.floor(this.width);
        this.height = Math.floor(this.height);
        return this;
    };
    l.round = function () {
        this.left = Math.round(this.left);
        this.top = Math.round(this.top);
        this.width = Math.round(this.width);
        this.height = Math.round(this.height);
        return this;
    };
    l.scale = function (a, b) {
        b = typeof b === "number" ? b : a;
        this.left *= a;
        this.width *= a;
        this.top *= b;
        this.height *= b;
        return this;
    };
    function Tk(a) {
        a = a === void 0 ? y : a;
        var b = a.context || a.AMP_CONTEXT_DATA;
        if (!b)
            try {
                b = a.parent.context || a.parent.AMP_CONTEXT_DATA;
            } catch (e) {}
        var c, d;
        return ((c = b) == null ? 0 : c.pageViewId) && ((d = b) == null ? 0 : d.canonicalUrl) ? b : null;
    }
    var Uk = function () {
            this.S = {};
        },
        Vk = function () {
            var a = Tk(window);
            if (a) {
                if (a) {
                    var b = a.pageViewId;
                    a = a.clientId;
                    typeof a === "string" && (b += a.replace(/\D/g, "").substr(0, 6));
                } else b = null;
                return +b;
            }
            b = Ij(window);
            a = b.google_global_correlator;
            a || (b.google_global_correlator = a = 1 + Math.floor(Math.random() * 8796093022208));
            return a;
        },
        Xk = function (a, b) {
            var c = Wk[7] || "google_ps_7";
            a = a.S;
            var d = a[c];
            return d === void 0 ? ((a[c] = b()), a[c]) : d;
        },
        Yk = function (a) {
            var b = Vk();
            return Xk(a, function () {
                return b;
            });
        },
        il = function () {
            if (hl) var a = hl;
            else {
                a = ((a = a === void 0 ? Tk() : a) ? (sj(a.master) ? a.master : null) : null) || window;
                var b = a.google_persistent_state_async;
                a = b != null && typeof b == "object" && b.S != null && typeof b.S == "object" ? (hl = b) : (a.google_persistent_state_async = hl = new Uk());
            }
            return Yk(a);
        },
        hl = null,
        jl = {},
        Wk = ((jl[8] = "google_prev_ad_formats_by_region"), (jl[9] = "google_prev_ad_slotnames_by_region"), jl);
    var kl = ka(["https://pagead2.googlesyndication.com/pagead/js/err_rep.js"]),
        ll = function () {
            var a = a === void 0 ? "jserror" : a;
            var b = b === void 0 ? 0.01 : b;
            var c = c === void 0 ? oi(kl) : c;
            this.j = a;
            this.l = !1;
            this.g = null;
            this.o = !1;
            this.C = Math.random();
            this.A = b;
            this.B = this.Wa;
            this.J = c;
        };
    l = ll.prototype;
    l.ee = function (a) {
        this.j = a;
    };
    l.gd = function (a) {
        this.g = a;
    };
    l.fe = function (a) {
        this.l = a;
    };
    l.ge = function (a) {
        this.o = a;
    };
    l.Wa = function (a, b, c, d, e) {
        c = c === void 0 ? this.A : c;
        e = e === void 0 ? this.j : e;
        if ((this.o ? this.C : Math.random()) > c) return this.l;
        Jh(b) || (b = new Ih(b, { context: a, id: e }));
        if (d || this.g) (b.meta = {}), this.g && this.g(b.meta), d && d(b.meta);
        y.google_js_errors = y.google_js_errors || [];
        y.google_js_errors.push(b);
        y.error_rep_loaded || ((b = y.document), (a = Hj("SCRIPT", b)), Ki(a, this.J), (b = b.getElementsByTagName("script")[0]) && b.parentNode && b.parentNode.insertBefore(a, b), (y.error_rep_loaded = !0));
        return this.l;
    };
    l.zb = function (a, b, c) {
        try {
            return b();
        } catch (d) {
            if (!this.B(a, d, this.A, c, this.j)) throw d;
        }
    };
    l.Xd = function (a, b, c, d) {
        var e = this;
        return function () {
            var f = Ma.apply(0, arguments);
            return e.zb(
                a,
                function () {
                    return b.apply(c, f);
                },
                d
            );
        };
    };
    var ml = function (a) {
            return a.prerendering ? 3 : { visible: 1, hidden: 2, prerender: 3, preview: 4, unloaded: 5 }[a.visibilityState || a.webkitVisibilityState || a.mozVisibilityState || ""] || 0;
        },
        nl = function (a) {
            var b;
            a.visibilityState ? (b = "visibilitychange") : a.mozVisibilityState ? (b = "mozvisibilitychange") : a.webkitVisibilityState && (b = "webkitvisibilitychange");
            return b;
        };
    var ol = null,
        pl = function () {
            if (ol === null) {
                ol = "";
                try {
                    var a = "";
                    try {
                        a = y.top.location.hash;
                    } catch (c) {
                        a = y.location.hash;
                    }
                    if (a) {
                        var b = a.match(/\bdeid=([\d,]+)/);
                        ol = b ? b[1] : "";
                    }
                } catch (c) {}
            }
            return ol;
        };
    function ql() {
        var a = a === void 0 ? y : a;
        return (a = a.performance) && a.now && a.timing ? Math.floor(a.now() + a.timing.navigationStart) : Date.now();
    }
    function rl() {
        var a = a === void 0 ? y : a;
        return (a = a.performance) && a.now ? a.now() : null;
    }
    function sl(a, b) {
        b = b === void 0 ? y : b;
        var c, d;
        return ((c = b.performance) == null ? void 0 : (d = c.timing) == null ? void 0 : d[a]) || 0;
    }
    function tl() {
        var a = a === void 0 ? y : a;
        var b = Math.min(sl("domLoading", a) || Infinity, sl("domInteractive", a) || Infinity);
        return b === Infinity ? Math.max(sl("responseEnd", a), sl("navigationStart", a)) : b;
    }
    var ul = function (a, b, c, d) {
        this.label = a;
        this.type = b;
        this.value = c;
        this.duration = d === void 0 ? 0 : d;
        this.taskId = this.slotId = void 0;
        this.uniqueId = Math.random();
    };
    var vl = y.performance,
        wl = !!(vl && vl.mark && vl.measure && vl.clearMarks),
        xl = Lh(function () {
            var a;
            if ((a = wl)) (a = pl()), (a = !!a.indexOf && a.indexOf("1337") >= 0);
            return a;
        }),
        yl = function (a, b) {
            this.events = [];
            this.g = b || y;
            var c = null;
            b && ((b.google_js_reporting_queue = b.google_js_reporting_queue || []), (this.events = b.google_js_reporting_queue), (c = b.google_measure_js_timing));
            this.l = xl() || (c != null ? c : Math.random() < a);
        };
    yl.prototype.B = function () {
        this.l = !1;
        this.events != this.g.google_js_reporting_queue && (xl() && Tb(this.events, zl), (this.events.length = 0));
    };
    yl.prototype.C = function (a) {
        !this.l || this.events.length > 2048 || this.events.push(a);
    };
    var zl = function (a) {
        a && vl && xl() && (vl.clearMarks("goog_" + a.label + "_" + a.uniqueId + "_start"), vl.clearMarks("goog_" + a.label + "_" + a.uniqueId + "_end"));
    };
    yl.prototype.start = function (a, b) {
        if (!this.l) return null;
        a = new ul(a, b, rl() || ql());
        b = "goog_" + a.label + "_" + a.uniqueId + "_start";
        vl && xl() && vl.mark(b);
        return a;
    };
    yl.prototype.end = function (a) {
        if (this.l && typeof a.value === "number") {
            a.duration = (rl() || ql()) - a.value;
            var b = "goog_" + a.label + "_" + a.uniqueId + "_end";
            vl && xl() && vl.mark(b);
            this.C(a);
        }
    };
    var Al = function (a) {
        a = a._google_rum_ns_ = a._google_rum_ns_ || {};
        return (a.pq = a.pq || []);
    };
    function Bl(a) {
        a = a === null ? "null" : a === void 0 ? "undefined" : a;
        var b = Vh();
        return new li(b ? b.createHTML(a) : a);
    }
    function Cl(a, b, c) {
        yj(b, function (d, e) {
            var f = c && c[e];
            (!d && d !== 0) || f || ((a += "&" + encodeURIComponent(e) + "=" + encodeURIComponent(String(d))), c && (c[e] = !0));
        });
        return a;
    }
    var Il = function (a, b, c, d, e, f, g, h) {
        f = f === void 0 ? Infinity : f;
        g = g === void 0 ? !1 : g;
        yl.call(this, a, h);
        var k = this;
        this.V = b;
        this.domain = c;
        this.path = d;
        this.Z = e;
        this.J = 0;
        this.A = {};
        this.G = {};
        this.W = [];
        this.report = {};
        this.j = 0;
        this.D = [];
        this.I = f;
        a = this.g.navigator;
        this.U = !(this.domain !== "csi.gstatic.com" || !a || !a.sendBeacon);
        (this.g.performance && this.g.performance.now) || Dl(this, "dat", 1);
        a && a.deviceMemory && Dl(this, "dmc", a.deviceMemory);
        this.g === this.g.top && Dl(this, "top", 1);
        this.P = !g;
        this.K = function () {
            k.g.setTimeout(function () {
                El(k);
            }, 1100);
        };
        this.M = function () {
            Dl(k, "uet", 2);
            for (var n = w(k.W), p = n.next(); !p.done; p = n.next()) {
                p = p.value;
                try {
                    p();
                } catch (t) {}
            }
            n = k.g;
            var q = q === void 0 ? {} : q;
            typeof window.CustomEvent === "function" ? (p = new CustomEvent("rum_blp", q)) : ((p = document.createEvent("CustomEvent")), p.initCustomEvent("rum_blp", !!q.bubbles, !!q.cancelable, q.detail));
            n.dispatchEvent(p);
            El(k);
            k.A.uet != null && ((k.o -= 3 + k.A.uet.length + 2), delete k.A.uet);
        };
        this.aa = Nh(function () {
            El(k);
        });
        this.fa = function () {
            var n = k.g.document;
            (n.hidden != null ? n.hidden : n.mozHidden != null ? n.mozHidden : n.webkitHidden != null && n.webkitHidden) && k.aa();
        };
        this.L = this.g.setTimeout(function () {
            El(k);
        }, 5e3);
        this.o = b.length + c.length + d.length + e.length + 3;
        Tb(this.events, function (n) {
            Fl(k, n);
        });
        b = Al(this.g);
        var m = function () {
            var n = Ma.apply(0, arguments)[0],
                p = n[0];
            n = n[1];
            var q = p.length + n.length + 2;
            k.o + k.j + q > 8e3 && El(k);
            k.D.push([p, n]);
            k.j += q;
            Gl(k);
            return 0;
        };
        Tb(b, function (n) {
            return m(n);
        });
        b.length = 0;
        b.push = m;
        Dl(this, "puid", (this.J + 1).toString(36) + "~" + Date.now().toString(36));
        Hl(this);
    };
    x(Il, yl);
    var Hl = function (a) {
            a.g.document.readyState === "complete"
                ? a.g.setTimeout(function () {
                      El(a);
                  }, 0)
                : Qh(a.g, "load", a.K);
            var b = nl(a.g.document);
            typeof b !== "undefined" && Qh(a.g, b, a.fa);
            Qh(a.g, "pagehide", a.M);
        },
        Dl = function (a, b, c) {
            c = String(c);
            a.o = a.A[b] != null ? a.o + (c.length - a.A[b].length) : a.o + (b.length + c.length + 2);
            a.A[b] = c;
        },
        Ll = function (a, b, c, d, e) {
            e = e === void 0 ? "" : e;
            var f = Jl(a, b, c, d, e);
            a.o + a.j + f > 8e3 && (El(a), (f = b.length + c.length + 2));
            Kl(a, b, c, d, e);
            a.j += f;
            Gl(a);
        },
        Jl = function (a, b, c, d, e) {
            return a.report[b] == null ? b.length + c.length + 2 : d ? c.length + (e === void 0 ? "" : e).length : c.length - a.report[b].length;
        },
        Kl = function (a, b, c, d, e) {
            a.report[b] = d && a.report[b] != null ? a.report[b] + ("" + (e === void 0 ? "" : e) + c) : c;
        },
        Gl = function (a) {
            a.o + a.j >= 6e3 && El(a);
        },
        El = function (a) {
            if (a.l && a.P) {
                try {
                    a.j && (a.sendBeacon(a.report), a.J === a.I && a.B());
                } catch (b) {
                    new ll().Wa(358, b);
                }
                a.report = {};
                a.j = 0;
                a.events.length = 0;
                a.g.clearTimeout(a.L);
                a.L = 0;
            }
        },
        Ml = function (a, b) {
            var c = a.V + "//" + a.domain + a.path + a.Z,
                d = {};
            c = Cl(c, a.A, d);
            c = Cl(c, b, d);
            b = a.g;
            b.google_timing_params && ((c = Cl(c, b.google_timing_params, d)), (b.google_timing_params = void 0));
            Tb(a.D, function (e) {
                var f = w(e);
                e = f.next().value;
                f = f.next().value;
                var g = {};
                c = Cl(c, ((g[e] = f), g));
            });
            a.D.length = 0;
            return c;
        };
    Il.prototype.sendBeacon = function (a) {
        this.J++;
        a = Ml(this, a);
        var b = !1;
        try {
            b = !!(this.U && this.g.navigator && this.g.navigator.sendBeacon(a, null));
        } catch (c) {
            this.U = !1;
        }
        b || Kj(this.g, a);
        Dl(this, "puid", (this.J + 1).toString(36) + "~" + Date.now().toString(36));
    };
    var Fl = function (a, b) {
        var c = "met." + b.type,
            d = typeof b.value === "number" ? Math.round(b.value).toString(36) : b.value,
            e = Math.round(b.duration);
        b = "" + b.label + (b.slotId != null ? "_" + b.slotId : "") + ("." + d) + (e > 0 ? "_" + e.toString(36) : "") + (b.taskId != null ? "__" + Math.round(b.taskId).toString(36) : "");
        Ll(a, c, b, !0, "~");
    };
    Il.prototype.C = function (a) {
        this.l && this.J < this.I && (yl.prototype.C.call(this, a), Fl(this, a));
    };
    Il.prototype.B = function () {
        yl.prototype.B.call(this);
        this.g.clearTimeout(this.L);
        this.j = this.L = 0;
        this.report = {};
        Fi(this.G);
        Fi(this.A);
        Rh(this.g, "load", this.K);
        Rh(this.g, "pagehide", this.M);
    };
    var J = function (a) {
        var b = "wb";
        if (a.wb && a.hasOwnProperty(b)) return a.wb;
        b = new a();
        return (a.wb = b);
    };
    var K = function () {
            this.g = new Il(1, "https:", "csi.gstatic.com", "/csi?v=2&s=", "ima", void 0, !0);
            var a = il();
            a != null && Dl(this.g, "c", a);
            a = parseInt(this.g.A.c, 10) / 2;
            a != null && Dl(this.g, "slotId", a);
        },
        L = function (a, b, c) {
            if (c != null) {
                a = a.g;
                var d = b + "=" + c;
                a.G[d] || (Ll(a, b, c, !1), d.length < 1e3 && (a.G[d] = !0));
            }
        },
        Nl = function (a, b) {
            for (var c in b) b[c] = typeof b[c] === "object" ? encodeURIComponent(JSON.stringify(b[c])) : encodeURIComponent(String(b[c]));
            a = a.g;
            var d = !1;
            c = 0;
            for (var e = w(Object.keys(b)), f = e.next(); !f.done; f = e.next()) (f = f.value), a.report[f] != null && (d = !0), (c += Jl(a, f, b[f], !1));
            (a.o + a.j + c > 8e3 || d) && El(a);
            d = w(Object.keys(b));
            for (e = d.next(); !e.done; e = d.next()) (e = e.value), Kl(a, e, b[e], !1);
            a.j += c;
            Gl(a);
        },
        Ol = function (a) {
            var b = K.getInstance().g;
            b.l && b.C(new ul(a, 4, ql() - 0, 0));
        };
    K.prototype.recordClick = function (a, b, c, d) {
        for (var e = !1, f = "notag"; d != void 0 && d != document.documentElement; ) {
            var g = void 0,
                h = void 0;
            if (((g = d) == null ? 0 : g.getAttribute("data-ck-navigates")) || ((h = d) == null ? 0 : h.getAttribute("data-ck-tag"))) {
                g = f = void 0;
                e = (g = (f = d) == null ? void 0 : f.getAttribute("data-ck-navigates")) != null ? g : !1;
                h = g = void 0;
                f = (h = (g = d) == null ? void 0 : g.getAttribute("data-ck-tag")) != null ? h : "notag";
                break;
            }
            g = void 0;
            d = (g = d.parentElement) != null ? g : void 0;
        }
        d = this.g;
        d.l && d.C(new ul(a + "_" + b + "x" + c + "|" + e + "|" + f, 4, ql(), 0));
    };
    K.getInstance = function () {
        return J(K);
    };
    var Pl = function (a) {
            return /^\s*$/.test(a)
                ? !1
                : /^[\],:{}\s\u2028\u2029]*$/.test(
                      a
                          .replace(/\\["\\\/bfnrtu]/g, "@")
                          .replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g, "]")
                          .replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g, "")
                  );
        },
        Ql = function (a) {
            try {
                return y.JSON.parse(a);
            } catch (b) {}
            a = String(a);
            if (Pl(a))
                try {
                    return eval("(" + a + ")");
                } catch (b) {}
            throw Error("Invalid JSON string: " + a);
        },
        Sl = function () {
            this.g = Rl;
        },
        Tl = function (a, b, c) {
            if (b == null) c.push("null");
            else {
                if (typeof b == "object") {
                    if (Array.isArray(b)) {
                        var d = b;
                        b = d.length;
                        c.push("[");
                        for (var e = "", f = 0; f < b; f++) c.push(e), (e = d[f]), Tl(a, a.g ? a.g.call(d, String(f), e) : e, c), (e = ",");
                        c.push("]");
                        return;
                    }
                    if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                    else {
                        c.push("{");
                        f = "";
                        for (d in b) Object.prototype.hasOwnProperty.call(b, d) && ((e = b[d]), typeof e != "function" && (c.push(f), Ul(d, c), c.push(":"), Tl(a, a.g ? a.g.call(b, d, e) : e, c), (f = ",")));
                        c.push("}");
                        return;
                    }
                }
                switch (typeof b) {
                    case "string":
                        Ul(b, c);
                        break;
                    case "number":
                        c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                        break;
                    case "boolean":
                        c.push(String(b));
                        break;
                    case "function":
                        c.push("null");
                        break;
                    default:
                        throw Error("Unknown type: " + typeof b);
                }
            }
        },
        Vl = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\v": "\\u000b" },
        Wl = /\uffff/.test("\uffff") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g,
        Ul = function (a, b) {
            b.push(
                '"',
                a.replace(Wl, function (c) {
                    var d = Vl[c];
                    d || ((d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).slice(1)), (Vl[c] = d));
                    return d;
                }),
                '"'
            );
        };
    var Xl = function () {
            this.l = null;
            this.g = "missing-id";
            this.j = !1;
        },
        Zl = function (a) {
            var b = null;
            try {
                b = document.getElementsByClassName("lima-exp-data");
            } catch (c) {
                return Yl("missing-element", a.g), null;
            }
            if (b.length > 1) return Yl("multiple-elements", a.g), null;
            b = b[0];
            return b ? b.innerHTML : (Yl("missing-element", a.g), null);
        },
        am = function () {
            var a = $l,
                b = Zl(a);
            if (b !== null)
                if (Pl(b)) {
                    var c = JSON.parse(b);
                    b = c.experimentIds;
                    var d = c.binaryIdentifier;
                    c = c.adEventId;
                    var e = typeof d === "string";
                    if (typeof c == "string") {
                        var f = K.getInstance();
                        c != null && Dl(f.g, "qqid", c);
                    }
                    e && (a.g = d);
                    typeof b !== "string" ? Yl("missing-flags", a.g) : (e || Yl("missing-binary-id", a.g), (a.l = b));
                } else Yl("invalid-json", a.g);
        };
    Xl.prototype.reset = function () {
        this.l = null;
        this.g = "missing-id";
    };
    var bm = function (a) {
        this.g = a || { cookie: "" };
    };
    l = bm.prototype;
    l.set = function (a, b, c) {
        var d = !1;
        if (typeof c === "object") {
            var e = c.ff;
            d = c.ed || !1;
            var f = c.domain || void 0;
            var g = c.path || void 0;
            var h = c.Qc;
        }
        if (/[;=\s]/.test(a)) throw Error('Invalid cookie name "' + a + '"');
        if (/[;\r\n]/.test(b)) throw Error('Invalid cookie value "' + b + '"');
        h === void 0 && (h = -1);
        this.g.cookie =
            a +
            "=" +
            b +
            (f ? ";domain=" + f : "") +
            (g ? ";path=" + g : "") +
            (h < 0 ? "" : h == 0 ? ";expires=" + new Date(1970, 1, 1).toUTCString() : ";expires=" + new Date(Date.now() + h * 1e3).toUTCString()) +
            (d ? ";secure" : "") +
            (e != null ? ";samesite=" + e : "");
    };
    l.get = function (a, b) {
        for (var c = a + "=", d = (this.g.cookie || "").split(";"), e = 0, f; e < d.length; e++) {
            f = xb(d[e]);
            if (f.lastIndexOf(c, 0) == 0) return f.slice(c.length);
            if (f == a) return "";
        }
        return b;
    };
    l.remove = function (a, b, c) {
        var d = this.get(a) !== void 0;
        this.set(a, "", { Qc: 0, path: b, domain: c });
        return d;
    };
    l.Hc = function () {
        return cm(this).keys;
    };
    l.Gb = function () {
        return cm(this).values;
    };
    l.isEmpty = function () {
        return !this.g.cookie;
    };
    l.clear = function () {
        for (var a = cm(this).keys, b = a.length - 1; b >= 0; b--) this.remove(a[b]);
    };
    var cm = function (a) {
        a = (a.g.cookie || "").split(";");
        for (var b = [], c = [], d, e, f = 0; f < a.length; f++) (e = xb(a[f])), (d = e.indexOf("=")), d == -1 ? (b.push(""), c.push(e)) : (b.push(e.substring(0, d)), c.push(e.substring(d + 1)));
        return { keys: b, values: c };
    };
    function dm(a, b, c) {
        return pg(b, 5) ? em(a, c) : null;
    }
    var fm;
    function gm(a) {
        return fm ? fm : a.origin === "null" ? (fm = !1) : (fm = hm(a));
    }
    function hm(a) {
        if (!a.navigator.cookieEnabled) return !1;
        var b = new bm(a.document);
        if (!b.isEmpty()) return !0;
        b.set("TESTCOOKIESENABLED", "1", { Qc: 60, ff: a.isSecureContext ? "none" : void 0, ed: a.isSecureContext || void 0 });
        if (b.get("TESTCOOKIESENABLED") !== "1") return !1;
        b.remove("TESTCOOKIESENABLED");
        return !0;
    }
    function em(a, b) {
        b = b.origin !== "null" ? b.document.cookie : null;
        return b === null ? null : new bm({ cookie: b }).get(a) || "";
    }
    function im(a, b, c, d) {
        d.origin !== "null" && (d.isSecureContext && (c = Object.assign({}, c, { ff: "none", ed: !0 })), new bm(d.document).set(a, b, c));
    }
    function jm(a, b) {
        var c = gg(a, mk, 2, Jf());
        if (!c.length) return km(a, b);
        a = F(a, 1);
        if (a === 1) {
            var d = jm(c[0], b);
            return d.success ? { success: !0, value: !d.value } : d;
        }
        c = Wb(c, function (h) {
            return jm(h, b);
        });
        switch (a) {
            case 2:
                var e;
                return (e =
                    (d = c.find(function (h) {
                        return h.success && !h.value;
                    })) != null
                        ? d
                        : c.find(function (h) {
                              return !h.success;
                          })) != null
                    ? e
                    : { success: !0, value: !0 };
            case 3:
                var f, g;
                return (g =
                    (f = c.find(function (h) {
                        return h.success && h.value;
                    })) != null
                        ? f
                        : c.find(function (h) {
                              return !h.success;
                          })) != null
                    ? g
                    : { success: !0, value: !1 };
            default:
                return { success: !1, Ca: 3 };
        }
    }
    function km(a, b) {
        var c = Zf(a, nk);
        a: {
            switch (c) {
                case 3:
                    var d = yg(a, 3, nk);
                    break a;
                case 4:
                    d = yg(a, 4, nk);
                    break a;
                case 5:
                    d = yg(a, 5, nk);
                    break a;
            }
            d = void 0;
        }
        if (!d) return { success: !1, Ca: 2 };
        b = (b = b[c]) && b[d];
        if (!b) return { success: !1, Kb: d, hc: c, Ca: 1 };
        try {
            var e = b.apply;
            var f = wg(a, 8, Jf());
            var g = e.call(b, null, la(f));
        } catch (h) {
            return { success: !1, Kb: d, hc: c, Ca: 2 };
        }
        e = F(a, 1);
        if (e === 4) return { success: !0, value: !!g };
        if (e === 5) return { success: !0, value: g != null };
        if (e === 12) a = D(a, $f(a, ok, 7));
        else
            a: {
                switch (c) {
                    case 4:
                        a = tg(a, $f(a, ok, 6));
                        break a;
                    case 5:
                        a = D(a, $f(a, ok, 7));
                        break a;
                }
                a = void 0;
            }
        if (a == null) return { success: !1, Kb: d, hc: c, Ca: 3 };
        if (e === 6) return { success: !0, value: g === a };
        if (e === 9) return { success: !0, value: g != null && Cb(String(g), a) === 0 };
        if (g == null) return { success: !1, Kb: d, hc: c, Ca: 4 };
        switch (e) {
            case 7:
                c = g < a;
                break;
            case 8:
                c = g > a;
                break;
            case 12:
                c = Fd(a) && Fd(g) && new RegExp(a).test(g);
                break;
            case 10:
                c = g != null && Cb(String(g), a) === -1;
                break;
            case 11:
                c = g != null && Cb(String(g), a) === 1;
                break;
            default:
                return { success: !1, Ca: 3 };
        }
        return { success: !0, value: c };
    }
    function lm(a, b) {
        return a ? (b ? jm(a, b) : { success: !1, Ca: 1 }) : { success: !0, value: !0 };
    }
    var ag = function (a) {
        this.F = B(a);
    };
    x(ag, H);
    var mm = function (a) {
        this.F = B(a);
    };
    x(mm, H);
    mm.prototype.getValue = function () {
        return eg(this, ag, 2);
    };
    var nm = function (a) {
        this.F = B(a);
    };
    x(nm, H);
    var om = Gh(nm),
        pm = [1, 2, 3, 6, 7, 8];
    var qm = function (a, b, c) {
            var d = d === void 0 ? new Ok(6, "unknown", b) : d;
            this.o = a;
            this.A = c;
            this.j = d;
            this.g = [];
            this.l = a > 0 && xj() < 1 / a;
        },
        sm = function (a, b, c, d, e, f) {
            if (a.l) {
                var g = Yj(Xj(new Wj(), b), c);
                b = gk(dk(ck(fk(ek(new bk(), d), e), g), a.g.slice()), f);
                b = tk(b);
                a.j.fd(rm(a, b));
                if (
                    f === 1 ||
                    f === 3 ||
                    (f === 4 &&
                        !a.g.some(function (h) {
                            return F(h, 1) === F(g, 1) && F(h, 2) === c;
                        }))
                )
                    a.g.push(g), a.g.length > 100 && a.g.shift();
            }
        },
        tm = function (a, b, c, d) {
            if (a.l) {
                var e = new Vj();
                b = Bg(e, 1, b);
                c = Bg(b, 2, c);
                d = Fg(c, 3, d);
                c = new rk();
                d = hg(c, 8, sk, d);
                a.j.fd(rm(a, d));
            }
        },
        um = function (a, b, c, d, e) {
            if (a.l) {
                var f = new pk();
                b = C(f, 1, b);
                c = Fg(b, 2, c);
                d = Bg(c, 3, d);
                if (e.hc === void 0) Yf(d, 4, qk, ge(e.Ca));
                else
                    switch (e.hc) {
                        case 3:
                            c = new kk();
                            c = Yf(c, 2, lk, ge(e.Kb));
                            e = Fg(c, 1, e.Ca);
                            hg(d, 5, qk, e);
                            break;
                        case 4:
                            c = new kk();
                            c = Yf(c, 3, lk, ge(e.Kb));
                            e = Fg(c, 1, e.Ca);
                            hg(d, 5, qk, e);
                            break;
                        case 5:
                            (c = new kk()), (c = Yf(c, 4, lk, ge(e.Kb))), (e = Fg(c, 1, e.Ca)), hg(d, 5, qk, e);
                    }
                e = new rk();
                e = hg(e, 9, sk, d);
                a.j.fd(rm(a, e));
            }
        },
        rm = function (a, b) {
            var c = Date.now();
            c = Number.isFinite(c) ? Math.round(c) : 0;
            b = Dg(b, 1, c);
            c = Gj();
            b = Dg(b, 2, c);
            return Dg(b, 6, a.o);
        };
    var vm = function () {
        var a = {};
        this.Ha = ((a[3] = {}), (a[4] = {}), (a[5] = {}), a);
    };
    var wm = /^true$/.test("false");
    function xm(a, b) {
        switch (b) {
            case 1:
                return yg(a, 1, pm);
            case 2:
                return yg(a, 2, pm);
            case 3:
                return yg(a, 3, pm);
            case 6:
                return yg(a, 6, pm);
            case 8:
                return yg(a, 8, pm);
            default:
                return null;
        }
    }
    function ym(a, b) {
        if (!a) return null;
        switch (b) {
            case 1:
                return pg(a, 1);
            case 7:
                return D(a, 3);
            case 2:
                return tg(a, 2);
            case 3:
                return D(a, 3);
            case 6:
                return wg(a, 4, Jf());
            case 8:
                return wg(a, 4, Jf());
            default:
                return null;
        }
    }
    var zm = Lh(function () {
        if (!wm) return {};
        try {
            var a;
            var b = b === void 0 ? window : b;
            try {
                var c = b.sessionStorage;
            } catch (e) {
                c = null;
            }
            var d = (a = c) == null ? void 0 : a.getItem("GGDFSSK");
            if (d) return JSON.parse(d);
        } catch (e) {}
        return {};
    });
    function Am(a, b, c, d) {
        var e = (d = d === void 0 ? 0 : d),
            f,
            g;
        J(Bm).l[e] = (g = (f = J(Bm).l[e]) == null ? void 0 : f.add(b)) != null ? g : new Set().add(b);
        e = zm();
        if (e[b] != null) return e[b];
        b = Cm(d)[b];
        if (!b) return c;
        b = om(JSON.stringify(b));
        b = Dm(b);
        a = ym(b, a);
        return a != null ? a : c;
    }
    function Dm(a) {
        var b = J(vm).Ha;
        if (b && Zf(a, pm) !== 8) {
            var c = ac(gg(a, mm, 5, Jf()), function (f) {
                f = lm(eg(f, mk, 1), b);
                return f.success && f.value;
            });
            if (c) {
                var d;
                return (d = c.getValue()) != null ? d : null;
            }
        }
        var e;
        return (e = eg(a, ag, 4)) != null ? e : null;
    }
    var Bm = function () {
        this.j = {};
        this.o = [];
        this.l = {};
        this.g = new Map();
    };
    function Em(a, b, c) {
        return !!Am(1, a, b === void 0 ? !1 : b, c);
    }
    function Fm(a, b, c) {
        b = b === void 0 ? 0 : b;
        a = Number(Am(2, a, b, c));
        return isNaN(a) ? b : a;
    }
    function Gm(a, b, c) {
        b = b === void 0 ? "" : b;
        a = Am(3, a, b, c);
        return typeof a === "string" ? a : b;
    }
    function Hm(a, b, c) {
        b = b === void 0 ? [] : b;
        a = Am(6, a, b, c);
        return Array.isArray(a) ? a : b;
    }
    function Im(a, b, c) {
        b = b === void 0 ? [] : b;
        a = Am(8, a, b, c);
        return Array.isArray(a) ? a : b;
    }
    function Cm(a) {
        return J(Bm).j[a] || (J(Bm).j[a] = {});
    }
    function Jm(a, b) {
        var c = Cm(b);
        yj(a, function (d, e) {
            if (c[e]) {
                d = om(JSON.stringify(d));
                var f = $f(d, pm, 8);
                if (he(Ff(d, f)) != null) {
                    var g = om(JSON.stringify(c[e]));
                    f = bg(d);
                    g = wg(dg(g, ag, 4), 4, Jf());
                    jg(f, 4, xe, g, wg);
                }
                c[e] = Hg(d);
            } else c[e] = d;
        });
    }
    function Km(a, b, c, d, e) {
        e = e === void 0 ? !1 : e;
        var f = [],
            g = [];
        b = w(b);
        for (var h = b.next(); !h.done; h = b.next()) {
            h = h.value;
            for (var k = Cm(h), m = w(a), n = m.next(); !n.done; n = m.next()) {
                n = n.value;
                var p = Zf(n, pm),
                    q = xm(n, p);
                if (q) {
                    var t = void 0,
                        u = void 0,
                        v = void 0;
                    var E = (t = (v = J(Bm).g.get(h)) == null ? void 0 : (u = v.get(q)) == null ? void 0 : u.slice(0)) != null ? t : [];
                    a: {
                        t = q;
                        u = p;
                        v = new hk();
                        switch (u) {
                            case 1:
                                Yf(v, 1, ik, ge(t));
                                break;
                            case 2:
                                Yf(v, 2, ik, ge(t));
                                break;
                            case 3:
                                Yf(v, 3, ik, ge(t));
                                break;
                            case 6:
                                Yf(v, 4, ik, ge(t));
                                break;
                            case 8:
                                Yf(v, 6, ik, ge(t));
                                break;
                            default:
                                E = void 0;
                                break a;
                        }
                        Uf(v, 5, E, ie);
                        E = v;
                    }
                    if ((t = E)) (u = void 0), (t = !((u = J(Bm).l[h]) == null || !u.has(q)));
                    t && f.push(E);
                    if (p === 8 && k[q]) (E = om(JSON.stringify(k[q]))), (p = bg(n)), (E = wg(dg(E, ag, 4), 4, Jf())), jg(p, 4, xe, E, wg);
                    else {
                        if ((p = E)) (t = void 0), (p = !((t = J(Bm).g.get(h)) == null || !t.has(q)));
                        p && g.push(E);
                    }
                    e || ((p = q), (E = h), (t = d), (u = J(Bm)), u.g.has(E) || u.g.set(E, new Map()), u.g.get(E).has(p) || u.g.get(E).set(p, []), t && u.g.get(E).get(p).push(t));
                    k[q] = Hg(n);
                }
            }
        }
        if (f.length || g.length) (a = d != null ? d : void 0), c.l && c.A && ((d = new jk()), (f = ig(d, 2, f)), (g = ig(f, 3, g)), a && Cg(g, 1, a), (f = new rk()), (g = hg(f, 7, sk, g)), c.j.fd(rm(c, g)));
    }
    function Lm(a, b) {
        b = Cm(b);
        a = w(a);
        for (var c = a.next(); !c.done; c = a.next()) {
            c = c.value;
            var d = om(JSON.stringify(c)),
                e = Zf(d, pm);
            (d = xm(d, e)) && (b[d] || (b[d] = c));
        }
    }
    function Mm() {
        return Object.keys(J(Bm).j).map(function (a) {
            return Number(a);
        });
    }
    function Nm(a) {
        J(Bm).o.includes(a) || Jm(Cm(4), a);
    }
    function Om(a, b, c) {
        c.hasOwnProperty(a) || Object.defineProperty(c, String(a), { value: b });
    }
    function Pm(a, b, c) {
        return b[a] || c;
    }
    function Qm(a) {
        Om(5, Em, a);
        Om(6, Fm, a);
        Om(7, Gm, a);
        Om(8, Hm, a);
        Om(17, Im, a);
        Om(13, Lm, a);
        Om(15, Nm, a);
    }
    function Rm(a) {
        Om(
            4,
            function (b) {
                J(vm).Ha = b;
            },
            a
        );
        Om(
            9,
            function (b, c) {
                var d = J(vm);
                d.Ha[3][b] == null && (d.Ha[3][b] = c);
            },
            a
        );
        Om(
            10,
            function (b, c) {
                var d = J(vm);
                d.Ha[4][b] == null && (d.Ha[4][b] = c);
            },
            a
        );
        Om(
            11,
            function (b, c) {
                var d = J(vm);
                d.Ha[5][b] == null && (d.Ha[5][b] = c);
            },
            a
        );
        Om(
            14,
            function (b) {
                for (var c = J(vm), d = w([3, 4, 5]), e = d.next(); !e.done; e = d.next()) (e = e.value), Object.assign(c.Ha[e], b[e]);
            },
            a
        );
    }
    function Sm(a) {
        a.hasOwnProperty("init-done") || Object.defineProperty(a, "init-done", { value: !0 });
    }
    var Tm = function () {};
    Tm.prototype.j = function () {};
    Tm.prototype.g = function () {
        return [];
    };
    var Um = function (a, b, c) {
        a.j = function (d, e) {
            Pm(2, b, function () {
                return [];
            })(d, c, e);
        };
        a.g = function () {
            return Pm(3, b, function () {
                return [];
            })(c);
        };
    };
    var Vm = function (a, b, c) {
            this.id = a;
            this.H = b;
            this.j = c;
            this.g = !1;
        },
        Wm = function (a) {
            return a.g || a.j;
        },
        Xm = function () {
            this.g = [];
        },
        Ym = function () {
            this.g = new Map();
            this.j = !1;
            this.o = new Xm();
            this.A = new Vm(0, 0, !1);
            this.l = [this.o];
        },
        M = function (a) {
            var b = Zm;
            if (b.j || b.g.has(a.id) || (a.H == null && a.control == null) || a.gj == 0) return b.A;
            var c = b.o;
            if (a.control != null)
                for (var d = w(b.l), e = d.next(); !e.done; e = d.next()) {
                    if (((e = e.value), e.g.includes(a.control))) {
                        c = e;
                        break;
                    }
                }
            else a.ba != null && (c = a.ba);
            d = 0;
            a.control != null ? (d = a.control.H) : a.H != null && (d = a.H);
            a = new Vm(a.id, d, !!a.jj);
            c.g.push(a);
            b.l.includes(c) || b.l.push(c);
            b.g.set(a.id, a);
            return a;
        },
        $m = function () {
            var a = Zm;
            a = [].concat(la(a.g.keys())).filter(function (c) {
                return Wm(this.g.get(c));
            }, a);
            var b = J(Tm).g();
            return [].concat(la(a), la(b));
        },
        an = function (a) {
            var b = Zm;
            b.j || (a.g(b.l, b.g), (b.j = !0));
        };
    Ym.prototype.reset = function () {
        for (var a = w(this.g), b = a.next(); !b.done; b = a.next()) (b = w(b.value)), b.next(), (b.next().value.g = !1);
        this.j = !1;
    };
    var Zm = new Ym(),
        cn = function () {
            return bn.g
                .filter(function (a) {
                    return Wm(a);
                })
                .map(function (a) {
                    return a.id;
                });
        };
    var dn = function () {};
    dn.prototype.g = function (a) {
        a = w(a);
        for (var b = a.next(); !b.done; b = a.next()) {
            var c = 0,
                d = Math.floor(Math.random() * 1e3);
            b = w(b.value.g);
            for (var e = b.next(); !e.done; e = b.next())
                if (((e = e.value), (c += e.H), d < c)) {
                    e.g = !0;
                    break;
                }
        }
    };
    var en = function (a) {
        this.j = a;
    };
    en.prototype.g = function (a, b) {
        a = w(this.j);
        for (var c = a.next(); !c.done; c = a.next()) if ((c = b.get(c.value))) c.g = !0;
    };
    var fn = function (a, b) {
        this.j = a;
        this.l = b;
    };
    x(fn, en);
    fn.prototype.g = function (a, b) {
        en.prototype.g.call(this, a, b);
        var c = [];
        a = [];
        for (var d = w(this.j), e = d.next(); !e.done; e = d.next()) (e = e.value), b.get(e) ? c.push(e) : a.push(e);
        b = c.map(String).join(",") || "0";
        a = a.map(String).join(",") || "0";
        L(K.getInstance(), "sei", b);
        L(K.getInstance(), "nsei", a);
        L(K.getInstance(), "bi", this.l);
    };
    var gn = function () {
        Xl.apply(this, arguments);
    };
    x(gn, Xl);
    var Yl = function (a, b) {
        var c = K.getInstance();
        L(c, "eee", a);
        L(c, "bi", b);
    };
    gn.getInstance = function () {
        return J(gn);
    };
    function hn() {
        return jn
            .split(",")
            .map(function (a) {
                return parseInt(a, 10);
            })
            .filter(function (a) {
                return !isNaN(a);
            });
    }
    var bn = new Xm(),
        kn = new Xm(),
        ln = new Xm(),
        mn = new Xm(),
        nn = new Xm(),
        on = new Xm(),
        pn = new Xm(),
        qn = new Xm(),
        rn = new Xm();
    M({ id: 95342636, H: 30 });
    M({ id: 95342637, H: 30 });
    M({ id: 318475490, H: 0 });
    M({ id: 324123032, H: 0 });
    M({ id: 420706097, H: 10 });
    M({ id: 420706098, H: 10 });
    M({ id: 95342168, H: 10 });
    M({ id: 95342169, H: 10 });
    M({ id: 21062100, H: 0 });
    M({ id: 420706142, H: 0 });
    M({ id: 44745813, H: 0 });
    M({ id: 44746068, H: 0 });
    M({ id: 21064565, H: 0 });
    M({ id: 21064567, H: 0 });
    M({ id: 418572006, H: 10 });
    M({ id: 95338773, H: 10, ba: mn });
    M({ id: 95338774, H: 10, ba: mn });
    M({ id: 95334214, H: 10 });
    M({ id: 95334215, H: 10 });
    M({ id: 44749839, H: 0 });
    M({ id: 44714743, H: 0 });
    M({ id: 44715336, H: 10 });
    M({ id: 44724516, H: 0 });
    M({ id: 44726389, H: 10 });
    M({ id: 44752711, H: 50 });
    M({ id: 44752052, H: 50 });
    M({ id: 44752657, H: 50 });
    M({ id: 44733246, H: 10 });
    M({ id: 44750823, H: 10, ba: kn });
    M({ id: 44750824, H: 10, ba: kn });
    M({ id: 44794282, H: 10, ba: kn });
    M({ id: 44797013, H: 10, ba: kn });
    M({ id: 44797014, H: 10, ba: kn });
    M({ id: 44750822, H: 10, ba: kn });
    M({ id: 44751889, H: 10 });
    M({ id: 44751890, H: 10 });
    M({ id: 44752995, H: 10 });
    M({ id: 44752996, H: 10 });
    M({ id: 44762627, H: 0 });
    M({ id: 44762628, H: 0 });
    M({ id: 44801479, H: 10, ba: ln });
    M({ id: 44801480, H: 10, ba: ln });
    M({ id: 44752538, H: 0 });
    M({ id: 44754608, H: 10 });
    M({ id: 44754609, H: 10 });
    M({ id: 44776384, H: 0 });
    M({ id: 95322945, H: 10 });
    var sn = M({ id: 95322946, H: 10 });
    M({ id: 44787954, H: 0 });
    M({ id: 44789282, H: 0 });
    M({ id: 44792636, H: 0 });
    M({ id: 44794298, H: 0 });
    M({ id: 44803996, H: 0 });
    M({ id: 44805453, H: 0 });
    M({ id: 44804917, H: 0 });
    M({ id: 95334260, H: 0 });
    var tn = M({ id: 75259416, H: 0 }),
        un = M({ id: 75259420, H: 0 }),
        vn = M({ id: 75259421, H: 0 });
    M({ id: 44785452, H: 10 });
    M({ id: 44785453, H: 10 });
    M({ id: 45401791, H: 0 });
    M({ id: 95326337, H: 990, ba: nn });
    var wn = window.navigator || {},
        xn = wn.cookieDeprecationLabel ? 990 : 0;
    M({ id: 95322906, H: wn.cookieDeprecationLabel ? 10 : 0, ba: on });
    var yn = M({ id: 95320461, H: 0, ba: on }),
        zn = M({ id: 95322907, H: xn, ba: on });
    M({ id: 44807614, H: 10 });
    M({ id: 44807615, H: 10 });
    M({ id: 44809192, H: 10, ba: qn });
    M({ id: 44809193, H: 10, ba: qn });
    M({ id: 95320804, H: 10, ba: qn });
    M({ id: 95320805, H: 10, ba: qn });
    M({ id: 95322027, H: 1e3, ba: pn });
    var An = M({ id: 46130031, H: 0 });
    M({ id: 95328713, H: 10 });
    M({ id: 95328714, H: 10 });
    var Bn = M({ id: 95327848, H: 0 });
    M({ id: 31065644, H: 1 });
    var Cn = M({ id: 31065645, H: 1 }),
        Dn = new Xm();
    M({ id: 95331588, H: 0, ba: Dn });
    M({ id: 95331589, H: 1e3, ba: Dn });
    var En = M({ id: 95332182, H: 0 });
    M({ id: 95342563, H: 0, ba: rn });
    M({ id: 95342564, H: 1e3, ba: rn });
    if (typeof window.initializeVirtualDom === "undefined") {
        var $l = gn.getInstance();
        $l.j || (am(), ($l.j = !0));
        var jn = $l.l,
            Fn;
        $l.j || (am(), ($l.j = !0));
        Fn = $l.g;
        if (jn != null) {
            var Gn = new fn(hn(), Fn);
            an(Gn);
        }
    }
    var Hn = function (a) {
        this.F = B(a);
    };
    x(Hn, H);
    Hn.prototype.getId = function () {
        return qg(this, 1);
    };
    var In = function (a) {
        this.F = B(a);
    };
    x(In, H);
    var Jn = function (a) {
        return gg(a, Hn, 2, Jf());
    };
    var Kn = function (a) {
        this.F = B(a);
    };
    x(Kn, H);
    var Ln = function (a) {
        this.F = B(a);
    };
    x(Ln, H);
    var Mn = function (a) {
        this.F = B(a);
    };
    x(Mn, H);
    var Nn = (function (a) {
        return function (b) {
            b = JSON.parse(b);
            if (!Array.isArray(b)) throw Error("Expected jspb data to be an array, got " + Wa(b) + ": " + b);
            od(b);
            return new a(b);
        };
    })(Mn);
    function On() {
        return qf(
            Nn(
                "[[[45641707,null,null,[1]],[45642592,null,null,[]],[45642676,null,null,[]],[45640378,null,null,[]],[null,45645574,null,[]],[45650866,null,null,[]],[45652001,null,null,[]],[45652000,null,null,[]],[45651995,null,null,[]],[45651993,null,null,[]],[45651997,null,null,[]],[45651996,null,null,[]],[45647593,null,null,[]],[45647592,null,null,[]],[45650216,null,null,[]]],[[16,[[1000,[[95332046]]],[null,[[95332047]]],[10,[[95333808],[95333809,[[635466687,null,null,[1]]]]]],[10,[[95336351],[95336352,[[45640378,null,null,[1]]]]]],[null,[[95337286],[95337287,[[45642676,null,null,[1]]]]]],[50,[[95337288],[95337289,[[45642592,null,null,[1]]]]]],[10,[[95338769,[[null,45645574,null,[null,1]]]],[95338770,[[null,45645574,null,[null,2]]]]]],[10,[[95339943,[[45647593,null,null,[1]]]],[95339944,[[45647592,null,null,[1]]]]]],[50,[[95340921],[95340922,[[45650090,null,null,[1]]]]]],[10,[[95341047],[95341048,[[45650216,null,null,[1]]]]]],[10,[[95341383],[95341384,[[45650866,null,null,[1]]]]]]]]],null,null,[null,1000,1,1000]]"
            )
        );
    }
    var Pn = [
        "A9AxgGSwmnfgzzkyJHILUr3H8nJ/3D+57oAsL4DBt4USlng4jZ0weq+fZtHC/Qwwn6gd4QSa5DzT3OBif+kXVA0AAAB4eyJvcmlnaW4iOiJodHRwczovL2ltYXNkay5nb29nbGVhcGlzLmNvbTo0NDMiLCJmZWF0dXJlIjoiUHJpdmFjeVNhbmRib3hBZHNBUElzIiwiZXhwaXJ5IjoxNjk1MTY3OTk5LCJpc1RoaXJkUGFydHkiOnRydWV9",
        "AlK2UR5SkAlj8jjdEc9p3F3xuFYlF6LYjAML3EOqw1g26eCwWPjdmecULvBH5MVPoqKYrOfPhYVL71xAXI1IBQoAAAB8eyJvcmlnaW4iOiJodHRwczovL2RvdWJsZWNsaWNrLm5ldDo0NDMiLCJmZWF0dXJlIjoiV2ViVmlld1hSZXF1ZXN0ZWRXaXRoRGVwcmVjYXRpb24iLCJleHBpcnkiOjE3NTgwNjcxOTksImlzU3ViZG9tYWluIjp0cnVlfQ==",
    ];
    function Qn(a, b) {
        b = b === void 0 ? document : b;
        var c;
        return !((c = b.featurePolicy) == null || !c.features().includes(a));
    }
    function Rn(a, b) {
        b = b === void 0 ? document : b;
        var c;
        return !((c = b.featurePolicy) == null || !c.allowedFeatures().includes(a));
    }
    function Sn() {
        var a = window.navigator,
            b = window.document;
        return !!(window.isSecureContext && "runAdAuction" in a && a.runAdAuction instanceof Function && Rn("run-ad-auction", b));
    }
    function Tn(a, b) {
        try {
            var c = a.split(".");
            a = y;
            for (var d = 0, e; a != null && d < c.length; d++) (e = a), (a = a[c[d]]), typeof a === "function" && (a = e[c[d]]());
            var f = a;
            if (typeof f === b) return f;
        } catch (g) {}
    }
    var Un = {},
        Vn = {},
        Wn = {},
        Xn = {},
        Yn =
            ((Xn[3] =
                ((Un[8] = function (a) {
                    try {
                        return Ta(a) != null;
                    } catch (b) {}
                }),
                (Un[9] = function (a) {
                    try {
                        var b = Ta(a);
                    } catch (c) {
                        return;
                    }
                    return typeof b === "function" && Cj(b);
                }),
                (Un[10] = function () {
                    return window === window.top;
                }),
                (Un[6] = function (a) {
                    return cc(J(Tm).g(), Number(a));
                }),
                (Un[27] = function (a) {
                    a = Tn(a, "boolean");
                    return a !== void 0 ? a : void 0;
                }),
                (Un[60] = function (a) {
                    try {
                        return !!y.document.querySelector(a);
                    } catch (b) {}
                }),
                (Un[80] = function (a) {
                    try {
                        return !!y.matchMedia(a).matches;
                    } catch (b) {}
                }),
                (Un[69] = function (a) {
                    return Qn(a, y.document);
                }),
                (Un[70] = function (a) {
                    return Rn(a, y.document);
                }),
                (Un[79] = function (a) {
                    var b = y.navigator;
                    b = b === void 0 ? navigator : b;
                    try {
                        var c, d;
                        var e = !!((c = b.protectedAudience) == null ? 0 : (d = c.queryFeatureSupport) == null ? 0 : d.call(c, a));
                    } catch (f) {
                        e = !1;
                    }
                    return e;
                }),
                Un)),
            (Xn[4] =
                ((Vn[3] = function () {
                    return Fj();
                }),
                (Vn[6] = function (a) {
                    a = Tn(a, "number");
                    return a !== void 0 ? a : void 0;
                }),
                Vn)),
            (Xn[5] =
                ((Wn[2] = function () {
                    return window.location.href;
                }),
                (Wn[3] = function () {
                    try {
                        return window.top.location.hash;
                    } catch (a) {
                        return "";
                    }
                }),
                (Wn[4] = function (a) {
                    a = Tn(a, "string");
                    return a !== void 0 ? a : void 0;
                }),
                Wn)),
            Xn);
    function Zn() {
        var a = a === void 0 ? y : a;
        return a.ggeac || (a.ggeac = {});
    }
    function $n(a) {
        var b = {};
        return ao(((b[0] = new Map()), (b[1] = new Map()), (b[2] = new Map()), b), a);
    }
    function ao(a, b) {
        for (var c = new Map(), d = w(a[1].entries()), e = d.next(); !e.done; e = d.next()) {
            var f = w(e.value);
            e = f.next().value;
            f = f.next().value;
            f = f[f.length - 1];
            c.set(e, f.kf + f.Qe * f.Re);
        }
        b = w(b);
        for (d = b.next(); !d.done; d = b.next())
            for (d = d.value, e = gg(d, In, 2, Jf()), e = w(e), f = e.next(); !f.done; f = e.next())
                if (((f = f.value), Jn(f).length !== 0)) {
                    var g = rg(f, 8);
                    if (F(f, 4) && !F(f, 13) && !F(f, 14)) {
                        var h = void 0;
                        g = (h = c.get(F(f, 4))) != null ? h : 0;
                        h = rg(f, 1) * Jn(f).length;
                        c.set(F(f, 4), g + h);
                    }
                    h = [];
                    for (var k = 0; k < Jn(f).length; k++) {
                        var m = { kf: g, Qe: rg(f, 1), Re: Jn(f).length, Qg: k, Ec: F(d, 1), md: f, Ma: Jn(f)[k] };
                        h.push(m);
                    }
                    bo(a[2], F(f, 10), h) || bo(a[1], F(f, 4), h) || bo(a[0], Jn(f)[0].getId(), h);
                }
        return a;
    }
    function bo(a, b, c) {
        if (!b) return !1;
        a.has(b) || a.set(b, []);
        var d;
        (d = a.get(b)).push.apply(d, la(c));
        return !0;
    }
    var co = [12, 13, 20],
        eo = function (a, b, c, d) {
            d = d === void 0 ? {} : d;
            var e = d.Dd === void 0 ? !1 : d.Dd;
            d = d.fh === void 0 ? [] : d.fh;
            this.bc = a;
            this.pb = c;
            this.o = {};
            this.Dd = e;
            a = {};
            this.g = ((a[b] = []), (a[4] = []), a);
            this.j = {};
            this.l = {};
            if ((b = pl())) for (b = w(b.split(",") || []), a = b.next(); !a.done; a = b.next()) (a = Number(a.value)) && (this.j[a] = !0);
            d = w(d);
            for (b = d.next(); !b.done; b = d.next()) this.j[b.value] = !0;
        },
        ho = function (a, b, c, d) {
            var e = [],
                f;
            if ((f = b !== 9)) a.o[b] ? (f = !0) : ((a.o[b] = !0), (f = !1));
            if (f) return sm(a.pb, b, c, e, [], 4), e;
            f = co.includes(b);
            for (var g = [], h = [], k = w([0, 1, 2]), m = k.next(); !m.done; m = k.next()) {
                m = m.value;
                for (var n = w(a.bc[m].entries()), p = n.next(); !p.done; p = n.next()) {
                    var q = w(p.value);
                    p = q.next().value;
                    q = q.next().value;
                    var t = p,
                        u = q;
                    p = new Zj();
                    q = u.filter(function (ca) {
                        return ca.Ec === b && a.j[ca.Ma.getId()] && fo(a, ca);
                    });
                    if (q.length) for (p = w(q), q = p.next(); !q.done; q = p.next()) h.push(q.value.Ma);
                    else if (!a.Dd) {
                        q = void 0;
                        m === 2 ? ((q = d[1]), Yf(p, 2, ak, ge(t))) : (q = d[0]);
                        var v = void 0,
                            E = void 0;
                        q = (E = (v = q) == null ? void 0 : v(String(t))) != null ? E : m === 2 && F(u[0].md, 11) === 1 ? void 0 : d[0](String(t));
                        if (q !== void 0) {
                            t = w(u);
                            for (u = t.next(); !u.done; u = t.next())
                                if (((u = u.value), u.Ec === b)) {
                                    v = q - u.kf;
                                    var P = u;
                                    E = P.Qe;
                                    var S = P.Re;
                                    P = P.Qg;
                                    v < 0 ||
                                        v >= E * S ||
                                        v % S !== P ||
                                        !fo(a, u) ||
                                        ((v = F(u.md, 13)), v !== 0 && v !== void 0 && ((E = a.l[String(v)]), E !== void 0 && E !== u.Ma.getId() ? tm(a.pb, a.l[String(v)], u.Ma.getId(), v) : (a.l[String(v)] = u.Ma.getId())), h.push(u.Ma));
                                }
                            Zf(p, ak) !== 0 && (Cg(p, 3, q), g.push(p));
                        }
                    }
                }
            }
            d = w(h);
            for (h = d.next(); !h.done; h = d.next()) (h = h.value), (k = h.getId()), e.push(k), go(a, k, f ? 4 : c), Km(gg(h, nm, 2, Jf()), f ? Mm() : [c], a.pb, k);
            sm(a.pb, b, c, e, g, 1);
            return e;
        },
        go = function (a, b, c) {
            a.g[c] || (a.g[c] = []);
            a = a.g[c];
            a.includes(b) || a.push(b);
        },
        fo = function (a, b) {
            var c = J(vm).Ha,
                d = lm(eg(b.md, mk, 3), c);
            if (!d.success) return um(a.pb, eg(b.md, mk, 3), b.Ec, b.Ma.getId(), d), !1;
            if (!d.value) return !1;
            c = lm(eg(b.Ma, mk, 3), c);
            return c.success ? (c.value ? !0 : !1) : (um(a.pb, eg(b.Ma, mk, 3), b.Ec, b.Ma.getId(), c), !1);
        },
        io = function (a, b) {
            b = b
                .map(function (c) {
                    return new Kn(c);
                })
                .filter(function (c) {
                    return !co.includes(F(c, 1));
                });
            a.bc = ao(a.bc, b);
        },
        jo = function (a, b) {
            Om(
                1,
                function (c) {
                    a.j[c] = !0;
                },
                b
            );
            Om(
                2,
                function (c, d, e) {
                    return ho(a, c, d, e);
                },
                b
            );
            Om(
                3,
                function (c) {
                    return (a.g[c] || []).concat(a.g[4]);
                },
                b
            );
            Om(
                12,
                function (c) {
                    return void io(a, c);
                },
                b
            );
            Om(
                16,
                function (c, d) {
                    return void go(a, c, d);
                },
                b
            );
        };
    var ko = function () {
        var a = {};
        this.g = function (b, c) {
            return a[b] != null ? a[b] : c;
        };
        this.j = function (b, c) {
            return a[b] != null ? a[b] : c;
        };
        this.A = function (b, c) {
            return a[b] != null ? a[b] : c;
        };
        this.B = function (b, c) {
            return a[b] != null ? a[b] : c;
        };
        this.o = function (b, c) {
            return a[b] != null ? c.concat(a[b]) : c;
        };
        this.l = function () {};
    };
    function lo(a) {
        return J(ko).g(a.g, a.defaultValue);
    }
    var mo = function () {
            this.g = function () {};
        },
        no = function (a, b) {
            a.g = Pm(14, b, function () {});
        };
    function oo(a) {
        J(mo).g(a);
    }
    var po, qo, ro, so, to, uo;
    function vo(a, b) {
        var c = (b = b === void 0 ? Zn() : b);
        Um(J(Tm), c, a);
        wo(b, a);
        a = b;
        no(J(mo), a);
        J(ko).l();
    }
    function wo(a, b) {
        var c = J(ko);
        c.g = function (d, e) {
            return Pm(5, a, function () {
                return !1;
            })(d, e, b);
        };
        c.j = function (d, e) {
            return Pm(6, a, function () {
                return 0;
            })(d, e, b);
        };
        c.A = function (d, e) {
            return Pm(7, a, function () {
                return "";
            })(d, e, b);
        };
        c.B = function (d, e) {
            return Pm(8, a, function () {
                return [];
            })(d, e, b);
        };
        c.o = function (d, e) {
            return Pm(17, a, function () {
                return [];
            })(d, e, b);
        };
        c.l = function () {
            Pm(15, a, function () {})(b);
        };
    }
    Zm.reset();
    an(new dn());
    (function (a) {
        var b = a.pg;
        var c = a.Ha;
        var d = a.config;
        var e = a.Zf === void 0 ? Zn() : a.Zf;
        var f = a.ze === void 0 ? 0 : a.ze;
        var g =
            a.pb === void 0
                ? new qm(
                      (so = (po = eg(b, Ln, 5)) == null ? void 0 : sg(po, 2)) != null ? so : 0,
                      (to = (qo = eg(b, Ln, 5)) == null ? void 0 : sg(qo, 4)) != null ? to : 0,
                      (uo = (ro = eg(b, Ln, 5)) == null ? void 0 : pg(ro, 3)) != null ? uo : !1
                  )
                : a.pb;
        a = a.bc === void 0 ? $n(gg(b, Kn, 2, Jf(Bd))) : a.bc;
        e.hasOwnProperty("init-done")
            ? (Pm(12, e, function () {})(
                  gg(b, Kn, 2, Jf()).map(function (h) {
                      return Hg(h);
                  })
              ),
              Pm(13, e, function () {})(
                  gg(b, nm, 1, Jf()).map(function (h) {
                      return Hg(h);
                  }),
                  f
              ),
              c && Pm(14, e, function () {})(c),
              vo(f, e))
            : (jo(new eo(a, f, g, d), e), Qm(e), Rm(e), Sm(e), vo(f, e), Km(gg(b, nm, 1, Jf(Bd)), [f], g, void 0, !0), (wm = wm || !(!d || !d.lj)), oo(Yn), c && oo(c));
    })({ pg: On(), ze: 7 });
    var xo = Gj(),
        yo = {},
        zo =
            ((yo[0] = (function (a) {
                a = a === void 0 ? xj() : a;
                return function (b) {
                    return zj(b + " + " + a) % 1e3;
                };
            })(xo)),
            yo);
    J(Tm).j(16, zo);
    var Ao = function (a) {
        var b = {};
        Tb(a, function (c) {
            var d = c.g,
                e = b[d];
            b.hasOwnProperty(d) ? e !== null && (c.j(e) || (b[d] = null)) : (b[d] = c);
        });
        fc(a, function (c) {
            return b[c.g] === null;
        });
    };
    var Bo = { NONE: 0, Oh: 1 },
        Co = { Mh: 0, Ji: 1, Ii: 2, Ki: 3 },
        Do = { uf: "a", Nh: "d", VIDEO: "v" };
    var Eo = function () {
        this.X = 0;
        this.g = !1;
        this.j = -1;
        this.xb = !1;
        this.ta = 0;
    };
    Eo.prototype.isVisible = function () {
        return this.xb ? this.X >= 0.3 : this.X >= 0.5;
    };
    var Fo = { Lh: 0, Rh: 1 },
        Go = { 668123728: 0, 668123729: 1 },
        Ho = { 44731964: 0, 44731965: 1 },
        Io = { NONE: 0, wi: 1, Wh: 2 },
        Jo = { 480596784: 0, 480596785: 1, 21063355: 2 };
    var Ko = function () {
            this.g = null;
            this.o = !1;
            this.l = null;
        },
        Lo = function (a) {
            a.o = !0;
            return a;
        },
        Mo = function (a, b) {
            a.l &&
                Tb(b, function (c) {
                    c = a.l[c];
                    c !== void 0 && a.j(c);
                });
        };
    Ko.prototype.getValue = function () {
        return this.g;
    };
    var No = function (a) {
        Ko.call(this);
        this.A = a;
    };
    x(No, Ko);
    No.prototype.j = function (a) {
        this.g === null && Bi(this.A, a) && (this.g = a);
    };
    var Oo = function () {
        Ko.call(this);
    };
    x(Oo, Ko);
    Oo.prototype.j = function (a) {
        this.g === null && typeof a === "number" && (this.g = a);
    };
    var Po = function () {
        Ko.call(this);
    };
    x(Po, Ko);
    Po.prototype.j = function (a) {
        this.g === null && typeof a === "string" && (this.g = a);
    };
    var Qo = function () {
        this.g = {};
        this.l = !0;
        this.j = {};
    };
    Qo.prototype.reset = function () {
        this.g = {};
        this.l = !0;
        this.j = {};
    };
    var Ro = function (a, b, c) {
            a.g[b] || (a.g[b] = new No(c));
            return a.g[b];
        },
        So = function (a) {
            a.g.queryid || (a.g.queryid = new Po());
        },
        To = function (a, b, c) {
            (a = a.g[b]) && a.j(c);
        },
        Uo = function (a, b) {
            if (Ai(a.j, b)) return a.j[b];
            if ((a = a.g[b])) return a.getValue();
        },
        Vo = function (a) {
            var b = {},
                c = ui(a.g, function (d) {
                    return d.o;
                });
            ti(
                c,
                function (d, e) {
                    d = a.j[e] !== void 0 ? String(a.j[e]) : d.o && d.g !== null ? String(d.g) : "";
                    d.length > 0 && (b[e] = d);
                },
                a
            );
            return b;
        },
        Wo = function (a) {
            a = Vo(a);
            var b = [];
            ti(a, function (c, d) {
                d in Object.prototype || (typeof c != "undefined" && b.push([d, ":", c].join("")));
            });
            return b;
        },
        Xo = function () {
            var a = N().R,
                b = cn();
            a.l &&
                Tb(xi(a.g), function (c) {
                    return Mo(c, b);
                });
        };
    var Yo = function (a) {
        Ro(a, "od", Bo);
        Lo(Ro(a, "opac", Fo));
        Lo(Ro(a, "sbeos", Fo));
        Lo(Ro(a, "prf", Fo));
        Lo(Ro(a, "mwt", Fo));
        Ro(a, "iogeo", Fo);
    };
    var Zo = document,
        O = window;
    var $o = !rc && !Ob();
    var ap = function () {
        this.g = this.ob = null;
    };
    var bp = function () {};
    bp.prototype.now = function () {
        return 0;
    };
    bp.prototype.j = function () {
        return 0;
    };
    bp.prototype.l = function () {
        return 0;
    };
    bp.prototype.g = function () {
        return 0;
    };
    var dp = function () {
        if (!cp()) throw Error();
    };
    x(dp, bp);
    var cp = function () {
        return !(!O || !O.performance);
    };
    dp.prototype.now = function () {
        return cp() && O.performance.now ? O.performance.now() : bp.prototype.now.call(this);
    };
    dp.prototype.j = function () {
        return cp() && O.performance.memory ? O.performance.memory.totalJSHeapSize || 0 : bp.prototype.j.call(this);
    };
    dp.prototype.l = function () {
        return cp() && O.performance.memory ? O.performance.memory.usedJSHeapSize || 0 : bp.prototype.l.call(this);
    };
    dp.prototype.g = function () {
        return cp() && O.performance.memory ? O.performance.memory.jsHeapSizeLimit || 0 : bp.prototype.g.call(this);
    };
    var ep = function () {};
    ep.prototype.isVisible = function () {
        return ml(Zo) === 1;
    };
    var fp = RegExp("^https?://(\\w|-)+\\.cdn\\.ampproject\\.(net|org)(\\?|/|$)"),
        jp = function (a) {
            a = a || gp();
            for (var b = new hp(y.location.href, !1), c = null, d = a.length - 1, e = d; e >= 0; --e) {
                var f = a[e];
                !c && fp.test(f.url) && (c = f);
                if (f.url && !f.Kd) {
                    b = f;
                    break;
                }
            }
            e = null;
            f = a.length && a[d].url;
            b.depth != 0 && f && (e = a[d]);
            return new ip(b, e, c);
        },
        gp = function () {
            var a = y,
                b = [],
                c = null;
            do {
                var d = a;
                if (sj(d)) {
                    var e = d.location.href;
                    c = (d.document && d.document.referrer) || null;
                } else (e = c), (c = null);
                b.push(new hp(e || ""));
                try {
                    a = d.parent;
                } catch (f) {
                    a = null;
                }
            } while (a && d != a);
            d = 0;
            for (a = b.length - 1; d <= a; ++d) b[d].depth = a - d;
            d = y;
            if (d.location && d.location.ancestorOrigins && d.location.ancestorOrigins.length == b.length - 1) for (a = 1; a < b.length; ++a) (e = b[a]), e.url || ((e.url = d.location.ancestorOrigins[a - 1] || ""), (e.Kd = !0));
            return b;
        },
        ip = function (a, b, c) {
            this.g = a;
            this.j = b;
            this.l = c;
        },
        hp = function (a, b) {
            this.url = a;
            this.Kd = !!b;
            this.depth = null;
        };
    var kp = function () {
            this.l = "&";
            this.j = {};
            this.o = 0;
            this.g = [];
        },
        lp = function (a, b) {
            var c = {};
            c[a] = b;
            return [c];
        },
        np = function (a, b, c, d, e) {
            var f = [];
            yj(a, function (g, h) {
                (g = mp(g, b, c, d, e)) && f.push(h + "=" + g);
            });
            return f.join(b);
        },
        mp = function (a, b, c, d, e) {
            if (a == null) return "";
            b = b || "&";
            c = c || ",$";
            typeof c === "string" && (c = c.split(""));
            if (a instanceof Array) {
                if ((d || (d = 0), d < c.length)) {
                    for (var f = [], g = 0; g < a.length; g++) f.push(mp(a[g], b, c, d + 1, e));
                    return f.join(c[d]);
                }
            } else if (typeof a === "object") return e || (e = 0), e < 2 ? encodeURIComponent(np(a, b, c, d, e + 1)) : "...";
            return encodeURIComponent(String(a));
        },
        op = function (a, b, c) {
            a.g.push(b);
            a.j[b] = c;
        },
        pp = function (a, b, c, d) {
            a.g.push(b);
            a.j[b] = lp(c, d);
        },
        rp = function (a, b, c) {
            b = b + "//pagead2.googlesyndication.com" + c;
            var d = qp(a) - c.length;
            if (d < 0) return "";
            a.g.sort(function (n, p) {
                return n - p;
            });
            c = null;
            for (var e = "", f = 0; f < a.g.length; f++)
                for (var g = a.g[f], h = a.j[g], k = 0; k < h.length; k++) {
                    if (!d) {
                        c = c == null ? g : c;
                        break;
                    }
                    var m = np(h[k], a.l, ",$");
                    if (m) {
                        m = e + m;
                        if (d >= m.length) {
                            d -= m.length;
                            b += m;
                            e = a.l;
                            break;
                        }
                        c = c == null ? g : c;
                    }
                }
            a = "";
            c != null && (a = "" + e + "trn=" + c);
            return b + a;
        },
        qp = function (a) {
            var b = 1,
                c;
            for (c in a.j) c.length > b && (b = c.length);
            return 3997 - b - a.l.length - 1;
        };
    var sp = function (a, b) {
            this.g = a;
            this.depth = b;
        },
        up = function () {
            var a = gp(),
                b = Math.max(a.length - 1, 0),
                c = jp(a);
            a = c.g;
            var d = c.j,
                e = c.l,
                f = [];
            c = function (h, k) {
                return h == null ? k : h;
            };
            e && f.push(new sp([e.url, e.Kd ? 2 : 0], c(e.depth, 1)));
            d && d != e && f.push(new sp([d.url, 2], 0));
            a.url && a != e && f.push(new sp([a.url, 0], c(a.depth, b)));
            var g = Wb(f, function (h, k) {
                return f.slice(0, f.length - k);
            });
            !a.url || ((e || d) && a != e) || ((d = Aj(a.url)) && g.push([new sp([d, 1], c(a.depth, b))]));
            g.push([]);
            return Wb(g, function (h) {
                return tp(b, h);
            });
        };
    function tp(a, b) {
        var c = Xb(
                b,
                function (e, f) {
                    return Math.max(e, f.depth);
                },
                -1
            ),
            d = lc(c + 2);
        d[0] = a;
        Tb(b, function (e) {
            return (d[e.depth + 1] = e.g);
        });
        return d;
    }
    function vp() {
        var a = a === void 0 ? up() : a;
        return a.map(function (b) {
            return mp(b);
        });
    }
    var wp = function () {
            this.j = new ep();
            this.g = cp() ? new dp() : new bp();
        },
        yp = function () {
            xp();
            var a = O.document;
            return !!(a && a.body && a.body.getBoundingClientRect && typeof O.setInterval === "function" && typeof O.clearInterval === "function" && typeof O.setTimeout === "function" && typeof O.clearTimeout === "function");
        };
    wp.prototype.setTimeout = function (a, b) {
        return O.setTimeout(a, b);
    };
    wp.prototype.clearTimeout = function (a) {
        O.clearTimeout(a);
    };
    var zp = function () {
        xp();
        return vp();
    };
    var Ap = function () {},
        xp = function () {
            var a = J(Ap);
            if (!a.g) {
                if (!O) throw Error("Context has not been set and window is undefined.");
                a.g = J(wp);
            }
            return a.g;
        };
    var Bp = function (a) {
        this.F = B(a);
    };
    x(Bp, H);
    Bp.prototype.g = Fh([0, rh, uh, -2, xh]);
    var Cp = function (a) {
            this.l = a;
            this.g = -1;
            this.j = this.o = 0;
        },
        Dp = function (a, b) {
            return function () {
                var c = Ma.apply(0, arguments);
                if (a.g > -1) return b.apply(null, la(c));
                try {
                    return (a.g = a.l.g.now()), b.apply(null, la(c));
                } finally {
                    (a.o += a.l.g.now() - a.g), (a.g = -1), (a.j += 1);
                }
            };
        };
    var Ep = function (a, b) {
        this.j = a;
        this.l = b;
        this.g = new Cp(a);
    };
    var Fp = function () {
            this.g = {};
        },
        Xp = function () {
            var a = N().flags,
                b = Wp;
            a = a.g[b.key];
            if (b.valueType === "proto") {
                try {
                    var c = JSON.parse(a);
                    if (Array.isArray(c)) return c;
                } catch (d) {}
                return b.defaultValue;
            }
            return typeof a === typeof b.defaultValue ? a : b.defaultValue;
        };
    var Yp = { Fi: 1, Wi: 2, Bi: 3 };
    var Zp = function () {
        this.l = void 0;
        this.j = this.B = 0;
        this.A = -1;
        this.R = new Qo();
        Lo(Ro(this.R, "mv", Io)).l = Jo === void 0 ? null : Jo;
        Ro(this.R, "omid", Fo);
        Lo(Ro(this.R, "epoh", Fo));
        Lo(Ro(this.R, "epph", Fo));
        Lo(Ro(this.R, "umt", Fo)).l = Go === void 0 ? null : Go;
        Lo(Ro(this.R, "phel", Fo));
        Lo(Ro(this.R, "phell", Fo));
        Lo(Ro(this.R, "oseid", Yp));
        var a = this.R;
        a.g.sloi || (a.g.sloi = new Oo());
        Lo(a.g.sloi);
        Ro(this.R, "mm", Do);
        Lo(Ro(this.R, "ovms", Co));
        Lo(Ro(this.R, "xdi", Fo));
        Lo(Ro(this.R, "amp", Fo));
        Lo(Ro(this.R, "prf", Fo));
        Lo(Ro(this.R, "gtx", Fo));
        Lo(Ro(this.R, "mvp_lv", Fo));
        Lo(Ro(this.R, "ssmol", Fo)).l = Ho === void 0 ? null : Ho;
        Lo(Ro(this.R, "fmd", Fo));
        Ro(this.R, "gen204simple", Fo);
        this.g = new Ep(xp(), this.R);
        this.o = !1;
        this.flags = new Fp();
    };
    Zp.prototype.Wd = function (a) {
        if (typeof a === "string" && a.length != 0) {
            var b = this.R;
            if (b.l) {
                a = a.split("&");
                for (var c = a.length - 1; c >= 0; c--) {
                    var d = a[c].split("="),
                        e = decodeURIComponent(d[0]);
                    d.length > 1 ? ((d = decodeURIComponent(d[1])), (d = /^[0-9]+$/g.exec(d) ? parseInt(d, 10) : d)) : (d = 1);
                    (e = b.g[e]) && e.j(d);
                }
            }
        }
    };
    var N = function () {
        return J(Zp);
    };
    var $p = function (a, b, c, d, e) {
        if ((d ? a.l : Math.random()) < (e || a.g))
            try {
                if (c instanceof kp) var f = c;
                else
                    (f = new kp()),
                        yj(c, function (h, k) {
                            var m = f,
                                n = m.o++;
                            op(m, n, lp(k, h));
                        });
                var g = rp(f, a.j, "/pagead/gen_204?id=" + b + "&");
                g && (xp(), Kj(O, g));
            } catch (h) {}
    };
    var cq = function () {
        var a = aq;
        this.B = bq;
        this.A = "jserror";
        this.l = !0;
        this.j = null;
        this.C = this.Wa;
        this.g = a === void 0 ? null : a;
        this.o = !1;
    };
    l = cq.prototype;
    l.gd = function (a) {
        this.j = a;
    };
    l.ee = function (a) {
        this.A = a;
    };
    l.fe = function (a) {
        this.l = a;
    };
    l.ge = function (a) {
        this.o = a;
    };
    l.zb = function (a, b, c) {
        var d = this;
        return Dp(N().g.g, function () {
            try {
                if (d.g && d.g.l) {
                    var e = d.g.start(a.toString(), 3);
                    var f = b();
                    d.g.end(e);
                } else f = b();
            } catch (h) {
                var g = d.l;
                try {
                    zl(e), (g = d.C(a, new dq(eq(h)), void 0, c));
                } catch (k) {
                    d.Wa(217, k);
                }
                if (!g) throw h;
            }
            return f;
        })();
    };
    l.Xd = function (a, b, c, d) {
        var e = this;
        return Dp(N().g.g, function () {
            var f = Ma.apply(0, arguments);
            return e.zb(
                a,
                function () {
                    return b.apply(c, f);
                },
                d
            );
        });
    };
    l.Wa = function (a, b, c, d, e) {
        e = e || this.A;
        try {
            var f = new kp();
            pp(f, 1, "context", a);
            Jh(b) || (b = new dq(eq(b)));
            b.msg && pp(f, 2, "msg", b.msg.substring(0, 512));
            var g = b.meta || {};
            if (this.j)
                try {
                    this.j(g);
                } catch (k) {}
            if (d)
                try {
                    d(g);
                } catch (k) {}
            op(f, 3, [g]);
            var h = jp();
            h.j && pp(f, 4, "top", h.j.url || "");
            op(f, 5, [{ url: h.g.url || "" }, { url: h.g.url ? oj(h.g.url) : "" }]);
            $p(this.B, e, f, this.o, c);
        } catch (k) {
            try {
                $p(this.B, e, { context: "ecmserr", rctx: a, msg: eq(k), url: h && h.g.url }, this.o, c);
            } catch (m) {}
        }
        return this.l;
    };
    var eq = function (a) {
            var b = a.toString();
            a.name && b.indexOf(a.name) == -1 && (b += ": " + a.name);
            a.message && b.indexOf(a.message) == -1 && (b += ": " + a.message);
            if (a.stack)
                a: {
                    a = a.stack;
                    var c = b;
                    try {
                        a.indexOf(c) == -1 && (a = c + "\n" + a);
                        for (var d; a != d; ) (d = a), (a = a.replace(/((https?:\/..*\/)[^\/:]*:\d+(?:.|\n)*)\2/, "$1"));
                        b = a.replace(/\n */g, "\n");
                        break a;
                    } catch (e) {
                        b = c;
                        break a;
                    }
                    b = void 0;
                }
            return b;
        },
        dq = function (a) {
            Ih.call(this, Error(a), { message: a });
        };
    x(dq, Ih);
    var bq,
        fq,
        aq = new yl(1, window),
        gq = function () {
            O && typeof O.google_measure_js_timing != "undefined" && (O.google_measure_js_timing || aq.B());
        };
    bq = new (function () {
        var a = "https:";
        O && O.location && O.location.protocol === "http:" && (a = "http:");
        this.j = a;
        this.g = 0.01;
        this.l = Math.random();
    })();
    fq = new cq();
    O &&
        O.document &&
        (O.document.readyState == "complete"
            ? gq()
            : aq.l &&
              Qh(O, "load", function () {
                  gq();
              }));
    var hq = function (a) {
            fq.gd(function (b) {
                Tb(a, function (c) {
                    c(b);
                });
            });
        },
        iq = function (a, b) {
            return fq.zb(a, b);
        },
        jq = function (a, b, c, d) {
            return fq.Xd(a, b, c, d);
        },
        kq = function (a, b, c, d) {
            fq.Wa(a, b, c, d);
        };
    var lq = Date.now(),
        mq = -1,
        nq = -1,
        oq,
        pq = -1,
        qq = !1,
        rq = function () {
            return Date.now() - lq;
        },
        sq = function () {
            var a = N().l,
                b = nq >= 0 ? rq() - nq : -1,
                c = qq ? rq() - mq : -1,
                d = pq >= 0 ? rq() - pq : -1;
            if (a == 947190542) return 100;
            if (a == 79463069) return 200;
            a = [2e3, 4e3];
            var e = [250, 500, 1e3];
            kq(637, Error(), 0.001);
            var f = b;
            c != -1 && c < b && (f = c);
            for (b = 0; b < a.length; ++b)
                if (f < a[b]) {
                    var g = e[b];
                    break;
                }
            g === void 0 && (g = e[a.length]);
            return d != -1 && d > 1500 && d < 4e3 ? 500 : g;
        };
    var tq = function (a, b, c) {
        var d = new I(0, 0, 0, 0);
        this.time = a;
        this.volume = null;
        this.l = b;
        this.g = d;
        this.j = c;
    };
    var uq = function (a, b, c, d, e, f, g) {
        this.l = a;
        this.j = b;
        this.A = c;
        this.g = d;
        this.o = e;
        this.C = f;
        this.B = g;
    };
    uq.prototype.getTimestamp = function () {
        return this.C;
    };
    var vq = { currentTime: 1, duration: 2, isVpaid: 4, volume: 8, isYouTube: 16, isPlaying: 32 },
        Di = {
            ve: "start",
            FIRST_QUARTILE: "firstquartile",
            MIDPOINT: "midpoint",
            THIRD_QUARTILE: "thirdquartile",
            COMPLETE: "complete",
            ERROR: "error",
            Hf: "metric",
            PAUSE: "pause",
            Qf: "resume",
            SKIPPED: "skip",
            VIEWABLE_IMPRESSION: "viewable_impression",
            If: "mute",
            Uf: "unmute",
            FULLSCREEN: "fullscreen",
            Ef: "exitfullscreen",
            zf: "bufferstart",
            yf: "bufferfinish",
            qe: "fully_viewable_audible_half_duration_impression",
            ue: "measurable_impression",
            tf: "abandon",
            pe: "engagedview",
            IMPRESSION: "impression",
            Bf: "creativeview",
            LOADED: "loaded",
            PROGRESS: "progress",
            Fh: "close",
            Gh: "collapse",
            Jf: "overlay_resize",
            Kf: "overlay_unmeasurable_impression",
            Lf: "overlay_unviewable_impression",
            Nf: "overlay_viewable_immediate_impression",
            Mf: "overlay_viewable_end_of_session_impression",
            Cf: "custom_metric_viewable",
            vf: "audio_audible",
            xf: "audio_measurable",
            wf: "audio_impression",
        },
        wq = "start firstquartile midpoint thirdquartile resume loaded".split(" "),
        xq = ["start", "firstquartile", "midpoint", "thirdquartile"],
        yq = ["abandon"],
        zq = {
            UNKNOWN: -1,
            ve: 0,
            FIRST_QUARTILE: 1,
            MIDPOINT: 2,
            THIRD_QUARTILE: 3,
            COMPLETE: 4,
            Hf: 5,
            PAUSE: 6,
            Qf: 7,
            SKIPPED: 8,
            VIEWABLE_IMPRESSION: 9,
            If: 10,
            Uf: 11,
            FULLSCREEN: 12,
            Ef: 13,
            qe: 14,
            ue: 15,
            tf: 16,
            pe: 17,
            IMPRESSION: 18,
            Bf: 19,
            LOADED: 20,
            Cf: 21,
            zf: 22,
            yf: 23,
            wf: 27,
            xf: 28,
            vf: 29,
        };
    var wi = { Bh: "addEventListener", Xh: "getMaxSize", Yh: "getScreenSize", Zh: "getState", ai: "getVersion", Hi: "removeEventListener", xi: "isViewable" },
        Aq = function (a) {
            var b = a !== a.top,
                c = a.top === Ij(a),
                d = -1,
                e = 0;
            if (b && c && a.top.mraid) {
                d = 3;
                var f = a.top.mraid;
            } else d = (f = a.mraid) ? (b ? (c ? 2 : 1) : 0) : -1;
            f &&
                (f.IS_GMA_SDK || (e = 2),
                vi(function (g) {
                    return typeof f[g] === "function";
                }) || (e = 1));
            return { Fa: f, Dc: e, kh: d };
        };
    var Bq = function () {
        var a = window.document;
        return a && typeof a.elementFromPoint === "function";
    };
    function Cq(a, b, c) {
        try {
            a && (b = b.top);
            var d = b;
            a && d !== null && d != d.top && (d = d.top);
            try {
                var e = (c === void 0 ? 0 : c) ? new ri(d.innerWidth, d.innerHeight).round() : bj(d || window).round();
            } catch (n) {
                e = new ri(-12245933, -12245933);
            }
            a = e;
            var f = a.height,
                g = a.width;
            if (g === -12245933) return new I(g, g, g, g);
            var h = cj(Yi(b.document).g),
                k = h.x,
                m = h.y;
            return new I(m, k + g, m + f, k);
        } catch (n) {
            return new I(-12245933, -12245933, -12245933, -12245933);
        }
    }
    var Eq = function (a, b) {
            if (typeof b === "string") (b = Dq(a, b)) && (a.style[b] = void 0);
            else
                for (var c in b) {
                    var d = a,
                        e = b[c],
                        f = Dq(d, c);
                    f && (d.style[f] = e);
                }
        },
        Fq = {},
        Dq = function (a, b) {
            var c = Fq[b];
            if (!c) {
                var d = Si(b);
                c = d;
                a.style[d] === void 0 && ((d = (vc ? "Webkit" : tc ? "Moz" : rc ? "ms" : null) + Ui(d)), a.style[d] !== void 0 && (c = d));
                Fq[b] = c;
            }
            return c;
        },
        Gq = function (a, b) {
            var c = a.style[Si(b)];
            return typeof c !== "undefined" ? c : a.style[Dq(a, b)] || "";
        },
        Hq = function (a, b) {
            var c = Xi(a);
            return c.defaultView && c.defaultView.getComputedStyle && (a = c.defaultView.getComputedStyle(a, null)) ? a[b] || a.getPropertyValue(b) || "" : "";
        },
        Iq = function (a) {
            try {
                return a.getBoundingClientRect();
            } catch (b) {
                return { left: 0, top: 0, right: 0, bottom: 0 };
            }
        },
        Jq = function (a) {
            var b = Xi(a),
                c = new qi(0, 0);
            if (a == (b ? Xi(b) : document).documentElement) return c;
            a = Iq(a);
            b = cj(Yi(b).g);
            c.x = a.left + b.x;
            c.y = a.top + b.y;
            return c;
        },
        Kq = function (a, b) {
            var c = new qi(0, 0),
                d = dj(Xi(a));
            if (!nc(d, "parent")) return c;
            do {
                if (d == b) var e = Jq(a);
                else (e = Iq(a)), (e = new qi(e.left, e.top));
                c.x += e.x;
                c.y += e.y;
            } while (d && d != b && d != d.parent && (a = d.frameElement) && (d = d.parent));
            return c;
        },
        Lq = function () {
            var a = "100%";
            typeof a == "number" && (a = Math.round(a) + "px");
            return a;
        },
        Nq = function (a) {
            var b = Mq,
                c;
            (c = Hq(a, "display")) || (c = a.currentStyle ? a.currentStyle.display : null);
            if ((c || (a.style && a.style.display)) != "none") return b(a);
            c = a.style;
            var d = c.display,
                e = c.visibility,
                f = c.position;
            c.visibility = "hidden";
            c.position = "absolute";
            c.display = "inline";
            a = b(a);
            c.display = d;
            c.position = f;
            c.visibility = e;
            return a;
        },
        Mq = function (a) {
            var b = a.offsetWidth,
                c = a.offsetHeight,
                d = vc && !b && !c;
            return (b === void 0 || d) && a.getBoundingClientRect ? ((a = Iq(a)), new ri(a.right - a.left, a.bottom - a.top)) : new ri(b, c);
        },
        Oq = function (a) {
            var b = new ri(a.offsetWidth, a.offsetHeight);
            var c = Hq(a, "paddingLeft");
            var d = Hq(a, "paddingRight"),
                e = Hq(a, "paddingTop"),
                f = Hq(a, "paddingBottom");
            c = new I(parseFloat(e), parseFloat(d), parseFloat(f), parseFloat(c));
            d = Hq(a, "borderLeftWidth");
            e = Hq(a, "borderRightWidth");
            f = Hq(a, "borderTopWidth");
            a = Hq(a, "borderBottomWidth");
            a = new I(parseFloat(f), parseFloat(e), parseFloat(a), parseFloat(d));
            return new ri(b.width - a.left - c.left - c.right - a.right, b.height - a.top - c.top - c.bottom - a.bottom);
        };
    var Pq = function (a, b) {
        b = Math.pow(10, b);
        return Math.floor(a * b) / b;
    };
    function Qq(a, b, c, d) {
        if (!a) return { value: d, done: !1 };
        d = b(d, a);
        var e = c(d, a);
        return !e && nc(a, "parentElement") ? Qq(a.parentElement || null, b, c, d) : { done: e, value: d };
    }
    var Rq = function (a, b, c, d) {
        if (!a) return d;
        d = Qq(a, b, c, d);
        if (!d.done)
            try {
                var e = Xi(a),
                    f = e && dj(e);
                return Rq(f && f.frameElement, b, c, d.value);
            } catch (g) {}
        return d.value;
    };
    function Sq(a) {
        var b = !rc || Ic();
        return Rq(
            a,
            function (c, d) {
                c = nc(d, "style") && d.style && Gq(d, "visibility");
                return { hidden: c === "hidden", visible: b && c === "visible" };
            },
            function (c) {
                return c.hidden || c.visible;
            },
            { hidden: !1, visible: !1 }
        ).hidden;
    }
    var Tq = function (a) {
            return Rq(
                a,
                function (b, c) {
                    return !(!nc(c, "style") || !c.style || Gq(c, "display") !== "none");
                },
                function (b) {
                    return b;
                },
                !1
            )
                ? !0
                : Sq(a);
        },
        Uq = function (a) {
            return new I(a.top, a.right, a.bottom, a.left);
        },
        Vq = function (a) {
            var b = a.top || 0,
                c = a.left || 0;
            return new I(b, c + (a.width || 0), b + (a.height || 0), c);
        },
        Wq = function (a) {
            return a != null && a >= 0 && a <= 1;
        };
    function Xq() {
        var a = Gb();
        return a
            ? Yb(
                  "AmazonWebAppPlatform;Android TV;Apple TV;AppleTV;BRAVIA;BeyondTV;Freebox;GoogleTV;HbbTV;LongTV;MiBOX;MiTV;NetCast.TV;Netcast;Opera TV;PANASONIC;POV_TV;SMART-TV;SMART_TV;SWTV;Smart TV;SmartTV;TV Store;UnionTV;WebOS".split(
                      ";"
                  ),
                  function (b) {
                      return zb(a, b);
                  }
              ) ||
              (zb(a, "OMI/") && !zb(a, "XiaoMi/"))
                ? !0
                : zb(a, "Presto") && zb(a, "Linux") && !zb(a, "X11") && !zb(a, "Android") && !zb(a, "Mobi")
            : !1;
    }
    function Yq() {
        var a = Gb();
        return zb(a, "AppleTV") || zb(a, "Apple TV") || zb(a, "CFNetwork") || zb(a, "tvOS");
    }
    function Zq() {
        var a;
        (a = (zb(Gb(), "CrKey") && !(zb(Gb(), "CrKey") && zb(Gb(), "SmartSpeaker"))) || zb(Gb(), "PlayStation") || zb(Gb(), "Roku") || Xq() || zb(Gb(), "Xbox") || Yq()) ||
            ((a = Gb()), (a = zb(a, "sdk_google_atv_x86") || zb(a, "Android TV")));
        return a;
    }
    var ar = function () {
            this.l = !sj(O.top);
            this.C = lj() || mj();
            var a = gp();
            a = a.length > 0 && a[a.length - 1] != null && a[a.length - 1].url != null ? ((a = a[a.length - 1].url.match(nj)[3] || null) ? decodeURI(a) : a) || "" : "";
            this.domain = a;
            this.g = new I(0, 0, 0, 0);
            this.A = new ri(0, 0);
            this.o = new ri(0, 0);
            this.J = new I(0, 0, 0, 0);
            this.frameOffset = new qi(0, 0);
            this.B = 0;
            this.L = !1;
            this.j = !(!O || !Aq(O).Fa);
            $q(this);
        },
        br = function (a, b) {
            b && b.screen && (a.A = new ri(b.screen.width, b.screen.height));
        },
        cr = function (a, b) {
            a: {
                var c = a.g ? new ri(a.g.getWidth(), a.g.getHeight()) : new ri(0, 0);
                b = b === void 0 ? O : b;
                b !== null && b != b.top && (b = b.top);
                var d = 0,
                    e = 0;
                try {
                    var f = b.document,
                        g = f.body,
                        h = f.documentElement;
                    if (f.compatMode == "CSS1Compat" && h.scrollHeight) (d = h.scrollHeight != c.height ? h.scrollHeight : h.offsetHeight), (e = h.scrollWidth != c.width ? h.scrollWidth : h.offsetWidth);
                    else {
                        var k = h.scrollHeight,
                            m = h.scrollWidth,
                            n = h.offsetHeight,
                            p = h.offsetWidth;
                        h.clientHeight != n && ((k = g.scrollHeight), (m = g.scrollWidth), (n = g.offsetHeight), (p = g.offsetWidth));
                        k > c.height ? (k > n ? ((d = k), (e = m)) : ((d = n), (e = p))) : k < n ? ((d = k), (e = m)) : ((d = n), (e = p));
                    }
                    var q = new ri(e, d);
                    break a;
                } catch (t) {
                    q = new ri(-12245933, -12245933);
                    break a;
                }
                q = void 0;
            }
            a.o = q;
        },
        $q = function (a) {
            O && O.document && ((a.J = Cq(!1, O, a.C)), (a.g = Cq(!0, O, a.C)), cr(a, O), br(a, O));
        },
        er = function () {
            var a = dr();
            if (a.B > 0 || a.L) return !0;
            a = xp().j.isVisible();
            var b = ml(Zo) === 0;
            return a || b;
        },
        dr = function () {
            return J(ar);
        };
    var fr = function (a) {
        this.l = a;
        this.j = 0;
        this.g = null;
    };
    fr.prototype.cancel = function () {
        xp().clearTimeout(this.g);
        this.g = null;
    };
    var gr = function (a) {
        var b = xp(),
            c = N().g.g;
        a.g = b.setTimeout(
            Dp(
                c,
                jq(143, function () {
                    a.j++;
                    a.l.sample();
                })
            ),
            sq()
        );
    };
    var hr = function (a, b, c) {
        this.l = a;
        this.ka = c === void 0 ? "na" : c;
        this.A = [];
        this.va = !1;
        this.o = new tq(-1, !0, this);
        this.g = this;
        this.L = b;
        this.I = this.D = !1;
        this.W = "uk";
        this.P = !1;
        this.C = !0;
    };
    hr.prototype.G = function () {
        return !1;
    };
    hr.prototype.initialize = function () {
        return (this.va = !0);
    };
    hr.prototype.Fb = function () {
        return this.g.W;
    };
    hr.prototype.Xb = function () {
        return this.g.I;
    };
    var jr = function (a, b, c) {
        if (!a.I || (c === void 0 ? 0 : c)) (a.I = !0), (a.W = b), (a.L = 0), a.g != a || ir(a);
    };
    hr.prototype.getName = function () {
        return this.g.ka;
    };
    hr.prototype.ib = function () {
        return this.g.Z();
    };
    hr.prototype.Z = function () {
        return {};
    };
    hr.prototype.Sa = function () {
        return this.g.L;
    };
    var kr = function (a, b) {
        cc(a.A, b) || (a.A.push(b), b.Hb(a.g), b.kb(a.o), b.Oa() && (a.D = !0));
    };
    hr.prototype.U = function () {
        var a = dr();
        a.g = Cq(!0, this.l, a.C);
    };
    hr.prototype.V = function () {
        br(dr(), this.l);
    };
    hr.prototype.aa = function () {
        return this.o.g;
    };
    var lr = function (a) {
        a = a.g;
        a.V();
        a.U();
        var b = dr();
        b.J = Cq(!1, a.l, b.C);
        cr(dr(), a.l);
        a.o.g = a.aa();
    };
    hr.prototype.sample = function () {};
    hr.prototype.isActive = function () {
        return this.g.C;
    };
    var mr = function (a) {
            a.D = a.A.length
                ? Yb(a.A, function (b) {
                      return b.Oa();
                  })
                : !1;
        },
        nr = function (a) {
            var b = hc(a.A);
            Tb(b, function (c) {
                c.kb(a.o);
            });
        },
        ir = function (a) {
            var b = hc(a.A);
            Tb(b, function (c) {
                c.Hb(a.g);
            });
            a.g != a || nr(a);
        };
    l = hr.prototype;
    l.Hb = function (a) {
        var b = this.g;
        this.g = a.Sa() >= this.L ? a : this;
        b !== this.g ? ((this.C = this.g.C), ir(this)) : this.C !== this.g.C && ((this.C = this.g.C), ir(this));
    };
    l.kb = function (a) {
        if (a.j === this.g) {
            var b = this.o,
                c = this.D;
            if ((c = a && (c === void 0 || !c || b.volume == a.volume) && b.l == a.l)) (b = b.g), (c = a.g), (c = b == c ? !0 : b && c ? b.top == c.top && b.right == c.right && b.bottom == c.bottom && b.left == c.left : !1);
            this.o = a;
            !c && nr(this);
        }
    };
    l.Oa = function () {
        return this.D;
    };
    l.dispose = function () {
        this.P = !0;
    };
    l.Ea = function () {
        return this.P;
    };
    var or = function (a, b, c, d) {
        this.l = a;
        this.g = new I(0, 0, 0, 0);
        this.A = new I(0, 0, 0, 0);
        this.j = b;
        this.R = c;
        this.I = d;
        this.G = !1;
        this.timestamp = -1;
        this.J = new uq(b.o, this.g, new I(0, 0, 0, 0), 0, 0, rq(), 0);
    };
    l = or.prototype;
    l.pd = function () {
        return !0;
    };
    l.qc = function () {};
    l.dispose = function () {
        if (!this.Ea()) {
            var a = this.j;
            dc(a.A, this);
            a.D && this.Oa() && mr(a);
            this.qc();
            this.G = !0;
        }
    };
    l.Ea = function () {
        return this.G;
    };
    l.ib = function () {
        return this.j.ib();
    };
    l.Sa = function () {
        return this.j.Sa();
    };
    l.Fb = function () {
        return this.j.Fb();
    };
    l.Xb = function () {
        return this.j.Xb();
    };
    l.Hb = function () {};
    l.kb = function () {
        this.fb();
    };
    l.Oa = function () {
        return this.I;
    };
    var pr = function (a) {
        this.A = !1;
        this.g = a;
        this.o = function () {};
    };
    l = pr.prototype;
    l.Sa = function () {
        return this.g.Sa();
    };
    l.Fb = function () {
        return this.g.Fb();
    };
    l.Xb = function () {
        return this.g.Xb();
    };
    l.create = function (a, b, c) {
        var d = null;
        this.g && ((d = this.rc(a, b, c)), kr(this.g, d));
        return d;
    };
    l.re = function () {
        return this.Ob();
    };
    l.Ob = function () {
        return !1;
    };
    l.init = function (a) {
        return this.g.initialize() ? (kr(this.g, this), (this.o = a), !0) : !1;
    };
    l.Hb = function (a) {
        a.Sa() == 0 && this.o(a.Fb(), this);
    };
    l.kb = function () {};
    l.Oa = function () {
        return !1;
    };
    l.dispose = function () {
        this.A = !0;
    };
    l.Ea = function () {
        return this.A;
    };
    l.ib = function () {
        return {};
    };
    var qr = function (a, b, c) {
            this.l = c === void 0 ? 0 : c;
            this.j = a;
            this.g = b == null ? "" : b;
        },
        rr = function (a) {
            switch (Math.trunc(a.l)) {
                case -16:
                    return -16;
                case -8:
                    return -8;
                case 0:
                    return 0;
                case 8:
                    return 8;
                case 16:
                    return 16;
                default:
                    return 16;
            }
        },
        sr = function (a, b) {
            return a.l < b.l ? !0 : a.l > b.l ? !1 : a.j < b.j ? !0 : a.j > b.j ? !1 : typeof a.g < typeof b.g ? !0 : typeof a.g > typeof b.g ? !1 : a.g < b.g;
        };
    var tr = function () {
        this.l = 0;
        this.g = [];
        this.j = !1;
    };
    tr.prototype.add = function (a, b, c) {
        ++this.l;
        a = new qr(a, b, c);
        this.g.push(new qr(a.j, a.g, a.l + this.l / 4096));
        this.j = !0;
        return this;
    };
    var ur = function (a, b) {
            Tb(b.g, function (c) {
                a.add(c.j, c.g, rr(c));
            });
        },
        vr = function (a, b) {
            var c = c === void 0 ? 0 : c;
            var d = d === void 0 ? !0 : d;
            yj(b, function (e, f) {
                (d && e === void 0) || a.add(f, e, c);
            });
            return a;
        },
        xr = function (a) {
            var b = wr;
            a.j &&
                (jc(a.g, function (c, d) {
                    return sr(d, c) ? 1 : sr(c, d) ? -1 : 0;
                }),
                (a.j = !1));
            return Xb(
                a.g,
                function (c, d) {
                    d = b(d);
                    return "" + c + (c != "" && d != "" ? "&" : "") + d;
                },
                ""
            );
        };
    var wr = function (a) {
        var b = a.j;
        a = a.g;
        return a === "" ? b : typeof a === "boolean" ? (a ? b : "") : Array.isArray(a) ? (a.length === 0 ? b : b + "=" + a.join()) : b + "=" + (cc(["mtos", "tos", "p"], b) ? a : encodeURIComponent(a));
    };
    var yr = function (a) {
        var b = b === void 0 ? !0 : b;
        this.g = new tr();
        a !== void 0 && ur(this.g, a);
        b && this.g.add("v", "unreleased", -16);
    };
    yr.prototype.toString = function () {
        var a = "//pagead2.googlesyndication.com//pagead/gen_204",
            b = xr(this.g);
        b.length > 0 && (a += "?" + b);
        return a;
    };
    var zr = function (a) {
            var b = [],
                c = [];
            ti(a, function (d, e) {
                if (!(e in Object.prototype) && typeof d != "undefined")
                    switch ((Array.isArray(d) && (d = d.join(",")), (d = [e, "=", d].join("")), e)) {
                        case "adk":
                        case "r":
                        case "tt":
                        case "error":
                        case "mtos":
                        case "tos":
                        case "p":
                        case "bs":
                            b.unshift(d);
                            break;
                        case "req":
                        case "url":
                        case "referrer":
                        case "iframe_loc":
                            c.push(d);
                            break;
                        default:
                            b.push(d);
                    }
            });
            return b.concat(c);
        },
        Ar = function (a) {
            a = a.toString();
            xp();
            Kj(O, a);
        };
    var Br = function () {
        this.g = 0;
    };
    function Cr(a) {
        a && typeof a.dispose == "function" && a.dispose();
    }
    var Q = function () {
        this.L = this.L;
        this.J = this.J;
    };
    Q.prototype.L = !1;
    Q.prototype.Ea = function () {
        return this.L;
    };
    Q.prototype.dispose = function () {
        this.L || ((this.L = !0), this.O());
    };
    Q.prototype[Symbol.dispose] = function () {
        this.dispose();
    };
    var Er = function (a, b) {
            Dr(a, ib(Cr, b));
        },
        Dr = function (a, b) {
            a.L ? b() : (a.J || (a.J = []), a.J.push(b));
        };
    Q.prototype.O = function () {
        if (this.J) for (; this.J.length; ) this.J.shift()();
    };
    var Fr = function (a, b, c) {
        Tb(a.l, function (d) {
            var e = a.g;
            if (!d.g && (d.l(b, c), d.o())) {
                d.g = !0;
                var f = d.j(),
                    g = new tr();
                g.add("id", "av-js");
                g.add("type", "verif");
                g.add("vtype", d.A);
                d = J(Br);
                g.add("i", d.g++);
                g.add("adk", e);
                vr(g, f);
                e = new yr(g);
                Ar(e);
            }
        });
    };
    var Gr = function () {
            this.j = this.l = this.o = this.g = 0;
        },
        Hr = function (a, b, c, d) {
            b && ((a.g += c), (a.j += c), (a.o += c), (a.l = Math.max(a.l, a.o)));
            if (d === void 0 ? !b : d) a.o = 0;
        };
    var Ir = [1, 0.75, 0.5, 0.3, 0],
        Jr = function (a) {
            this.j = a = a === void 0 ? Ir : a;
            this.g = Wb(this.j, function () {
                return new Gr();
            });
        },
        Lr = function (a, b) {
            return Kr(
                a,
                function (c) {
                    return c.g;
                },
                b === void 0 ? !0 : b
            );
        },
        Nr = function (a, b) {
            return Mr(a, b, function (c) {
                return c.g;
            });
        },
        Or = function (a, b) {
            return Kr(
                a,
                function (c) {
                    return c.l;
                },
                b === void 0 ? !0 : b
            );
        },
        Pr = function (a, b) {
            return Mr(a, b, function (c) {
                return c.l;
            });
        },
        Qr = function (a, b) {
            return Mr(a, b, function (c) {
                return c.j;
            });
        },
        Rr = function (a) {
            Tb(a.g, function (b) {
                b.j = 0;
            });
        },
        Sr = function (a, b, c, d, e, f, g) {
            g = g === void 0 ? !0 : g;
            c = f ? Math.min(b, c) : c;
            for (f = 0; f < a.j.length; f++) {
                var h = a.j[f],
                    k = c > 0 && c >= h;
                h = !(b > 0 && b >= h) || d;
                Hr(a.g[f], g && k, e, !g || h);
            }
        },
        Kr = function (a, b, c) {
            a = Wb(a.g, function (d) {
                return b(d);
            });
            return c ? a : Tr(a);
        },
        Mr = function (a, b, c) {
            var d = bc(a.j, function (e) {
                return b <= e;
            });
            return d == -1 ? 0 : c(a.g[d]);
        },
        Tr = function (a) {
            return Wb(a, function (b, c, d) {
                return c > 0 ? d[c] - d[c - 1] : d[c];
            });
        };
    var Ur = function () {
            this.j = new Jr();
            this.W = this.V = 0;
            this.aa = new Gr();
            this.I = this.C = -1;
            this.ka = 1e3;
            this.oa = new Jr([1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1, 0]);
            this.P = this.K = -1;
        },
        Vr = function (a, b) {
            return Or(a.j, b === void 0 ? !0 : b);
        };
    Ur.prototype.L = function (a, b, c, d) {
        this.C = this.C != -1 ? Math.min(this.C, b.X) : b.X;
        this.I = Math.max(this.I, b.X);
        this.K = this.K != -1 ? Math.min(this.K, b.ta) : b.ta;
        this.P = Math.max(this.P, b.ta);
        Sr(this.oa, b.ta, c.ta, b.g, a, d);
        this.V += a;
        b.X === 0 && (this.W += a);
        Sr(this.j, b.X, c.X, b.g, a, d);
        c = d || c.xb != b.xb ? c.isVisible() && b.isVisible() : c.isVisible();
        b = !b.isVisible() || b.g;
        Hr(this.aa, c, a, b);
    };
    Ur.prototype.Va = function () {
        return this.aa.l >= this.ka;
    };
    if (Zo && Zo.URL) {
        var Wr = Zo.URL,
            Xr;
        if ((Xr = !!Wr)) {
            var Yr;
            a: {
                if (Wr) {
                    var Zr = RegExp(".*[&#?]google_debug(=[^&]*)?(&.*)?$");
                    try {
                        var $r = Zr.exec(decodeURIComponent(Wr));
                        if ($r) {
                            Yr = $r[1] && $r[1].length > 1 ? $r[1].substring(1) : "true";
                            break a;
                        }
                    } catch (a) {}
                }
                Yr = "";
            }
            Xr = Yr.length > 0;
        }
        fq.fe(!Xr);
    }
    var as = function (a, b, c, d) {
        var e = e === void 0 ? !1 : e;
        c = jq(d, c);
        Qh(a, b, c, { capture: e });
    };
    var bs = new I(0, 0, 0, 0);
    function cs(a, b) {
        b = ds(b);
        return b === 0 ? 0 : ds(a) / b;
    }
    function ds(a) {
        return Math.max(a.bottom - a.top, 0) * Math.max(a.right - a.left, 0);
    }
    function es(a, b) {
        if (!a || !b) return !1;
        for (var c = 0; a !== null && c++ < 100; ) {
            if (a === b) return !0;
            try {
                if ((a = a.parentElement || a)) {
                    var d = Xi(a),
                        e = d && dj(d),
                        f = e && e.frameElement;
                    f && (a = f);
                }
            } catch (g) {
                break;
            }
        }
        return !1;
    }
    function fs(a, b, c) {
        if (!a || !b) return !1;
        b = Qk(Pk(a), -b.left, -b.top);
        a = (b.left + b.right) / 2;
        b = (b.top + b.bottom) / 2;
        sj(window.top) && window.top && window.top.document && (window = window.top);
        if (!Bq()) return !1;
        a = window.document.elementFromPoint(a, b);
        if (!a) return !1;
        b = (b = (b = Xi(c)) && b.defaultView && b.defaultView.frameElement) && es(b, a);
        var d = a === c;
        a =
            !d &&
            a &&
            kj(a, function (e) {
                return e === c;
            });
        return !(b || d || a);
    }
    function gs(a, b, c, d) {
        return dr().l
            ? !1
            : a.getWidth() <= 0 || a.getHeight() <= 0
            ? !0
            : c && d
            ? iq(208, function () {
                  return fs(a, b, c);
              })
            : !1;
    }
    var hs = new I(0, 0, 0, 0),
        js = function (a, b, c) {
            Q.call(this);
            this.position = Pk(hs);
            this.Uc = this.Ic();
            this.Ld = -2;
            this.ph = Date.now();
            this.mf = -1;
            this.Lc = b;
            this.Kc = null;
            this.Tb = !1;
            this.Zc = null;
            this.opacity = -1;
            this.bh = c;
            this.qh = !1;
            this.Od = function () {};
            this.qf = function () {};
            this.ua = new ap();
            this.ua.ob = a;
            this.ua.g = a;
            this.Ta = !1;
            this.ub = { Rd: null, Qd: null };
            this.gf = !0;
            this.lc = null;
            this.Ib = this.Lg = !1;
            N().B++;
            this.ra = this.Gd();
            this.lf = -1;
            this.ca = null;
            this.Me = this.Ig = !1;
            this.R = new Qo();
            Yo(this.R);
            is(this);
            this.bh == 1 ? To(this.R, "od", 1) : To(this.R, "od", 0);
        };
    x(js, Q);
    js.prototype.O = function () {
        this.ua.g && (this.ub.Rd && (Rh(this.ua.g, "mouseover", this.ub.Rd), (this.ub.Rd = null)), this.ub.Qd && (Rh(this.ua.g, "mouseout", this.ub.Qd), (this.ub.Qd = null)));
        this.lc && this.lc.dispose();
        this.ca && this.ca.dispose();
        delete this.Uc;
        delete this.Od;
        delete this.qf;
        delete this.ua.ob;
        delete this.ua.g;
        delete this.ub;
        delete this.lc;
        delete this.ca;
        delete this.R;
        Q.prototype.O.call(this);
    };
    js.prototype.jb = function () {
        return this.ca ? this.ca.g : this.position;
    };
    js.prototype.Wd = function (a) {
        N().Wd(a);
    };
    var is = function (a) {
        a = a.ua.ob;
        var b;
        if ((b = a && a.getAttribute)) b = /-[a-z]/.test("googleAvInapp") ? !1 : $o && a.dataset ? "googleAvInapp" in a.dataset : a.hasAttribute ? a.hasAttribute("data-" + Ti()) : !!a.getAttribute("data-" + Ti());
        b && (dr().j = !0);
    };
    js.prototype.Oa = function () {
        return !1;
    };
    js.prototype.Ic = function () {
        return new Ur();
    };
    js.prototype.qa = function () {
        return this.Uc;
    };
    var ks = function (a, b) {
            b != a.Ib && ((a.Ib = b), (a = dr()), b ? a.B++ : a.B > 0 && a.B--);
        },
        ls = function (a, b) {
            if (a.ca) {
                if (b.getName() === a.ca.getName()) return;
                a.ca.dispose();
                a.ca = null;
            }
            b = b.create(a.ua.g, a.R, a.Oa());
            if ((b = b != null && b.pd() ? b : null)) a.ca = b;
        },
        ms = function (a, b, c) {
            if (!a.Kc || a.Lc == -1 || b.getTimestamp() === -1 || a.Kc.getTimestamp() === -1) return 0;
            a = b.getTimestamp() - a.Kc.getTimestamp();
            return a > c ? 0 : a;
        };
    js.prototype.Je = function (a) {
        return ms(this, a, 1e4);
    };
    var ns = function (a, b, c) {
            if (a.ca) {
                a.ca.fb();
                var d = a.ca.J,
                    e = d.l,
                    f = e.g;
                if (d.A != null) {
                    var g = d.j;
                    a.Zc = new qi(g.left - f.left, g.top - f.top);
                }
                f = a.jd() ? Math.max(d.g, d.o) : d.g;
                g = {};
                e.volume !== null && (g.volume = e.volume);
                e = a.Je(d);
                a.Kc = d;
                a.je(f, b, c, !1, g, e, d.B);
            }
        },
        os = function (a) {
            if (a.Tb && a.lc) {
                var b = Uo(a.R, "od") == 1,
                    c = dr().g,
                    d = a.lc,
                    e = a.ca ? a.ca.getName() : "ns",
                    f = a.Zc,
                    g = new ri(c.getWidth(), c.getHeight());
                c = a.jd();
                a = { mh: e, Zc: f, Ah: g, jd: c, X: a.ra.X, vh: b };
                if ((b = d.j)) {
                    b.fb();
                    e = b.J;
                    f = e.l.g;
                    var h = (g = null);
                    e.A != null && f && ((g = e.j), (g = new qi(g.left - f.left, g.top - f.top)), (h = new ri(f.right - f.left, f.bottom - f.top)));
                    e = c ? Math.max(e.g, e.o) : e.g;
                    c = { mh: b.getName(), Zc: g, Ah: h, jd: c, vh: !1, X: e };
                } else c = null;
                c && Fr(d, a, c);
            }
        };
    l = js.prototype;
    l.je = function (a, b, c, d, e, f, g) {
        this.Ta ||
            (this.Tb &&
                ((a = this.qd(a, c, e, g)),
                (d = d && this.ra.X >= (this.xb() ? 0.3 : 0.5)),
                this.ke(f, a, d),
                (this.Lc = b),
                a.X > 0 && -1 === this.lf && (this.lf = b),
                this.mf == -1 && this.Va() && (this.mf = b),
                this.Ld == -2 && (this.Ld = ds(this.jb()) ? a.X : -1),
                (this.ra = a)),
            this.Od(this));
    };
    l.ke = function (a, b, c) {
        this.qa().L(a, b, this.ra, c);
    };
    l.Gd = function () {
        return new Eo();
    };
    l.qd = function (a, b, c, d) {
        c = this.Gd();
        c.g = b;
        b = xp().j;
        b = ml(Zo) === 0 ? -1 : b.isVisible() ? 0 : 1;
        c.j = b;
        c.X = this.wd(a);
        c.xb = this.xb();
        c.ta = d;
        return c;
    };
    l.wd = function (a) {
        return this.opacity === 0 && Uo(this.R, "opac") === 1 ? 0 : a;
    };
    l.xb = function () {
        return !1;
    };
    l.jd = function () {
        return this.Ig || this.Lg;
    };
    l.za = function () {
        return 0;
    };
    l.Va = function () {
        return this.Uc.Va();
    };
    l.Le = function () {
        var a = this.Tb;
        a = (this.Me || this.Ea()) && !a;
        var b = N().j !== 2 || this.qh;
        return this.Ta || (b && a) ? 2 : this.Va() ? 4 : 3;
    };
    l.Gc = function () {
        return 0;
    };
    var ps = function (a, b, c) {
        b && (a.Od = b);
        c && (a.qf = c);
    };
    var qs = function () {};
    qs.prototype.next = function () {
        return rs;
    };
    var rs = { done: !0, value: void 0 };
    qs.prototype.Cb = function () {
        return this;
    };
    var ts = function () {
            this.o = this.g = this.l = this.j = this.A = 0;
        },
        us = function (a) {
            var b = {};
            b = ((b.ptlt = Date.now() - a.A), b);
            var c = a.j;
            c && (b.pnk = c);
            (c = a.l) && (b.pnc = c);
            (c = a.o) && (b.pnmm = c);
            (a = a.g) && (b.pns = a);
            return b;
        };
    var vs = function () {
        Eo.call(this);
        this.fullscreen = !1;
        this.volume = void 0;
        this.l = !1;
        this.mediaTime = -1;
    };
    x(vs, Eo);
    var ws = function (a) {
        return Wq(a.volume) && a.volume > 0;
    };
    var ys = function (a, b, c, d) {
            c = c === void 0 ? !0 : c;
            d =
                d === void 0
                    ? function () {
                          return !0;
                      }
                    : d;
            return function (e) {
                var f = e[a];
                if (Array.isArray(f) && d(e)) return xs(f, b, c);
            };
        },
        zs = function (a, b) {
            return function (c) {
                return b(c) ? c[a] : void 0;
            };
        },
        As = function (a) {
            return function (b) {
                for (var c = 0; c < a.length; c++) if (a[c] === b.e || (a[c] === void 0 && !b.hasOwnProperty("e"))) return !0;
                return !1;
            };
        },
        xs = function (a, b, c) {
            return c === void 0 || c
                ? Vb(a, function (d, e) {
                      return cc(b, e);
                  })
                : Wb(b, function (d, e, f) {
                      return a.slice(e > 0 ? f[e - 1] + 1 : 0, d + 1).reduce(function (g, h) {
                          return g + h;
                      }, 0);
                  });
        };
    var Bs = As([void 0, 1, 2, 3, 4, 8, 16]),
        Cs = As([void 0, 4, 8, 16]),
        Ds = {
            sv: "sv",
            v: "v",
            cb: "cb",
            e: "e",
            nas: "nas",
            msg: "msg",
            if: "if",
            sdk: "sdk",
            p: "p",
            p0: zs("p0", Cs),
            p1: zs("p1", Cs),
            p2: zs("p2", Cs),
            p3: zs("p3", Cs),
            cp: "cp",
            tos: "tos",
            mtos: "mtos",
            amtos: "amtos",
            mtos1: ys("mtos1", [0, 2, 4], !1, Cs),
            mtos2: ys("mtos2", [0, 2, 4], !1, Cs),
            mtos3: ys("mtos3", [0, 2, 4], !1, Cs),
            mcvt: "mcvt",
            ps: "ps",
            scs: "scs",
            bs: "bs",
            vht: "vht",
            mut: "mut",
            a: "a",
            a0: zs("a0", Cs),
            a1: zs("a1", Cs),
            a2: zs("a2", Cs),
            a3: zs("a3", Cs),
            ft: "ft",
            dft: "dft",
            at: "at",
            dat: "dat",
            as: "as",
            vpt: "vpt",
            gmm: "gmm",
            std: "std",
            efpf: "efpf",
            swf: "swf",
            nio: "nio",
            px: "px",
            nnut: "nnut",
            vmer: "vmer",
            vmmk: "vmmk",
            vmiec: "vmiec",
            nmt: "nmt",
            tcm: "tcm",
            bt: "bt",
            pst: "pst",
            vpaid: "vpaid",
            dur: "dur",
            vmtime: "vmtime",
            dtos: "dtos",
            dtoss: "dtoss",
            dvs: "dvs",
            dfvs: "dfvs",
            dvpt: "dvpt",
            fmf: "fmf",
            vds: "vds",
            is: "is",
            i0: "i0",
            i1: "i1",
            i2: "i2",
            i3: "i3",
            ic: "ic",
            cs: "cs",
            c: "c",
            c0: zs("c0", Cs),
            c1: zs("c1", Cs),
            c2: zs("c2", Cs),
            c3: zs("c3", Cs),
            mc: "mc",
            nc: "nc",
            mv: "mv",
            nv: "nv",
            qmt: zs("qmtos", Bs),
            qnc: zs("qnc", Bs),
            qmv: zs("qmv", Bs),
            qnv: zs("qnv", Bs),
            raf: "raf",
            rafc: "rafc",
            lte: "lte",
            ces: "ces",
            tth: "tth",
            femt: "femt",
            femvt: "femvt",
            emc: "emc",
            emuc: "emuc",
            emb: "emb",
            avms: "avms",
            nvat: "nvat",
            qi: "qi",
            psm: "psm",
            psv: "psv",
            psfv: "psfv",
            psa: "psa",
            pnk: "pnk",
            pnc: "pnc",
            pnmm: "pnmm",
            pns: "pns",
            ptlt: "ptlt",
            pngs: "pings",
            veid: "veid",
            ssb: "ssb",
            ss0: zs("ss0", Cs),
            ss1: zs("ss1", Cs),
            ss2: zs("ss2", Cs),
            ss3: zs("ss3", Cs),
            dc_rfl: "urlsigs",
            obd: "obd",
            omidp: "omidp",
            omidr: "omidr",
            omidv: "omidv",
            omida: "omida",
            omids: "omids",
            omidpv: "omidpv",
            omidam: "omidam",
            omidct: "omidct",
            omidia: "omidia",
            omiddc: "omiddc",
            omidlat: "omidlat",
            omiddit: "omiddit",
            nopd: "nopd",
            co: "co",
            tm: "tm",
            tu: "tu",
        },
        Es = Object.assign({}, Ds, {
            avid: (function (a) {
                return function () {
                    return a;
                };
            })("audio"),
            avas: "avas",
            vs: "vs",
        }),
        Fs = {
            atos: "atos",
            avt: ys("atos", [2]),
            davs: "davs",
            dafvs: "dafvs",
            dav: "dav",
            ss: (function (a, b) {
                return function (c) {
                    return c[a] === void 0 && b !== void 0 ? b : c[a];
                };
            })("ss", 0),
            t: "t",
        };
    var Gs = function () {
        this.j = this.g = "";
    };
    var Hs = function () {},
        Is = function (a, b) {
            var c = {};
            if (a !== void 0)
                if (b != null)
                    for (var d in b) {
                        var e = b[d];
                        d in Object.prototype || (e != null && (c[d] = typeof e === "function" ? e(a) : a[e]));
                    }
                else Ii(c, a);
            return xr(vr(new tr(), c));
        };
    var Js = function () {
        var a = {};
        this.j =
            ((a.vs = [1, 0]),
            (a.vw = [0, 1]),
            (a.am = [2, 2]),
            (a.a = [4, 4]),
            (a.f = [8, 8]),
            (a.bm = [16, 16]),
            (a.b = [32, 32]),
            (a.avw = [0, 64]),
            (a.avs = [64, 0]),
            (a.pv = [256, 256]),
            (a.gdr = [0, 512]),
            (a.p = [0, 1024]),
            (a.r = [0, 2048]),
            (a.m = [0, 4096]),
            (a.um = [0, 8192]),
            (a.ef = [0, 16384]),
            (a.s = [0, 32768]),
            (a.pmx = [0, 16777216]),
            (a.mut = [33554432, 33554432]),
            (a.umutb = [67108864, 67108864]),
            (a.tvoff = [134217728, 134217728]),
            a);
        this.g = {};
        for (var b in this.j) this.j[b][1] > 0 && (this.g[b] = 0);
        this.l = 0;
    };
    Js.prototype.reportEvent = function (a) {
        var b = this.j[a],
            c = b[1];
        this.l += b[0];
        c > 0 && this.g[a] == 0 && (this.g[a] = 1);
    };
    var Ks = function (a) {
            var b = yi(a.j),
                c = 0,
                d;
            for (d in a.g) cc(b, d) && a.g[d] == 1 && ((c += a.j[d][1]), (a.g[d] = 2));
            return c;
        },
        Ls = function (a) {
            var b = 0,
                c;
            for (c in a.g) {
                var d = a.g[c];
                if (d == 1 || d == 2) b += a.j[c][1];
            }
            return b;
        };
    var Ms = function () {
        this.g = this.j = 0;
    };
    Ms.prototype.getValue = function () {
        return this.j;
    };
    var Ns = function (a, b, c) {
        b >= 32 || (a.g & (1 << b) && !c ? (a.j &= ~(1 << b)) : a.g & (1 << b) || !c || (a.j |= 1 << b), (a.g |= 1 << b));
    };
    var Os = function () {
        Ur.call(this);
        this.l = new Gr();
        this.Z = this.D = this.M = 0;
        this.J = -1;
        this.wa = new Gr();
        this.A = new Gr();
        this.g = new Jr();
        this.B = this.o = -1;
        this.G = new Gr();
        this.ka = 2e3;
        this.U = new Ms();
        this.ga = new Ms();
        this.fa = new Ms();
    };
    x(Os, Ur);
    var Ps = function (a, b, c) {
        var d = a.Z;
        qq || c || a.J == -1 || (d += b - a.J);
        return d;
    };
    Os.prototype.L = function (a, b, c, d) {
        if (!b.l) {
            Ur.prototype.L.call(this, a, b, c, d);
            var e = ws(b) && ws(c),
                f = (d ? Math.min(b.X, c.X) : c.X) >= 0.5;
            Wq(b.volume) && ((this.o = this.o != -1 ? Math.min(this.o, b.volume) : b.volume), (this.B = Math.max(this.B, b.volume)));
            f && ((this.M += a), (this.D += e ? a : 0));
            Sr(this.g, b.X, c.X, b.g, a, d, e);
            Hr(this.l, !0, a);
            Hr(this.A, e, a);
            Hr(this.G, c.fullscreen, a);
            Hr(this.wa, e && !f, a);
            a = Math.floor(b.mediaTime / 1e3);
            Ns(this.U, a, b.isVisible());
            Ns(this.ga, a, b.X >= 1);
            Ns(this.fa, a, ws(b));
        }
    };
    var Qs = function () {
        this.l = !1;
    };
    Qs.prototype.j = function (a) {
        this.l || (this.g(a) ? ((a = this.L.report(this.o, a)), (this.A |= a), (a = a == 0)) : (a = !1), (this.l = a));
    };
    var Rs = function (a, b) {
        this.l = !1;
        this.o = a;
        this.L = b;
        this.A = 0;
    };
    x(Rs, Qs);
    Rs.prototype.g = function () {
        return !0;
    };
    Rs.prototype.B = function () {
        return !1;
    };
    Rs.prototype.getId = function () {
        var a = this,
            b = Ci(function (c) {
                return c == a.o;
            });
        return zq[b].toString();
    };
    Rs.prototype.toString = function () {
        var a = "";
        this.B() && (a += "c");
        this.l && (a += "s");
        this.A > 0 && (a += ":" + this.A);
        return this.getId() + a;
    };
    var Ss = function (a, b) {
        Rs.call(this, a, b);
        this.C = [];
    };
    x(Ss, Rs);
    Ss.prototype.j = function (a, b) {
        b = b === void 0 ? null : b;
        b != null && this.C.push(b);
        Rs.prototype.j.call(this, a);
    };
    var Ts = function () {};
    var Us = function () {};
    x(Us, Ts);
    Us.prototype.j = function () {
        return null;
    };
    Us.prototype.l = function () {
        return [];
    };
    var Vs = function (a, b, c, d) {
        or.call(this, a, b, c, d);
    };
    x(Vs, or);
    l = Vs.prototype;
    l.td = function () {
        if (this.l) {
            var a = this.l,
                b = this.j.g.l;
            try {
                try {
                    var c = Uq(a.getBoundingClientRect());
                } catch (m) {
                    c = new I(0, 0, 0, 0);
                }
                var d = c.right - c.left,
                    e = c.bottom - c.top,
                    f = Kq(a, b),
                    g = f.x,
                    h = f.y;
                var k = new I(Math.round(h), Math.round(g + d), Math.round(h + e), Math.round(g));
            } catch (m) {
                k = Pk(bs);
            }
            this.g = k;
        }
    };
    l.Ae = function () {
        this.A = this.j.o.g;
    };
    l.Ne = function (a) {
        var b = Uo(this.R, "od") == 1;
        return gs(a, this.A, this.l, b);
    };
    l.Be = function () {
        this.timestamp = rq();
    };
    l.fb = function () {
        this.Be();
        this.td();
        if (this.l && typeof this.l.videoWidth === "number" && typeof this.l.videoHeight === "number") {
            var a = this.l;
            var b = new ri(a.videoWidth, a.videoHeight);
            a = this.g;
            var c = a.getWidth(),
                d = a.getHeight(),
                e = b.width;
            b = b.height;
            e <= 0 ||
                b <= 0 ||
                c <= 0 ||
                d <= 0 ||
                ((e /= b),
                (a = Pk(a)),
                e > c / d
                    ? ((c /= e), (d = (d - c) / 2), d > 0 && ((d = a.top + d), (a.top = Math.round(d)), (a.bottom = Math.round(d + c))))
                    : ((d *= e), (c = Math.round((c - d) / 2)), c > 0 && ((c = a.left + c), (a.left = Math.round(c)), (a.right = Math.round(c + d)))));
            this.g = a;
        }
        this.Ae();
        a = this.g;
        c = this.A;
        a = a.left <= c.right && c.left <= a.right && a.top <= c.bottom && c.top <= a.bottom ? new I(Math.max(a.top, c.top), Math.min(a.right, c.right), Math.min(a.bottom, c.bottom), Math.max(a.left, c.left)) : new I(0, 0, 0, 0);
        c = a.top >= a.bottom || a.left >= a.right ? new I(0, 0, 0, 0) : a;
        a = this.j.o;
        b = e = d = 0;
        (this.g.bottom - this.g.top) * (this.g.right - this.g.left) > 0 && (this.Ne(c) ? (c = new I(0, 0, 0, 0)) : ((d = dr().A), (b = new I(0, d.height, d.width, 0)), (d = cs(c, this.g)), (e = cs(c, dr().g)), (b = cs(c, b))));
        c = c.top >= c.bottom || c.left >= c.right ? new I(0, 0, 0, 0) : Qk(c, -this.g.left, -this.g.top);
        er() || (e = d = 0);
        this.J = new uq(a, this.g, c, d, e, this.timestamp, b);
    };
    l.getName = function () {
        return this.j.getName();
    };
    var Ws = new I(0, 0, 0, 0),
        Xs = function (a, b, c) {
            or.call(this, null, a, b, c);
            this.C = a.isActive();
            this.B = 0;
        };
    x(Xs, Vs);
    l = Xs.prototype;
    l.pd = function () {
        this.o();
        return !0;
    };
    l.kb = function () {
        Vs.prototype.fb.call(this);
    };
    l.Be = function () {};
    l.td = function () {};
    l.fb = function () {
        this.o();
        Vs.prototype.fb.call(this);
    };
    l.Hb = function (a) {
        a = a.isActive();
        a !== this.C && (a ? this.o() : ((dr().g = new I(0, 0, 0, 0)), (this.g = new I(0, 0, 0, 0)), (this.A = new I(0, 0, 0, 0)), (this.timestamp = -1)));
        this.C = a;
    };
    function Ys(a) {
        return [a.top, a.left, a.bottom, a.right];
    }
    var Zs = {},
        $s = ((Zs.firstquartile = 0), (Zs.midpoint = 1), (Zs.thirdquartile = 2), (Zs.complete = 3), Zs),
        at = function (a, b, c, d, e, f) {
            f = f === void 0 ? new Us() : f;
            js.call(this, b, c, d);
            this.Vd = e;
            this.zd = 0;
            this.ia = {};
            this.ha = new Js();
            this.rf = {};
            this.ma = "";
            this.qb = null;
            this.Ra = !1;
            this.g = [];
            this.Xa = f.j();
            this.B = f.l();
            this.A = null;
            this.l = -1;
            this.Z = this.G = void 0;
            this.K = this.I = 0;
            this.U = -1;
            this.ka = this.ga = !1;
            this.P = this.D = this.j = this.Nb = this.Qa = 0;
            new Jr();
            this.V = this.aa = 0;
            this.fa = -1;
            this.la = 0;
            this.C = Kh;
            this.M = [this.Ic()];
            this.Eb = 2;
            this.Bb = {};
            this.Bb.pause = "p";
            this.Bb.resume = "r";
            this.Bb.skip = "s";
            this.Bb.mute = "m";
            this.Bb.unmute = "um";
            this.Bb.exitfullscreen = "ef";
            this.o = null;
            this.oa = this.wa = !1;
            this.Db = Math.floor(Date.now() / 1e3 - 1704067200);
            this.W = 0;
        };
    x(at, js);
    at.prototype.Oa = function () {
        return !0;
    };
    var bt = function (a) {
            a.Me = !0;
            a.la != 0 && (a.la = 3);
        },
        ct = function (a) {
            return a === void 0 ? a : Number(a) ? Pq(a, 3) : 0;
        };
    l = at.prototype;
    l.Je = function (a) {
        return ms(this, a, Math.max(1e4, this.l / 3));
    };
    l.je = function (a, b, c, d, e, f, g) {
        var h = this,
            k = this.C(this) || {};
        Ii(k, e);
        this.l = k.duration || this.l;
        this.G = k.isVpaid || this.G;
        this.Z = k.isYouTube || this.Z;
        xp();
        this.oa = !1;
        e = dt(this, b);
        et(this) === 1 && (f = e);
        js.prototype.je.call(this, a, b, c, d, k, f, g);
        this.Xa &&
            this.Xa.l &&
            Tb(this.B, function (m) {
                m.j(h);
            });
    };
    l.ke = function (a, b, c) {
        js.prototype.ke.call(this, a, b, c);
        ft(this).L(a, b, this.ra, c);
        this.ka = ws(this.ra) && ws(b);
        this.U == -1 && this.ga && (this.U = this.qa().l.g);
        this.ha.l = 0;
        a = this.Va();
        b.isVisible() && this.ha.reportEvent("vs");
        a && this.ha.reportEvent("vw");
        Wq(b.volume) && this.ha.reportEvent("am");
        ws(b) ? this.ha.reportEvent("a") : this.ha.reportEvent("mut");
        this.Ib && this.ha.reportEvent("f");
        b.j != -1 && (this.ha.reportEvent("bm"), b.j == 1 && (this.ha.reportEvent("b"), ws(b) && this.ha.reportEvent("umutb")));
        ws(b) && b.isVisible() && this.ha.reportEvent("avs");
        this.ka && a && this.ha.reportEvent("avw");
        b.X > 0 && this.ha.reportEvent("pv");
        gt(this, this.qa().l.g, !0) && this.ha.reportEvent("gdr");
        Pr(this.qa().j, 1) >= 2e3 && this.ha.reportEvent("pmx");
        this.oa && this.ha.reportEvent("tvoff");
    };
    l.Ic = function () {
        return new Os();
    };
    l.qa = function () {
        return this.Uc;
    };
    var ft = function (a, b) {
        return a.M[b != null && b < a.M.length ? b : a.M.length - 1];
    };
    at.prototype.Gd = function () {
        return new vs();
    };
    at.prototype.qd = function (a, b, c, d) {
        a = js.prototype.qd.call(this, a, b, c, d === void 0 ? -1 : d);
        a.fullscreen = this.Ib;
        a.l = this.la == 2;
        a.volume = c.volume;
        Wq(a.volume) || (this.Qa++, (b = this.ra), Wq(b.volume) && (a.volume = b.volume));
        c = c.currentTime;
        a.mediaTime = c !== void 0 && c >= 0 ? c : -1;
        return a;
    };
    var et = function (a) {
            var b = !!Uo(N().R, "umt");
            return a.G || (!b && !a.Z) ? 0 : 1;
        },
        dt = function (a, b) {
            a.la == 2 ? (b = 0) : a.Lc == -1 ? (b = 0) : ((b -= a.Lc), (b = b > Math.max(1e4, a.l / 3) ? 0 : b));
            var c = a.C(a) || {};
            c = c.currentTime !== void 0 ? c.currentTime : a.I;
            var d = c - a.I,
                e = 0;
            d >= 0 ? ((a.K += b), (a.V += Math.max(b - d, 0)), (e = Math.min(d, a.K))) : (a.aa += Math.abs(d));
            d != 0 && (a.K = 0);
            a.fa == -1 && d > 0 && (a.fa = pq >= 0 ? rq() - pq : -1);
            a.I = c;
            return e;
        };
    at.prototype.wd = function (a) {
        return dr(), this.Ib ? 1 : js.prototype.wd.call(this, a);
    };
    at.prototype.za = function () {
        return 1;
    };
    at.prototype.getDuration = function () {
        return this.l;
    };
    var ht = function (a, b) {
            Yb(a.B, function (c) {
                return c.o == b.o;
            }) || a.B.push(b);
        },
        it = function (a) {
            var b = Nr(a.qa().g, 1);
            return gt(a, b);
        },
        gt = function (a, b, c) {
            return b >= 15e3 ? !0 : a.ga ? ((c === void 0 ? 0 : c) ? !0 : a.l > 0 ? b >= a.l / 2 : a.U > 0 ? b >= a.U : !1) : !1;
        },
        jt = function (a) {
            var b = {},
                c = dr();
            b.insideIframe = c.l;
            b.unmeasurable = a.Ta;
            b.position = a.jb();
            b.exposure = a.ra.X;
            b.documentSize = c.o;
            b.viewportSize = new ri(c.g.getWidth(), c.g.getHeight());
            a.o != null && (b.presenceData = a.o);
            b.screenShare = a.ra.ta;
            return b;
        },
        kt = function (a) {
            var b = Pq(a.ra.X, 2),
                c = a.ha.l,
                d = a.ra,
                e = ft(a),
                f = ct(e.o),
                g = ct(e.B),
                h = ct(d.volume),
                k = Pq(e.C, 2),
                m = Pq(e.I, 2),
                n = Pq(d.X, 2),
                p = Pq(e.K, 2),
                q = Pq(e.P, 2);
            d = Pq(d.ta, 2);
            a = Pk(a.jb());
            a.round();
            e = Vr(e, !1);
            return { zh: b, Zb: c, Vc: f, Rc: g, Qb: h, Wc: k, Sc: m, X: n, Xc: p, Tc: q, ta: d, position: a, Yc: e };
        },
        mt = function (a, b) {
            lt(a.g, b, function () {
                return { zh: 0, Zb: void 0, Vc: -1, Rc: -1, Qb: -1, Wc: -1, Sc: -1, X: -1, Xc: -1, Tc: -1, ta: -1, position: void 0, Yc: [] };
            });
            a.g[b] = kt(a);
        },
        lt = function (a, b, c) {
            for (var d = a.length; d < b + 1; ) a.push(c()), d++;
        },
        pt = function (a, b, c) {
            var d = a.rf[b];
            if (d != null) return d;
            d = nt(a, b);
            var e = Ci(function (f) {
                return f == b;
            });
            a = ot(a, d, d, c, $s[Di[e]]);
            b == "fully_viewable_audible_half_duration_impression" && (a.std = "csm");
            return a;
        },
        qt = function (a, b, c) {
            var d = [b];
            if (a != b || c != b) d.unshift(a), d.push(c);
            return d;
        },
        ot = function (a, b, c, d, e) {
            if (a.Ta) return { if: 0, vs: 0 };
            var f = Pk(a.jb());
            f.round();
            var g = dr(),
                h = N(),
                k = a.qa(),
                m = a.ca ? a.ca.getName() : "ns",
                n = {};
            n["if"] = g.l ? 1 : void 0;
            n.sdk = a.A ? a.A : void 0;
            n.t = a.ph;
            n.p = [f.top, f.left, f.bottom, f.right];
            n.tos = Lr(k.j, !1);
            n.mtos = Vr(k);
            n.mcvt = k.aa.l;
            n.ps = void 0;
            n.vht = Ps(k, rq(), a.la == 2);
            n.mut = k.wa.l;
            n.a = ct(a.ra.volume);
            n.mv = ct(k.B);
            n.fs = a.Ib ? 1 : 0;
            n.ft = k.G.g;
            n.at = k.A.g;
            n.as = k.o > 0 ? 1 : 0;
            n.atos = Lr(k.g);
            n.ssb = Lr(k.oa, !1);
            n.amtos = Or(k.g, !1);
            n.uac = a.Qa;
            n.vpt = k.l.g;
            m == "nio" && ((n.nio = 1), (n.avms = "nio"));
            n.gmm = "4";
            n.gdr = gt(a, k.l.g, !0) ? 1 : 0;
            n.efpf = a.Eb;
            if (m == "gsv" || m == "nis") (f = a.ca), f.B > 0 && (n.nnut = f.B);
            n.tcm = et(a);
            n.nmt = a.aa;
            n.bt = a.V;
            n.pst = a.fa;
            n.vpaid = a.G;
            n.dur = a.l;
            n.vmtime = a.I;
            n.is = a.ha.l;
            a.g.length >= 1 && ((n.i0 = a.g[0].Zb), (n.a0 = [a.g[0].Qb]), (n.c0 = [a.g[0].X]), (n.ss0 = [a.g[0].ta]), (f = a.g[0].position), (n.p0 = f ? Ys(f) : void 0));
            a.g.length >= 2 &&
                ((n.i1 = a.g[1].Zb),
                (n.a1 = qt(a.g[1].Vc, a.g[1].Qb, a.g[1].Rc)),
                (n.c1 = qt(a.g[1].Wc, a.g[1].X, a.g[1].Sc)),
                (n.ss1 = qt(a.g[1].Xc, a.g[1].ta, a.g[1].Tc)),
                (f = a.g[1].position),
                (n.p1 = f ? Ys(f) : void 0),
                (n.mtos1 = a.g[1].Yc));
            a.g.length >= 3 &&
                ((n.i2 = a.g[2].Zb),
                (n.a2 = qt(a.g[2].Vc, a.g[2].Qb, a.g[2].Rc)),
                (n.c2 = qt(a.g[2].Wc, a.g[2].X, a.g[2].Sc)),
                (n.ss2 = qt(a.g[2].Xc, a.g[2].ta, a.g[2].Tc)),
                (f = a.g[2].position),
                (n.p2 = f ? Ys(f) : void 0),
                (n.mtos2 = a.g[2].Yc));
            a.g.length >= 4 &&
                ((n.i3 = a.g[3].Zb),
                (n.a3 = qt(a.g[3].Vc, a.g[3].Qb, a.g[3].Rc)),
                (n.c3 = qt(a.g[3].Wc, a.g[3].X, a.g[3].Sc)),
                (n.ss3 = qt(a.g[3].Xc, a.g[3].ta, a.g[3].Tc)),
                (f = a.g[3].position),
                (n.p3 = f ? Ys(f) : void 0),
                (n.mtos3 = a.g[3].Yc));
            n.cs = Ls(a.ha);
            b &&
                ((n.ic = Ks(a.ha)),
                (n.dvpt = k.l.j),
                (n.dvs = Qr(k.j, 0.5)),
                (n.dfvs = Qr(k.j, 1)),
                (n.davs = Qr(k.g, 0.5)),
                (n.dafvs = Qr(k.g, 1)),
                c && ((k.l.j = 0), Rr(k.j), Rr(k.g)),
                a.Va() && ((n.dtos = k.M), (n.dav = k.D), (n.dtoss = a.zd + 1), c && ((k.M = 0), (k.D = 0), a.zd++)),
                (n.dat = k.A.j),
                (n.dft = k.G.j),
                c && ((k.A.j = 0), (k.G.j = 0)));
            n.ps = [g.o.width, g.o.height];
            n.bs = [g.g.getWidth(), g.g.getHeight()];
            n.scs = [g.A.width, g.A.height];
            n.dom = g.domain;
            a.Nb && (n.vds = a.Nb);
            if (a.B.length > 0 || a.Xa)
                (b = hc(a.B)),
                    a.Xa && b.push(a.Xa),
                    (n.pings = Wb(b, function (p) {
                        return p.toString();
                    }));
            b = Wb(
                Vb(a.B, function (p) {
                    return p.B();
                }),
                function (p) {
                    return p.getId();
                }
            );
            ic(b);
            n.ces = b;
            a.j && (n.vmer = a.j);
            a.D && (n.vmmk = a.D);
            a.P && (n.vmiec = a.P);
            n.avms = a.ca ? a.ca.getName() : "ns";
            a.ca && Ii(n, a.ca.ib());
            d ? ((n.c = Pq(a.ra.X, 2)), (n.ss = Pq(a.ra.ta, 2))) : (n.tth = rq() - oq);
            n.mc = Pq(k.I, 2);
            n.nc = Pq(k.C, 2);
            n.mv = ct(k.B);
            n.nv = ct(k.o);
            n.lte = Pq(a.Ld, 2);
            d = ft(a, e);
            Vr(k);
            n.qmtos = Vr(d);
            n.qnc = Pq(d.C, 2);
            n.qmv = ct(d.B);
            n.qnv = ct(d.o);
            n.qas = d.o > 0 ? 1 : 0;
            n.qi = a.ma;
            n.avms || (n.avms = "geo");
            n.psm = k.U.g;
            n.psv = k.U.getValue();
            n.psfv = k.ga.getValue();
            n.psa = k.fa.getValue();
            h = Wo(h.R);
            h.length && (n.veid = h);
            a.o && Ii(n, us(a.o));
            n.avas = a.Gc();
            n.vs = a.Le();
            n.co = rt(a);
            n.tm = k.V;
            n.tu = k.W;
            return n;
        },
        nt = function (a, b) {
            if (cc(yq, b)) return !0;
            var c = a.ia[b];
            return c !== void 0 ? ((a.ia[b] = !0), !c) : !1;
        };
    at.prototype.Le = function () {
        return this.Ta ? 2 : it(this) ? 5 : this.Va() ? 4 : 3;
    };
    at.prototype.Gc = function () {
        return this.wa ? (this.qa().A.l >= 2e3 ? 4 : 3) : 2;
    };
    var rt = function (a) {
        var b = a.W.toString(10).padStart(2, "0");
        b = "" + a.Db + b;
        a.W < 99 && a.W++;
        return b;
    };
    var tt = Date.now(),
        wt = function () {
            this.g = {};
            var a = dj();
            ut(this, a, document);
            var b = vt();
            try {
                if ("1" == b) {
                    for (var c = a.parent; c != a.top; c = c.parent) ut(this, c, c.document);
                    ut(this, a.top, a.top.document);
                }
            } catch (d) {}
        },
        vt = function () {
            var a = document.documentElement;
            try {
                if (!sj(dj().top)) return "2";
                var b = [],
                    c = dj(a.ownerDocument);
                for (a = c; a != c.top; a = a.parent)
                    if (a.frameElement) b.push(a.frameElement);
                    else break;
                return b && b.length != 0 ? "1" : "0";
            } catch (d) {
                return "2";
            }
        },
        ut = function (a, b, c) {
            as(
                c,
                "mousedown",
                function () {
                    return xt(a);
                },
                301
            );
            as(
                b,
                "scroll",
                function () {
                    return yt(a);
                },
                302
            );
            as(
                c,
                "touchmove",
                function () {
                    return zt(a);
                },
                303
            );
            as(
                c,
                "mousemove",
                function () {
                    return At(a);
                },
                304
            );
            as(
                c,
                "keydown",
                function () {
                    return Bt(a);
                },
                305
            );
        },
        xt = function (a) {
            ti(a.g, function (b) {
                b.l > 1e5 || ++b.l;
            });
        },
        yt = function (a) {
            ti(a.g, function (b) {
                b.g > 1e5 || ++b.g;
            });
        },
        zt = function (a) {
            ti(a.g, function (b) {
                b.g > 1e5 || ++b.g;
            });
        },
        Bt = function (a) {
            ti(a.g, function (b) {
                b.j > 1e5 || ++b.j;
            });
        },
        At = function (a) {
            ti(a.g, function (b) {
                b.o > 1e5 || ++b.o;
            });
        };
    var Ct = function () {
            this.g = [];
            this.j = [];
        },
        Dt = function (a, b) {
            return Zb(a.g, function (c) {
                return c.ma == b;
            });
        },
        Et = function (a, b) {
            return b
                ? Zb(a.g, function (c) {
                      return c.ua.ob == b;
                  })
                : null;
        },
        Ft = function (a, b) {
            return Zb(a.j, function (c) {
                return c.za() == 2 && c.ma == b;
            });
        },
        Ht = function () {
            var a = Gt;
            return a.g.length == 0 ? a.j : a.j.length == 0 ? a.g : gc(a.j, a.g);
        };
    Ct.prototype.reset = function () {
        this.g = [];
        this.j = [];
    };
    var It = function (a, b) {
            a = b.za() == 1 ? a.g : a.j;
            var c = $b(a, function (d) {
                return d == b;
            });
            return c != -1 ? (a.splice(c, 1), b.ca && b.ca.qc(), b.dispose(), !0) : !1;
        },
        Jt = function (a) {
            var b = Gt;
            if (It(b, a)) {
                switch (a.za()) {
                    case 0:
                        var c = function () {
                            return null;
                        };
                    case 2:
                        c = function () {
                            return Ft(b, a.ma);
                        };
                        break;
                    case 1:
                        c = function () {
                            return Dt(b, a.ma);
                        };
                }
                for (var d = c(); d; d = c()) It(b, d);
            }
        },
        Kt = function (a) {
            var b = Gt;
            a = Vb(a, function (c) {
                return !Et(b, c.ua.ob);
            });
            b.g.push.apply(b.g, la(a));
        },
        Lt = function (a) {
            var b = [];
            Tb(a, function (c) {
                Yb(Gt.g, function (d) {
                    return d.ua.ob === c.ua.ob && d.ma === c.ma;
                }) || (Gt.g.push(c), b.push(c));
            });
        },
        Gt = J(Ct);
    var Mt = function () {
            this.g = this.j = null;
        },
        Nt = function (a, b) {
            if (a.j == null) return !1;
            var c = function (d, e) {
                b(d, e);
            };
            a.g = Zb(a.j, function (d) {
                return d != null && d.re();
            });
            a.g && (a.g.init(c) ? lr(a.g.g) : b(a.g.g.Fb(), a.g));
            return a.g != null;
        };
    var Pt = function (a) {
        a = Ot(a);
        pr.call(this, a.length ? a[a.length - 1] : new hr(O, 0));
        this.l = a;
        this.j = null;
    };
    x(Pt, pr);
    l = Pt.prototype;
    l.getName = function () {
        return (this.j ? this.j : this.g).getName();
    };
    l.ib = function () {
        return (this.j ? this.j : this.g).ib();
    };
    l.Sa = function () {
        return (this.j ? this.j : this.g).Sa();
    };
    l.init = function (a) {
        var b = !1;
        Tb(this.l, function (c) {
            c.initialize() && (b = !0);
        });
        b && ((this.o = a), kr(this.g, this));
        return b;
    };
    l.dispose = function () {
        Tb(this.l, function (a) {
            a.dispose();
        });
        pr.prototype.dispose.call(this);
    };
    l.re = function () {
        return Yb(this.l, function (a) {
            return a.G();
        });
    };
    l.Ob = function () {
        return Yb(this.l, function (a) {
            return a.G();
        });
    };
    l.rc = function (a, b, c) {
        return new Vs(a, this.g, b, c);
    };
    l.kb = function (a) {
        this.j = a.j;
    };
    var Ot = function (a) {
        if (!a.length) return [];
        a = Vb(a, function (c) {
            return c != null && c.G();
        });
        for (var b = 1; b < a.length; b++) kr(a[b - 1], a[b]);
        return a;
    };
    var Qt = { threshold: [0, 0.3, 0.5, 0.75, 1] },
        Rt = function (a, b, c, d) {
            or.call(this, a, b, c, d);
            this.D = this.L = this.B = this.C = this.o = null;
        };
    x(Rt, Vs);
    Rt.prototype.pd = function () {
        var a = this;
        this.D || (this.D = rq());
        if (
            iq(298, function () {
                return St(a);
            })
        )
            return !0;
        jr(this.j, "msf");
        return !1;
    };
    Rt.prototype.qc = function () {
        if (this.o && this.l)
            try {
                this.o.unobserve(this.l), this.C ? (this.C.unobserve(this.l), (this.C = null)) : this.B && (this.B.disconnect(), (this.B = null));
            } catch (a) {}
    };
    var Tt = function (a) {
            return a.o && a.o.takeRecords ? a.o.takeRecords() : [];
        },
        St = function (a) {
            if (!a.l) return !1;
            var b = a.l,
                c = a.j.g.l,
                d = N().g.g;
            a.o = new c.IntersectionObserver(
                Dp(d, function (e) {
                    return Ut(a, e);
                }),
                Qt
            );
            d = Dp(d, function () {
                a.o.unobserve(b);
                a.o.observe(b);
                Ut(a, Tt(a));
            });
            c.ResizeObserver ? ((a.C = new c.ResizeObserver(d)), a.C.observe(b)) : c.MutationObserver && ((a.B = new y.MutationObserver(d)), a.B.observe(b, { attributes: !0, childList: !0, characterData: !0, subtree: !0 }));
            a.o.observe(b);
            Ut(a, Tt(a));
            return !0;
        },
        Ut = function (a, b) {
            try {
                if (b.length) {
                    a.L || (a.L = rq());
                    var c = Vt(b),
                        d = Kq(a.l, a.j.g.l),
                        e = d.x,
                        f = d.y;
                    a.g = new I(Math.round(f), Math.round(e) + c.boundingClientRect.width, Math.round(f) + c.boundingClientRect.height, Math.round(e));
                    var g = Uq(c.intersectionRect);
                    a.A = Qk(g, a.g.left - g.left, a.g.top - g.top);
                }
            } catch (h) {
                a.qc(), kq(299, h);
            }
        },
        Vt = function (a) {
            return Xb(
                a,
                function (b, c) {
                    return b.time > c.time ? b : c;
                },
                a[0]
            );
        };
    l = Rt.prototype;
    l.fb = function () {
        var a = Tt(this);
        a.length > 0 && Ut(this, a);
        Vs.prototype.fb.call(this);
    };
    l.td = function () {};
    l.Ne = function () {
        return !1;
    };
    l.Ae = function () {};
    l.ib = function () {
        var a = {};
        return Object.assign(this.j.ib(), ((a.niot_obs = this.D), (a.niot_cbk = this.L), a));
    };
    l.getName = function () {
        return "nio";
    };
    var Wt = function (a) {
        a = a === void 0 ? O : a;
        pr.call(this, new hr(a, 2));
    };
    x(Wt, pr);
    Wt.prototype.getName = function () {
        return "nio";
    };
    Wt.prototype.Ob = function () {
        return !dr().j && this.g.g.l.IntersectionObserver != null;
    };
    Wt.prototype.rc = function (a, b, c) {
        return new Rt(a, this.g, b, c);
    };
    var Yt = function () {
        var a = Xt();
        hr.call(this, O.top, a, "geo");
    };
    x(Yt, hr);
    Yt.prototype.aa = function () {
        return dr().g;
    };
    Yt.prototype.G = function () {
        var a = Xt();
        this.L !== a && (this.g != this && a > this.g.L && ((this.g = this), ir(this)), (this.L = a));
        return a == 2;
    };
    var Xt = function () {
        N();
        var a = dr();
        return a.l || a.j ? 0 : 2;
    };
    var Zt = function () {};
    var $t = function () {
            this.done = !1;
            this.g = { Wf: 0, we: 0, tj: 0, Fe: 0, Jd: -1, ig: 0, hg: 0, jg: 0, lh: 0 };
            this.A = null;
            this.B = !1;
            this.l = null;
            this.C = 0;
            this.j = new fr(this);
        },
        cu = function () {
            var a = au;
            a.B ||
                ((a.B = !0),
                bu(a, function () {
                    return a.o.apply(a, la(Ma.apply(0, arguments)));
                }),
                a.o());
        };
    $t.prototype.sample = function () {
        du(this, Ht(), !1);
    };
    var eu = function () {
            J(Zt);
            var a = J(Mt);
            a.g != null && a.g.g ? lr(a.g.g) : $q(dr());
        },
        du = function (a, b, c) {
            if (!a.done && (a.j.cancel(), b.length != 0)) {
                a.l = null;
                try {
                    eu();
                    var d = rq();
                    N().A = d;
                    if (J(Mt).g != null) for (var e = 0; e < b.length; e++) ns(b[e], d, c);
                    for (d = 0; d < b.length; d++) os(b[d]);
                    ++a.g.Fe;
                } finally {
                    c
                        ? Tb(b, function (f) {
                              f.ra.X = 0;
                          })
                        : gr(a.j);
                }
            }
        },
        bu = function (a, b) {
            if (!a.A) {
                b = jq(142, b);
                xp();
                var c = nl(Zo);
                c && Qh(Zo, c, b, { capture: !1 }) && (a.A = b);
            }
        };
    $t.prototype.o = function () {
        var a = er(),
            b = rq();
        a
            ? (qq ||
                  ((mq = b),
                  Tb(Gt.g, function (c) {
                      var d = c.qa();
                      d.Z = Ps(d, b, c.la != 1);
                  })),
              (qq = !0))
            : ((this.C = fu(this, b)),
              (qq = !1),
              (oq = b),
              Tb(Gt.g, function (c) {
                  c.Tb && (c.qa().J = b);
              }));
        du(this, Ht(), !a);
    };
    var gu = function () {
            var a = J(Mt);
            if (a.g != null) {
                var b = a.g;
                Tb(Ht(), function (c) {
                    return ls(c, b);
                });
            }
        },
        fu = function (a, b) {
            a = a.C;
            qq && (a += b - mq);
            return a;
        },
        hu = function (a) {
            a =
                a === void 0
                    ? function () {
                          return {};
                      }
                    : a;
            fq.ee("av-js");
            bq.g = 0.01;
            hq([
                function (b) {
                    var c = N(),
                        d = {};
                    d = ((d.bin = c.j), (d.type = "error"), d);
                    c = Vo(c.R);
                    if (!au.l) {
                        var e = au,
                            f = O.document,
                            g = nq >= 0 ? rq() - nq : -1,
                            h = rq();
                        e.g.Jd == -1 && (g = h);
                        var k = dr(),
                            m = N(),
                            n = Vo(m.R),
                            p = Ht();
                        try {
                            if (p.length > 0) {
                                var q = k.g;
                                q && (n.bs = [q.getWidth(), q.getHeight()]);
                                var t = k.o;
                                t && (n.ps = [t.width, t.height]);
                                O.screen && (n.scs = [O.screen.width, O.screen.height]);
                            } else (n.url = encodeURIComponent(O.location.href.substring(0, 512))), f.referrer && (n.referrer = encodeURIComponent(f.referrer.substring(0, 512)));
                            n.tt = g;
                            n.pt = nq;
                            n.bin = m.j;
                            O.google_osd_load_pub_page_exp !== void 0 && (n.olpp = O.google_osd_load_pub_page_exp);
                            n.deb = [1, e.g.Wf, e.g.we, e.g.Fe, e.g.Jd, 0, e.j.j, e.g.ig, e.g.hg, e.g.jg, e.g.lh, -1].join(";");
                            n.tvt = fu(e, h);
                            k.j && (n.inapp = 1);
                            if (O !== null && O != O.top) {
                                p.length > 0 && (n.iframe_loc = encodeURIComponent(O.location.href.substring(0, 512)));
                                var u = k.J;
                                n.is = [u.getWidth(), u.getHeight()];
                            }
                        } catch (E) {
                            n.error = 1;
                        }
                        au.l = n;
                    }
                    t = au.l;
                    q = {};
                    for (var v in t) q[v] = t[v];
                    v = N().g;
                    if (Uo(v.l, "prf") == 1) {
                        t = new Bp();
                        u = v.g;
                        e = 0;
                        u.g > -1 && (e = u.l.g.now() - u.g);
                        u = u.o + e;
                        if (u != null && typeof u !== "number") throw Error("Value of float/double field must be a number, found " + typeof u + ": " + u);
                        t = Vf(t, 1, u, 0);
                        u = v.g;
                        t = Cg(t, 5, u.g > -1 ? u.j + 1 : u.j);
                        t = Dg(t, 2, v.j.g.l());
                        t = Dg(t, 3, v.j.g.j());
                        v = Dg(t, 4, v.j.g.g());
                        t = {};
                        v = ((t.pf = Sc(v.g())), t);
                    } else v = {};
                    Ii(q, v);
                    Ii(b, d, c, q, a());
                },
            ]);
        },
        au = J($t);
    var iu = null,
        ju = "",
        ku = !1,
        lu = function () {
            var a = iu || O;
            if (!a) return "";
            var b = [];
            if (!a.location || !a.location.href) return "";
            b.push("url=" + encodeURIComponent(a.location.href.substring(0, 512)));
            a.document && a.document.referrer && b.push("referrer=" + encodeURIComponent(a.document.referrer.substring(0, 512)));
            return b.join("&");
        };
    function mu() {
        var a =
                "av.default_js_unreleased_RCxx".match(/_(\d{8})_RC\d+$/) ||
                "av.default_js_unreleased_RCxx".match(/_(\d{8})_\d+_\d+$/) ||
                "av.default_js_unreleased_RCxx".match(/_(\d{8})_\d+\.\d+$/) ||
                "av.default_js_unreleased_RCxx".match(/_(\d{8})_\d+_RC\d+$/),
            b;
        if (((b = a) == null ? void 0 : b.length) == 2) return a[1];
        a = "av.default_js_unreleased_RCxx".match(/.*_(\d{2})\.(\d{4})\.\d+_RC\d+$/);
        var c;
        return ((c = a) == null ? void 0 : c.length) == 3 ? "20" + a[1] + a[2] : null;
    }
    var nu = function () {
            return "ima_html5_sdk".includes("ima_html5_sdk")
                ? { Ka: "ima", La: null }
                : "ima_html5_sdk".includes("ima_native_sdk")
                ? { Ka: "nima", La: null }
                : "ima_html5_sdk".includes("admob-native-video-javascript")
                ? { Ka: "an", La: null }
                : "av.default_js_unreleased_RCxx".includes("cast_js_sdk")
                ? { Ka: "cast", La: mu() }
                : "av.default_js_unreleased_RCxx".includes("youtube.player.web")
                ? { Ka: "yw", La: mu() }
                : "av.default_js_unreleased_RCxx".includes("outstream_web_client")
                ? { Ka: "out", La: mu() }
                : "av.default_js_unreleased_RCxx".includes("drx_rewarded_web")
                ? { Ka: "r", La: mu() }
                : "av.default_js_unreleased_RCxx".includes("gam_native_web_video")
                ? { Ka: "n", La: mu() }
                : "av.default_js_unreleased_RCxx".includes("admob_interstitial_video")
                ? { Ka: "int", La: mu() }
                : { Ka: "j", La: null };
        },
        ou = nu().Ka,
        pu = nu().La;
    var ru = function (a, b) {
            var c = { sv: "964" };
            pu !== null && (c.v = pu);
            c.cb = ou;
            c.nas = Gt.g.length;
            c.msg = a;
            b !== void 0 && (a = qu(b)) && (c.e = zq[a]);
            return c;
        },
        tu = function (a) {
            return a.lastIndexOf("custom_metric_viewable", 0) == 0;
        },
        qu = function (a) {
            var b = tu(a) ? "custom_metric_viewable" : a.toLowerCase();
            return Ci(function (c) {
                return c == b;
            });
        };
    var uu = { Sh: "visible", Dh: "audible", Ni: "time", Pi: "timetype" },
        vu = {
            visible: function (a) {
                return /^(100|[0-9]{1,2})$/.test(a);
            },
            audible: function (a) {
                return a == "0" || a == "1";
            },
            timetype: function (a) {
                return a == "mtos" || a == "tos";
            },
            time: function (a) {
                return /^(100|[0-9]{1,2})%$/.test(a) || /^([0-9])+ms$/.test(a);
            },
        },
        wu = function () {
            this.g = void 0;
            this.j = !1;
            this.l = 0;
            this.o = -1;
            this.A = "tos";
        },
        xu = function (a) {
            try {
                var b = a.split(",");
                return b.length > yi(uu).length
                    ? null
                    : Xb(
                          b,
                          function (c, d) {
                              d = d.toLowerCase().split("=");
                              if (d.length != 2 || vu[d[0]] === void 0 || !vu[d[0]](d[1])) throw Error("Entry (" + d[0] + ", " + d[1] + ") is invalid.");
                              c[d[0]] = d[1];
                              return c;
                          },
                          {}
                      );
            } catch (c) {
                return null;
            }
        },
        yu = function (a, b) {
            if (a.g == void 0) return 0;
            switch (a.A) {
                case "mtos":
                    return a.j ? Pr(b.g, a.g) : Pr(b.j, a.g);
                case "tos":
                    return a.j ? Nr(b.g, a.g) : Nr(b.j, a.g);
            }
            return 0;
        };
    var zu = function (a, b, c, d) {
        Rs.call(this, b, d);
        this.C = a;
        this.J = c;
    };
    x(zu, Rs);
    zu.prototype.getId = function () {
        return this.C;
    };
    zu.prototype.B = function () {
        return !0;
    };
    zu.prototype.g = function (a) {
        var b = a.qa(),
            c = a.getDuration();
        return Yb(this.J, function (d) {
            if (d.g != void 0) var e = yu(d, b);
            else
                b: {
                    switch (d.A) {
                        case "mtos":
                            e = d.j ? b.A.l : b.l.g;
                            break b;
                        case "tos":
                            e = d.j ? b.A.g : b.l.g;
                            break b;
                    }
                    e = 0;
                }
            e == 0 ? (d = !1) : ((d = d.l != -1 ? d.l : c !== void 0 && c > 0 ? d.o * c : -1), (d = d != -1 && e >= d));
            return d;
        });
    };
    var Au = function () {};
    x(Au, Hs);
    Au.prototype.g = function (a) {
        var b = new Gs();
        b.g = Is(a, Ds);
        b.j = Is(a, Fs);
        return b;
    };
    var Bu = function (a) {
        Rs.call(this, "fully_viewable_audible_half_duration_impression", a);
    };
    x(Bu, Rs);
    Bu.prototype.g = function (a) {
        return it(a);
    };
    var Cu = function (a) {
        this.g = a;
    };
    x(Cu, Ts);
    var Du = function (a, b) {
        Rs.call(this, a, b);
    };
    x(Du, Rs);
    Du.prototype.g = function (a) {
        return a.qa().Va();
    };
    var Eu = function (a) {
        Ss.call(this, "measurable_impression", a);
    };
    x(Eu, Ss);
    Eu.prototype.g = function (a) {
        var b = cc(this.C, Uo(N().R, "ovms"));
        return !a.Ta && (a.la != 0 || b);
    };
    var Fu = function () {
        Cu.apply(this, arguments);
    };
    x(Fu, Cu);
    Fu.prototype.j = function () {
        return new Eu(this.g);
    };
    Fu.prototype.l = function () {
        return [new Du("viewable_impression", this.g), new Bu(this.g)];
    };
    var Gu = function (a, b, c) {
        Xs.call(this, a, b, c);
    };
    x(Gu, Xs);
    Gu.prototype.o = function () {
        var a = Ta("ima.admob.getViewability"),
            b = Uo(this.R, "queryid");
        typeof a === "function" && b && a(b);
    };
    Gu.prototype.getName = function () {
        return "gsv";
    };
    var Hu = function (a) {
        a = a === void 0 ? O : a;
        pr.call(this, new hr(a, 2));
    };
    x(Hu, pr);
    Hu.prototype.getName = function () {
        return "gsv";
    };
    Hu.prototype.Ob = function () {
        var a = dr();
        N();
        return a.j && !1;
    };
    Hu.prototype.rc = function (a, b, c) {
        return new Gu(this.g, b, c);
    };
    var Iu = function (a, b, c) {
        Xs.call(this, a, b, c);
    };
    x(Iu, Xs);
    Iu.prototype.o = function () {
        var a = this,
            b = Ta("ima.bridge.getNativeViewability"),
            c = Uo(this.R, "queryid");
        typeof b === "function" &&
            c &&
            b(c, function (d) {
                Ei(d) && a.B++;
                var e = d.opt_nativeViewVisibleBounds || {},
                    f = d.opt_nativeViewHidden;
                a.g = Vq(d.opt_nativeViewBounds || {});
                var g = a.j.o;
                g.g = f ? Pk(Ws) : Vq(e);
                a.timestamp = d.opt_nativeTime || -1;
                dr().g = g.g;
                d = d.opt_nativeVolume;
                d !== void 0 && (g.volume = d);
            });
    };
    Iu.prototype.getName = function () {
        return "nis";
    };
    var Ju = function (a) {
        a = a === void 0 ? O : a;
        pr.call(this, new hr(a, 2));
    };
    x(Ju, pr);
    Ju.prototype.getName = function () {
        return "nis";
    };
    Ju.prototype.Ob = function () {
        var a = dr();
        N();
        return a.j && !1;
    };
    Ju.prototype.rc = function (a, b, c) {
        return new Iu(this.g, b, c);
    };
    var Ku = function () {
        hr.call(this, O, 2, "mraid");
        this.fa = 0;
        this.K = this.M = !1;
        this.J = null;
        this.j = Aq(this.l);
        this.o.g = new I(0, 0, 0, 0);
        this.ga = !1;
    };
    x(Ku, hr);
    Ku.prototype.G = function () {
        return this.j.Fa != null;
    };
    Ku.prototype.Z = function () {
        var a = {};
        this.fa && (a.mraid = this.fa);
        this.M && (a.mlc = 1);
        a.mtop = this.j.kh;
        this.J && (a.mse = this.J);
        this.ga && (a.msc = 1);
        a.mcp = this.j.Dc;
        return a;
    };
    Ku.prototype.B = function (a) {
        var b = Ma.apply(1, arguments);
        try {
            return this.j.Fa[a].apply(this.j.Fa, b);
        } catch (c) {
            kq(538, c, 0.01, function (d) {
                d.method = a;
            });
        }
    };
    var Lu = function (a, b, c) {
        a.B("addEventListener", b, c);
    };
    Ku.prototype.initialize = function () {
        var a = this;
        if (this.va) return !this.Xb();
        this.va = !0;
        if (this.j.Dc === 2) return (this.J = "ng"), jr(this, "w"), !1;
        if (this.j.Dc === 1) return (this.J = "mm"), jr(this, "w"), !1;
        dr().L = !0;
        this.l.document.readyState && this.l.document.readyState == "complete"
            ? Mu(this)
            : as(
                  this.l,
                  "load",
                  function () {
                      xp().setTimeout(
                          jq(292, function () {
                              return Mu(a);
                          }),
                          100
                      );
                  },
                  292
              );
        return !0;
    };
    var Mu = function (a) {
            N().o = !!a.B("isViewable");
            Lu(a, "viewableChange", Nu);
            a.B("getState") === "loading" ? Lu(a, "ready", Ou) : Pu(a);
        },
        Pu = function (a) {
            typeof a.j.Fa.AFMA_LIDAR === "string" ? ((a.M = !0), Qu(a)) : ((a.j.Dc = 3), (a.J = "nc"), jr(a, "w"));
        },
        Qu = function (a) {
            a.K = !1;
            var b = Uo(N().R, "rmmt") == 1,
                c = !!a.B("isViewable");
            (b ? !c : 1) &&
                xp().setTimeout(
                    jq(524, function () {
                        a.K || (Ru(a), kq(540, Error()), (a.J = "mt"), jr(a, "w"));
                    }),
                    500
                );
            Su(a);
            Lu(a, a.j.Fa.AFMA_LIDAR, Tu);
        },
        Su = function (a) {
            var b = Uo(N().R, "sneio") == 1,
                c = a.j.Fa.AFMA_LIDAR_EXP_1 !== void 0,
                d = a.j.Fa.AFMA_LIDAR_EXP_2 !== void 0;
            (b = b && d) && (a.j.Fa.AFMA_LIDAR_EXP_2 = !0);
            c && (a.j.Fa.AFMA_LIDAR_EXP_1 = !b);
        },
        Ru = function (a) {
            a.B("removeEventListener", a.j.Fa.AFMA_LIDAR, Tu);
            a.M = !1;
        };
    Ku.prototype.U = function () {
        var a = dr(),
            b = Uu(this, "getMaxSize");
        a.g = new I(0, b.width, b.height, 0);
    };
    Ku.prototype.V = function () {
        dr().A = Uu(this, "getScreenSize");
    };
    var Uu = function (a, b) {
        if (a.B("getState") === "loading") return new ri(-1, -1);
        b = a.B(b);
        if (!b) return new ri(-1, -1);
        a = parseInt(b.width, 10);
        b = parseInt(b.height, 10);
        return isNaN(a) || isNaN(b) ? new ri(-1, -1) : new ri(a, b);
    };
    Ku.prototype.dispose = function () {
        Ru(this);
        hr.prototype.dispose.call(this);
    };
    var Ou = function () {
            try {
                var a = J(Ku);
                a.B("removeEventListener", "ready", Ou);
                Pu(a);
            } catch (b) {
                kq(541, b);
            }
        },
        Tu = function (a, b) {
            try {
                var c = J(Ku);
                c.K = !0;
                var d = a ? new I(a.y, a.x + a.width, a.y + a.height, a.x) : new I(0, 0, 0, 0);
                var e = rq(),
                    f = er();
                var g = new tq(e, f, c);
                g.g = d;
                g.volume = b;
                c.kb(g);
            } catch (h) {
                kq(542, h);
            }
        },
        Nu = function (a) {
            var b = N(),
                c = J(Ku);
            a && !b.o && ((b.o = !0), (c.ga = !0), c.J && jr(c, "w", !0));
        };
    var Wp = new (function (a, b) {
        this.key = a;
        this.defaultValue = b === void 0 ? !1 : b;
        this.valueType = "boolean";
    })("45378663");
    var Wu = function () {
        this.l = this.va = !1;
        this.g = this.j = null;
        var a = {};
        this.M =
            ((a.start = this.Eg),
            (a.firstquartile = this.zg),
            (a.midpoint = this.Bg),
            (a.thirdquartile = this.Fg),
            (a.complete = this.wg),
            (a.error = this.xg),
            (a.pause = this.Ud),
            (a.resume = this.df),
            (a.skip = this.Dg),
            (a.viewable_impression = this.Na),
            (a.mute = this.Mb),
            (a.unmute = this.Mb),
            (a.fullscreen = this.Ag),
            (a.exitfullscreen = this.yg),
            (a.fully_viewable_audible_half_duration_impression = this.Na),
            (a.measurable_impression = this.Na),
            (a.abandon = this.Ud),
            (a.engagedview = this.Na),
            (a.impression = this.Na),
            (a.creativeview = this.Na),
            (a.progress = this.Mb),
            (a.custom_metric_viewable = this.Na),
            (a.bufferstart = this.Ud),
            (a.bufferfinish = this.df),
            (a.audio_measurable = this.Na),
            (a.audio_audible = this.Na),
            a);
        a = {};
        this.U =
            ((a.overlay_resize = this.Cg),
            (a.abandon = this.Id),
            (a.close = this.Id),
            (a.collapse = this.Id),
            (a.overlay_unmeasurable_impression = function (b) {
                return pt(b, "overlay_unmeasurable_impression", er());
            }),
            (a.overlay_viewable_immediate_impression = function (b) {
                return pt(b, "overlay_viewable_immediate_impression", er());
            }),
            (a.overlay_unviewable_impression = function (b) {
                return pt(b, "overlay_unviewable_impression", er());
            }),
            (a.overlay_viewable_end_of_session_impression = function (b) {
                return pt(b, "overlay_viewable_end_of_session_impression", er());
            }),
            a);
        N().j = 3;
        Vu(this);
    };
    Wu.prototype.A = function (a) {
        ks(a, !1);
        Jt(a);
    };
    Wu.prototype.J = function () {};
    var Xu = function (a, b, c, d) {
        a = a.B(null, d, !0, b);
        a.A = c;
        Kt([a]);
        return a;
    };
    Wu.prototype.B = function (a, b, c, d) {
        var e = this;
        a = new at(O, a, c ? b : -1, 7, this.xd(), this.Ee());
        a.ma = d;
        So(a.R);
        To(a.R, "queryid", a.ma);
        a.Wd("");
        ps(
            a,
            function () {
                return e.K.apply(e, la(Ma.apply(0, arguments)));
            },
            function () {
                return e.P.apply(e, la(Ma.apply(0, arguments)));
            }
        );
        (d = J(Mt).g) && ls(a, d);
        a.ua.ob && J(Zt);
        return a;
    };
    var Yu = function (a, b, c) {
            Ao(b);
            var d = a.g;
            Tb(b, function (e) {
                var f = Wb(e.l, function (g) {
                    var h = xu(g);
                    if (h == null) g = null;
                    else if (((g = new wu()), h.visible != null && (g.g = h.visible / 100), h.audible != null && (g.j = h.audible == 1), h.time != null)) {
                        var k = h.timetype == "mtos" ? "mtos" : "tos",
                            m = vb(h.time, "%") ? "%" : "ms";
                        h = parseInt(h.time, 10);
                        m == "%" && (h /= 100);
                        m == "ms" ? ((g.l = h), (g.o = -1)) : ((g.l = -1), (g.o = h));
                        g.A = k === void 0 ? "tos" : k;
                    }
                    return g;
                });
                Yb(f, function (g) {
                    return g == null;
                }) || ht(c, new zu(e.id, e.g, f, d));
            });
        },
        Zu = function () {
            var a = [],
                b = N();
            a.push(J(Yt));
            Uo(b.R, "mvp_lv") && a.push(J(Ku));
            b = [new Hu(), new Ju()];
            b.push(new Pt(a));
            b.push(new Wt(O));
            return b;
        },
        av = function (a) {
            if (!a.va) {
                a.va = !0;
                try {
                    var b = rq(),
                        c = N(),
                        d = dr();
                    nq = b;
                    c.l = 79463069;
                    a.j !== "o" && (iu = Ij(O));
                    if (yp()) {
                        au.g.we = 0;
                        au.g.Jd = rq() - b;
                        var e = Zu(),
                            f = J(Mt);
                        f.j = e;
                        Nt(f, function () {
                            $u();
                        })
                            ? au.done || (gu(), kr(f.g.g, a), cu())
                            : d.l
                            ? $u()
                            : cu();
                    } else ku = !0;
                } catch (g) {
                    throw (Gt.reset(), g);
                }
            }
        },
        bv = function (a) {
            au.j.cancel();
            ju = a;
            au.done = !0;
        },
        cv = function (a) {
            if (a.j) return a.j;
            var b = J(Mt).g;
            if (b)
                switch (b.getName()) {
                    case "nis":
                        a.j = "n";
                        break;
                    case "gsv":
                        a.j = "m";
                }
            a.j || (a.j = "h");
            return a.j;
        },
        dv = function (a, b, c) {
            if (a.g == null) return (b.Nb |= 4), !1;
            a = a.g.report(c, b);
            b.Nb |= a;
            return a == 0;
        };
    Wu.prototype.Hb = function (a) {
        switch (a.Sa()) {
            case 0:
                if ((a = J(Mt).g)) (a = a.g), dc(a.A, this), a.D && this.Oa() && mr(a);
                $u();
                break;
            case 2:
                cu();
        }
    };
    Wu.prototype.kb = function () {};
    Wu.prototype.Oa = function () {
        return !1;
    };
    var $u = function () {
        var a = [new Wt(O)],
            b = J(Mt);
        b.j = a;
        Nt(b, function () {
            bv("i");
        })
            ? au.done || (gu(), cu())
            : bv("i");
    };
    Wu.prototype.P = function (a, b) {
        a.Ta = !0;
        switch (a.za()) {
            case 1:
                ev(a, b);
                break;
            case 2:
                this.Zd(a);
        }
        this.de(a);
    };
    var ev = function (a, b) {
        if (!a.Ra) {
            var c = pt(a, "start", er());
            c = a.Vd.g(c).g;
            var d = { id: "lidarv" };
            d.r = b;
            d.sv = "964";
            pu !== null && (d.v = pu);
            pj(c, function (e, f) {
                return (d[e] = e == "mtos" || e == "tos" ? f : encodeURIComponent(f));
            });
            b = lu();
            pj(b, function (e, f) {
                return (d[e] = encodeURIComponent(f));
            });
            b = "//pagead2.googlesyndication.com/pagead/gen_204?" + xr(vr(new tr(), d));
            Ar(b);
            a.Ra = !0;
        }
    };
    l = Wu.prototype;
    l.Eg = function (a) {
        var b = a.C(a);
        b && ((b = b.volume), (a.wa = Wq(b) && b > 0));
        mt(a, 0);
        return pt(a, "start", er());
    };
    l.Mb = function (a, b, c) {
        du(au, [a], !er());
        return this.Na(a, b, c);
    };
    l.Na = function (a, b, c) {
        return pt(a, c, er());
    };
    l.zg = function (a) {
        return fv(a, "firstquartile", 1);
    };
    l.Bg = function (a) {
        a.ga = !0;
        return fv(a, "midpoint", 2);
    };
    l.Fg = function (a) {
        return fv(a, "thirdquartile", 3);
    };
    l.wg = function (a) {
        var b = fv(a, "complete", 4);
        bt(a);
        return b;
    };
    l.xg = function (a) {
        a.la = 3;
        return pt(a, "error", er());
    };
    var fv = function (a, b, c) {
        du(au, [a], !er());
        mt(a, c);
        c != 4 && lt(a.M, c, a.Ic);
        return pt(a, b, er());
    };
    l = Wu.prototype;
    l.df = function (a, b, c) {
        b = er();
        a.la != 2 || b || (a.qa().J = rq());
        du(au, [a], !b);
        a.la == 2 && (a.la = 1);
        return pt(a, c, b);
    };
    l.Dg = function (a, b) {
        b = this.Mb(a, b || {}, "skip");
        bt(a);
        return b;
    };
    l.Ag = function (a, b) {
        ks(a, !0);
        return this.Mb(a, b || {}, "fullscreen");
    };
    l.yg = function (a, b) {
        ks(a, !1);
        return this.Mb(a, b || {}, "exitfullscreen");
    };
    l.Ud = function (a, b, c) {
        b = a.qa();
        b.Z = Ps(b, rq(), a.la != 1);
        du(au, [a], !er());
        a.la == 1 && (a.la = 2);
        return pt(a, c, er());
    };
    l.Cg = function (a) {
        du(au, [a], !er());
        return a.j();
    };
    l.Id = function (a) {
        du(au, [a], !er());
        this.af(a);
        bt(a);
        return a.j();
    };
    var Vu = function (a) {
            hu(function () {
                var b = gv();
                a.j != null && (b.sdk = a.j);
                var c = J(Mt);
                c.g != null && (b.avms = c.g.getName());
                return b;
            });
        },
        hv = function (a, b, c, d) {
            var e = Et(Gt, c);
            e !== null && e.ma !== b && (a.A(e), (e = null));
            e || ((b = a.B(c, rq(), !1, b)), Gt.j.length == 0 && (N().l = 79463069), Lt([b]), (e = b), (e.A = cv(a)), d && (e.qb = d));
            return e;
        };
    Wu.prototype.K = function () {};
    var jv = function (a, b) {
        b.D = 0;
        for (var c in vq) a[c] == null && (b.D |= vq[c]);
        iv(a, "currentTime");
        iv(a, "duration");
    };
    l = Wu.prototype;
    l.Zd = function () {};
    l.af = function () {};
    l.se = function () {};
    l.de = function () {};
    l.yd = function () {};
    l.Ee = function () {
        this.g || (this.g = this.yd());
        return this.g == null || this.l ? new Us() : new Fu(this.g);
    };
    l.xd = function () {
        return new Au();
    };
    var iv = function (a, b) {
            var c = a[b];
            c !== void 0 && c > 0 && (a[b] = Math.floor(c * 1e3));
        },
        gv = function () {
            var a = dr(),
                b = {},
                c = {},
                d = {};
            return Object.assign({}, ((b.sv = "964"), b), pu !== null && ((c.v = pu), c), ((d["if"] = a.l ? "1" : "0"), (d.nas = String(Gt.g.length)), d));
        };
    var kv = function (a) {
        Rs.call(this, "audio_audible", a);
    };
    x(kv, Rs);
    kv.prototype.g = function (a) {
        return a.Gc() == 4;
    };
    var lv = function (a) {
        Ss.call(this, "audio_measurable", a);
    };
    x(lv, Ss);
    lv.prototype.g = function (a) {
        a = a.Gc();
        return a == 3 || a == 4;
    };
    var mv = function () {
        Cu.apply(this, arguments);
    };
    x(mv, Cu);
    mv.prototype.j = function () {
        return new lv(this.g);
    };
    mv.prototype.l = function () {
        return [new kv(this.g)];
    };
    var nv = function () {};
    x(nv, Hs);
    nv.prototype.g = function (a) {
        a && (a.e === 28 && (a = Object.assign({}, a, { avas: 3 })), a.vs === 4 || a.vs === 5) && (a = Object.assign({}, a, { vs: 3 }));
        var b = new Gs();
        b.g = Is(a, Es);
        b.j = Is(a, Fs);
        return b;
    };
    var ov = function (a) {
        this.j = a;
    };
    ov.prototype.report = function (a, b) {
        var c = this.g(b);
        if (typeof c === "function") {
            var d = {};
            var e = {};
            d = Object.assign({}, pu !== null && ((d.v = pu), d), ((e.sv = "964"), (e.cb = ou), (e.e = pv(a)), e));
            e = pt(b, a, er());
            Ii(d, e);
            b.rf[a] = e;
            d = b.za() == 2 ? zr(d).join("&") : b.Vd.g(d).g;
            try {
                return c(b.ma, d, a), 0;
            } catch (f) {
                return 2;
            }
        } else return 1;
    };
    var pv = function (a) {
        var b = tu(a) ? "custom_metric_viewable" : a;
        a = Ci(function (c) {
            return c == b;
        });
        return zq[a];
    };
    ov.prototype.g = function () {
        return Ta(this.j);
    };
    var qv = function (a, b) {
        this.j = a;
        this.l = b;
    };
    x(qv, ov);
    qv.prototype.g = function (a) {
        if (!a.qb) return ov.prototype.g.call(this, a);
        if (this.l[a.qb]) return function () {};
        kq(393, Error());
        return null;
    };
    var rv = function () {
        Wu.call(this);
        this.D = void 0;
        this.G = null;
        this.L = !1;
        this.o = {};
        this.I = 0;
        this.C = "ACTIVE_VIEW_TRAFFIC_TYPE_UNSPECIFIED";
    };
    x(rv, Wu);
    rv.prototype.J = function (a, b) {
        var c = this,
            d = J(Mt);
        if (d.g != null)
            switch (d.g.getName()) {
                case "nis":
                    var e = tv(this, a, b);
                    break;
                case "gsv":
                    e = uv(this, a, b);
                    break;
                case "exc":
                    e = vv(this, a);
            }
        e || (b.opt_overlayAdElement ? (e = void 0) : b.opt_adElement && (e = hv(this, a, b.opt_adElement, b.opt_osdId)));
        e &&
            e.za() == 1 &&
            (e.C == Kh &&
                (e.C = function (f) {
                    return c.se(f);
                }),
            wv(this, e, b));
        return e;
    };
    var wv = function (a, b, c) {
        c = c.opt_configurable_tracking_events;
        a.g != null && Array.isArray(c) && Yu(a, c, b);
    };
    rv.prototype.se = function (a) {
        a.j = 0;
        a.P = 0;
        if (a.A == "h" || a.A == "n") {
            var b;
            N();
            if (a.qb && xv(this)) {
                var c = this.o[a.qb];
                c
                    ? (b = function (e) {
                          return yv(c, e);
                      })
                    : c !== null && kq(379, Error());
            } else b = Ta("ima.common.getVideoMetadata");
            if (typeof b === "function")
                try {
                    var d = b(a.ma);
                } catch (e) {
                    a.j |= 4;
                }
            else a.j |= 2;
        } else if (a.A == "b")
            if (((b = Ta("ytads.bulleit.getVideoMetadata")), typeof b === "function"))
                try {
                    d = b(a.ma);
                } catch (e) {
                    a.j |= 4;
                }
            else a.j |= 2;
        else if (a.A == "ml")
            if (((b = Ta("ima.common.getVideoMetadata")), typeof b === "function"))
                try {
                    d = b(a.ma);
                } catch (e) {
                    a.j |= 4;
                }
            else a.j |= 2;
        else a.j |= 1;
        a.j || (d === void 0 ? (a.j |= 8) : d === null ? (a.j |= 16) : Ei(d) ? (a.j |= 32) : d.errorCode != null && ((a.P = d.errorCode), (a.j |= 64)));
        d == null && (d = {});
        jv(d, a);
        Wq(d.volume) && Wq(this.D) && (d.volume *= this.D);
        return d;
    };
    var uv = function (a, b, c) {
            var d = Dt(Gt, b);
            d || ((d = c.opt_nativeTime || -1), (d = Xu(a, b, cv(a), d)), c.opt_osdId && (d.qb = c.opt_osdId));
            return d;
        },
        tv = function (a, b, c) {
            var d = Dt(Gt, b);
            d || (d = Xu(a, b, "n", c.opt_nativeTime || -1));
            return d;
        },
        vv = function (a, b) {
            var c = Dt(Gt, b);
            c || (c = Xu(a, b, "h", -1));
            return c;
        };
    rv.prototype.yd = function () {
        if (xv(this)) return new qv("ima.common.triggerExternalActivityEvent", this.o);
        var a = zv(this);
        return a != null ? new ov(a) : null;
    };
    var zv = function (a) {
        N();
        switch (cv(a)) {
            case "b":
                return "ytads.bulleit.triggerExternalActivityEvent";
            case "n":
                return "ima.bridge.triggerExternalActivityEvent";
            case "h":
            case "m":
            case "ml":
                return "ima.common.triggerExternalActivityEvent";
        }
        return null;
    };
    rv.prototype.Zd = function (a) {
        !a.g && a.Ta && dv(this, a, "overlay_unmeasurable_impression") && (a.g = !0);
    };
    rv.prototype.af = function (a) {
        a.gf && (a.Va() ? dv(this, a, "overlay_viewable_end_of_session_impression") : dv(this, a, "overlay_unviewable_impression"), (a.gf = !1));
    };
    var Av = function (a, b, c, d) {
        c = c === void 0 ? {} : c;
        var e = {};
        Ii(e, { opt_adElement: void 0, opt_fullscreen: void 0 }, c);
        var f = a.J(b, c);
        c = f ? f.Vd : a.xd();
        if (e.opt_bounds) return c.g(ru("ol", d));
        if (d !== void 0)
            if (qu(d) !== void 0)
                if (ku) a = ru("ue", d);
                else if ((av(a), ju == "i")) (a = ru("i", d)), (a["if"] = 0);
                else if ((b = a.J(b, e))) {
                    b: {
                        ju == "i" && ((b.Ta = !0), a.de(b));
                        f = e.opt_fullscreen;
                        f !== void 0 && ks(b, !!f);
                        var g;
                        if ((f = !dr().j && !Zq())) xp(), (f = ml(Zo) === 0);
                        if ((g = f)) {
                            switch (b.za()) {
                                case 1:
                                    ev(b, "pv");
                                    break;
                                case 2:
                                    a.Zd(b);
                            }
                            bv("pv");
                        }
                        f = d.toLowerCase();
                        if ((g = !g))
                            c: {
                                if (Uo(N().R, "ssmol") && ((g = a.l), f === "loaded")) break c;
                                g = cc(wq, f);
                            }
                        if (g && b.la == 0) {
                            ju != "i" && (au.done = !1);
                            g = e !== void 0 ? e.opt_nativeTime : void 0;
                            pq = g = typeof g === "number" ? g : rq();
                            b.Tb = !0;
                            var h = er();
                            b.la = 1;
                            b.ia = {};
                            b.ia.start = !1;
                            b.ia.firstquartile = !1;
                            b.ia.midpoint = !1;
                            b.ia.thirdquartile = !1;
                            b.ia.complete = !1;
                            b.ia.resume = !1;
                            b.ia.pause = !1;
                            b.ia.skip = !1;
                            b.ia.mute = !1;
                            b.ia.unmute = !1;
                            b.ia.viewable_impression = !1;
                            b.ia.measurable_impression = !1;
                            b.ia.fully_viewable_audible_half_duration_impression = !1;
                            b.ia.fullscreen = !1;
                            b.ia.exitfullscreen = !1;
                            b.zd = 0;
                            h || (b.qa().J = g);
                            du(au, [b], !h);
                        }
                        (g = b.Bb[f]) && b.ha.reportEvent(g);
                        Uo(N().R, "fmd") || (cc(xq, f) && b.Xa && b.Xa.j(b, null));
                        switch (b.za()) {
                            case 1:
                                var k = tu(f) ? a.M.custom_metric_viewable : a.M[f];
                                break;
                            case 2:
                                k = a.U[f];
                        }
                        if (k && ((d = k.call(a, b, e, d)), Uo(N().R, "fmd") && cc(xq, f) && b.Xa && b.Xa.j(b, null), d !== void 0)) {
                            e = ru(void 0, f);
                            Ii(e, d);
                            d = e;
                            break b;
                        }
                        d = void 0;
                    }
                    b.la == 3 && a.A(b);
                    a = d;
                } else a = ru("nf", d);
            else a = void 0;
        else ku ? (a = ru("ue")) : f ? ((a = ru()), Ii(a, ot(f, !0, !1, !1))) : (a = ru("nf"));
        return typeof a === "string" ? c.g() : c.g(a);
    };
    rv.prototype.K = function (a) {
        this.l && a.za() == 1 && Bv(this, a);
    };
    rv.prototype.de = function (a) {
        this.l && a.za() == 1 && Bv(this, a);
    };
    var Bv = function (a, b) {
            var c;
            if (b.qb && xv(a)) {
                var d = a.o[b.qb];
                d
                    ? (c = function (f, g) {
                          Cv(d, f, g);
                      })
                    : d !== null && kq(379, Error());
            } else c = Ta("ima.common.triggerViewabilityMeasurementUpdate");
            if (typeof c === "function") {
                var e = jt(b);
                e.nativeVolume = a.D;
                c(b.ma, e);
            }
        },
        xv = function (a) {
            return (N(), cv(a) != "h" && cv(a) != "m") ? !1 : a.I != 0;
        };
    rv.prototype.B = function (a, b, c, d) {
        if (Xp()) {
            var e = Uo(N().R, "mm"),
                f = {};
            (e = ((f[Do.uf] = "ACTIVE_VIEW_TRAFFIC_TYPE_AUDIO"), (f[Do.VIDEO] = "ACTIVE_VIEW_TRAFFIC_TYPE_VIDEO"), f)[e]) && e && (this.C = e);
            this.C === "ACTIVE_VIEW_TRAFFIC_TYPE_UNSPECIFIED" && kq(1044, Error());
        }
        a = Wu.prototype.B.call(this, a, b, c, d);
        this.L && ((b = this.G), a.o == null && (a.o = new ts()), (b.g[a.ma] = a.o), (a.o.A = tt));
        return a;
    };
    rv.prototype.A = function (a) {
        a && a.za() == 1 && this.L && delete this.G.g[a.ma];
        return Wu.prototype.A.call(this, a);
    };
    rv.prototype.Ee = function () {
        this.g || (this.g = this.yd());
        return this.g == null || this.l ? new Us() : this.C === "ACTIVE_VIEW_TRAFFIC_TYPE_AUDIO" ? new mv(this.g) : new Fu(this.g);
    };
    rv.prototype.xd = function () {
        return this.C === "ACTIVE_VIEW_TRAFFIC_TYPE_AUDIO" ? new nv() : new Au();
    };
    var Dv = function (a) {
            var b = {};
            return (b.viewability = a.g), (b.googleViewability = a.j), b;
        },
        Ev = function (a, b, c) {
            c = c === void 0 ? {} : c;
            a = Av(J(rv), b, c, a);
            return Dv(a);
        },
        Fv = jq(193, Ev, void 0, gv);
    z("Goog_AdSense_Lidar_sendVastEvent", Fv);
    var Gv = jq(194, function (a, b) {
        b = b === void 0 ? {} : b;
        a = Av(J(rv), a, b);
        return Dv(a);
    });
    z("Goog_AdSense_Lidar_getViewability", Gv);
    var Hv = jq(195, function () {
        return zp();
    });
    z("Goog_AdSense_Lidar_getUrlSignalsArray", Hv);
    var Iv = jq(196, function () {
        return JSON.stringify(zp());
    });
    z("Goog_AdSense_Lidar_getUrlSignalsList", Iv);
    y.console && typeof y.console.log === "function" && gb(y.console.log, y.console);
    var Jv = function (a) {
        for (var b = [], c = (a = dj(a.ownerDocument)); c != a.top; c = c.parent)
            if (c.frameElement) b.push(c.frameElement);
            else break;
        return b;
    };
    var Kv = function (a, b) {
        this.type = a;
        this.currentTarget = this.target = b;
        this.defaultPrevented = this.j = !1;
    };
    Kv.prototype.stopPropagation = function () {
        this.j = !0;
    };
    Kv.prototype.preventDefault = function () {
        this.defaultPrevented = !0;
    };
    var Lv = (function () {
        if (!y.addEventListener || !Object.defineProperty) return !1;
        var a = !1,
            b = Object.defineProperty({}, "passive", {
                get: function () {
                    a = !0;
                },
            });
        try {
            var c = function () {};
            y.addEventListener("test", c, b);
            y.removeEventListener("test", c, b);
        } catch (d) {}
        return a;
    })();
    var Mv = function (a, b) {
        Kv.call(this, a ? a.type : "");
        this.relatedTarget = this.currentTarget = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.g = null;
        a && this.init(a, b);
    };
    jb(Mv, Kv);
    Mv.prototype.init = function (a, b) {
        var c = (this.type = a.type),
            d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.currentTarget = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? (b = a.fromElement) : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d
            ? ((this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX), (this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY), (this.screenX = d.screenX || 0), (this.screenY = d.screenY || 0))
            : ((this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX), (this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY), (this.screenX = a.screenX || 0), (this.screenY = a.screenY || 0));
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.g = a;
        a.defaultPrevented && Mv.Ia.preventDefault.call(this);
    };
    Mv.prototype.stopPropagation = function () {
        Mv.Ia.stopPropagation.call(this);
        this.g.stopPropagation ? this.g.stopPropagation() : (this.g.cancelBubble = !0);
    };
    Mv.prototype.preventDefault = function () {
        Mv.Ia.preventDefault.call(this);
        var a = this.g;
        a.preventDefault ? a.preventDefault() : (a.returnValue = !1);
    };
    var Nv = "closure_listenable_" + ((Math.random() * 1e6) | 0),
        Ov = function (a) {
            return !(!a || !a[Nv]);
        };
    var Pv = 0;
    var Qv = function (a, b, c, d, e) {
            this.listener = a;
            this.proxy = null;
            this.src = b;
            this.type = c;
            this.capture = !!d;
            this.Jc = e;
            this.key = ++Pv;
            this.kc = this.zc = !1;
        },
        Rv = function (a) {
            a.kc = !0;
            a.listener = null;
            a.proxy = null;
            a.src = null;
            a.Jc = null;
        };
    var Sv = function (a) {
        this.src = a;
        this.g = {};
        this.j = 0;
    };
    Sv.prototype.add = function (a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || ((a = this.g[f] = []), this.j++);
        var g = Tv(a, b, d, e);
        g > -1 ? ((b = a[g]), c || (b.zc = !1)) : ((b = new Qv(b, this.src, f, !!d, e)), (b.zc = c), a.push(b));
        return b;
    };
    Sv.prototype.remove = function (a, b, c, d) {
        a = a.toString();
        if (!(a in this.g)) return !1;
        var e = this.g[a];
        b = Tv(e, b, c, d);
        return b > -1 ? (Rv(e[b]), ec(e, b), e.length == 0 && (delete this.g[a], this.j--), !0) : !1;
    };
    var Uv = function (a, b) {
        var c = b.type;
        c in a.g && dc(a.g[c], b) && (Rv(b), a.g[c].length == 0 && (delete a.g[c], a.j--));
    };
    Sv.prototype.Vb = function (a, b, c, d) {
        a = this.g[a.toString()];
        var e = -1;
        a && (e = Tv(a, b, c, d));
        return e > -1 ? a[e] : null;
    };
    var Tv = function (a, b, c, d) {
        for (var e = 0; e < a.length; ++e) {
            var f = a[e];
            if (!f.kc && f.listener == b && f.capture == !!c && f.Jc == d) return e;
        }
        return -1;
    };
    var Vv = "closure_lm_" + ((Math.random() * 1e6) | 0),
        Wv = {},
        Xv = 0,
        Zv = function (a, b, c, d, e) {
            if (d && d.once) return Yv(a, b, c, d, e);
            if (Array.isArray(b)) {
                for (var f = 0; f < b.length; f++) Zv(a, b[f], c, d, e);
                return null;
            }
            c = $v(c);
            return Ov(a) ? a.listen(b, c, Ya(d) ? !!d.capture : !!d, e) : aw(a, b, c, !1, d, e);
        },
        aw = function (a, b, c, d, e, f) {
            if (!b) throw Error("Invalid event type");
            var g = Ya(e) ? !!e.capture : !!e,
                h = bw(a);
            h || (a[Vv] = h = new Sv(a));
            c = h.add(b, c, d, g, f);
            if (c.proxy) return c;
            d = cw();
            c.proxy = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) Lv || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent) a.attachEvent(dw(b.toString()), d);
            else if (a.addListener && a.removeListener) a.addListener(d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            Xv++;
            return c;
        },
        cw = function () {
            var a = ew,
                b = function (c) {
                    return a.call(b.src, b.listener, c);
                };
            return b;
        },
        Yv = function (a, b, c, d, e) {
            if (Array.isArray(b)) {
                for (var f = 0; f < b.length; f++) Yv(a, b[f], c, d, e);
                return null;
            }
            c = $v(c);
            return Ov(a) ? a.dc(b, c, Ya(d) ? !!d.capture : !!d, e) : aw(a, b, c, !0, d, e);
        },
        fw = function (a, b, c, d, e) {
            if (Array.isArray(b)) for (var f = 0; f < b.length; f++) fw(a, b[f], c, d, e);
            else (d = Ya(d) ? !!d.capture : !!d), (c = $v(c)), Ov(a) ? a.sb(b, c, d, e) : a && (a = bw(a)) && (b = a.Vb(b, c, d, e)) && gw(b);
        },
        gw = function (a) {
            if (typeof a !== "number" && a && !a.kc) {
                var b = a.src;
                if (Ov(b)) Uv(b.o, a);
                else {
                    var c = a.type,
                        d = a.proxy;
                    b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(dw(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                    Xv--;
                    (c = bw(b)) ? (Uv(c, a), c.j == 0 && ((c.src = null), (b[Vv] = null))) : Rv(a);
                }
            }
        },
        dw = function (a) {
            return a in Wv ? Wv[a] : (Wv[a] = "on" + a);
        },
        ew = function (a, b) {
            if (a.kc) a = !0;
            else {
                b = new Mv(b, this);
                var c = a.listener,
                    d = a.Jc || a.src;
                a.zc && gw(a);
                a = c.call(d, b);
            }
            return a;
        },
        bw = function (a) {
            a = a[Vv];
            return a instanceof Sv ? a : null;
        },
        hw = "__closure_events_fn_" + ((Math.random() * 1e9) >>> 0),
        $v = function (a) {
            if (typeof a === "function") return a;
            a[hw] ||
                (a[hw] = function (b) {
                    return a.handleEvent(b);
                });
            return a[hw];
        };
    var R = function () {
        Q.call(this);
        this.o = new Sv(this);
        this.Db = this;
        this.fa = null;
    };
    jb(R, Q);
    R.prototype[Nv] = !0;
    l = R.prototype;
    l.addEventListener = function (a, b, c, d) {
        Zv(this, a, b, c, d);
    };
    l.removeEventListener = function (a, b, c, d) {
        fw(this, a, b, c, d);
    };
    l.dispatchEvent = function (a) {
        var b,
            c = this.fa;
        if (c) for (b = []; c; c = c.fa) b.push(c);
        c = this.Db;
        var d = a.type || a;
        if (typeof a === "string") a = new Kv(a, c);
        else if (a instanceof Kv) a.target = a.target || c;
        else {
            var e = a;
            a = new Kv(d, c);
            Ii(a, e);
        }
        e = !0;
        if (b)
            for (var f = b.length - 1; !a.j && f >= 0; f--) {
                var g = (a.currentTarget = b[f]);
                e = iw(g, d, !0, a) && e;
            }
        a.j || ((g = a.currentTarget = c), (e = iw(g, d, !0, a) && e), a.j || (e = iw(g, d, !1, a) && e));
        if (b) for (f = 0; !a.j && f < b.length; f++) (g = a.currentTarget = b[f]), (e = iw(g, d, !1, a) && e);
        return e;
    };
    l.O = function () {
        R.Ia.O.call(this);
        if (this.o) {
            var a = this.o,
                b = 0,
                c;
            for (c in a.g) {
                for (var d = a.g[c], e = 0; e < d.length; e++) ++b, Rv(d[e]);
                delete a.g[c];
                a.j--;
            }
        }
        this.fa = null;
    };
    l.listen = function (a, b, c, d) {
        return this.o.add(String(a), b, !1, c, d);
    };
    l.dc = function (a, b, c, d) {
        return this.o.add(String(a), b, !0, c, d);
    };
    l.sb = function (a, b, c, d) {
        this.o.remove(String(a), b, c, d);
    };
    var iw = function (a, b, c, d) {
        b = a.o.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for (var e = !0, f = 0; f < b.length; ++f) {
            var g = b[f];
            if (g && !g.kc && g.capture == c) {
                var h = g.listener,
                    k = g.Jc || g.src;
                g.zc && Uv(a.o, g);
                e = h.call(k, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    };
    R.prototype.Vb = function (a, b, c, d) {
        return this.o.Vb(String(a), b, c, d);
    };
    var jw = function (a, b) {
        this.l = a;
        this.o = b;
        this.j = 0;
        this.g = null;
    };
    jw.prototype.get = function () {
        if (this.j > 0) {
            this.j--;
            var a = this.g;
            this.g = a.next;
            a.next = null;
        } else a = this.l();
        return a;
    };
    var kw = function (a, b) {
        a.o(b);
        a.j < 100 && (a.j++, (b.next = a.g), (a.g = b));
    };
    var lw,
        mw = function () {
            if (typeof MessageChannel !== "undefined") {
                var a = new MessageChannel(),
                    b = {},
                    c = b;
                a.port1.onmessage = function () {
                    if (b.next !== void 0) {
                        b = b.next;
                        var d = b.Ce;
                        b.Ce = null;
                        d();
                    }
                };
                return function (d) {
                    c.next = { Ce: d };
                    c = c.next;
                    a.port2.postMessage(0);
                };
            }
            return function (d) {
                y.setTimeout(d, 0);
            };
        };
    var nw = function () {
        this.j = this.g = null;
    };
    nw.prototype.add = function (a, b) {
        var c = ow.get();
        c.set(a, b);
        this.j ? (this.j.next = c) : (this.g = c);
        this.j = c;
    };
    nw.prototype.remove = function () {
        var a = null;
        this.g && ((a = this.g), (this.g = this.g.next), this.g || (this.j = null), (a.next = null));
        return a;
    };
    var ow = new jw(
            function () {
                return new pw();
            },
            function (a) {
                return a.reset();
            }
        ),
        pw = function () {
            this.next = this.g = this.j = null;
        };
    pw.prototype.set = function (a, b) {
        this.j = a;
        this.g = b;
        this.next = null;
    };
    pw.prototype.reset = function () {
        this.next = this.g = this.j = null;
    };
    var qw,
        rw = !1,
        tw = new nw(),
        vw = function (a, b) {
            qw || uw();
            rw || (qw(), (rw = !0));
            tw.add(a, b);
        },
        uw = function () {
            if (y.Promise && y.Promise.resolve) {
                var a = y.Promise.resolve(void 0);
                qw = function () {
                    a.then(ww);
                };
            } else
                qw = function () {
                    var b = ww;
                    typeof y.setImmediate !== "function" || (y.Window && y.Window.prototype && y.Window.prototype.setImmediate == y.setImmediate) ? (lw || (lw = mw()), lw(b)) : y.setImmediate(b);
                };
        },
        ww = function () {
            for (var a; (a = tw.remove()); ) {
                try {
                    a.j.call(a.g);
                } catch (b) {
                    ub(b);
                }
                kw(ow, a);
            }
            rw = !1;
        };
    var xw = function (a) {
        if (!a) return !1;
        try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    };
    var zw = function (a) {
            this.g = 0;
            this.C = void 0;
            this.o = this.j = this.l = null;
            this.A = this.B = !1;
            if (a != Kh)
                try {
                    var b = this;
                    a.call(
                        void 0,
                        function (c) {
                            yw(b, 2, c);
                        },
                        function (c) {
                            yw(b, 3, c);
                        }
                    );
                } catch (c) {
                    yw(this, 3, c);
                }
        },
        Aw = function () {
            this.next = this.context = this.j = this.l = this.g = null;
            this.o = !1;
        };
    Aw.prototype.reset = function () {
        this.context = this.j = this.l = this.g = null;
        this.o = !1;
    };
    var Bw = new jw(
            function () {
                return new Aw();
            },
            function (a) {
                a.reset();
            }
        ),
        Cw = function (a, b, c) {
            var d = Bw.get();
            d.l = a;
            d.j = b;
            d.context = c;
            return d;
        };
    zw.prototype.then = function (a, b, c) {
        return Dw(this, typeof a === "function" ? a : null, typeof b === "function" ? b : null, c);
    };
    zw.prototype.$goog_Thenable = !0;
    zw.prototype.J = function (a, b) {
        return Dw(this, null, a, b);
    };
    zw.prototype.catch = zw.prototype.J;
    zw.prototype.cancel = function (a) {
        if (this.g == 0) {
            var b = new Ew(a);
            vw(function () {
                Fw(this, b);
            }, this);
        }
    };
    var Fw = function (a, b) {
            if (a.g == 0)
                if (a.l) {
                    var c = a.l;
                    if (c.j) {
                        for (var d = 0, e = null, f = null, g = c.j; g && (g.o || (d++, g.g == a && (e = g), !(e && d > 1))); g = g.next) e || (f = g);
                        e && (c.g == 0 && d == 1 ? Fw(c, b) : (f ? ((d = f), d.next == c.o && (c.o = d), (d.next = d.next.next)) : Gw(c), Hw(c, e, 3, b)));
                    }
                    a.l = null;
                } else yw(a, 3, b);
        },
        Jw = function (a, b) {
            a.j || (a.g != 2 && a.g != 3) || Iw(a);
            a.o ? (a.o.next = b) : (a.j = b);
            a.o = b;
        },
        Dw = function (a, b, c, d) {
            var e = Cw(null, null, null);
            e.g = new zw(function (f, g) {
                e.l = b
                    ? function (h) {
                          try {
                              var k = b.call(d, h);
                              f(k);
                          } catch (m) {
                              g(m);
                          }
                      }
                    : f;
                e.j = c
                    ? function (h) {
                          try {
                              var k = c.call(d, h);
                              k === void 0 && h instanceof Ew ? g(h) : f(k);
                          } catch (m) {
                              g(m);
                          }
                      }
                    : g;
            });
            e.g.l = a;
            Jw(a, e);
            return e.g;
        };
    zw.prototype.D = function (a) {
        this.g = 0;
        yw(this, 2, a);
    };
    zw.prototype.G = function (a) {
        this.g = 0;
        yw(this, 3, a);
    };
    var yw = function (a, b, c) {
            if (a.g == 0) {
                a === c && ((b = 3), (c = new TypeError("Promise cannot resolve to itself")));
                a.g = 1;
                a: {
                    var d = c,
                        e = a.D,
                        f = a.G;
                    if (d instanceof zw) {
                        Jw(d, Cw(e || Kh, f || null, a));
                        var g = !0;
                    } else if (xw(d)) d.then(e, f, a), (g = !0);
                    else {
                        if (Ya(d))
                            try {
                                var h = d.then;
                                if (typeof h === "function") {
                                    Kw(d, h, e, f, a);
                                    g = !0;
                                    break a;
                                }
                            } catch (k) {
                                f.call(a, k);
                                g = !0;
                                break a;
                            }
                        g = !1;
                    }
                }
                g || ((a.C = c), (a.g = b), (a.l = null), Iw(a), b != 3 || c instanceof Ew || Lw(a, c));
            }
        },
        Kw = function (a, b, c, d, e) {
            var f = !1,
                g = function (k) {
                    f || ((f = !0), c.call(e, k));
                },
                h = function (k) {
                    f || ((f = !0), d.call(e, k));
                };
            try {
                b.call(a, g, h);
            } catch (k) {
                h(k);
            }
        },
        Iw = function (a) {
            a.B || ((a.B = !0), vw(a.L, a));
        },
        Gw = function (a) {
            var b = null;
            a.j && ((b = a.j), (a.j = b.next), (b.next = null));
            a.j || (a.o = null);
            return b;
        };
    zw.prototype.L = function () {
        for (var a; (a = Gw(this)); ) Hw(this, a, this.g, this.C);
        this.B = !1;
    };
    var Hw = function (a, b, c, d) {
            if (c == 3 && b.j && !b.o) for (; a && a.A; a = a.l) a.A = !1;
            if (b.g) (b.g.l = null), Mw(b, c, d);
            else
                try {
                    b.o ? b.l.call(b.context) : Mw(b, c, d);
                } catch (e) {
                    Nw.call(null, e);
                }
            kw(Bw, b);
        },
        Mw = function (a, b, c) {
            b == 2 ? a.l.call(a.context, c) : a.j && a.j.call(a.context, c);
        },
        Lw = function (a, b) {
            a.A = !0;
            vw(function () {
                a.A && Nw.call(null, b);
            });
        },
        Nw = ub,
        Ew = function (a) {
            kb.call(this, a);
        };
    jb(Ew, kb);
    Ew.prototype.name = "cancel";
    var Ow = function (a, b) {
        R.call(this);
        this.j = a || 1;
        this.g = b || y;
        this.l = gb(this.oh, this);
        this.A = Date.now();
    };
    jb(Ow, R);
    l = Ow.prototype;
    l.enabled = !1;
    l.Pa = null;
    l.oh = function () {
        if (this.enabled) {
            var a = Date.now() - this.A;
            a > 0 && a < this.j * 0.8 ? (this.Pa = this.g.setTimeout(this.l, this.j - a)) : (this.Pa && (this.g.clearTimeout(this.Pa), (this.Pa = null)), this.dispatchEvent("tick"), this.enabled && (this.stop(), this.start()));
        }
    };
    l.start = function () {
        this.enabled = !0;
        this.Pa || ((this.Pa = this.g.setTimeout(this.l, this.j)), (this.A = Date.now()));
    };
    l.stop = function () {
        this.enabled = !1;
        this.Pa && (this.g.clearTimeout(this.Pa), (this.Pa = null));
    };
    l.O = function () {
        Ow.Ia.O.call(this);
        this.stop();
        delete this.g;
    };
    var Pw = function (a, b, c) {
            if (typeof a === "function") c && (a = gb(a, c));
            else if (a && typeof a.handleEvent == "function") a = gb(a.handleEvent, a);
            else throw Error("Invalid listener argument");
            return Number(b) > 2147483647 ? -1 : y.setTimeout(a, b || 0);
        },
        Qw = function (a, b) {
            var c = null;
            return new zw(function (d, e) {
                c = Pw(function () {
                    d(b);
                }, a);
                c == -1 && e(Error("Failed to schedule timer."));
            }).J(function (d) {
                y.clearTimeout(c);
                throw d;
            });
        };
    var Rw = function () {
        return Math.round(Date.now() / 1e3);
    };
    var Sw = function () {
        this.g = {};
        return this;
    };
    Sw.prototype.remove = function (a) {
        var b = this.g;
        a in b && delete b[a];
    };
    Sw.prototype.set = function (a, b) {
        this.g[a] = b;
    };
    var Tw = function (a, b) {
        a.g.eb = Gi(a.g, "eb", 0) | b;
    };
    Sw.prototype.get = function (a) {
        return Gi(this.g, a, null);
    };
    var Uw = null,
        Vw = function () {
            this.g = {};
            this.j = 0;
        },
        Ww = function () {
            Uw || (Uw = new Vw());
            return Uw;
        },
        Xw = function (a, b) {
            a.g[b.getName()] = b;
        },
        Yw = function (a, b) {
            this.o = a;
            this.l = !0;
            this.g = b;
        };
    Yw.prototype.getName = function () {
        return this.o;
    };
    Yw.prototype.getValue = function () {
        return this.g;
    };
    Yw.prototype.j = function () {
        return String(this.g);
    };
    var Zw = function (a, b) {
        Yw.call(this, String(a), b);
        this.A = a;
        this.g = !!b;
    };
    x(Zw, Yw);
    Zw.prototype.j = function () {
        return this.g ? "1" : "0";
    };
    var $w = function (a, b) {
        Yw.call(this, a, b);
    };
    x($w, Yw);
    $w.prototype.j = function () {
        return this.g ? Math.round(this.g.top) + "." + Math.round(this.g.left) + "." + (Math.round(this.g.top) + Math.round(this.g.height)) + "." + (Math.round(this.g.left) + Math.round(this.g.width)) : "";
    };
    var ax = function (a) {
        if (a.match(/^-?[0-9]+\.-?[0-9]+\.-?[0-9]+\.-?[0-9]+$/)) {
            a = a.split(".");
            var b = Number(a[0]),
                c = Number(a[1]);
            return new $w("", new Rk(c, b, Number(a[3]) - c, Number(a[2]) - b));
        }
        return new $w("", new Rk(0, 0, 0, 0));
    };
    var bx = function (a) {
            var b = new Rk(-Number.MAX_VALUE / 2, -Number.MAX_VALUE / 2, Number.MAX_VALUE, Number.MAX_VALUE),
                c = new Rk(0, 0, 0, 0);
            if (!a || 0 == a.length) return c;
            for (var d = 0; d < a.length; d++) {
                a: {
                    var e = b;
                    var f = a[d],
                        g = Math.max(e.left, f.left),
                        h = Math.min(e.left + e.width, f.left + f.width);
                    if (g <= h) {
                        var k = Math.max(e.top, f.top);
                        f = Math.min(e.top + e.height, f.top + f.height);
                        if (k <= f) {
                            e.left = g;
                            e.top = k;
                            e.width = h - g;
                            e.height = f - k;
                            e = !0;
                            break a;
                        }
                    }
                    e = !1;
                }
                if (!e) return c;
            }
            return b;
        },
        cx = function (a, b) {
            var c = a.getBoundingClientRect();
            a = Kq(a, b);
            return new Rk(Math.round(a.x), Math.round(a.y), Math.round(c.right - c.left), Math.round(c.bottom - c.top));
        },
        dx = function (a, b, c) {
            if (b && c) {
                a: {
                    var d = Math.max(b.left, c.left);
                    var e = Math.min(b.left + b.width, c.left + c.width);
                    if (d <= e) {
                        var f = Math.max(b.top, c.top),
                            g = Math.min(b.top + b.height, c.top + c.height);
                        if (f <= g) {
                            d = new Rk(d, f, e - d, g - f);
                            break a;
                        }
                    }
                    d = null;
                }
                e = d ? d.height * d.width : 0;
                f = d ? b.height * b.width : 0;
                d = d && f ? Math.round((e / f) * 100) : 0;
                Xw(a, new Yw("vp", d));
                d && d > 0 ? ((e = Sk(b)), (f = Sk(c)), (e = e.top >= f.top && e.top < f.bottom)) : (e = !1);
                Xw(a, new Zw(512, e));
                d && d > 0 ? ((e = Sk(b)), (f = Sk(c)), (e = e.bottom <= f.bottom && e.bottom > f.top)) : (e = !1);
                Xw(a, new Zw(1024, e));
                d && d > 0 ? ((e = Sk(b)), (f = Sk(c)), (e = e.left >= f.left && e.left < f.right)) : (e = !1);
                Xw(a, new Zw(2048, e));
                d && d > 0 ? ((b = Sk(b)), (c = Sk(c)), (c = b.right <= c.right && b.right > c.left)) : (c = !1);
                Xw(a, new Zw(4096, c));
            }
        };
    var ex = function (a, b) {
        var c = 0;
        zi(dj(), "ima", "video", "client", "tagged") && (c = 1);
        var d = null;
        a && (d = a());
        if (d) {
            a = Ww();
            a.g = {};
            var e = new Zw(32, !0);
            e.l = !1;
            Xw(a, e);
            e = dj().document;
            e = e.visibilityState || e.webkitVisibilityState || e.mozVisibilityState || e.msVisibilityState || "";
            Xw(a, new Zw(64, e.toLowerCase().substring(e.length - 6) != "hidden" ? !0 : !1));
            a: {
                try {
                    var f = dj().top;
                    try {
                        var g = !!f.location.href || f.location.href === "";
                    } catch (n) {
                        g = !1;
                    }
                    if (g) {
                        var h = Jv(d);
                        var k = h && h.length != 0 ? "1" : "0";
                        break a;
                    }
                    k = "2";
                    break a;
                } catch (n) {
                    k = "2";
                    break a;
                }
                k = void 0;
            }
            Xw(a, new Zw(256, k == "2"));
            Xw(a, new Zw(128, k == "1"));
            h = g = dj().top;
            k == "2" && (h = dj());
            f = cx(d, h);
            Xw(a, new $w("er", f));
            try {
                var m = h.document && !h.document.body ? null : bj(h || window);
            } catch (n) {
                m = null;
            }
            m ? ((h = cj(Yi(h.document).g)), Xw(a, new Zw(16384, !!h)), (m = h ? new Rk(h.x, h.y, m.width, m.height) : null)) : (m = null);
            Xw(a, new $w("vi", m));
            if (m && "1" == k) {
                k = Jv(d);
                d = [];
                for (h = 0; h < k.length; h++) (e = cx(k[h], g)) && d.push(e);
                d.push(m);
                m = bx(d);
            }
            dx(a, f, m);
            a.j && Xw(a, new Yw("ts", Rw() - a.j));
            a.j = Rw();
        } else (a = Ww()), (a.g = {}), (a.j = Rw()), Xw(a, new Zw(32, !1));
        this.l = a;
        this.g = new Sw();
        this.g.set("ve", 4);
        c && Tw(this.g, 1);
        zi(dj(), "ima", "video", "client", "crossdomainTag") && Tw(this.g, 4);
        zi(dj(), "ima", "video", "client", "sdkTag") && Tw(this.g, 8);
        zi(dj(), "ima", "video", "client", "jsTag") && Tw(this.g, 2);
        b && Gi(b, "fullscreen", !1) && Tw(this.g, 16);
        this.j = b = null;
        if (c && ((c = zi(dj(), "ima", "video", "client")), c.getEData)) {
            this.j = c.getEData();
            if ((c = zi(dj(), "ima", "video", "client", "getLastSnapshotFromTop")))
                if ((a = c()))
                    this.j.extendWithDataFromTopIframe(a.tagstamp, a.playstamp, a.lactstamp),
                        (c = this.l),
                        (b = a.er),
                        (a = a.vi),
                        b &&
                            a &&
                            ((b = ax(b).getValue()),
                            (a = ax(a).getValue()),
                            (k = null),
                            Gi(c.g, "er", null) && ((k = Gi(c.g, "er", null).getValue()), (k.top += b.top), (k.left += b.left), Xw(c, new $w("er", k))),
                            Gi(c.g, "vi", null) && ((m = Gi(c.g, "vi", null).getValue()), (m.top += b.top), (m.left += b.left), (d = []), d.push(m), d.push(b), d.push(a), (b = bx(d)), dx(c, k, b), Xw(c, new $w("vi", a))));
            a: {
                if (this.j) {
                    if (this.j.getTagLoadTimestamp) {
                        b = this.j.getTagLoadTimestamp();
                        break a;
                    }
                    if (this.j.getTimeSinceTagLoadSeconds) {
                        b = this.j.getTimeSinceTagLoadSeconds();
                        break a;
                    }
                }
                b = null;
            }
        }
        c = this.g;
        a = window.performance && window.performance.timing && window.performance.timing.domLoading && window.performance.timing.domLoading > 0 ? Math.round(window.performance.timing.domLoading / 1e3) : null;
        c.set.call(c, "td", Rw() - (a != null ? a : b != null ? b : Rw()));
    };
    new Ow(200);
    var fx = function (a, b) {
        try {
            var c = new ex(a, b);
            a = [];
            var d = Number(c.g.get("eb"));
            c.g.remove("eb");
            var e,
                f = c.g;
            b = [];
            for (var g in f.g) b.push(g + f.g[g]);
            (e = b.join("_")) && a.push(e);
            if (c.j) {
                var h = c.j.serialize();
                h && a.push(h);
            }
            var k,
                m = c.l;
            e = d;
            f = [];
            e || (e = 0);
            for (var n in m.g) {
                var p = m.g[n];
                if (p instanceof Zw) p.getValue() && (e |= p.A);
                else {
                    var q = m.g[n],
                        t = q.l ? q.j() : "";
                    t && f.push(n + t);
                }
            }
            f.push("eb" + String(e));
            (k = f.join("_")) && a.push(k);
            c.g.set("eb", d);
            return a.join("_");
        } catch (u) {
            return "tle;" + Oi(u.name, 12) + ";" + Oi(u.message, 40);
        }
    };
    var gx = function (a) {
        this.F = B(a);
    };
    x(gx, H);
    gx.prototype.getId = function () {
        return D(this, 1);
    };
    var hx = [0, zh];
    var ix = function (a) {
        this.F = B(a);
    };
    x(ix, H);
    var jx = [0, zh, -3];
    var kx = function (a) {
        this.F = B(a);
    };
    x(kx, H);
    kx.prototype.getWidth = function () {
        return qg(this, 1);
    };
    kx.prototype.getHeight = function () {
        return qg(this, 2);
    };
    var lx = [0, wh, -1];
    var mx = function (a) {
        this.F = B(a);
    };
    x(mx, H);
    var nx = [0, th, yh, zh, -1];
    var ox = function (a) {
        this.F = B(a);
    };
    x(ox, H);
    ox.prototype.getAdId = function () {
        return D(this, 1);
    };
    ox.prototype.getSize = function () {
        return eg(this, kx, 7);
    };
    ox.prototype.Wb = function () {
        return eg(this, mx, 9);
    };
    var px = [0, zh, th, zh, Ah, Dh, hx, lx, th, nx, zh, jx];
    var qx = function (a) {
        this.F = B(a);
    };
    x(qx, H);
    var rx = function (a, b) {
            return Fg(a, 1, b);
        },
        sx = function (a, b) {
            return zg(a, 4, b);
        },
        tx = function (a, b) {
            return Bg(a, 2, b);
        };
    var ux = function (a) {
        this.F = B(a);
    };
    x(ux, H);
    var vx = function (a, b) {
            return Eg(a, 1, b);
        },
        wx = function (a, b) {
            return lg(a, 3, ox, b);
        },
        xx = function (a, b) {
            return Fg(a, 4, b);
        };
    var yx = [0, Dh, wh, zh, yh];
    var zx = [0, zh, th, Bh, px, Dh, yx, yh, Dh, 2, Ah];
    var Ax = function (a) {
        this.F = B(a);
    };
    x(Ax, H);
    var Bx = function (a) {
        this.F = B(a);
    };
    x(Bx, H);
    var Cx = function (a, b) {
            return kg(a, 2, ux, b);
        },
        Dx = function (a, b) {
            C(a, 5, b);
        },
        Ex = function (a, b) {
            Eg(a, 10, b);
        },
        Fx = function (a, b) {
            Eg(a, 11, b);
        };
    var Gx = [0, Dh, Bh, zx, Dh, zh, yx, zh, yh, wh, [0, Dh, yh, th], zh, -1];
    var Hx = function (a) {
        this.F = B(a);
    };
    x(Hx, H);
    var Ix = function (a) {
        var b = new Bx();
        b = Fg(b, 1, 1);
        return kg(a, 1, Bx, b);
    };
    Hx.prototype.g = Fh([0, Bh, Gx]);
    var Jx = function (a) {
        this.F = B(a);
    };
    x(Jx, H);
    var Kx = function (a) {
        this.F = B(a);
    };
    x(Kx, H);
    var Lx = function (a) {
        this.F = B(a);
    };
    x(Lx, H);
    var Mx = function (a) {
        this.F = B(a);
    };
    x(Mx, H);
    var Nx = function (a) {
        this.F = B(a);
    };
    x(Nx, H);
    var Ox = function (a) {
        this.F = B(a);
    };
    x(Ox, H);
    var Px = function (a) {
        this.F = B(a);
    };
    x(Px, H);
    var Qx = Gh(Px);
    var Rx = function (a) {
        this.F = B(a);
    };
    x(Rx, H);
    var Sx = function (a) {
        var b = new Rx();
        return Fg(b, 1, a);
    };
    var Tx = [0, Dh];
    var Ux = function (a) {
        this.F = B(a);
    };
    x(Ux, H);
    var Vx = function (a) {
            var b = new Ux();
            return Eg(b, 1, a);
        },
        Wx = function (a) {
            var b = window.Date.now();
            b = Number.isFinite(b) ? Math.round(b) : 0;
            return If(a, 3, re(b));
        };
    Ux.prototype.getError = function () {
        return eg(this, Rx, 10);
    };
    Ux.prototype.ab = function (a) {
        return C(this, 10, a);
    };
    var Xx = Gh(Ux);
    var Yx = [0, zh, -1, th, wh, -2, th, sh, yh, Tx, yh];
    var Zx = [0, 1, [0, vh, -2], -1, zh, -1, yh, [0, 3, Dh, zh], th, Eh, Ch];
    var $x = function (a) {
        this.F = B(a);
    };
    x($x, H);
    $x.prototype.g = Fh([0, Bh, Zx, Bh, Yx]);
    var cy = function () {
        var a = ay;
        this.A = by;
        this.B = "jserror";
        this.o = !0;
        this.g = a === void 0 ? null : a;
        this.j = null;
        this.l = !1;
        this.C = this.Wa;
    };
    l = cy.prototype;
    l.gd = function (a) {
        this.j = a;
    };
    l.ee = function (a) {
        this.B = a;
    };
    l.fe = function (a) {
        this.o = a;
    };
    l.ge = function (a) {
        this.l = a;
    };
    l.zb = function (a, b, c) {
        try {
            if (this.g && this.g.l) {
                var d = this.g.start(a.toString(), 3);
                var e = b();
                this.g.end(d);
            } else e = b();
        } catch (h) {
            b = this.o;
            try {
                zl(d), (b = this.C(a, new Ih(h, { message: dy(h) }), void 0, c));
            } catch (k) {
                this.Wa(217, k);
            }
            if (b) {
                var f, g;
                (f = window.console) == null || (g = f.error) == null || g.call(f, h);
            } else throw h;
        }
        return e;
    };
    l.Xd = function (a, b, c, d) {
        var e = this;
        return function () {
            var f = Ma.apply(0, arguments);
            return e.zb(
                a,
                function () {
                    return b.apply(c, f);
                },
                d
            );
        };
    };
    l.Wa = function (a, b, c, d, e) {
        e = e || this.B;
        try {
            var f = new kp();
            pp(f, 1, "context", a);
            Jh(b) || (b = new Ih(b, { message: dy(b) }));
            b.msg && pp(f, 2, "msg", b.msg.substring(0, 512));
            var g = b.meta || {};
            if (this.j)
                try {
                    this.j(g);
                } catch (k) {}
            if (d)
                try {
                    d(g);
                } catch (k) {}
            op(f, 3, [g]);
            var h = jp();
            h.j && pp(f, 4, "top", h.j.url || "");
            op(f, 5, [{ url: h.g.url || "" }, { url: h.g.url ? oj(h.g.url) : "" }]);
            ey(this.A, e, f, this.l, c);
        } catch (k) {
            try {
                ey(this.A, e, { context: "ecmserr", rctx: a, msg: dy(k), url: h && h.g.url }, this.l, c);
            } catch (m) {}
        }
        return this.o;
    };
    var dy = function (a) {
        var b = a.toString();
        a.name && b.indexOf(a.name) == -1 && (b += ": " + a.name);
        a.message && b.indexOf(a.message) == -1 && (b += ": " + a.message);
        if (a.stack)
            a: {
                a = a.stack;
                var c = b;
                try {
                    a.indexOf(c) == -1 && (a = c + "\n" + a);
                    for (var d; a != d; ) (d = a), (a = a.replace(RegExp("((https?:/..*/)[^/:]*:\\d+(?:.|\n)*)\\2"), "$1"));
                    b = a.replace(RegExp("\n *", "g"), "\n");
                    break a;
                } catch (e) {
                    b = c;
                    break a;
                }
                b = void 0;
            }
        return b;
    };
    var fy = function () {
            this.g = Math.random();
        },
        gy = function () {
            var a = by,
                b = window.google_srt;
            b >= 0 && b <= 1 && (a.g = b);
        },
        ey = function (a, b, c, d, e) {
            if (((d === void 0 ? 0 : d) ? a.g : Math.random()) < (e || 0.01))
                try {
                    if (c instanceof kp) var f = c;
                    else
                        (f = new kp()),
                            yj(c, function (h, k) {
                                var m = f,
                                    n = m.o++;
                                op(m, n, lp(k, h));
                            });
                    var g = rp(f, "https:", "/pagead/gen_204?id=" + b + "&");
                    g && Kj(y, g);
                } catch (h) {}
        };
    var by,
        hy,
        ay = new yl(1, window);
    (function (a) {
        by = a != null ? a : new fy();
        typeof window.google_srt !== "number" && (window.google_srt = Math.random());
        gy();
        hy = new cy();
        hy.gd(function () {});
        hy.ge(!0);
        window.document.readyState == "complete"
            ? window.google_measure_js_timing || ay.B()
            : ay.l &&
              Qh(window, "load", function () {
                  window.google_measure_js_timing || ay.B();
              });
    })();
    var iy = function (a) {
        this.F = B(a);
    };
    x(iy, H);
    var jy = { "-": 0, Y: 2, N: 1 };
    var ky = function (a) {
        this.F = B(a);
    };
    x(ky, H);
    ky.prototype.getType = function () {
        return qg(this, 1);
    };
    ky.prototype.getVersion = function () {
        return qg(this, 2);
    };
    function ly(a) {
        return Uc(a.length % 4 !== 0 ? a + "A" : a)
            .map(function (b) {
                return b.toString(2).padStart(8, "0");
            })
            .join("");
    }
    function my(a) {
        if (!/^[0-1]+$/.test(a)) throw Error("Invalid input [" + a + "] not a bit string.");
        return parseInt(a, 2);
    }
    function ny(a) {
        if (!/^[0-1]+$/.test(a)) throw Error("Invalid input [" + a + "] not a bit string.");
        for (var b = [1, 2, 3, 5], c = 0, d = 0; d < a.length - 1; d++) b.length <= d && b.push(b[d - 1] + b[d - 2]), (c += parseInt(a[d], 2) * b[d]);
        return c;
    }
    function oy(a, b) {
        a = ly(a);
        return a.length < b ? a.padEnd(b, "0") : a;
    }
    function py(a, b) {
        var c = a.indexOf("11");
        if (c === -1) throw Error("Expected section bitstring but not found in [" + a + "] part of [" + b + "]");
        return a.slice(0, c + 2);
    }
    var qy = function (a) {
        this.F = B(a);
    };
    x(qy, H);
    var ry = function (a) {
        this.F = B(a);
    };
    x(ry, H);
    var sy = function (a) {
        this.F = B(a);
    };
    x(sy, H);
    sy.prototype.getVersion = function () {
        return qg(this, 1);
    };
    var ty = function (a) {
        this.F = B(a);
    };
    x(ty, H);
    var LA = function (a) {
        this.F = B(a);
    };
    x(LA, H);
    var MA = function (a) {
        var b = new LA();
        return C(b, 1, a);
    };
    var NA = [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
        OA =
            6 +
            NA.reduce(function (a, b) {
                return a + b;
            });
    var PA = function (a) {
        this.F = B(a);
    };
    x(PA, H);
    var QA = function (a) {
        this.F = B(a);
    };
    x(QA, H);
    QA.prototype.getVersion = function () {
        return qg(this, 1);
    };
    var RA = function (a) {
        this.F = B(a);
    };
    x(RA, H);
    var SA = function (a) {
        this.F = B(a);
    };
    x(SA, H);
    var TA = function (a) {
        var b = new SA();
        return C(b, 1, a);
    };
    var UA = [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
        VA =
            6 +
            UA.reduce(function (a, b) {
                return a + b;
            });
    var WA = function (a) {
        this.F = B(a);
    };
    x(WA, H);
    var XA = function (a) {
        this.F = B(a);
    };
    x(XA, H);
    var YA = function (a) {
        this.F = B(a);
    };
    x(YA, H);
    YA.prototype.getVersion = function () {
        return qg(this, 1);
    };
    var ZA = function (a) {
        this.F = B(a);
    };
    x(ZA, H);
    var $A = function (a) {
        this.F = B(a);
    };
    x($A, H);
    var aB = function (a) {
        var b = new $A();
        return C(b, 1, a);
    };
    var bB = [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
        cB =
            6 +
            bB.reduce(function (a, b) {
                return a + b;
            });
    var dB = function (a) {
        this.F = B(a);
    };
    x(dB, H);
    var eB = function (a) {
        this.F = B(a);
    };
    x(eB, H);
    var fB = function (a) {
        this.F = B(a);
    };
    x(fB, H);
    fB.prototype.getVersion = function () {
        return qg(this, 1);
    };
    var gB = function (a) {
        this.F = B(a);
    };
    x(gB, H);
    var hB = function (a) {
        this.F = B(a);
    };
    x(hB, H);
    var iB = function (a) {
        var b = new hB();
        return C(b, 1, a);
    };
    var jB = [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
        kB =
            6 +
            jB.reduce(function (a, b) {
                return a + b;
            });
    var lB = function (a) {
        this.F = B(a);
    };
    x(lB, H);
    var mB = function (a) {
        this.F = B(a);
    };
    x(mB, H);
    mB.prototype.getVersion = function () {
        return qg(this, 1);
    };
    var nB = [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
        oB =
            6 +
            nB.reduce(function (a, b) {
                return a + b;
            });
    var pB = function (a) {
        this.F = B(a);
    };
    x(pB, H);
    var qB = function (a) {
        this.F = B(a);
    };
    x(qB, H);
    var rB = function (a, b) {
            return Uf(a, 1, b, fe);
        },
        sB = function (a, b) {
            return Uf(a, 2, b, fe);
        },
        tB = function (a, b) {
            return Uf(a, 3, b, ie);
        },
        uB = function (a, b) {
            Uf(a, 4, b, ie);
        };
    var vB = function (a) {
        this.F = B(a);
    };
    x(vB, H);
    var wB = function (a) {
        this.F = B(a);
    };
    x(wB, H);
    wB.prototype.getVersion = function () {
        return qg(this, 1);
    };
    var xB = function (a, b) {
            return Cg(a, 1, b);
        },
        yB = function (a, b) {
            return C(a, 2, b);
        },
        zB = function (a, b) {
            return C(a, 3, b);
        },
        AB = function (a, b) {
            return Cg(a, 4, b);
        },
        BB = function (a, b) {
            return Cg(a, 5, b);
        },
        CB = function (a, b) {
            return Cg(a, 6, b);
        },
        DB = function (a, b) {
            return Vf(a, 7, ye(b), "");
        },
        EB = function (a, b) {
            return Cg(a, 8, b);
        },
        FB = function (a, b) {
            return Cg(a, 9, b);
        },
        GB = function (a, b) {
            return Ag(a, 10, b);
        },
        HB = function (a, b) {
            return Ag(a, 11, b);
        },
        IB = function (a, b) {
            return Uf(a, 12, b, fe);
        },
        JB = function (a, b) {
            return Uf(a, 13, b, fe);
        },
        KB = function (a, b) {
            return Uf(a, 14, b, fe);
        },
        LB = function (a, b) {
            return Ag(a, 15, b);
        },
        MB = function (a, b) {
            return Vf(a, 16, ye(b), "");
        },
        NB = function (a, b) {
            return Uf(a, 17, b, ie);
        },
        OB = function (a, b) {
            return Uf(a, 18, b, ie);
        },
        PB = function (a, b) {
            return ig(a, 19, b);
        };
    var QB = function (a) {
        this.F = B(a);
    };
    x(QB, H);
    var RB = "a".charCodeAt(),
        SB = xi({ mi: 0, li: 1, hi: 2, ci: 3, ji: 4, di: 5, ki: 6, fi: 7, gi: 8, bi: 9, ei: 10, pi: 11 }),
        TB = xi({ si: 0, ti: 1, ri: 2 });
    var UB = function (a) {
            if (/[^01]/.test(a)) throw Error("Input bitstring " + a + " is malformed!");
            this.j = a;
            this.g = 0;
        },
        WB = function (a) {
            a = VB(a, 36);
            var b = new vB();
            b = Dg(b, 1, Math.floor(a / 10));
            return Cg(b, 2, (a % 10) * 1e8);
        },
        XB = function (a) {
            return String.fromCharCode(RB + VB(a, 6)) + String.fromCharCode(RB + VB(a, 6));
        },
        $B = function (a) {
            var b = VB(a, 16);
            return !!VB(a, 1) === !0
                ? ((a = YB(a)),
                  a.forEach(function (c) {
                      if (c > b) throw Error("ID " + c + " is past MaxVendorId " + b + "!");
                  }),
                  a)
                : ZB(a, b);
        },
        aC = function (a) {
            for (var b = [], c = VB(a, 12); c--; ) {
                var d = VB(a, 6),
                    e = VB(a, 2),
                    f = YB(a),
                    g = b,
                    h = g.push,
                    k = new pB();
                d = G(k, 1, d);
                e = G(d, 2, e);
                f = Uf(e, 3, f, ie);
                h.call(g, f);
            }
            return b;
        },
        YB = function (a) {
            for (var b = VB(a, 12), c = []; b--; ) {
                var d = !!VB(a, 1) === !0,
                    e = VB(a, 16);
                if (d) for (d = VB(a, 16); e <= d; e++) c.push(e);
                else c.push(e);
            }
            c.sort(function (f, g) {
                return f - g;
            });
            return c;
        },
        ZB = function (a, b, c) {
            for (var d = [], e = 0; e < b; e++)
                if (VB(a, 1)) {
                    var f = e + 1;
                    if (c && c.indexOf(f) === -1) throw Error("ID: " + f + " is outside of allowed values!");
                    d.push(f);
                }
            return d;
        },
        VB = function (a, b) {
            if (a.g + b > a.j.length) throw Error("Requested length " + b + " is past end of string.");
            var c = a.j.substring(a.g, a.g + b);
            a.g += b;
            return parseInt(c, 2);
        };
    UB.prototype.skip = function (a) {
        this.g += a;
    };
    var bC = function (a) {
        try {
            var b = Uc(a)
                    .map(function (f) {
                        return f.toString(2).padStart(8, "0");
                    })
                    .join(""),
                c = new UB(b);
            if (VB(c, 3) !== 3) return null;
            var d = sB(rB(new qB(), ZB(c, 24, SB)), ZB(c, 24, SB)),
                e = VB(c, 6);
            e !== 0 && uB(tB(d, ZB(c, e)), ZB(c, e));
            return d;
        } catch (f) {
            return null;
        }
    };
    var cC = function (a) {
        try {
            var b = Uc(a)
                    .map(function (d) {
                        return d.toString(2).padStart(8, "0");
                    })
                    .join(""),
                c = new UB(b);
            return PB(
                OB(
                    NB(
                        MB(
                            LB(
                                KB(
                                    JB(IB(HB(GB(FB(EB(DB(CB(BB(AB(zB(yB(xB(new wB(), VB(c, 6)), WB(c)), WB(c)), VB(c, 12)), VB(c, 12)), VB(c, 6)), XB(c)), VB(c, 12)), VB(c, 6)), !!VB(c, 1)), !!VB(c, 1)), ZB(c, 12, TB)), ZB(c, 24, SB)),
                                    ZB(c, 24, SB)
                                ),
                                !!VB(c, 1)
                            ),
                            XB(c)
                        ),
                        $B(c)
                    ),
                    $B(c)
                ),
                aC(c)
            );
        } catch (d) {
            return null;
        }
    };
    var eC = function (a) {
            if (!a) return null;
            var b = a.split(".");
            if (b.length > 4) return null;
            a = cC(b[0]);
            if (!a) return null;
            var c = new QB();
            a = C(c, 1, a);
            b.shift();
            b = w(b);
            for (c = b.next(); !c.done; c = b.next())
                switch (((c = c.value), dC(c))) {
                    case 1:
                    case 2:
                        break;
                    case 3:
                        c = bC(c);
                        if (!c) return null;
                        C(a, 2, c);
                        break;
                    default:
                        return null;
                }
            return a;
        },
        dC = function (a) {
            try {
                var b = Uc(a)
                    .map(function (c) {
                        return c.toString(2).padStart(8, "0");
                    })
                    .join("");
                return VB(new UB(b), 3);
            } catch (c) {
                return -1;
            }
        };
    var gC = function (a, b) {
            var c = eC(a);
            if (!c || !a) return null;
            var d = eg(c, wB, 1),
                e = eg(c, qB, 2) || new qB();
            c = qg(d, 9);
            var f = qg(d, 4),
                g = qg(d, 5),
                h = pg(d, 10),
                k = pg(d, 11),
                m = D(d, 16),
                n = pg(d, 15);
            var p = xg(d, 13, Jf());
            p = fC(p, SB);
            var q = xg(d, 14, Jf());
            p = { consents: p, legitimateInterests: fC(q, SB) };
            q = vg(d, 17);
            q = fC(q);
            var t = vg(d, 18);
            q = { consents: q, legitimateInterests: fC(t) };
            t = xg(d, 12, Jf());
            t = fC(t, TB);
            var u = gg(d, pB, 19, Jf());
            d = {};
            u = w(u);
            for (var v = u.next(); !v.done; v = u.next()) {
                v = v.value;
                var E = F(v, 1);
                d[E] = d[E] || {};
                for (var P = w(vg(v, 3)), S = P.next(); !S.done; S = P.next()) d[E][S.value] = F(v, 2);
            }
            u = xg(e, 1, Jf());
            u = fC(u, SB);
            v = xg(e, 2, Jf());
            v = fC(v, SB);
            E = vg(e, 3);
            E = fC(E);
            e = vg(e, 4);
            return {
                tcString: a,
                tcfPolicyVersion: c,
                gdprApplies: b,
                cmpId: f,
                cmpVersion: g,
                isServiceSpecific: h,
                useNonStandardStacks: k,
                publisherCC: m,
                purposeOneTreatment: n,
                purpose: p,
                vendor: q,
                specialFeatureOptins: t,
                publisher: { restrictions: d, consents: u, legitimateInterests: v, customPurposes: { consents: E, legitimateInterests: fC(e) } },
            };
        },
        fC = function (a, b) {
            var c = {};
            if (Array.isArray(b) && b.length !== 0) {
                b = w(b);
                for (var d = b.next(); !d.done; d = b.next()) (d = d.value), (c[d] = a.indexOf(d) !== -1);
            } else for (a = w(a), b = a.next(); !b.done; b = a.next()) c[b.value] = !0;
            delete c[0];
            return c;
        };
    var hC = function (a, b) {
        this.g = a;
        this.defaultValue = b === void 0 ? !1 : b;
    };
    var iC = new hC(45641707, !0),
        jC = new hC(45642592),
        kC = new hC(635466687),
        lC = new (function (a, b) {
            this.g = a;
            this.defaultValue = b === void 0 ? 0 : b;
        })(45645574),
        mC = new hC(45650866);
    var nC = function (a) {
        this.F = B(a);
    };
    x(nC, H);
    var oC = function (a) {
        var b = new nC();
        jg(b, 1, fe, a, xg);
    };
    var pC = /^((market|itms|intent|itms-appss):\/\/)/i;
    var qC = "ad_type vpos mridx pos vad_type videoad_start_delay".split(" ");
    var rC = function (a) {
        var b = a.tb;
        var c = a.bb;
        var d = a.height;
        var e = a.width;
        a = a.Ga === void 0 ? !1 : a.Ga;
        this.tb = b;
        this.bb = c;
        this.height = d;
        this.width = e;
        this.Ga = a;
    };
    rC.prototype.getHeight = function () {
        return this.height;
    };
    rC.prototype.getWidth = function () {
        return this.width;
    };
    var sC = function (a) {
        var b = a.yh;
        var c = a.bg;
        var d = a.tb;
        var e = a.bb;
        var f = a.xh;
        var g = a.ag;
        rC.call(this, { tb: d, bb: e, height: a.height, width: a.width, Ga: a.Ga === void 0 ? !1 : a.Ga });
        this.o = b;
        this.j = c;
        this.l = f;
        this.g = g;
    };
    x(sC, rC);
    var tC = function (a) {
        var b = a.Og;
        rC.call(this, { tb: a.tb, bb: a.bb, height: a.height, width: a.width, Ga: a.Ga === void 0 ? !1 : a.Ga });
        this.g = b;
    };
    x(tC, rC);
    tC.prototype.getMediaUrl = function () {
        return this.g;
    };
    function uC(a) {
        return new (Function.prototype.bind.apply(a, [null].concat(la(Ma.apply(1, arguments)))))();
    }
    var vC = function (a, b, c, d) {
        Q.call(this);
        this.G = b;
        this.D = c;
        this.C = d;
        this.A = new Map();
        this.I = 0;
        this.o = new Map();
        this.B = new Map();
        this.l = void 0;
        this.j = a;
    };
    x(vC, Q);
    vC.prototype.O = function () {
        delete this.g;
        this.A.clear();
        this.o.clear();
        this.B.clear();
        this.l && (Rh(this.j, "message", this.l), delete this.l);
        delete this.j;
        delete this.C;
        Q.prototype.O.call(this);
    };
    var wC = function (a) {
            if (a.g) return a.g;
            a.D && a.D(a.j) ? (a.g = a.j) : (a.g = Ej(a.j, a.G));
            var b;
            return (b = a.g) != null ? b : null;
        },
        yC = function (a, b, c) {
            if (wC(a))
                if (a.g === a.j) (b = a.A.get(b)) && b(a.g, c);
                else {
                    var d = a.o.get(b);
                    if (d && d.Pc) {
                        xC(a);
                        var e = ++a.I;
                        a.B.set(e, { ec: d.ec, kg: d.Nd(c), ah: b === "addEventListener" });
                        a.g.postMessage(d.Pc(c, e), "*");
                    }
                }
        },
        xC = function (a) {
            a.l ||
                ((a.l = function (b) {
                    try {
                        var c = a.C ? a.C(b) : void 0;
                        if (c) {
                            var d = c.Ve,
                                e = a.B.get(d);
                            if (e) {
                                e.ah || a.B.delete(d);
                                var f;
                                (f = e.ec) == null || f.call(e, e.kg, c.payload);
                            }
                        }
                    } catch (g) {}
                }),
                Qh(a.j, "message", a.l));
        };
    var zC = function (a) {
            a.addtlConsent !== void 0 && typeof a.addtlConsent !== "string" && (a.addtlConsent = void 0);
            a.gdprApplies !== void 0 && typeof a.gdprApplies !== "boolean" && (a.gdprApplies = void 0);
            return (a.tcString !== void 0 && typeof a.tcString !== "string") || (a.listenerId !== void 0 && typeof a.listenerId !== "number") ? 2 : a.cmpStatus && a.cmpStatus !== "error" ? 0 : 3;
        },
        AC = function (a, b) {
            b = b === void 0 ? {} : b;
            Q.call(this);
            this.j = a;
            this.g = null;
            this.B = {};
            this.C = 0;
            var c;
            this.o = (c = b.timeoutMs) != null ? c : 500;
            var d;
            this.A = (d = b.dj) != null ? d : !1;
            this.l = null;
        };
    x(AC, Q);
    AC.prototype.O = function () {
        this.B = {};
        this.l && (Rh(this.j, "message", this.l), delete this.l);
        delete this.B;
        delete this.j;
        delete this.g;
        Q.prototype.O.call(this);
    };
    var CC = function (a) {
            return typeof a.j.__tcfapi === "function" || BC(a) != null;
        },
        FC = function (a, b) {
            var c = { internalErrorState: 0, internalBlockOnErrors: a.A },
                d = Mh(function () {
                    return b(c);
                }),
                e = 0;
            a.o !== -1 &&
                (e = setTimeout(function () {
                    e = 0;
                    c.tcString = "tcunavailable";
                    c.internalErrorState = 1;
                    d();
                }, a.o));
            DC(a, "addEventListener", function (f) {
                f &&
                    ((c = f),
                    (c.internalErrorState = zC(c)),
                    (c.internalBlockOnErrors = a.A),
                    EC(c)
                        ? (c.internalErrorState != 0 && (c.tcString = "tcunavailable"), DC(a, "removeEventListener", null, c.listenerId), (f = e) && clearTimeout(f), d())
                        : (c.cmpStatus === "error" || c.internalErrorState !== 0) && (f = e) && clearTimeout(f));
            });
        };
    AC.prototype.addEventListener = function (a) {
        var b = this,
            c = { internalBlockOnErrors: this.A },
            d = Mh(function () {
                return a(c);
            }),
            e = 0;
        this.o !== -1 &&
            (e = setTimeout(function () {
                c.tcString = "tcunavailable";
                c.internalErrorState = 1;
                d();
            }, this.o));
        var f = function (g, h) {
            clearTimeout(e);
            g
                ? ((c = g), (c.internalErrorState = zC(c)), (c.internalBlockOnErrors = b.A), (h && c.internalErrorState === 0) || ((c.tcString = "tcunavailable"), h || (c.internalErrorState = 3)))
                : ((c.tcString = "tcunavailable"), (c.internalErrorState = 3));
            a(c);
        };
        try {
            DC(this, "addEventListener", f);
        } catch (g) {
            (c.tcString = "tcunavailable"), (c.internalErrorState = 3), e && (clearTimeout(e), (e = 0)), d();
        }
    };
    AC.prototype.removeEventListener = function (a) {
        a && a.listenerId && DC(this, "removeEventListener", null, a.listenerId);
    };
    var HC = function (a, b, c) {
            var d = d === void 0 ? "755" : d;
            a: {
                if (a.publisher && a.publisher.restrictions) {
                    var e = a.publisher.restrictions[b];
                    if (e !== void 0) {
                        e = e[d === void 0 ? "755" : d];
                        break a;
                    }
                }
                e = void 0;
            }
            if (e === 0) return !1;
            var f = c;
            c === 2 ? ((f = 0), e === 2 && (f = 1)) : c === 3 && ((f = 1), e === 1 && (f = 0));
            a =
                f === 0
                    ? a.purpose && a.vendor
                        ? (c = GC(a.vendor.consents, d === void 0 ? "755" : d)) && b === "1" && a.purposeOneTreatment && a.publisherCC === "CH"
                            ? !0
                            : c && GC(a.purpose.consents, b)
                        : !0
                    : f === 1
                    ? a.purpose && a.vendor
                        ? GC(a.purpose.legitimateInterests, b) && GC(a.vendor.legitimateInterests, d === void 0 ? "755" : d)
                        : !0
                    : !0;
            return a;
        },
        GC = function (a, b) {
            return !(!a || !a[b]);
        },
        DC = function (a, b, c, d) {
            c || (c = function () {});
            if (typeof a.j.__tcfapi === "function") (a = a.j.__tcfapi), a(b, 2, c, d);
            else if (BC(a)) {
                IC(a);
                var e = ++a.C;
                a.B[e] = c;
                a.g && ((c = {}), a.g.postMessage(((c.__tcfapiCall = { command: b, version: 2, callId: e, parameter: d }), c), "*"));
            } else c({}, !1);
        },
        BC = function (a) {
            if (a.g) return a.g;
            a.g = Ej(a.j, "__tcfapiLocator");
            return a.g;
        },
        IC = function (a) {
            a.l ||
                ((a.l = function (b) {
                    try {
                        var c = (typeof b.data === "string" ? JSON.parse(b.data) : b.data).__tcfapiReturn;
                        a.B[c.callId](c.returnValue, c.success);
                    } catch (d) {}
                }),
                Qh(a.j, "message", a.l));
        },
        EC = function (a) {
            if (a.gdprApplies === !1) return !0;
            a.internalErrorState === void 0 && (a.internalErrorState = zC(a));
            return a.cmpStatus === "error" || a.internalErrorState !== 0
                ? a.internalBlockOnErrors
                    ? (Mj({ e: String(a.internalErrorState) }, "tcfe"), !1)
                    : !0
                : a.cmpStatus !== "loaded" || (a.eventStatus !== "tcloaded" && a.eventStatus !== "useractioncomplete")
                ? !1
                : !0;
        },
        JC = function (a, b, c) {
            return a.gdprApplies === !1
                ? !0
                : b.every(function (d) {
                      return HC(a, d, c);
                  });
        };
    var KC = function (a, b) {
            b = b.listener;
            (a = (0, a.__gpp)("addEventListener", b)) && b(a, !0);
        },
        LC = function (a, b) {
            (0, a.__gpp)("removeEventListener", b.listener, b.listenerId);
        },
        MC = {
            Nd: function (a) {
                return a.listener;
            },
            Pc: function (a, b) {
                a = {};
                return (a.__gppCall = { callId: b, command: "addEventListener", version: "1.1" }), a;
            },
            ec: function (a, b) {
                b = b.__gppReturn;
                a(b.returnValue, b.success);
            },
        },
        NC = {
            Nd: function (a) {
                return a.listener;
            },
            Pc: function (a, b) {
                var c = {};
                return (c.__gppCall = { callId: b, command: "removeEventListener", version: "1.1", parameter: a.listenerId }), c;
            },
            ec: function (a, b) {
                b = b.__gppReturn;
                var c = b.returnValue.data;
                a == null || a(c, b.success);
            },
        };
    function OC(a) {
        var b = {};
        typeof a.data === "string" ? (b = JSON.parse(a.data)) : (b = a.data);
        return { payload: b, Ve: b.__gppReturn.callId };
    }
    var PC = function (a, b) {
        var c = b === void 0 ? {} : b;
        b = c.timeoutMs;
        c = c.cmpInteractionEventReporter;
        Q.call(this);
        this.caller = new vC(
            a,
            "__gppLocator",
            function (d) {
                return typeof d.__gpp === "function";
            },
            OC
        );
        this.caller.A.set("addEventListener", KC);
        this.caller.o.set("addEventListener", MC);
        this.caller.A.set("removeEventListener", LC);
        this.caller.o.set("removeEventListener", NC);
        this.timeoutMs = b != null ? b : 500;
        this.cmpInteractionEventReporter = c;
    };
    x(PC, Q);
    PC.prototype.O = function () {
        this.caller.dispose();
        Q.prototype.O.call(this);
    };
    PC.prototype.addEventListener = function (a) {
        var b = this,
            c = Mh(function () {
                a(QC, !0);
            }),
            d =
                this.timeoutMs === -1
                    ? void 0
                    : setTimeout(function () {
                          c();
                      }, this.timeoutMs);
        yC(this.caller, "addEventListener", {
            listener: function (e, f) {
                clearTimeout(d);
                try {
                    var g;
                    if (((g = e.pingData) == null ? void 0 : g.gppVersion) === void 0 || e.pingData.gppVersion === "1" || e.pingData.gppVersion === "1.0") {
                        b.removeEventListener(e.listenerId);
                        var h = { eventName: "signalStatus", data: "ready", pingData: { internalErrorState: 1, gppString: "GPP_ERROR_STRING_IS_DEPRECATED_SPEC", applicableSections: [-1] } };
                    } else
                        Array.isArray(e.pingData.applicableSections)
                            ? (h = e)
                            : (b.removeEventListener(e.listenerId),
                              (h = { eventName: "signalStatus", data: "ready", pingData: { internalErrorState: 2, gppString: "GPP_ERROR_STRING_EXPECTED_APPLICATION_SECTION_ARRAY", applicableSections: [-1] } }));
                    a(h, f);
                    var k;
                    (k = b.cmpInteractionEventReporter) == null || k.g();
                } catch (m) {
                    if (e == null ? 0 : e.listenerId)
                        try {
                            b.removeEventListener(e.listenerId);
                        } catch (n) {
                            a(RC, !0);
                            return;
                        }
                    a(SC, !0);
                }
            },
        });
    };
    PC.prototype.removeEventListener = function (a) {
        yC(this.caller, "removeEventListener", { listener: function () {}, listenerId: a });
    };
    var TC = function (a, b) {
            var c = c === void 0 ? !1 : c;
            if (!a) return !1;
            var d = ly(a.split("~")[0]),
                e = my(d.slice(0, 6)),
                f = my(d.slice(6, 12)),
                g = new ky();
            var h = Cg(g, 1, e);
            var k = Cg(h, 2, f);
            for (var m = d.slice(12), n = my(m.slice(0, 12)), p = [], q = m.slice(12).replace(/0+$/, ""), t = 0; t < n; t++) {
                if (q.length === 0) throw Error("Found " + t + " of " + n + " sections [" + p + "] but reached end of input [" + m + "]");
                var u = my(q[0]) === 0;
                q = q.slice(1);
                var v = py(q, m),
                    E = p.length === 0 ? 0 : p[p.length - 1],
                    P = ny(v) + E;
                q = q.slice(v.length);
                if (u) p.push(P);
                else {
                    for (var S = py(q, m), ca = ny(S), Qa = 0; Qa <= ca; Qa++) p.push(P + Qa);
                    q = q.slice(S.length);
                }
            }
            if (q.length > 0) throw Error("Found " + n + " sections [" + p + "] but has remaining input [" + q + "], entire input [" + m + "]");
            var ra = Uf(k, 3, p, ie);
            var rb = a.includes("~") ? a.split("~").slice(1) : [];
            var Ab = vg(ra, 3);
            for (var db = 0; db < Ab.length; ++db) {
                var uc = Ab[db];
                if (b.includes(uc)) {
                    var Ba = rb[db];
                    switch (uc) {
                        case 2:
                            if (c) {
                                var Kc = gC(Ba, !0);
                                if (!Kc) throw Error("Cannot decode TCF V2 section string.");
                                if (!JC(Kc, ["3", "4"], 0)) return !0;
                            }
                            break;
                        case 7:
                            if (Ba.length === 0) throw Error("Cannot decode empty USNat section string.");
                            var fa = Ba.split(".");
                            if (fa.length > 2) throw Error("Expected at most 2 segments but got " + fa.length + " when decoding " + Ba + ".");
                            var Ja = void 0,
                                Lc = void 0,
                                Mc = void 0,
                                ke = void 0,
                                eb = void 0,
                                Xh = void 0,
                                Yh = void 0,
                                Zh = void 0,
                                $h = void 0,
                                uy = void 0,
                                vy = void 0,
                                wy = void 0,
                                yy = void 0,
                                zy = void 0,
                                Ay = void 0,
                                By = void 0,
                                Cy = void 0,
                                Dy = void 0,
                                Ey = void 0,
                                Fy = void 0,
                                Gy = void 0,
                                Hy = void 0,
                                Iy = void 0,
                                Jy = void 0,
                                Ky = void 0,
                                Ly = void 0,
                                My = void 0,
                                Ny = void 0,
                                Oy = void 0,
                                Py = void 0,
                                Qy = fa[0];
                            if (Qy.length === 0) throw Error("Cannot decode empty core segment string.");
                            var Zk = oy(Qy, kB),
                                Gp = my(Zk.slice(0, 6));
                            Zk = Zk.slice(6);
                            if (Gp !== 1) throw Error("Unable to decode unsupported USNat Section specification version " + Gp + " - only version 1 is supported.");
                            for (var Hp = 0, ta = [], Ip = 0; Ip < jB.length; Ip++) {
                                var Ry = jB[Ip];
                                ta.push(my(Zk.slice(Hp, Hp + Ry)));
                                Hp += Ry;
                            }
                            var RK = new fB();
                            Py = Cg(RK, 1, Gp);
                            var SK = ta.shift();
                            Oy = G(Py, 2, SK);
                            var TK = ta.shift();
                            Ny = G(Oy, 3, TK);
                            var UK = ta.shift();
                            My = G(Ny, 4, UK);
                            var VK = ta.shift();
                            Ly = G(My, 5, VK);
                            var WK = ta.shift();
                            Ky = G(Ly, 6, WK);
                            var XK = ta.shift();
                            Jy = G(Ky, 7, XK);
                            var YK = ta.shift();
                            Iy = G(Jy, 8, YK);
                            var ZK = ta.shift();
                            Hy = G(Iy, 9, ZK);
                            var $K = ta.shift();
                            Gy = G(Hy, 10, $K);
                            var aL = new eB(),
                                bL = ta.shift();
                            Fy = G(aL, 1, bL);
                            var cL = ta.shift();
                            Ey = G(Fy, 2, cL);
                            var dL = ta.shift();
                            Dy = G(Ey, 3, dL);
                            var eL = ta.shift();
                            Cy = G(Dy, 4, eL);
                            var fL = ta.shift();
                            By = G(Cy, 5, fL);
                            var gL = ta.shift();
                            Ay = G(By, 6, gL);
                            var hL = ta.shift();
                            zy = G(Ay, 7, hL);
                            var iL = ta.shift();
                            yy = G(zy, 8, iL);
                            var jL = ta.shift();
                            wy = G(yy, 9, jL);
                            var kL = ta.shift();
                            vy = G(wy, 10, kL);
                            var lL = ta.shift();
                            uy = G(vy, 11, lL);
                            var mL = ta.shift();
                            $h = G(uy, 12, mL);
                            Zh = C(Gy, 11, $h);
                            var nL = new dB(),
                                oL = ta.shift();
                            Yh = G(nL, 1, oL);
                            var pL = ta.shift();
                            Xh = G(Yh, 2, pL);
                            eb = C(Zh, 12, Xh);
                            var qL = ta.shift();
                            ke = G(eb, 13, qL);
                            var rL = ta.shift();
                            Mc = G(ke, 14, rL);
                            var sL = ta.shift();
                            Lc = G(Mc, 15, sL);
                            var tL = ta.shift();
                            var Sy = (Ja = G(Lc, 16, tL));
                            if (fa.length === 1) var Ty = iB(Sy);
                            else {
                                var uL = iB(Sy),
                                    Uy = void 0,
                                    Vy = void 0,
                                    Wy = void 0,
                                    Xy = fa[1];
                                if (Xy.length === 0) throw Error("Cannot decode empty GPC segment string.");
                                var Yy = oy(Xy, 3),
                                    $k = my(Yy.slice(0, 2));
                                if ($k < 0 || $k > 1) throw Error("Attempting to decode unknown GPC segment subsection type " + $k + ".");
                                Wy = $k + 1;
                                var vL = my(Yy.slice(2, 3)),
                                    wL = new gB();
                                Vy = G(wL, 2, Wy);
                                Uy = Ag(Vy, 1, !!vL);
                                Ty = C(uL, 2, Uy);
                            }
                            var Jp = eg(Ty, fB, 1);
                            if (F(Jp, 8) === 1 || F(Jp, 9) === 1 || F(Jp, 10) === 1) return !0;
                            break;
                        case 8:
                            if (Ba.length === 0) throw Error("Cannot decode empty USCA section string.");
                            var ai = Ba.split(".");
                            if (ai.length > 2) throw Error("Expected at most 1 sub-section but got " + (ai.length - 1) + " when decoding " + Ba + ".");
                            var xL = void 0,
                                Zy = void 0,
                                $y = void 0,
                                az = void 0,
                                bz = void 0,
                                cz = void 0,
                                dz = void 0,
                                ez = void 0,
                                fz = void 0,
                                gz = void 0,
                                hz = void 0,
                                iz = void 0,
                                jz = void 0,
                                kz = void 0,
                                lz = void 0,
                                mz = void 0,
                                nz = void 0,
                                oz = void 0,
                                pz = void 0,
                                qz = void 0,
                                rz = void 0,
                                sz = void 0,
                                tz = void 0,
                                uz = ai[0];
                            if (uz.length === 0) throw Error("Cannot decode empty core segment string.");
                            var al = oy(uz, OA),
                                Kp = my(al.slice(0, 6));
                            al = al.slice(6);
                            if (Kp !== 1) throw Error("Unable to decode unsupported USCA Section specification version " + Kp + " - only version 1 is supported.");
                            for (var Lp = 0, Na = [], Mp = 0; Mp < NA.length; Mp++) {
                                var vz = NA[Mp];
                                Na.push(my(al.slice(Lp, Lp + vz)));
                                Lp += vz;
                            }
                            var yL = new sy();
                            tz = Cg(yL, 1, Kp);
                            var zL = Na.shift();
                            sz = G(tz, 2, zL);
                            var AL = Na.shift();
                            rz = G(sz, 3, AL);
                            var BL = Na.shift();
                            qz = G(rz, 4, BL);
                            var CL = Na.shift();
                            pz = G(qz, 5, CL);
                            var DL = Na.shift();
                            oz = G(pz, 6, DL);
                            var EL = new ry(),
                                FL = Na.shift();
                            nz = G(EL, 1, FL);
                            var GL = Na.shift();
                            mz = G(nz, 2, GL);
                            var HL = Na.shift();
                            lz = G(mz, 3, HL);
                            var IL = Na.shift();
                            kz = G(lz, 4, IL);
                            var JL = Na.shift();
                            jz = G(kz, 5, JL);
                            var KL = Na.shift();
                            iz = G(jz, 6, KL);
                            var LL = Na.shift();
                            hz = G(iz, 7, LL);
                            var ML = Na.shift();
                            gz = G(hz, 8, ML);
                            var NL = Na.shift();
                            fz = G(gz, 9, NL);
                            ez = C(oz, 7, fz);
                            var OL = new qy(),
                                PL = Na.shift();
                            dz = G(OL, 1, PL);
                            var QL = Na.shift();
                            cz = G(dz, 2, QL);
                            bz = C(ez, 8, cz);
                            var RL = Na.shift();
                            az = G(bz, 9, RL);
                            var SL = Na.shift();
                            $y = G(az, 10, SL);
                            var TL = Na.shift();
                            Zy = G($y, 11, TL);
                            var UL = Na.shift();
                            var wz = (xL = G(Zy, 12, UL));
                            if (ai.length === 1) var xz = MA(wz);
                            else {
                                var VL = MA(wz),
                                    yz = void 0,
                                    zz = void 0,
                                    Az = void 0,
                                    Bz = ai[1];
                                if (Bz.length === 0) throw Error("Cannot decode empty GPC segment string.");
                                var Cz = oy(Bz, 3),
                                    bl = my(Cz.slice(0, 2));
                                if (bl < 0 || bl > 1) throw Error("Attempting to decode unknown GPC segment subsection type " + bl + ".");
                                Az = bl + 1;
                                var WL = my(Cz.slice(2, 3)),
                                    XL = new ty();
                                zz = G(XL, 2, Az);
                                yz = Ag(zz, 1, !!WL);
                                xz = C(VL, 2, yz);
                            }
                            var Dz = eg(xz, sy, 1);
                            if (F(Dz, 5) === 1 || F(Dz, 6) === 1) return !0;
                            break;
                        case 9:
                            if (Ba.length === 0) throw Error("Cannot decode empty USVA section string.");
                            var cl = oy(Ba, oB),
                                Np = my(cl.slice(0, 6));
                            cl = cl.slice(6);
                            if (Np !== 1) throw Error("Unable to decode unsupported USVA Section specification version " + Np + " - only version 1 is supported.");
                            for (var Op = 0, lb = [], Pp = 0; Pp < nB.length; Pp++) {
                                var Ez = nB[Pp];
                                lb.push(my(cl.slice(Op, Op + Ez)));
                                Op += Ez;
                            }
                            var YL = Np,
                                ZL = new mB(),
                                $L = Cg(ZL, 1, YL),
                                aM = lb.shift(),
                                bM = G($L, 2, aM),
                                cM = lb.shift(),
                                dM = G(bM, 3, cM),
                                eM = lb.shift(),
                                fM = G(dM, 4, eM),
                                gM = lb.shift(),
                                hM = G(fM, 5, gM),
                                iM = lb.shift();
                            var jM = G(hM, 6, iM);
                            var kM = new lB(),
                                lM = lb.shift(),
                                mM = G(kM, 1, lM),
                                nM = lb.shift(),
                                oM = G(mM, 2, nM),
                                pM = lb.shift(),
                                qM = G(oM, 3, pM),
                                rM = lb.shift(),
                                sM = G(qM, 4, rM),
                                tM = lb.shift(),
                                uM = G(sM, 5, tM),
                                vM = lb.shift(),
                                wM = G(uM, 6, vM),
                                xM = lb.shift(),
                                yM = G(wM, 7, xM),
                                zM = lb.shift();
                            var AM = G(yM, 8, zM);
                            var BM = C(jM, 7, AM),
                                CM = lb.shift(),
                                DM = G(BM, 8, CM),
                                EM = lb.shift(),
                                FM = G(DM, 9, EM),
                                GM = lb.shift(),
                                HM = G(FM, 10, GM),
                                IM = lb.shift(),
                                Fz = G(HM, 11, IM);
                            if (F(Fz, 5) === 1 || F(Fz, 6) === 1) return !0;
                            break;
                        case 10:
                            if (Ba.length === 0) throw Error("Cannot decode empty USCO section string.");
                            var bi = Ba.split(".");
                            if (bi.length > 2) throw Error("Expected at most 2 segments but got " + bi.length + " when decoding " + Ba + ".");
                            var JM = void 0,
                                Gz = void 0,
                                Hz = void 0,
                                Iz = void 0,
                                Jz = void 0,
                                Kz = void 0,
                                Lz = void 0,
                                Mz = void 0,
                                Nz = void 0,
                                Oz = void 0,
                                Pz = void 0,
                                Qz = void 0,
                                Rz = void 0,
                                Sz = void 0,
                                Tz = void 0,
                                Uz = void 0,
                                Vz = void 0,
                                Wz = void 0,
                                Xz = bi[0];
                            if (Xz.length === 0) throw Error("Cannot decode empty core segment string.");
                            var dl = oy(Xz, VA),
                                Qp = my(dl.slice(0, 6));
                            dl = dl.slice(6);
                            if (Qp !== 1) throw Error("Unable to decode unsupported USCO Section specification version " + Qp + " - only version 1 is supported.");
                            for (var Rp = 0, sb = [], Sp = 0; Sp < UA.length; Sp++) {
                                var Yz = UA[Sp];
                                sb.push(my(dl.slice(Rp, Rp + Yz)));
                                Rp += Yz;
                            }
                            var KM = new QA();
                            Wz = Cg(KM, 1, Qp);
                            var LM = sb.shift();
                            Vz = G(Wz, 2, LM);
                            var MM = sb.shift();
                            Uz = G(Vz, 3, MM);
                            var NM = sb.shift();
                            Tz = G(Uz, 4, NM);
                            var OM = sb.shift();
                            Sz = G(Tz, 5, OM);
                            var PM = sb.shift();
                            Rz = G(Sz, 6, PM);
                            var QM = new PA(),
                                RM = sb.shift();
                            Qz = G(QM, 1, RM);
                            var SM = sb.shift();
                            Pz = G(Qz, 2, SM);
                            var TM = sb.shift();
                            Oz = G(Pz, 3, TM);
                            var UM = sb.shift();
                            Nz = G(Oz, 4, UM);
                            var VM = sb.shift();
                            Mz = G(Nz, 5, VM);
                            var WM = sb.shift();
                            Lz = G(Mz, 6, WM);
                            var XM = sb.shift();
                            Kz = G(Lz, 7, XM);
                            Jz = C(Rz, 7, Kz);
                            var YM = sb.shift();
                            Iz = G(Jz, 8, YM);
                            var ZM = sb.shift();
                            Hz = G(Iz, 9, ZM);
                            var $M = sb.shift();
                            Gz = G(Hz, 10, $M);
                            var aN = sb.shift();
                            var Zz = (JM = G(Gz, 11, aN));
                            if (bi.length === 1) var $z = TA(Zz);
                            else {
                                var bN = TA(Zz),
                                    aA = void 0,
                                    bA = void 0,
                                    cA = void 0,
                                    dA = bi[1];
                                if (dA.length === 0) throw Error("Cannot decode empty GPC segment string.");
                                var eA = oy(dA, 3),
                                    el = my(eA.slice(0, 2));
                                if (el < 0 || el > 1) throw Error("Attempting to decode unknown GPC segment subsection type " + el + ".");
                                cA = el + 1;
                                var cN = my(eA.slice(2, 3)),
                                    dN = new RA();
                                bA = G(dN, 2, cA);
                                aA = Ag(bA, 1, !!cN);
                                $z = C(bN, 2, aA);
                            }
                            var fA = eg($z, QA, 1);
                            if (F(fA, 5) === 1 || F(fA, 6) === 1) return !0;
                            break;
                        case 12:
                            if (Ba.length === 0) throw Error("Cannot decode empty usct section string.");
                            var ci = Ba.split(".");
                            if (ci.length > 2) throw Error("Expected at most 2 segments but got " + ci.length + " when decoding " + Ba + ".");
                            var eN = void 0,
                                gA = void 0,
                                hA = void 0,
                                iA = void 0,
                                jA = void 0,
                                kA = void 0,
                                lA = void 0,
                                mA = void 0,
                                nA = void 0,
                                oA = void 0,
                                pA = void 0,
                                qA = void 0,
                                rA = void 0,
                                sA = void 0,
                                tA = void 0,
                                uA = void 0,
                                vA = void 0,
                                wA = void 0,
                                xA = void 0,
                                yA = void 0,
                                zA = void 0,
                                AA = void 0,
                                BA = ci[0];
                            if (BA.length === 0) throw Error("Cannot decode empty core segment string.");
                            var fl = oy(BA, cB),
                                Tp = my(fl.slice(0, 6));
                            fl = fl.slice(6);
                            if (Tp !== 1) throw Error("Unable to decode unsupported USCT Section specification version " + Tp + " - only version 1 is supported.");
                            for (var Up = 0, Va = [], Vp = 0; Vp < bB.length; Vp++) {
                                var CA = bB[Vp];
                                Va.push(my(fl.slice(Up, Up + CA)));
                                Up += CA;
                            }
                            var fN = new YA();
                            AA = Cg(fN, 1, Tp);
                            var gN = Va.shift();
                            zA = G(AA, 2, gN);
                            var hN = Va.shift();
                            yA = G(zA, 3, hN);
                            var iN = Va.shift();
                            xA = G(yA, 4, iN);
                            var jN = Va.shift();
                            wA = G(xA, 5, jN);
                            var kN = Va.shift();
                            vA = G(wA, 6, kN);
                            var lN = new XA(),
                                mN = Va.shift();
                            uA = G(lN, 1, mN);
                            var nN = Va.shift();
                            tA = G(uA, 2, nN);
                            var oN = Va.shift();
                            sA = G(tA, 3, oN);
                            var pN = Va.shift();
                            rA = G(sA, 4, pN);
                            var qN = Va.shift();
                            qA = G(rA, 5, qN);
                            var rN = Va.shift();
                            pA = G(qA, 6, rN);
                            var sN = Va.shift();
                            oA = G(pA, 7, sN);
                            var tN = Va.shift();
                            nA = G(oA, 8, tN);
                            mA = C(vA, 7, nA);
                            var uN = new WA(),
                                vN = Va.shift();
                            lA = G(uN, 1, vN);
                            var wN = Va.shift();
                            kA = G(lA, 2, wN);
                            var xN = Va.shift();
                            jA = G(kA, 3, xN);
                            iA = C(mA, 8, jA);
                            var yN = Va.shift();
                            hA = G(iA, 9, yN);
                            var zN = Va.shift();
                            gA = G(hA, 10, zN);
                            var AN = Va.shift();
                            var DA = (eN = G(gA, 11, AN));
                            if (ci.length === 1) var EA = aB(DA);
                            else {
                                var BN = aB(DA),
                                    FA = void 0,
                                    GA = void 0,
                                    HA = void 0,
                                    IA = ci[1];
                                if (IA.length === 0) throw Error("Cannot decode empty GPC segment string.");
                                var JA = oy(IA, 3),
                                    gl = my(JA.slice(0, 2));
                                if (gl < 0 || gl > 1) throw Error("Attempting to decode unknown GPC segment subsection type " + gl + ".");
                                HA = gl + 1;
                                var CN = my(JA.slice(2, 3)),
                                    DN = new ZA();
                                GA = G(DN, 2, HA);
                                FA = Ag(GA, 1, !!CN);
                                EA = C(BN, 2, FA);
                            }
                            var KA = eg(EA, YA, 1);
                            if (F(KA, 5) === 1 || F(KA, 6) === 1) return !0;
                    }
                }
            }
            return !1;
        },
        SC = { eventName: "signalStatus", data: "ready", pingData: { internalErrorState: 2, gppString: "GPP_ERROR_STRING_UNAVAILABLE", applicableSections: [-1] }, listenerId: -1 },
        QC = { eventName: "signalStatus", data: "ready", pingData: { gppString: "GPP_ERROR_STRING_LISTENER_REGISTRATION_TIMEOUT", internalErrorState: 2, applicableSections: [-1] }, listenerId: -1 },
        RC = { eventName: "signalStatus", data: "ready", pingData: { gppString: "GPP_ERROR_STRING_REMOVE_EVENT_LISTENER_ERROR", internalErrorState: 2, applicableSections: [-1] }, listenerId: -1 };
    oC([1, 8, 9, 10, 11, 12, 2, 3, 4, 5, 15, 16, 19, 20, 21]);
    oC([1, 6, 7, 9, 10, 11, 12, 2, 3, 4, 5, 13, 14, 18, 19, 20, 21]);
    oC([1, 6, 7, 9, 10, 11, 12, 22, 2, 3, 4, 5, 13, 14, 17, 18, 19, 20, 21]);
    new nC();
    var T = function (a, b) {
        this.j = this.B = this.o = "";
        this.J = null;
        this.L = this.l = "";
        this.A = !1;
        var c;
        a instanceof T
            ? ((this.A = b !== void 0 ? b : a.A), UC(this, a.o), (this.B = a.B), (this.j = a.j), VC(this, a.J), (this.l = a.l), WC(this, XC(a.g)), (this.L = a.D()))
            : a && (c = String(a).match(nj))
            ? ((this.A = !!b), UC(this, c[1] || "", !0), (this.B = YC(c[2] || "")), (this.j = YC(c[3] || "", !0)), VC(this, c[4]), (this.l = YC(c[5] || "", !0)), WC(this, c[6] || "", !0), (this.L = YC(c[7] || "")))
            : ((this.A = !!b), (this.g = new ZC(null, this.A)));
    };
    T.prototype.toString = function () {
        var a = [],
            b = this.o;
        b && a.push($C(b, aD, !0), ":");
        var c = this.j;
        if (c || b == "file") a.push("//"), (b = this.B) && a.push($C(b, aD, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), (c = this.J), c != null && a.push(":", String(c));
        if ((c = this.l)) this.j && c.charAt(0) != "/" && a.push("/"), a.push($C(c, c.charAt(0) == "/" ? bD : cD, !0));
        (c = this.g.toString()) && a.push("?", c);
        (c = this.D()) && a.push("#", $C(c, dD));
        return a.join("");
    };
    T.prototype.resolve = function (a) {
        var b = this.G(),
            c = !!a.o;
        c ? UC(b, a.o) : (c = !!a.B);
        c ? (b.B = a.B) : (c = !!a.j);
        c ? (b.j = a.j) : (c = a.J != null);
        var d = a.l;
        if (c) VC(b, a.J);
        else if ((c = !!a.l)) {
            if (d.charAt(0) != "/")
                if (this.j && !this.l) d = "/" + d;
                else {
                    var e = b.l.lastIndexOf("/");
                    e != -1 && (d = b.l.slice(0, e + 1) + d);
                }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (yb(e, "./") || yb(e, "/.")) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                for (var f = [], g = 0; g < e.length; ) {
                    var h = e[g++];
                    h == "." ? d && g == e.length && f.push("") : h == ".." ? ((f.length > 1 || (f.length == 1 && f[0] != "")) && f.pop(), d && g == e.length && f.push("")) : (f.push(h), (d = !0));
                }
                d = f.join("/");
            } else d = e;
        }
        c ? (b.l = d) : (c = a.g.toString() !== "");
        c ? WC(b, XC(a.g)) : (c = !!a.L);
        c && (b.L = a.D());
        return b;
    };
    T.prototype.G = function () {
        return new T(this);
    };
    var UC = function (a, b, c) {
            a.o = c ? YC(b, !0) : b;
            a.o && (a.o = a.o.replace(/:$/, ""));
        },
        VC = function (a, b) {
            if (b) {
                b = Number(b);
                if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
                a.J = b;
            } else a.J = null;
        },
        WC = function (a, b, c) {
            b instanceof ZC ? ((a.g = b), eD(a.g, a.A)) : (c || (b = $C(b, fD)), (a.g = new ZC(b, a.A)));
        },
        gD = function (a, b, c) {
            a.g.set(b, c);
            return a;
        };
    T.prototype.D = function () {
        return this.L;
    };
    var hD = function (a) {
            return a instanceof T ? a.G() : new T(a, void 0);
        },
        YC = function (a, b) {
            return a ? (b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a)) : "";
        },
        $C = function (a, b, c) {
            return typeof a === "string" ? ((a = encodeURI(a).replace(b, iD)), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
        },
        iD = function (a) {
            a = a.charCodeAt(0);
            return "%" + ((a >> 4) & 15).toString(16) + (a & 15).toString(16);
        },
        aD = /[#\/\?@]/g,
        cD = /[#\?:]/g,
        bD = /[#\?]/g,
        fD = /[#\?@]/g,
        dD = /#/g,
        ZC = function (a, b) {
            this.j = this.g = null;
            this.l = a || null;
            this.o = !!b;
        },
        jD = function (a) {
            a.g ||
                ((a.g = new Map()),
                (a.j = 0),
                a.l &&
                    pj(a.l, function (b, c) {
                        a.add(Ni(b), c);
                    }));
        };
    ZC.prototype.add = function (a, b) {
        jD(this);
        this.l = null;
        a = kD(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, (c = []));
        c.push(b);
        this.j += 1;
        return this;
    };
    ZC.prototype.remove = function (a) {
        jD(this);
        a = kD(this, a);
        return this.g.has(a) ? ((this.l = null), (this.j -= this.g.get(a).length), this.g.delete(a)) : !1;
    };
    ZC.prototype.clear = function () {
        this.g = this.l = null;
        this.j = 0;
    };
    ZC.prototype.isEmpty = function () {
        jD(this);
        return this.j == 0;
    };
    var lD = function (a, b) {
        jD(a);
        b = kD(a, b);
        return a.g.has(b);
    };
    l = ZC.prototype;
    l.forEach = function (a, b) {
        jD(this);
        this.g.forEach(function (c, d) {
            c.forEach(function (e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    l.Hc = function () {
        jD(this);
        for (var a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [], d = 0; d < b.length; d++) for (var e = a[d], f = 0; f < e.length; f++) c.push(b[d]);
        return c;
    };
    l.Gb = function (a) {
        jD(this);
        var b = [];
        if (typeof a === "string") lD(this, a) && (b = b.concat(this.g.get(kD(this, a))));
        else {
            a = Array.from(this.g.values());
            for (var c = 0; c < a.length; c++) b = b.concat(a[c]);
        }
        return b;
    };
    l.set = function (a, b) {
        jD(this);
        this.l = null;
        a = kD(this, a);
        lD(this, a) && (this.j -= this.g.get(a).length);
        this.g.set(a, [b]);
        this.j += 1;
        return this;
    };
    l.get = function (a, b) {
        if (!a) return b;
        a = this.Gb(a);
        return a.length > 0 ? String(a[0]) : b;
    };
    l.toString = function () {
        if (this.l) return this.l;
        if (!this.g) return "";
        for (var a = [], b = Array.from(this.g.keys()), c = 0; c < b.length; c++) {
            var d = b[c],
                e = encodeURIComponent(String(d));
            d = this.Gb(d);
            for (var f = 0; f < d.length; f++) {
                var g = e;
                d[f] !== "" && (g += "=" + encodeURIComponent(String(d[f])));
                a.push(g);
            }
        }
        return (this.l = a.join("&"));
    };
    var XC = function (a) {
            var b = new ZC();
            b.l = a.l;
            a.g && ((b.g = new Map(a.g)), (b.j = a.j));
            return b;
        },
        kD = function (a, b) {
            b = String(b);
            a.o && (b = b.toLowerCase());
            return b;
        },
        eD = function (a, b) {
            b &&
                !a.o &&
                (jD(a),
                (a.l = null),
                a.g.forEach(function (c, d) {
                    var e = d.toLowerCase();
                    d != e && (this.remove(d), this.remove(e), c.length > 0 && ((this.l = null), this.g.set(kD(this, e), hc(c)), (this.j += c.length)));
                }, a));
            a.o = b;
        };
    var mD,
        nD,
        oD,
        pD = function () {
            return y.navigator ? y.navigator.userAgent : "";
        },
        qD = yb(pD(), "(iPad") || yb(pD(), "(Macintosh") || yb(pD(), "(iPod") || yb(pD(), "(iPhone");
    var rD = "ad.doubleclick.net bid.g.doubleclick.net ggpht.com google.co.uk google.com googleads.g.doubleclick.net googleads4.g.doubleclick.net googleadservices.com googlesyndication.com googleusercontent.com gstatic.com gvt1.com prod.google.com pubads.g.doubleclick.net s0.2mdn.net static.doubleclick.net surveys.g.doubleclick.net youtube.com ytimg.com".split(
            " "
        ),
        sD = ["c.googlesyndication.com"];
    function tD(a, b) {
        b = b === void 0 ? window.location.protocol : b;
        var c = !1;
        a == null || !a.startsWith("http") || (a == null ? 0 : a.startsWith("https")) ? (c = !1) : uD(a, sD) ? (c = !1) : b.includes("https") && uD(a, rD) && (c = !0);
        return c ? ((a = new T(a)), L(K.getInstance(), "htp", "1"), UC(a, "https"), a.toString()) : a;
    }
    function vD(a) {
        if (!a) return !1;
        try {
            var b = typeof a === "string" ? new T(a) : a;
            return b.o == "gcache" && !!b.g.get("url");
        } catch (c) {
            return !1;
        }
    }
    function wD(a) {
        try {
            var b = typeof a === "string" ? new T(a) : a;
            if (vD(b)) {
                var c = b.g.get("url");
                return typeof c === "undefined" ? null : c;
            }
        } catch (d) {}
        return null;
    }
    function uD(a, b) {
        return new RegExp("^https?://([a-z0-9-]{1,63}\\.)*(" + b.join("|").replace(/\./g, "\\.") + ")(:[0-9]+)?([/?#]|$)", "i").test(a);
    }
    var xD = -1;
    function yD(a, b) {
        b = b != null ? b : "";
        rc && (b = "");
        if (!wb(Qi(a))) {
            var c = a instanceof ei || !pC.test(a) ? a : new ei(a);
            if (c instanceof ei) var d = c;
            else {
                d = d === void 0 ? ii : d;
                a: if (((d = d === void 0 ? ii : d), !(a instanceof ei))) {
                    for (c = 0; c < d.length; ++c) {
                        var e = d[c];
                        if (e instanceof gi && e.Mg(a)) {
                            a = new ei(a);
                            break a;
                        }
                    }
                    a = void 0;
                }
                d = a || fi;
            }
            a = window;
            if (d instanceof ei)
                if (d instanceof ei) d = d.g;
                else throw Error("");
            else d = ki.test(d) ? d : void 0;
            d !== void 0 && a.open(d, "_blank", b);
        }
    }
    function zD(a, b) {
        for (var c; !(c = a.next()).done; ) b(c.value);
    }
    var AD = function (a, b) {
        this.g = a[y.Symbol.iterator]();
        this.j = b;
    };
    AD.prototype[Symbol.iterator] = function () {
        return this;
    };
    AD.prototype.next = function () {
        var a = this.g.next();
        return { value: a.done ? void 0 : this.j.call(void 0, a.value), done: a.done };
    };
    var BD = function (a, b) {
        return new AD(a, b);
    };
    var CD = function (a, b) {
        var c = new Set(a);
        zD(b[Symbol.iterator](), function (d) {
            return c.add(d);
        });
        return c;
    };
    var DD = new Map(),
        ED = function () {
            this.j = this.g = null;
        };
    function FD(a, b, c, d) {
        var e = Nq(a);
        si(b, e)
            ? ((e = setTimeout(function () {
                  return FD(a, b, c, d);
              }, 200)),
              (d.j = e))
            : (GD(d), c(e));
    }
    function HD(a) {
        var b = new ED(),
            c = new Promise(function (f) {
                var g = Nq(a);
                if ("ResizeObserver" in window) {
                    var h = new ResizeObserver(function (k) {
                        window.requestAnimationFrame(function () {
                            for (var m = new ri(0, 0), n = w(k), p = n.next(); !p.done; p = n.next())
                                if (
                                    ((p = p.value),
                                    p.contentBoxSize
                                        ? ((p = Array.isArray(p.contentBoxSize) ? p.contentBoxSize[0] : p.contentBoxSize), (m.width = Math.floor(p.inlineSize)), (m.height = Math.floor(p.blockSize)))
                                        : ((m.width = Math.floor(p.contentRect.width)), (m.height = Math.floor(p.contentRect.height))),
                                    !si(g, m))
                                )
                                    return GD(b), f(m);
                        });
                    });
                    b.g = h;
                    h.observe(a);
                } else FD(a, g, f, b);
            }),
            d,
            e = (d = DD.get(c)) != null ? d : new Set();
        e.add(b);
        DD.set(c, e);
        return c;
    }
    function ID(a, b) {
        b = b === void 0 ? new ri(1, 1) : b;
        var c = function (g) {
                var h = HD(a),
                    k,
                    m = (k = DD.get(g)) != null ? k : new Set(),
                    n;
                k = (n = DD.get(h)) != null ? n : new Set();
                DD.set(g, CD(m, k));
                return h;
            },
            d = function (g, h) {
                c(g).then(function (k) {
                    return b.width <= k.width && b.height <= k.height ? (JD(g), h(k)) : d(g, h);
                });
            },
            e,
            f = new Promise(function (g) {
                e = g;
            });
        d(f, e);
        return f;
    }
    function JD(a) {
        a = DD.get(a);
        a = w(a);
        for (var b = a.next(); !b.done; b = a.next()) GD(b.value);
    }
    function GD(a) {
        a.j && window.clearTimeout(a.j);
        a.g && (a.g.disconnect(), (a.g = null));
    }
    function KD(a, b) {
        return a && (a[b] || (a[b] = {}));
    }
    function LD(a, b) {
        var c;
        if ((c = c === void 0 ? (typeof omidExports === "undefined" ? null : omidExports) : c)) (a = a.split(".")), (a.slice(0, a.length - 1).reduce(KD, c)[a[a.length - 1]] = b);
    }
    var MD = new Map([
        [2, [/^(https?:\/\/|\/\/)?[-a-zA-Z0-9.]+\.moatads\.com\/.*$/]],
        [3, [/^(https?:\/\/|\/\/)?[-a-zA-Z0-9.]+\.doubleverify\.com\/.*$/, /^(https?:\/\/|\/\/)?c\.[\w\-]+\.com\/vfw\/dv\/.*$/, /^(https?:\/\/|\/\/)?(www\.)?[\w]+\.tv\/r\/s\/d\/.*$/, /^(https?:\/\/|\/\/)?(\w\.?)+\.dv\.tech\/.*$/]],
        [4, [/^(https?:\/\/|\/\/)?[-a-zA-Z0-9.]+\.adsafeprotected\.com\/.*$/]],
        [5, [/^https?:\/\/(q|cdn)\.adrta\.com\/s\/.*\/(aa|aanf)\.js.*$/, /^https:\/\/cdn\.rta247\.com\/s\/.*\/(aa|aanf)\.js.*$/]],
        [6, []],
        [7, [/^(https?:\/\/|\/\/)?[-a-zA-Z0-9.]+\.voicefive\.com\/.*$/, /^(https?:\/\/|\/\/)?[-a-zA-Z0-9.]+\.measuread\.com\/.*$/, /^(https?:\/\/|\/\/)?[-a-zA-Z0-9.]+\.scorecardresearch\.com\/.*$/]],
        [8, [/^(https?:\/\/|\/\/)?s418\.mxcdn\.net\/bb-serve\/omid-meetrics.*\.js$/]],
        [9, [/^(https?:\/\/|\/\/)?pagead2\.googlesyndication\.com\/.*$/, /^(https?:\/\/|\/\/)?www\.googletagservices\.com\/.*$/]],
    ]);
    LD("OmidSessionClient.verificationVendorIdForScriptUrl", function (a) {
        for (var b = w(MD.keys()), c = b.next(); !c.done; c = b.next()) {
            c = c.value;
            for (var d = w(MD.get(c)), e = d.next(); !e.done; e = d.next()) if (e.value.test(a)) return c;
        }
        return 1;
    });
    LD("OmidSessionClient.VerificationVendorId", { OTHER: 1, MOAT: 2, DOUBLEVERIFY: 3, INTEGRAL_AD_SCIENCE: 4, PIXELATE: 5, NIELSEN: 6, COMSCORE: 7, MEETRICS: 8, GOOGLE: 9 });
    var ND = /OS (\S+) like/,
        OD = /Android ([\d\.]+)/;
    function PD(a, b) {
        a = (a = a.exec(Gb())) ? a[1] : "";
        a = a.replace(/_/g, ".");
        return Cb(a, b) >= 0;
    }
    var QD = function () {
            return zc || (wc && "ontouchstart" in document.documentElement);
        },
        RD = function (a) {
            return Bc && PD(ND, a);
        },
        SD = function (a) {
            return (a = a === void 0 ? null : a) && typeof a.getAttribute === "function" ? (a.getAttribute("playsinline") ? !0 : !1) : !1;
        };
    var TD = function (a) {
        R.call(this);
        this.j = a;
        this.A = this.B = !1;
        this.C = this.D = 0;
        this.g = new Ow(1e3);
        Er(this, this.g);
        Zv(this.g, "tick", this.G, !1, this);
        Zv(this.j, "pause", this.l, !1, this);
        Zv(this.j, "playing", this.l, !1, this);
        Zv(this.j, "ended", this.l, !1, this);
        Zv(this.j, "timeupdate", this.l, !1, this);
    };
    x(TD, R);
    var UD = function (a) {
        var b;
        return (b = a.j.currentTime) != null ? b : a.j.getCurrentTime();
    };
    TD.prototype.l = function (a) {
        switch (a.type) {
            case "playing":
                VD(this);
                break;
            case "pause":
            case "ended":
                this.g.enabled && this.g.stop();
                break;
            case "timeupdate":
                !this.B && UD(this) > 0 && ((this.B = !0), VD(this));
        }
    };
    var VD = function (a) {
        !a.g.enabled && a.B && ((a.D = UD(a) * 1e3), (a.C = Date.now()), (a.A = !1), a.g.start());
    };
    TD.prototype.G = function () {
        var a = Date.now(),
            b = a - this.C,
            c = UD(this) * 1e3;
        c - this.D < b * 0.5 ? this.A || ((this.A = !0), this.dispatchEvent("playbackStalled")) : (this.A = !1);
        this.D = c;
        this.C = a;
    };
    var WD = "://secure-...imrworldwide.com/ ://cdn.imrworldwide.com/ ://aksecure.imrworldwide.com/ ://[^.]*.moatads.com ://youtube[0-9]+.moatpixel.com ://pm.adsafeprotected.com/youtube ://pm.test-adsafeprotected.com/youtube ://e[0-9]+.yt.srs.doubleverify.com www.google.com/pagead/xsul www.youtube.com/pagead/slav".split(
            " "
        ),
        XD = /\bocr\b/;
    function YD(a) {
        if (wb(Qi(a)) || (rc && a.length > 2048)) return !1;
        try {
            if (new T(a).D().match(XD)) return !0;
        } catch (b) {}
        return (
            WD.find(function (b) {
                return a.match(b) != null;
            }) != null
        );
    }
    function ZD(a, b) {
        return wb(b) ? !1 : new RegExp(a).test(b);
    }
    function $D(a) {
        var b = {};
        a.split(",").forEach(function (c) {
            var d = c.split("=");
            d.length == 2 && ((c = xb(d[0])), (d = xb(d[1])), c.length > 0 && (b[c] = d));
        });
        return b;
    }
    function aE(a) {
        var b = "af am ar_eg ar_sa ar_xb ar be bg bn ca cs da de_at de_cn de el en_au en_ca en_gb en_ie en_in en_sg en_xa en_xc en_za en es_419 es_ar es_bo es_cl es_co es_cr es_do es_ec es_gt es_hn es_mx es_ni es_pa es_pe es_pr es_py es_sv es_us es_uy es_ve es et eu fa fi fil fr_ca fr_ch fr gl gsw gu he hi hr hu id in is it iw ja kn ko ln lo lt lv ml mo mr ms nb ne nl no pl pt_br pt_pt pt ro ru sk sl sr_latn sr sv sw ta te th tl tr uk ur vi zh_cn zh_hk zh_tw zh zu".split(
            " "
        );
        if (!a) return null;
        a = a.toLowerCase().replace("-", "_");
        if (b.includes(a)) return a;
        a = (a = a.match(/^\w{2,3}([-_]|$)/)) ? a[0].replace(/[_-]/g, "") : "";
        return b.includes(a) ? a : null;
    }
    var bE = function () {
        this.g = Date.now();
    };
    bE.prototype.reset = function () {
        this.g = Date.now();
    };
    var cE = function (a) {
        a = a.g + 5e3 - Date.now();
        return a > 0 ? a : 0;
    };
    var dE = function (a, b) {
        this.url = a;
        this.g = b === void 0 ? null : b;
    };
    var eE = function (a) {
        switch (a) {
            case 0:
                return "No Error";
            case 1:
                return "Access denied to content document";
            case 2:
                return "File not found";
            case 3:
                return "Firefox silently errored";
            case 4:
                return "Application custom error";
            case 5:
                return "An exception occurred";
            case 6:
                return "Http response at 400 or 500 level";
            case 7:
                return "Request was aborted";
            case 8:
                return "Request timed out";
            case 9:
                return "The resource is not available offline";
            default:
                return "Unrecognized error code";
        }
    };
    var fE = function (a) {
        var b = Error.call(this, a);
        this.message = b.message;
        "stack" in b && (this.stack = b.stack);
        this.errorCode = a;
    };
    x(fE, Error);
    var gE = function (a) {
        Q.call(this);
        this.o = a;
        this.j = {};
    };
    jb(gE, Q);
    var hE = [];
    gE.prototype.listen = function (a, b, c, d) {
        return iE(this, a, b, c, d);
    };
    var iE = function (a, b, c, d, e, f) {
        Array.isArray(c) || (c && (hE[0] = c.toString()), (c = hE));
        for (var g = 0; g < c.length; g++) {
            var h = Zv(b, c[g], d || a.handleEvent, e || !1, f || a.o || a);
            if (!h) break;
            a.j[h.key] = h;
        }
        return a;
    };
    gE.prototype.dc = function (a, b, c, d) {
        return jE(this, a, b, c, d);
    };
    var jE = function (a, b, c, d, e, f) {
        if (Array.isArray(c)) for (var g = 0; g < c.length; g++) jE(a, b, c[g], d, e, f);
        else {
            b = Yv(b, c, d || a.handleEvent, e, f || a.o || a);
            if (!b) return a;
            a.j[b.key] = b;
        }
        return a;
    };
    gE.prototype.sb = function (a, b, c, d, e) {
        if (Array.isArray(b)) for (var f = 0; f < b.length; f++) this.sb(a, b[f], c, d, e);
        else
            (c = c || this.handleEvent),
                (d = Ya(d) ? !!d.capture : !!d),
                (e = e || this.o || this),
                (c = $v(c)),
                (d = !!d),
                (b = Ov(a) ? a.Vb(b, c, d, e) : a ? ((a = bw(a)) ? a.Vb(b, c, d, e) : null) : null),
                b && (gw(b), delete this.j[b.key]);
    };
    var kE = function (a) {
        ti(
            a.j,
            function (b, c) {
                this.j.hasOwnProperty(c) && gw(b);
            },
            a
        );
        a.j = {};
    };
    gE.prototype.O = function () {
        gE.Ia.O.call(this);
        kE(this);
    };
    gE.prototype.handleEvent = function () {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var lE = function () {};
    lE.prototype.g = null;
    var mE = function (a) {
        var b;
        (b = a.g) || (b = a.g = {});
        return b;
    };
    var nE,
        oE = function () {};
    jb(oE, lE);
    nE = new oE();
    var pE = function (a) {
        R.call(this);
        this.headers = new Map();
        this.W = a || null;
        this.j = !1;
        this.D = this.g = null;
        this.K = "";
        this.A = 0;
        this.l = this.I = this.B = this.G = !1;
        this.M = 0;
        this.C = null;
        this.V = "";
        this.P = !1;
    };
    jb(pE, R);
    var qE = /^https?$/i,
        rE = ["POST", "PUT"],
        uE = function (a, b, c, d) {
            if (a.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.K + "; newUri=" + b);
            c = c ? c.toUpperCase() : "GET";
            a.K = b;
            a.A = 0;
            a.G = !1;
            a.j = !0;
            a.g = new XMLHttpRequest();
            a.D = a.W ? mE(a.W) : mE(nE);
            a.g.onreadystatechange = gb(a.U, a);
            try {
                (a.I = !0), a.g.open(c, String(b), !0), (a.I = !1);
            } catch (g) {
                sE(a);
                return;
            }
            b = d || "";
            d = new Map(a.headers);
            var e = Array.from(d.keys()).find(function (g) {
                    return "content-type" == g.toLowerCase();
                }),
                f = y.FormData && b instanceof y.FormData;
            !cc(rE, c) || e || f || d.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
            c = w(d);
            for (d = c.next(); !d.done; d = c.next()) (e = w(d.value)), (d = e.next().value), (e = e.next().value), a.g.setRequestHeader(d, e);
            a.V && (a.g.responseType = a.V);
            "withCredentials" in a.g && a.g.withCredentials !== a.P && (a.g.withCredentials = a.P);
            try {
                tE(a), a.M > 0 && (a.C = Pw(a.aa, a.M, a)), (a.B = !0), a.g.send(b), (a.B = !1);
            } catch (g) {
                sE(a);
            }
        };
    pE.prototype.aa = function () {
        typeof Sa != "undefined" && this.g && ((this.A = 8), this.dispatchEvent("timeout"), this.abort(8));
    };
    var sE = function (a) {
            a.j = !1;
            a.g && ((a.l = !0), a.g.abort(), (a.l = !1));
            a.A = 5;
            vE(a);
            wE(a);
        },
        vE = function (a) {
            a.G || ((a.G = !0), a.dispatchEvent("complete"), a.dispatchEvent("error"));
        };
    pE.prototype.abort = function (a) {
        this.g && this.j && ((this.j = !1), (this.l = !0), this.g.abort(), (this.l = !1), (this.A = a || 7), this.dispatchEvent("complete"), this.dispatchEvent("abort"), wE(this));
    };
    pE.prototype.O = function () {
        this.g && (this.j && ((this.j = !1), (this.l = !0), this.g.abort(), (this.l = !1)), wE(this, !0));
        pE.Ia.O.call(this);
    };
    pE.prototype.U = function () {
        this.Ea() || (this.I || this.B || this.l ? xE(this) : this.Z());
    };
    pE.prototype.Z = function () {
        xE(this);
    };
    var xE = function (a) {
            if (a.j && typeof Sa != "undefined" && (!a.D[1] || yE(a) != 4 || zE(a) != 2))
                if (a.B && yE(a) == 4) Pw(a.U, 0, a);
                else if ((a.dispatchEvent("readystatechange"), yE(a) == 4)) {
                    a.j = !1;
                    try {
                        var b = zE(a);
                        a: switch (b) {
                            case 200:
                            case 201:
                            case 202:
                            case 204:
                            case 206:
                            case 304:
                            case 1223:
                                var c = !0;
                                break a;
                            default:
                                c = !1;
                        }
                        var d;
                        if (!(d = c)) {
                            var e;
                            if ((e = b === 0)) {
                                var f = String(a.K).match(nj)[1] || null;
                                !f && y.self && y.self.location && (f = y.self.location.protocol.slice(0, -1));
                                e = !qE.test(f ? f.toLowerCase() : "");
                            }
                            d = e;
                        }
                        d ? (a.dispatchEvent("complete"), a.dispatchEvent("success")) : ((a.A = 6), vE(a));
                    } finally {
                        wE(a);
                    }
                }
        },
        wE = function (a, b) {
            if (a.g) {
                tE(a);
                var c = a.g,
                    d = a.D[0] ? function () {} : null;
                a.g = null;
                a.D = null;
                b || a.dispatchEvent("ready");
                try {
                    c.onreadystatechange = d;
                } catch (e) {}
            }
        },
        tE = function (a) {
            a.C && (y.clearTimeout(a.C), (a.C = null));
        };
    pE.prototype.isActive = function () {
        return !!this.g;
    };
    var yE = function (a) {
            return a.g ? a.g.readyState : 0;
        },
        zE = function (a) {
            try {
                return yE(a) > 2 ? a.g.status : -1;
            } catch (b) {
                return -1;
            }
        },
        AE = function (a) {
            if (a.g) {
                a: {
                    a = a.g.responseText;
                    if (y.JSON)
                        try {
                            var b = y.JSON.parse(a);
                            break a;
                        } catch (c) {}
                    b = Ql(a);
                }
                return b;
            }
        };
    var BE = function () {};
    BE.prototype.get = function (a) {
        return CE({ url: a.url, timeout: a.timeout, withCredentials: a.withCredentials === void 0 ? !0 : a.withCredentials, method: "GET", headers: a.headers === void 0 ? {} : a.headers });
    };
    var CE = function (a) {
            var b = a.url;
            var c = a.timeout;
            var d = a.withCredentials;
            var e = a.method;
            var f = a.content === void 0 ? void 0 : a.content;
            var g = a.headers === void 0 ? {} : a.headers;
            return DE({ url: b, timeout: c, withCredentials: d, method: e, content: f, headers: g }).then(
                function (h) {
                    return Promise.resolve(h);
                },
                function (h) {
                    return h instanceof Error && h.message == 6 && d ? DE({ url: b, timeout: c, withCredentials: !d, method: e, content: f, headers: g }) : Promise.reject(h);
                }
            );
        },
        DE = function (a) {
            var b = a.url;
            var c = a.timeout;
            var d = a.withCredentials;
            var e = a.method;
            var f = a.content === void 0 ? void 0 : a.content;
            a = a.headers === void 0 ? {} : a.headers;
            var g = new pE();
            g.P = d;
            g.M = Math.max(0, cE(c));
            for (var h in a) g.headers.set(h, a[h]);
            var k = new gE();
            return new Promise(function (m, n) {
                k.dc(g, "success", function () {
                    a: {
                        if (Yq())
                            try {
                                AE(g);
                                var p = "application/json";
                                break a;
                            } catch (u) {
                                p = "application/xml";
                                break a;
                            }
                        g.g && yE(g) == 4 ? ((p = g.g.getResponseHeader("Content-Type")), (p = p === null ? void 0 : p)) : (p = void 0);
                        p = p || "";
                    }
                    if (p.indexOf("application/json") != -1)
                        try {
                            m(AE(g) || {});
                        } catch (u) {
                            n(new fE(5, zE(g)));
                        }
                    else {
                        try {
                            var q = g.g ? g.g.responseXML : null;
                        } catch (u) {
                            q = null;
                        }
                        if (q == null) {
                            try {
                                var t = g.g ? g.g.responseText : "";
                            } catch (u) {
                                t = "";
                            }
                            if (typeof DOMParser != "undefined") (q = new DOMParser()), (t = Bl(t)), (q = q.parseFromString(mi(t), "application/xml"));
                            else throw Error("Your browser does not support loading xml documents");
                        }
                        m(q);
                    }
                    k.dispose();
                    g.dispose();
                });
                k.dc(g, ["error", "timeout"], function () {
                    n(new fE(g.A, zE(g)));
                    k.dispose();
                    g.dispose();
                });
                uE(g, tD(b), e, f);
            });
        };
    z("google.javascript.ads.imalib.common.UrlLoader", BE);
    var EE = RegExp("^(https?:)?\\/\\/ad\\.doubleclick\\.net/ddm/track(imp|clk)");
    function FE() {
        return Qn("attribution-reporting");
    }
    var JE = function (a, b, c, d, e) {
            c = c === void 0 ? !1 : c;
            e = e === void 0 ? null : e;
            try {
                b = (d === void 0 ? 0 : d) ? tD(b, "https") : tD(b);
                EE.test(b) && ((b = b.replace("?", ";tpsrc=ima?")), (e = e || ""));
                c = c || YD(b);
                var f = e != null && window.fetch != null;
                if (a.j || f) GE(a, b, c, e);
                else {
                    var g = FE() ? e : null;
                    Yq() ? HE(b) : IE(a, b, c, g);
                }
            } catch (h) {}
        },
        KE = function (a, b) {
            var c = { keepalive: !0, method: "get", redirect: "follow", credentials: "include" };
            a && (c.referrerPolicy = "no-referrer");
            b
                ? "setAttributionReporting" in XMLHttpRequest.prototype
                    ? ((c.attributionReporting = { eventSourceEligible: !0, triggerEligible: !1 }), (c.mode = "no-cors"))
                    : (c.headers = { "Attribution-Reporting-Eligible": "event-source" })
                : (c.mode = "no-cors");
            return c;
        },
        GE = function (a, b, c, d) {
            d = d === void 0 ? null : d;
            L(K.getInstance(), "faa", "1");
            L(K.getInstance(), "alp", d === null ? "0" : "1");
            var e = FE();
            L(K.getInstance(), "arpa", e ? "1" : "0");
            fetch(b, KE(c, d === "" && e))
                .then(function () {
                    L(K.getInstance(), "fas", "1");
                })
                .catch(function () {
                    L(K.getInstance(), "faf", "1");
                    a.j = !1;
                    var f = d;
                    f = FE() ? f : null;
                    Yq() ? HE(b) : IE(a, b, c, f);
                });
            e && d && fetch(d, KE(c, !0));
        },
        IE = function (a, b, c, d) {
            var e = new Image(),
                f = (a.l++).toString();
            a.g.set(f, e);
            e.onload = e.onerror = function () {
                a.g.delete(f);
            };
            c && (e.referrerPolicy = "no-referrer");
            d != null && (e.attributionSrc = d);
            e.src = b;
        },
        HE = function (a) {
            new BE().get({ url: a, timeout: new bE() });
        };
    var LE = {
        AUTOPLAY_DISALLOWED: "autoplayDisallowed",
        Eh: "beginFullscreen",
        CAN_PLAY: "canPlay",
        CAN_PLAY_THROUGH: "canPlayThrough",
        CLICK: "click",
        DURATION_CHANGE: "durationChange",
        Ph: "end",
        Qh: "endFullscreen",
        ERROR: "error",
        Uh: "focusSkipButton",
        LOAD_START: "loadStart",
        LOADED: "loaded",
        yi: "mediaLoadTimeout",
        zi: "mediaPlaybackTimeout",
        PAUSE: "pause",
        PLAY: "play",
        PLAYING: "playing",
        SEEKED: "seeked",
        SEEKING: "seeking",
        Li: "skip",
        Rf: "skipShown",
        STALLED: "stalled",
        ve: "start",
        TIME_UPDATE: "timeUpdate",
        Oi: "timedMetadata",
        Xi: "volumeChange",
        WAITING: "waiting",
        Yi: "windowFocusChanged",
        Vh: "fullyLoaded",
    };
    var ME = function () {
        R.apply(this, arguments);
    };
    x(ME, R);
    ME.prototype.C = function () {
        return !1;
    };
    ME.prototype.D = function () {
        return -1;
    };
    ME.prototype.G = function () {};
    var NE = {},
        OE =
            ((NE[18] = -1),
            (NE[22] = -1),
            (NE[43] = 350),
            (NE[44] = 350),
            (NE[45] = 350),
            (NE[59] = -1),
            (NE[133] = 350),
            (NE[134] = 350),
            (NE[135] = 350),
            (NE[136] = 350),
            (NE[139] = 50),
            (NE[140] = 50),
            (NE[141] = 50),
            (NE[160] = 350),
            (NE[242] = 150),
            (NE[243] = 150),
            (NE[244] = 150),
            (NE[245] = 150),
            (NE[247] = 150),
            (NE[249] = 50),
            (NE[250] = 50),
            (NE[251] = 50),
            (NE[278] = 150),
            (NE[342] = -1),
            (NE[343] = -1),
            (NE[344] = -1),
            (NE[345] = -1),
            (NE[346] = -1),
            (NE[347] = -1),
            NE),
        PE = {},
        QE =
            ((PE[18] = !1),
            (PE[22] = !1),
            (PE[43] = !0),
            (PE[44] = !0),
            (PE[45] = !0),
            (PE[59] = !1),
            (PE[133] = !0),
            (PE[134] = !0),
            (PE[135] = !0),
            (PE[136] = !0),
            (PE[139] = !0),
            (PE[140] = !0),
            (PE[141] = !0),
            (PE[160] = !0),
            (PE[242] = !0),
            (PE[243] = !0),
            (PE[244] = !0),
            (PE[245] = !0),
            (PE[247] = !0),
            (PE[249] = !0),
            (PE[250] = !0),
            (PE[251] = !0),
            (PE[278] = !0),
            (PE[342] = !1),
            (PE[343] = !1),
            (PE[344] = !1),
            (PE[345] = !1),
            (PE[346] = !1),
            (PE[347] = !1),
            PE),
        RE = {},
        SE =
            ((RE[18] = "video/mp4"),
            (RE[22] = "video/mp4"),
            (RE[43] = "video/webm"),
            (RE[44] = "video/webm"),
            (RE[45] = "video/webm"),
            (RE[59] = "video/mp4"),
            (RE[133] = "video/mp4"),
            (RE[134] = "video/mp4"),
            (RE[135] = "video/mp4"),
            (RE[136] = "video/mp4"),
            (RE[139] = "audio/mp4"),
            (RE[140] = "audio/mp4"),
            (RE[141] = "audio/mp4"),
            (RE[160] = "video/mp4"),
            (RE[242] = "video/webm"),
            (RE[243] = "video/webm"),
            (RE[244] = "video/webm"),
            (RE[245] = "video/webm"),
            (RE[247] = "video/webm"),
            (RE[249] = "audio/webm"),
            (RE[250] = "audio/webm"),
            (RE[251] = "audio/webm"),
            (RE[278] = "video/webm"),
            (RE[342] = "video/mp4"),
            (RE[343] = "video/mp4"),
            (RE[344] = "video/mp4"),
            (RE[345] = "video/mp4"),
            (RE[346] = "video/mp4"),
            (RE[347] = "video/mp4"),
            RE),
        TE = {},
        UE =
            ((TE[18] = "avc1.42001E, mp4a.40.2"),
            (TE[22] = "avc1.64001F, mp4a.40.2"),
            (TE[43] = "vp8, vorbis"),
            (TE[44] = "vp8, vorbis"),
            (TE[45] = "vp8, vorbis"),
            (TE[59] = "avc1.4D001F, mp4a.40.2"),
            (TE[133] = "avc1.4D401E"),
            (TE[134] = "avc1.4D401E"),
            (TE[135] = "avc1.4D401E"),
            (TE[136] = "avc1.4D401E"),
            (TE[139] = "mp4a.40.2"),
            (TE[140] = "mp4a.40.2"),
            (TE[141] = "mp4a.40.2"),
            (TE[160] = "avc1.4D401E"),
            (TE[242] = "vp9"),
            (TE[243] = "vp9"),
            (TE[244] = "vp9"),
            (TE[245] = "vp9"),
            (TE[247] = "vp9"),
            (TE[249] = "opus"),
            (TE[250] = "opus"),
            (TE[251] = "opus"),
            (TE[278] = "vp9"),
            (TE[342] = "avc1.42E01E, mp4a.40.2"),
            (TE[343] = "avc1.42E01E, mp4a.40.2"),
            (TE[344] = "avc1.42E01E, mp4a.40.2"),
            (TE[345] = "avc1.42E01E, mp4a.40.2"),
            (TE[346] = "avc1.42E01E, mp4a.40.2"),
            (TE[347] = "avc1.4D001F, mp4a.40.2"),
            TE);
    var VE = RegExp("/itag/(\\d+)/");
    function WE(a) {
        var b = Number(rj(a, "itag"));
        return b ? b : (a = a.match(VE)) && a.length === 2 ? Number(a[1]) : null;
    }
    function XE(a) {
        var b = SE[a];
        a = UE[a];
        b ? ((b = Qi(b).toLowerCase()), (b = a ? b + '; codecs="' + Qi(a) + '"' : b)) : (b = "");
        return b;
    }
    function YE(a, b) {
        if (typeof CustomEvent === "function") return new CustomEvent(a, { detail: b });
        var c = document.createEvent("CustomEvent");
        c.initCustomEvent(a, !1, !0, b);
        return c;
    }
    var ZE = function (a, b) {
        ME.call(this);
        var c = this;
        this.j = b;
        this.B = this.l = this.g = 0;
        this.A = null;
        this.uri = new T(a);
        this.state = 0;
        var d;
        this.I = (d = this.j) == null ? void 0 : d.initialize();
        Dr(this, function () {
            Cr(c.j);
        });
    };
    x(ZE, ME);
    ZE.prototype.D = function () {
        return this.g;
    };
    ZE.prototype.C = function () {
        return this.state === 3;
    };
    ZE.prototype.G = function (a) {
        this.state === 1 ? ((this.g += a), (this.state = 2)) : this.state === 0 && ((this.g += a), (this.state = 1), $E(this));
    };
    var $E = function (a) {
            La(function (b) {
                if (b.g == 1) return a.state === 2 && (a.state = 1), Aa(b, aF(a), 4);
                var c = a.B > 3;
                if (c) {
                    a.A === null && (a.A = 400);
                    var d = YE("media_source_error", {
                        code: a.l > 0 ? MediaError.MEDIA_ERR_NETWORK : MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
                        message: 'Response code "' + a.A + '" with ' + a.g + " bytes requested and " + a.l + " bytes loaded",
                    });
                    a.dispatchEvent(d);
                }
                a.l < a.g && a.state !== 3 && !c ? (b.g = 1) : (a.state !== 3 && (a.state = 0), (b.g = 0));
            });
        },
        aF = function (a) {
            var b;
            return La(function (c) {
                switch (c.g) {
                    case 1:
                        b = a.l + "-" + (a.g - 1);
                        gD(a.uri, "range", b);
                        if (!a.j) {
                            c.g = 2;
                            break;
                        }
                        return Aa(c, a.I, 3);
                    case 3:
                        return c.return(bF(a));
                    case 2:
                        return (c.l = 4), Aa(c, cF(a), 6);
                    case 6:
                        Ca(c);
                        break;
                    case 4:
                        Da(c), a.B++, (c.g = 0);
                }
            });
        },
        bF = function (a) {
            var b;
            return La(function (c) {
                switch (c.g) {
                    case 1:
                        return a.j ? Aa(c, a.j.Wb(a.uri), 2) : c.return(Promise.reject());
                    case 2:
                        if ((b = c.j)) return b.xa && (a.state = 3), dF(a, b.video), c.return();
                        c.l = 3;
                        return Aa(c, cF(a), 5);
                    case 5:
                        Ca(c);
                        break;
                    case 3:
                        Da(c), a.B++, (c.g = 0);
                }
            });
        },
        cF = function (a) {
            var b, c, d, e, f, g, h;
            return La(function (k) {
                if (k.g == 1) return (b = 0), (c = a.g - a.l), Aa(k, fetch(a.uri.toString()), 2);
                d = k.j;
                if (d.status >= 400) return L(K.getInstance(), "lvlfes", d.status.toString()), (a.A = d.status), k.return(Promise.reject());
                f = (e = d.body) == null ? void 0 : e.getReader();
                if (!f) return Ol("lvlmr"), (a.A = d.status), k.return(Promise.reject());
                g = [];
                h = function () {
                    var m, n, p, q, t, u;
                    return La(function (v) {
                        if (v.g == 1) return Aa(v, f.read(), 2);
                        m = v.j;
                        n = m.done;
                        p = m.value;
                        if (n) return (q = b < c), eF(a, g, q), v.return();
                        g.push(p);
                        b += (t = p) == null ? void 0 : t.length;
                        dF(a, (u = p) == null ? void 0 : u.buffer);
                        return Aa(v, h(), 0);
                    });
                };
                return Aa(k, h(), 0);
            });
        },
        eF = function (a, b, c) {
            c && ((a.state = 3), dF(a, new ArrayBuffer(0)));
            var d = new Uint8Array(
                    b.reduce(function (g, h) {
                        return g + h.length;
                    }, 0)
                ),
                e = 0;
            b = w(b);
            for (var f = b.next(); !f.done; f = b.next()) (f = f.value), d.set(f, e), (e += f.length);
            a.j && d.buffer.byteLength > 0 && a.j.wc(d.buffer, a.uri, 0, c);
        },
        dF = function (a, b) {
            b !== null && ((b = b.slice(0)), (a.l += b.byteLength), a.dispatchEvent({ type: "progress", ud: b }));
        };
    ZE.prototype.O = function () {
        var a;
        ((a = this.j) == null ? 0 : a.Ua()) && this.j.close();
        ME.prototype.O.call(this);
    };
    var gF = function (a) {
            this.uri = a;
            this.g = fF(a);
        },
        fF = function (a) {
            return new Map(
                a.l.split("/").reduce(function (b, c, d, e) {
                    d % 2 && b.set(e[d - 1], c);
                    return b;
                }, new Map())
            );
        },
        hF = function (a) {
            var b, c;
            return (b = a.uri) == null ? void 0 : (c = b.l) == null ? void 0 : c.startsWith("/videoplayback");
        };
    gF.prototype.getId = function () {
        return iF(this, "id");
    };
    var jF = function (a) {
            a = a.uri.g.get("range");
            if (!a) return null;
            a = a.split("-")[0];
            return !a || isNaN(Number(a)) ? null : Number(a);
        },
        iF = function (a, b) {
            var c = a.uri.g.get(b);
            return c ? c : (a = a.g.get(b)) ? a : null;
        };
    var kF = function () {};
    var lF = ["doubleclick.net"];
    function mF() {
        if (Rb() || A("iPad") || A("iPod")) var a = !1;
        else if (Qb()) {
            if (oD === void 0) {
                a: {
                    if (mD === void 0) {
                        if (qD) {
                            a = yb(pD(), "Safari");
                            var b = new T(window.location.href).g.Gb("js");
                            b: {
                                if ((b = b.length ? b[0] : "") && b.lastIndexOf("afma-", 0) == 0) {
                                    var c = b.lastIndexOf("v");
                                    if (c > -1 && (b = b.substr(c + 1).match(/^(\d+\.\d+\.\d+|^\d+\.\d+|^\d+)(-.*)?$/))) {
                                        b = b[1];
                                        break b;
                                    }
                                }
                                b = "0.0.0";
                            }
                            if (!a || b !== "0.0.0") {
                                a = mD = !0;
                                break a;
                            }
                        }
                        mD = !1;
                    }
                    a = mD;
                }
                a || (nD === void 0 && (nD = yb(pD(), "afma-sdk-a") ? !0 : !1), (a = nD));
                oD = a;
            }
            a = oD ? !0 : lj() ? !1 : nF();
        } else a = !1;
        return a;
    }
    function nF() {
        var a = !1,
            b = new T(window.location.href).j;
        lF.forEach(function (c) {
            b.includes(c) && (a = !0);
        });
        return a;
    }
    var oF,
        rF = function (a, b, c) {
            if (typeof a === "number") var d = { name: pF(a) };
            else (d = a), (a = qF(a.name));
            this.code = a;
            this.g = d;
            b = "Error " + b + ": " + this.getName();
            c && (b += ", " + c);
            kb.call(this, b);
        };
    jb(rF, kb);
    rF.prototype.getName = function () {
        return this.g.name || "";
    };
    var sF = { Tf: 1, Di: 2, NOT_FOUND_ERR: 3, Af: 4, Df: 5, Ei: 6, Sf: 7, ABORT_ERR: 8, Pf: 9, Ri: 10, TIMEOUT_ERR: 11, Of: 12, INVALID_ACCESS_ERR: 13, INVALID_STATE_ERR: 14 },
        tF = (y.g || y.j || sF).Tf,
        uF = (y.g || y.j || sF).NOT_FOUND_ERR,
        vF = (y.g || y.j || sF).Af,
        wF = (y.g || y.j || sF).Df,
        xF = (y.g || y.j || sF).Sf,
        yF = (y.g || y.j || sF).ABORT_ERR,
        zF = (y.g || y.j || sF).Pf,
        AF = (y.g || y.j || sF).TIMEOUT_ERR,
        BF = (y.g || y.j || sF).Of,
        CF = (y.DOMException || sF).INVALID_ACCESS_ERR,
        DF = (y.DOMException || sF).INVALID_STATE_ERR,
        qF = function (a) {
            switch (a) {
                case "UnknownError":
                    return tF;
                case "NotFoundError":
                    return uF;
                case "ConstraintError":
                    return vF;
                case "DataError":
                    return wF;
                case "TransactionInactiveError":
                    return xF;
                case "AbortError":
                    return yF;
                case "ReadOnlyError":
                    return zF;
                case "TimeoutError":
                    return AF;
                case "QuotaExceededError":
                    return BF;
                case "InvalidAccessError":
                    return CF;
                case "InvalidStateError":
                    return DF;
                default:
                    return tF;
            }
        },
        pF = function (a) {
            switch (a) {
                case tF:
                    return "UnknownError";
                case uF:
                    return "NotFoundError";
                case vF:
                    return "ConstraintError";
                case wF:
                    return "DataError";
                case xF:
                    return "TransactionInactiveError";
                case yF:
                    return "AbortError";
                case zF:
                    return "ReadOnlyError";
                case AF:
                    return "TimeoutError";
                case BF:
                    return "QuotaExceededError";
                case CF:
                    return "InvalidAccessError";
                case DF:
                    return "InvalidStateError";
                default:
                    return "UnknownError";
            }
        },
        EF = function (a, b) {
            return "error" in a ? new rF(a.error, b) : new rF({ name: "UnknownError" }, b);
        },
        FF = function (a, b) {
            return "name" in a ? new rF(a, b + ": " + a.message) : new rF({ name: "UnknownError" }, b);
        };
    var GF = function (a) {
            this.g = a;
        },
        HF = y.IDBKeyRange || y.webkitIDBKeyRange; /*

 Copyright 2005, 2007 Bob Ippolito. All Rights Reserved.
 Copyright The Closure Library Authors.
 SPDX-License-Identifier: MIT
*/
    var IF = function () {
        this.A = [];
        this.o = this.l = !1;
        this.j = void 0;
        this.L = this.G = this.C = !1;
        this.B = 0;
        this.g = null;
        this.J = 0;
    };
    IF.prototype.cancel = function (a) {
        if (this.l) this.j instanceof IF && this.j.cancel();
        else {
            if (this.g) {
                var b = this.g;
                delete this.g;
                a ? b.cancel(a) : (b.J--, b.J <= 0 && b.cancel());
            }
            this.L = !0;
            this.l || JF(this, new KF(this));
        }
    };
    IF.prototype.D = function (a, b) {
        this.C = !1;
        LF(this, a, b);
    };
    var LF = function (a, b, c) {
            a.l = !0;
            a.j = c;
            a.o = !b;
            MF(a);
        },
        OF = function (a) {
            if (a.l) {
                if (!a.L) throw new NF(a);
                a.L = !1;
            }
        };
    IF.prototype.Ba = function (a) {
        OF(this);
        LF(this, !0, a);
    };
    var JF = function (a, b) {
            OF(a);
            LF(a, !1, b);
        },
        QF = function (a, b) {
            return PF(a, b, null);
        },
        PF = function (a, b, c, d) {
            a.A.push([b, c, d]);
            a.l && MF(a);
            return a;
        };
    IF.prototype.then = function (a, b, c) {
        var d,
            e,
            f = new zw(function (g, h) {
                e = g;
                d = h;
            });
        PF(
            this,
            e,
            function (g) {
                g instanceof KF ? f.cancel() : d(g);
                return RF;
            },
            this
        );
        return f.then(a, b, c);
    };
    IF.prototype.$goog_Thenable = !0;
    var SF = function (a) {
            return Yb(a.A, function (b) {
                return typeof b[1] === "function";
            });
        },
        RF = {},
        MF = function (a) {
            if (a.B && a.l && SF(a)) {
                var b = a.B,
                    c = TF[b];
                c && (y.clearTimeout(c.g), delete TF[b]);
                a.B = 0;
            }
            a.g && (a.g.J--, delete a.g);
            b = a.j;
            for (var d = (c = !1); a.A.length && !a.C; ) {
                var e = a.A.shift(),
                    f = e[0],
                    g = e[1];
                e = e[2];
                if ((f = a.o ? g : f))
                    try {
                        var h = f.call(e || null, b);
                        h === RF && (h = void 0);
                        h !== void 0 && ((a.o = a.o && (h == b || h instanceof Error)), (a.j = b = h));
                        if (xw(b) || (typeof y.Promise === "function" && b instanceof y.Promise)) (d = !0), (a.C = !0);
                    } catch (k) {
                        (b = k), (a.o = !0), SF(a) || (c = !0);
                    }
            }
            a.j = b;
            d && ((h = gb(a.D, a, !0)), (d = gb(a.D, a, !1)), b instanceof IF ? (PF(b, h, d), (b.G = !0)) : b.then(h, d));
            c && ((b = new UF(b)), (TF[b.g] = b), (a.B = b.g));
        },
        NF = function () {
            kb.call(this);
        };
    jb(NF, kb);
    NF.prototype.message = "Deferred has already fired";
    NF.prototype.name = "AlreadyCalledError";
    var KF = function () {
        kb.call(this);
    };
    jb(KF, kb);
    KF.prototype.message = "Deferred was canceled";
    KF.prototype.name = "CanceledError";
    var UF = function (a) {
        this.g = y.setTimeout(gb(this.l, this), 0);
        this.j = a;
    };
    UF.prototype.l = function () {
        delete TF[this.g];
        throw this.j;
    };
    var TF = {};
    var VF = function () {
        R.call(this);
    };
    jb(VF, R);
    VF.prototype.g = null;
    VF.prototype.next = function (a) {
        if (a) this.g["continue"](a);
        else this.g["continue"]();
    };
    VF.prototype.remove = function () {
        var a = new IF();
        try {
            var b = this.g["delete"]();
        } catch (c) {
            return JF(a, FF(c, "deleting via cursor")), a;
        }
        b.onsuccess = function () {
            a.Ba();
        };
        b.onerror = function (c) {
            JF(a, EF(c.target, "deleting via cursor"));
        };
        return a;
    };
    VF.prototype.getValue = function () {
        return this.g.value;
    };
    var WF = function (a, b) {
        var c = new VF();
        try {
            var d = a.openCursor(b ? b.g : null);
        } catch (e) {
            throw (c.dispose(), FF(e, a.name));
        }
        d.onsuccess = function (e) {
            c.g = e.target.result || null;
            c.g ? c.dispatchEvent("n") : c.dispatchEvent("c");
        };
        d.onerror = function () {
            c.dispatchEvent("e");
        };
        return c;
    };
    var XF = function (a) {
        this.g = a;
    };
    XF.prototype.getName = function () {
        return this.g.name;
    };
    var YF = function (a, b, c) {
        var d = new IF();
        try {
            var e = a.g.get(c);
        } catch (f) {
            return (b += " with key " + Li(c)), JF(d, FF(f, b)), d;
        }
        e.onsuccess = function (f) {
            d.Ba(f.target.result);
        };
        e.onerror = function (f) {
            b += " with key " + Li(c);
            JF(d, EF(f.target, b));
        };
        return d;
    };
    XF.prototype.get = function (a) {
        return YF(this, "getting from index " + this.getName(), a);
    };
    var ZF = function (a, b) {
        return WF(a.g, b);
    };
    var $F = function (a) {
        this.g = a;
    };
    $F.prototype.getName = function () {
        return this.g.name;
    };
    var aG = function (a, b, c, d, e) {
            var f = new IF();
            try {
                var g = e ? a.g[b](d, e) : a.g[b](d);
            } catch (h) {
                return (c += Li(d)), e && (c += ", with key " + Li(e)), JF(f, FF(h, c)), f;
            }
            g.onsuccess = function (h) {
                f.Ba(h.target.result);
            };
            g.onerror = function (h) {
                c += Li(d);
                e && (c += ", with key " + Li(e));
                JF(f, EF(h.target, c));
            };
            return f;
        },
        bG = function (a, b) {
            return aG(a, "put", "putting into " + a.getName() + " with value", b);
        };
    $F.prototype.add = function (a, b) {
        return aG(this, "add", "adding into " + this.getName() + " with value ", a, b);
    };
    $F.prototype.remove = function (a) {
        var b = new IF();
        try {
            var c = this.g["delete"](a instanceof GF ? a.g : a);
        } catch (e) {
            return (c = "removing from " + this.getName() + " with key " + Li(a)), JF(b, FF(e, c)), b;
        }
        c.onsuccess = function () {
            b.Ba();
        };
        var d = this;
        c.onerror = function (e) {
            var f = "removing from " + d.getName() + " with key " + Li(a);
            JF(b, EF(e.target, f));
        };
        return b;
    };
    $F.prototype.get = function (a) {
        var b = new IF();
        try {
            var c = this.g.get(a);
        } catch (e) {
            return (c = "getting from " + this.getName() + " with key " + Li(a)), JF(b, FF(e, c)), b;
        }
        c.onsuccess = function (e) {
            b.Ba(e.target.result);
        };
        var d = this;
        c.onerror = function (e) {
            var f = "getting from " + d.getName() + " with key " + Li(a);
            JF(b, EF(e.target, f));
        };
        return b;
    };
    $F.prototype.clear = function () {
        var a = "clearing store " + this.getName(),
            b = new IF();
        try {
            var c = this.g.clear();
        } catch (d) {
            return JF(b, FF(d, a)), b;
        }
        c.onsuccess = function () {
            b.Ba();
        };
        c.onerror = function (d) {
            JF(b, EF(d.target, a));
        };
        return b;
    };
    var cG = function (a) {
        try {
            return new XF(a.g.index("timestamp"));
        } catch (b) {
            throw FF(b, "getting index timestamp");
        }
    };
    var dG = function (a, b) {
        R.call(this);
        this.g = a;
        this.l = b;
        this.j = new gE(this);
        this.j.listen(this.g, "complete", gb(this.dispatchEvent, this, "complete"));
        this.j.listen(this.g, "abort", gb(this.dispatchEvent, this, "abort"));
        this.j.listen(this.g, "error", this.Ff);
    };
    jb(dG, R);
    l = dG.prototype;
    l.Ff = function (a) {
        a.target instanceof rF ? this.dispatchEvent({ type: "error", target: a.target }) : this.dispatchEvent({ type: "error", target: EF(a.target, "in transaction") });
    };
    l.objectStore = function (a) {
        try {
            return new $F(this.g.objectStore(a));
        } catch (b) {
            throw FF(b, "getting object store " + a);
        }
    };
    l.commit = function (a) {
        if (this.g.commit || !a)
            try {
                this.g.commit();
            } catch (b) {
                throw FF(b, "cannot commit the transaction");
            }
    };
    l.wait = function () {
        var a = new IF();
        Yv(this, "complete", gb(a.Ba, a));
        var b = Yv(this, "abort", function () {
            gw(c);
            JF(a, new rF(yF, "waiting for transaction to complete"));
        });
        var c = Yv(this, "error", function (e) {
            gw(b);
            JF(a, e.target);
        });
        var d = this.l;
        return QF(a, function () {
            return d;
        });
    };
    l.abort = function () {
        this.g.abort();
    };
    l.O = function () {
        dG.Ia.O.call(this);
        this.j.dispose();
    };
    var eG = function (a) {
        R.call(this);
        this.g = a;
        this.j = new gE(this);
        this.j.listen(this.g, "abort", gb(this.dispatchEvent, this, "abort"));
        this.j.listen(this.g, "error", this.Gf);
        this.j.listen(this.g, "versionchange", this.mg);
        this.j.listen(this.g, "close", gb(this.dispatchEvent, this, "close"));
    };
    jb(eG, R);
    l = eG.prototype;
    l.Sd = !0;
    l.Gf = function (a) {
        a = (a = a.target) && a.error;
        this.dispatchEvent({ type: "error", errorCode: a && a.severity });
    };
    l.mg = function (a) {
        this.dispatchEvent(new fG(a.oldVersion, a.newVersion));
    };
    l.close = function () {
        this.Sd && (this.g.close(), (this.Sd = !1));
    };
    l.Ua = function () {
        return this.Sd;
    };
    l.getName = function () {
        return this.g.name;
    };
    l.getVersion = function () {
        return Number(this.g.version);
    };
    var gG = function (a) {
        var b = ["MediaSourceVideoChunk"];
        try {
            var c = a.g.transaction(b, "readwrite");
            return new dG(c, a);
        } catch (d) {
            throw FF(d, "creating transaction");
        }
    };
    eG.prototype.O = function () {
        eG.Ia.O.call(this);
        this.j.dispose();
    };
    var fG = function (a, b) {
        Kv.call(this, "versionchange");
        this.oldVersion = a;
        this.newVersion = b;
    };
    jb(fG, Kv);
    var hG = function (a) {
        var b = new IF();
        oF == void 0 && (oF = y.indexedDB || y.mozIndexedDB || y.webkitIndexedDB || y.moz_indexedDB);
        var c = oF.open("IndexedDbVideoChunkPersistentStorage", 6);
        c.onsuccess = function (d) {
            d = new eG(d.target.result);
            b.Ba(d);
        };
        c.onerror = function (d) {
            JF(b, EF(d.target, "opening database IndexedDbVideoChunkPersistentStorage"));
        };
        c.onupgradeneeded = function (d) {
            if (a) {
                var e = new eG(d.target.result);
                a(new fG(d.oldVersion, d.newVersion), e, new dG(d.target.transaction, e));
            }
        };
        c.onblocked = function () {};
        return b;
    };
    var iG = function () {
        R.apply(this, arguments);
        this.g = null;
    };
    x(iG, R);
    iG.prototype.initialize = function () {
        var a = this;
        return Promise.resolve(hG(this.j)).then(
            function (b) {
                a.g = b;
            },
            function (b) {
                L(K.getInstance(), "codf", b.message);
            }
        );
    };
    iG.prototype.Ua = function () {
        return this.g !== null && this.g.Ua();
    };
    iG.prototype.close = function () {
        var a = this;
        return new Promise(function (b) {
            jG(a, b);
        })
            .then(function () {
                return kG();
            })
            .then(function () {
                a.g.close();
            });
    };
    var kG = function () {
        var a;
        return ((a = navigator.storage) == null ? 0 : a.estimate)
            ? navigator.storage.estimate().then(function (b) {
                  L(K.getInstance(), "csue", String(b.usage));
              })
            : Promise.resolve(void 0);
    };
    iG.prototype.Wb = function (a) {
        return (a = lG(a, 0)) ? mG(this, nG(a), a.Mc) : Promise.resolve(null);
    };
    iG.prototype.wc = function (a, b, c, d) {
        (b = lG(b, c)) ? ((c = b.startIndex), oG(this, { ej: nG(b), startIndex: c, Fc: c + a.byteLength - 1, Mc: b.Mc, timestamp: new Date(Date.now()), xa: d, yb: b.yb, video: a })) : Promise.resolve(void 0);
    };
    iG.prototype.j = function (a, b) {
        if (b.g.objectStoreNames.contains("MediaSourceVideoChunk"))
            try {
                b.g.deleteObjectStore("MediaSourceVideoChunk");
            } catch (d) {
                throw FF(d, "deleting object store MediaSourceVideoChunk");
            }
        a = { keyPath: "cacheId" };
        try {
            var c = new $F(b.g.createObjectStore("MediaSourceVideoChunk", a));
        } catch (d) {
            throw FF(d, "creating object store MediaSourceVideoChunk");
        }
        b = { unique: !1 };
        try {
            c.g.createIndex("timestamp", "timestamp", b);
        } catch (d) {
            throw FF(d, "creating new index timestamp with key path timestamp");
        }
    };
    var jG = function (a, b) {
            var c = new Date(Date.now());
            c.setDate(c.getDate() - 30);
            c = new GF(HF.upperBound(c, void 0));
            var d = ZF(cG(gG(a.g).objectStore("MediaSourceVideoChunk")), c),
                e = d.listen("n", function () {
                    d.remove();
                    d.next();
                });
            Yv(d, "c", function () {
                gw(e);
                b();
            });
        },
        lG = function (a, b) {
            var c = new gF(a);
            a = c.getId();
            var d = iF(c, "itag"),
                e = iF(c, "source"),
                f = iF(c, "lmt");
            c = jF(c);
            var g = [];
            a ? (d ? (e ? (f ? c === null && g.push("startIndex") : g.push("lmt")) : g.push("source")) : g.push("itag")) : g.push("videoId");
            return g.length > 0 ? (L(K.getInstance(), "civp", g.join("-")), null) : { wh: a, yb: d, source: e, Mc: f, startIndex: c + b };
        },
        nG = function (a) {
            for (var b = [a.wh, a.source, a.startIndex].join(), c = 0, d = 0; d < b.length; d++) c = (Math.imul(31, c) + b.charCodeAt(d)) | 0;
            return c.toString() + "," + a.yb;
        },
        mG = function (a, b, c) {
            var d = gG(a.g).objectStore("MediaSourceVideoChunk");
            return Promise.resolve(d.get(b)).then(
                function (e) {
                    if (!e) return L(K.getInstance(), "cenf", "1"), null;
                    if (e.Mc !== c)
                        return (
                            L(K.getInstance(), "cdl", "1"),
                            d.remove(b).then(null, function (f) {
                                L(K.getInstance(), "crdlvf", f.message);
                            }),
                            null
                        );
                    L(K.getInstance(), "cefml", "1");
                    return { yb: e.yb, Fc: e.Fc, xa: e.xa, video: e.video };
                },
                function (e) {
                    L(K.getInstance(), "cgvf", e.message);
                    return null;
                }
            );
        },
        oG = function (a, b) {
            a = gG(a.g).objectStore("MediaSourceVideoChunk");
            Promise.resolve(bG(a, b)).then(
                function () {
                    L(K.getInstance(), "cavs", "1");
                },
                function (c) {
                    L(K.getInstance(), "cavf", c.message);
                }
            );
        };
    var pG = function (a) {
        ME.call(this);
        var b = this;
        this.I = this.j = this.g = 0;
        this.A = this.K = null;
        this.uri = new T(a);
        this.state = 0;
        this.l = (this.B = mF() && !vD(this.uri)) ? uC(iG) : null;
        Dr(this, function () {
            Cr(b.l);
        });
        this.K = this.B ? this.l.initialize() : null;
    };
    x(pG, ME);
    pG.prototype.D = function () {
        return this.g;
    };
    pG.prototype.C = function () {
        return this.state === 3;
    };
    pG.prototype.G = function (a) {
        this.state === 1 ? ((this.g += a), (this.state = 2)) : this.state === 0 && ((this.g += a), (this.state = 1), qG(this));
    };
    var qG = function (a) {
            La(function (b) {
                if (b.g == 1) return a.state === 2 && (a.state = 1), Aa(b, rG(a), 4);
                var c = a.I > 3;
                if (c && a.A !== null) {
                    var d = YE("media_source_error", {
                        code: a.j > 0 ? MediaError.MEDIA_ERR_NETWORK : MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
                        message: 'Response code "' + a.A + '" with ' + a.g + " bytes requested and " + a.j + " bytes loaded",
                    });
                    a.dispatchEvent(d);
                }
                a.j < a.g && a.state !== 3 && !c ? (b.g = 1) : (a.state !== 3 && (a.state = 0), (b.g = 0));
            });
        },
        rG = function (a) {
            var b;
            return La(function (c) {
                switch (c.g) {
                    case 1:
                        b = a.j + "-" + (a.g - 1);
                        gD(a.uri, "range", b);
                        if (!a.B) {
                            c.g = 2;
                            break;
                        }
                        return Aa(c, a.K, 3);
                    case 3:
                        return c.return(sG(a));
                    case 2:
                        return (c.l = 4), Aa(c, tG(a), 6);
                    case 6:
                        Ca(c);
                        break;
                    case 4:
                        Da(c), uG(a), (c.g = 0);
                }
            });
        },
        sG = function (a) {
            var b;
            return La(function (c) {
                switch (c.g) {
                    case 1:
                        return Aa(c, a.l.Wb(a.uri), 2);
                    case 2:
                        if ((b = c.j)) {
                            b.xa && (a.state = 3);
                            vG(a, b.video, 0);
                            c.g = 0;
                            break;
                        }
                        c.l = 4;
                        return Aa(c, tG(a), 6);
                    case 6:
                        Ca(c);
                        break;
                    case 4:
                        Da(c), uG(a), (c.g = 0);
                }
            });
        },
        uG = function (a) {
            var b = new gF(a.uri);
            if (Wm(An) && hF(b)) {
                a: if (hF(b)) {
                    var c = iF(b, "mn");
                    var d = c ? c.split(",") : null;
                    var e = iF(b, "fvip");
                    c = b.uri.G();
                    if (d && e) {
                        var f = (Number(iF(b, "fallback_count")) || 0) + 1;
                        if ((d = d[f])) {
                            c.j = "r" + e + "---" + d + ".googlevideo.com";
                            gD(c, "fallback_count", f);
                            b = c;
                            break a;
                        }
                    }
                    var g, h;
                    e = Number(((h = (g = c.g.get("cmo")) == null ? void 0 : g.split("=")) != null ? h : [])[1]) || 0;
                    b.uri.j.match(/^r{1,2}(\d+)---(.+)\.googlevideo.com$/) && (c.j = "redirector.googlevideo.com");
                    gD(c, "cmo", "pf=" + (e + 1));
                    b = c;
                } else b = b.uri;
                a.uri = b;
                a.dispatchEvent(YE("bandaid_fallback_count"));
            } else Wm(En) && vD(a.uri) && (a.uri = new T(wD(a.uri)));
            a.I++;
        },
        tG = function (a) {
            return new Promise(function (b, c) {
                var d = new XMLHttpRequest(),
                    e = 0,
                    f = a.g - a.j;
                d.addEventListener("load", function () {
                    Ol("lvlcl");
                    if (d.status >= 400) L(K.getInstance(), "lvlxes", d.status.toString()), (a.A = d.status), c();
                    else {
                        var g = d.response;
                        g.byteLength < f && (a.state = 3);
                        var h = vG(a, g, e);
                        e += h;
                        a.B && g.byteLength > 0 && a.l.wc(g, a.uri, 0, g.byteLength < f);
                        b();
                    }
                });
                d.addEventListener("timeout", function () {
                    Ol("lvlct");
                    a.A = d.status;
                    c();
                });
                d.addEventListener("error", function () {
                    Ol("lvlce");
                    a.A = d.status;
                    c();
                });
                d.addEventListener("progress", function () {
                    if (d.status >= 400) a.A = d.status;
                    else {
                        var g = vG(a, d.response, e);
                        e += g;
                    }
                });
                d.responseType = "arraybuffer";
                d.open("get", a.uri.toString());
                d.send(null);
            });
        },
        vG = function (a, b, c) {
            if (b === null) return 0;
            b = b.slice(c);
            a.j += b.byteLength;
            a.dispatchEvent({ type: "progress", ud: b });
            return b.byteLength;
        };
    pG.prototype.O = function () {
        this.B && this.l.Ua() && this.l.close();
        ME.prototype.O.call(this);
    };
    var wG = { qj: 2e5, oj: 7e4, Ja: 3e5, nj: 5e3, xj: 5e3, pj: 6e3 };
    function xG() {
        return !!window.MediaSource;
    }
    function yG(a) {
        return [43, 44, 45].includes(a) && Jc ? !1 : QE[a] ? ((a = XE(a)), !!a && xG() && MediaSource.isTypeSupported(a)) : !1;
    }
    var zG = function () {};
    zG.prototype.Rg = function (a, b, c) {
        return c === 0 ? 1e6 : b - a < 5e3 ? 3e5 : 0;
    };
    var BG = function (a, b) {
            var c = this;
            this.g = a;
            this.index = b;
            this.j = [];
            this.g || Ol("msms_sbf" + this.index);
            this.g.addEventListener("updateend", function () {
                AG(c);
            });
            this.g.addEventListener("error", function () {
                Ol("msms_sbe" + c.index);
            });
        },
        AG = function (a) {
            if (a.j.length > 0 && !a.g.updating) {
                var b = a.j.shift();
                a.g.appendBuffer(b);
            }
        };
    var CG = function () {
        this.g = this.cache = null;
    };
    l = CG.prototype;
    l.initialize = function () {
        var a = this;
        return window.caches.open("CACHE_VIDEO_CHUNK_PERSISTENT_STORAGE").then(
            function (b) {
                a.cache = b;
            },
            function (b) {
                L(K.getInstance(), "codf", b.message);
            }
        );
    };
    l.Ua = function () {
        return this.cache !== null;
    };
    l.close = function () {
        return Promise.resolve();
    };
    l.Wb = function (a) {
        var b = this;
        a = DG(this, a);
        return this.Ua() && a
            ? this.cache.match(a).then(
                  function (c) {
                      if (!c) return L(K.getInstance(), "cenf", "1"), Promise.resolve(null);
                      L(K.getInstance(), "cef", "1");
                      return c.arrayBuffer().then(function (d) {
                          var e = jF(b.g),
                              f;
                          (f = b.g.uri.g.get("range")) ? ((f = f.split("-")[1]), (f = !f || isNaN(Number(f)) ? null : Number(f))) : (f = null);
                          e = e + d.byteLength - 1;
                          f = f > e;
                          return { yb: iF(b.g, "itag"), Fc: e, xa: f, video: d };
                      });
                  },
                  function (c) {
                      L(K.getInstance(), "cgvf", c.message);
                      return Promise.resolve(null);
                  }
              )
            : (L(K.getInstance(), "cgvf", "1"), Promise.resolve(null));
    };
    l.wc = function (a, b) {
        b = DG(this, b);
        a = new Response(a);
        this.Ua() && b
            ? this.cache.put(b, a).then(
                  function () {
                      L(K.getInstance(), "cavs", "1");
                  },
                  function (c) {
                      L(K.getInstance(), "cavf", c.message);
                  }
              )
            : (L(K.getInstance(), "cavf", "1"), Promise.resolve());
    };
    var DG = function (a, b) {
        a.g = new gF(b);
        b = a.g.getId();
        var c = iF(a.g, "itag"),
            d = iF(a.g, "source"),
            e = iF(a.g, "lmt");
        a = iF(a.g, "range");
        if (b && c && d && a) return new Request("http://url/videoplayback?id=" + b + "&itag=" + c + "&source=" + d + "&lmt=" + e + "&range=" + a);
        L(K.getInstance(), "civp", "1");
        return null;
    };
    var GG = function (a) {
        R.call(this);
        var b = this;
        this.l = a;
        this.g = [];
        this.B = null;
        this.C = 0;
        this.M = !1;
        this.G = 0;
        this.D = [];
        if (Wm(tn)) {
            var c = null;
            mF() && (Wm(vn) ? (c = uC(CG)) : (c = uC(iG)));
            this.A = this.l.map(function (d) {
                return uC(ZE, d.url, vD(d.url) ? null : c);
            });
        } else
            this.A = this.l.map(function (d) {
                return uC(pG, d.url);
            });
        this.j = uC(MediaSource);
        this.I = function () {
            EG(b);
        };
        this.j.addEventListener("sourceopen", this.I);
        this.K = FG(this);
    };
    x(GG, R);
    var FG = function (a) {
            for (var b = [], c = 0; c < a.l.length; ++c) b.push(new zG());
            return b;
        },
        EG = function (a) {
            Ol("msms_oso");
            for (var b = { Aa: 0 }; b.Aa < a.l.length; b = { Yd: void 0, Nc: void 0, rb: void 0, Aa: b.Aa, Oc: void 0 }, ++b.Aa) {
                var c = a.l[b.Aa];
                L(K.getInstance(), "msms_mime" + b.Aa, c.mimeType);
                L(K.getInstance(), "msms_cs" + b.Aa, c.Ja.toString());
                Wm(un)
                    ? ((b.Yd = new BG(a.j.addSourceBuffer(c.mimeType), b.Aa)),
                      (b.Nc = a.A[b.Aa]),
                      b.Nc.listen(
                          "progress",
                          (function (d) {
                              return function (e) {
                                  var f = d.Yd,
                                      g = d.Nc;
                                  e = e.ud;
                                  e.byteLength !== 0 && (f.j.push(e), AG(f));
                                  g.C() && (a.C++, a.C === a.g.length && HG(a));
                              };
                          })(b)
                      ),
                      b.Nc.listen("media_source_error", function (d) {
                          a.dispatchEvent(d);
                      }),
                      a.g.push(b.Yd.g))
                    : ((b.rb = a.j.addSourceBuffer(c.mimeType)),
                      b.rb
                          ? ((b.Oc = a.A[b.Aa]),
                            Wm(tn) &&
                                b.rb.addEventListener(
                                    "updateend",
                                    (function (d) {
                                        return function () {
                                            if (a.D.length > 0 && !d.rb.updating) {
                                                var e = a.D.shift();
                                                d.rb.appendBuffer(e);
                                            }
                                        };
                                    })(b)
                                ),
                            b.rb.addEventListener(
                                "error",
                                (function (d) {
                                    return function () {
                                        Ol("msms_sbe" + d.Aa);
                                    };
                                })(b)
                            ),
                            b.Oc.listen(
                                "progress",
                                (function (d) {
                                    return function (e) {
                                        var f = d.rb,
                                            g = d.Oc;
                                        e = e.ud;
                                        e.byteLength !== 0 && (Wm(tn) ? (f.updating ? a.D.push(e) : f.appendBuffer(e)) : f.appendBuffer(e));
                                        g.C() && (a.C++, a.C === a.g.length && HG(a));
                                    };
                                })(b)
                            ),
                            b.Oc.listen("media_source_error", function (d) {
                                a.dispatchEvent(d);
                            }),
                            a.g.push(b.rb))
                          : Ol("msms_sbf" + b.Aa));
            }
            L(K.getInstance(), "msms_ns", a.g.length.toString());
            a.M = !0;
            IG(a);
        },
        HG = function (a) {
            Promise.all(
                a.g.map(function (b) {
                    return new Promise(function (c) {
                        b.updating
                            ? b.addEventListener("updateend", function () {
                                  c();
                              })
                            : c();
                    });
                })
            ).then(function () {
                a.j.endOfStream();
            });
        },
        IG = function (a) {
            if (a.M)
                for (var b = 0; b < a.l.length; ++b) {
                    var c = a.A[b],
                        d = a.g[b];
                    d = d.buffered.length === 0 ? 0 : d.buffered.end(0) * 1e3;
                    d = a.K[b].Rg(a.G, d, c.D());
                    d !== 0 && c.G(d);
                }
        },
        JG = function (a) {
            a.B = ji(a.j).toString();
            return a.B;
        };
    GG.prototype.O = function () {
        this.B && window.URL.revokeObjectURL(this.B);
        for (var a = w(this.A), b = a.next(); !b.done; b = a.next()) b.value.dispose();
        this.j.removeEventListener("sourceopen", this.I);
        R.prototype.O.call(this);
    };
    GG.prototype.hd = function (a) {
        this.K.filter(function () {
            return !1;
        })
            .map(function (b) {
                return b;
            })
            .forEach(function (b) {
                b.g = Object.assign({}, wG, b.g, a);
            });
    };
    var KG = RegExp(
            "/pagead/conversion|/pagead/adview|/pagead/gen_204|/activeview?|csi.gstatic.com/csi|google.com/pagead/xsul|google.com/ads/measurement/l|googleads.g.doubleclick.net/pagead/ide_cookie|googleads.g.doubleclick.net/xbbe/pixel"
        ),
        LG = RegExp("outstream.min.js"),
        MG = RegExp("outstream.min.css"),
        NG = RegExp("fonts.gstatic.com"),
        OG = RegExp("googlevideo.com/videoplayback|c.2mdn.net/videoplayback|gcdn.2mdn.net/videoplayback"),
        PG = RegExp("custom.elements.min.js");
    function QG(a, b) {
        var c = 0,
            d = 0,
            e = 0,
            f = 0,
            g = 0,
            h = 0,
            k = 0,
            m = !1,
            n = !1;
        if (typeof Ta("performance.getEntriesByType", y) === "function" && "transferSize" in y.PerformanceResourceTiming.prototype) {
            var p = y.performance.getEntriesByType("resource");
            p = w(p);
            for (var q = p.next(); !q.done; q = p.next())
                (q = q.value),
                    KG.test(q.name) ||
                        ((f += 1),
                        q.transferSize
                            ? ((c += q.transferSize),
                              q.encodedBodySize && q.transferSize < q.encodedBodySize && ((h += 1), (e += q.encodedBodySize), LG.test(q.name) && (m = !0), MG.test(q.name) && (n = !0)),
                              OG.test(q.name) && (d += q.transferSize))
                            : q.transferSize === 0 && q.encodedBodySize === 0
                            ? PG.test(q.name)
                                ? (c += 6686)
                                : NG.test(q.name) || ((k += 1), Nl(K.getInstance(), { event_name: "unmeasurable_asset", resource_name: q.name, encoded_body_size: q.encodedBodySize, transfer_size: q.transferSize }))
                            : ((g += 1), (e += q.encodedBodySize), LG.test(q.name) && (m = !0), MG.test(q.name) && (n = !0)));
            p = 0;
            if (a.duration) {
                for (q = 0; q < a.buffered.length; q++) p += a.buffered.end(q) - a.buffered.start(q);
                p = Math.min(p, a.duration);
            }
            Nl(K.getInstance(), {
                event_name: b,
                asset_bytes: c,
                video_bytes: d,
                cached_data_bytes: e,
                js_cached: m,
                css_cached: n,
                num_assets: f,
                num_assets_cached: g,
                num_assets_cache_validated: h,
                num_assets_unmeasurable: k,
                video_played_seconds: a.currentTime.toFixed(2),
                video_muted: a.muted,
                video_seconds_loaded: p.toFixed(2),
            });
        } else L(K.getInstance(), "error", "reporting_timing_not_supported");
    }
    var RG = function (a, b, c, d) {
        this.url = a;
        this.mimeType = b;
        this.Ja = c;
        this.g = d === void 0 ? null : d;
    };
    function SG(a) {
        var b = K.getInstance(),
            c = a.getVideoPlaybackQuality && a.getVideoPlaybackQuality();
        c ? ((a = a.currentTime), L(b, "vqdf", String(c.droppedVideoFrames)), L(b, "vqtf", String(c.totalVideoFrames)), L(b, "vqfr", String(Math.round(c.totalVideoFrames / a)))) : L(b, "vqu", "1");
    }
    var TG = function (a) {
        this.g = a;
    };
    TG.prototype.toString = function () {
        return this.g;
    };
    var UG = new TG("video_mute"),
        VG = new TG("video_caption_visibility");
    var WG = function (a) {
        Q.call(this);
        this.B = 1;
        this.l = [];
        this.o = 0;
        this.g = [];
        this.j = {};
        this.D = !!a;
    };
    jb(WG, Q);
    var XG = function (a, b, c) {
            var d = VG.toString(),
                e = a.j[d];
            e || (e = a.j[d] = []);
            var f = a.B;
            a.g[f] = d;
            a.g[f + 1] = b;
            a.g[f + 2] = c;
            a.B = f + 3;
            e.push(f);
        },
        YG = function (a, b, c) {
            var d = a.j[VG.toString()];
            if (d) {
                var e = a.g;
                (d = d.find(function (f) {
                    return e[f + 1] == b && e[f + 2] == c;
                })) && a.A(d);
            }
        };
    WG.prototype.A = function (a) {
        var b = this.g[a];
        if (b) {
            var c = this.j[b];
            this.o != 0 ? (this.l.push(a), (this.g[a + 1] = function () {})) : (c && dc(c, a), delete this.g[a], delete this.g[a + 1], delete this.g[a + 2]);
        }
        return !!b;
    };
    WG.prototype.C = function (a, b) {
        var c = this.j[a];
        if (c) {
            for (var d = Array(arguments.length - 1), e = 1, f = arguments.length; e < f; e++) d[e - 1] = arguments[e];
            if (this.D)
                for (e = 0; e < c.length; e++) {
                    var g = c[e];
                    ZG(this.g[g + 1], this.g[g + 2], d);
                }
            else {
                this.o++;
                try {
                    for (e = 0, f = c.length; e < f && !this.Ea(); e++) (g = c[e]), this.g[g + 1].apply(this.g[g + 2], d);
                } finally {
                    if ((this.o--, this.l.length > 0 && this.o == 0)) for (; (c = this.l.pop()); ) this.A(c);
                }
            }
        }
    };
    var ZG = function (a, b, c) {
        vw(function () {
            a.apply(b, c);
        });
    };
    WG.prototype.clear = function (a) {
        if (a) {
            var b = this.j[a];
            b && (b.forEach(this.A, this), delete this.j[a]);
        } else (this.g.length = 0), (this.j = {});
    };
    WG.prototype.O = function () {
        WG.Ia.O.call(this);
        this.clear();
        this.l.length = 0;
    };
    var $G = function (a) {
        Q.call(this);
        this.g = new WG(a);
        Er(this, this.g);
    };
    jb($G, Q);
    $G.prototype.clear = function (a) {
        this.g.clear(a !== void 0 ? a.toString() : void 0);
    };
    var aH = function (a) {
        a = a === void 0 ? null : a;
        Q.call(this);
        this.g = new gE(this);
        Er(this, this.g);
        this.Ab = a;
    };
    x(aH, Q);
    var bH = function (a, b, c) {
        a.Ab &&
            (XG(a.Ab.g, b, c),
            Dr(a, function () {
                YG(a.Ab.g, b, c);
            }));
    };
    var cH = function (a, b) {
        aH.call(this, b);
        bH(
            this,
            function (c) {
                c ? (a.g.mode = "showing") : a.lb();
            },
            this
        );
    };
    x(cH, aH);
    var dH = function () {
        R.call(this);
        this.j = new gE(this);
        Er(this, this.j);
    };
    x(dH, R);
    var fH = function (a, b, c) {
        c = c === void 0 ? !0 : c;
        dH.call(this);
        a.setAttribute("crossorigin", "anonymous");
        var d = gj("TRACK");
        d.setAttribute("kind", "captions");
        d.setAttribute("src", b);
        d.setAttribute("default", "");
        a.appendChild(d);
        this.g = a.textTracks[0];
        eH(this);
        c ? (this.g.mode = "showing") : this.lb();
    };
    x(fH, dH);
    var eH = function (a) {
        var b = a.g;
        b.addEventListener(
            "cuechange",
            function () {
                for (var c = b.cues, d = 0; d < c.length; d++) {
                    var e = c[d];
                    e.align = "center";
                    e.position = "auto";
                }
            },
            { once: !0 }
        );
    };
    fH.prototype.lb = function () {
        this.g.mode = "hidden";
    };
    function gH(a, b) {
        if (typeof ReportingObserver !== "undefined") {
            var c = function (e) {
                    e = w(e);
                    for (var f = e.next(); !f.done; f = e.next()) (f = f.value), a(f) && b(f);
                },
                d = new ReportingObserver(c, { buffered: !0 });
            y.addEventListener("pagehide", function () {
                c(d.takeRecords(), d);
                d.disconnect();
            });
            d.observe();
        }
    }
    function hH(a) {
        a = a === void 0 ? null : a;
        gH(
            function (b) {
                return b.body && b.body.id === "HeavyAdIntervention";
            },
            function (b) {
                var c = b.body.message,
                    d = K.getInstance();
                L(d, "ham", c);
                c.includes("CPU") ? L(d, "hacpu", "true") : c.includes("network") && L(d, "habytes", "true");
                a && a(b);
            }
        );
    }
    var iH = "autoplay controls crossorigin demuxedaudiosrc demuxedvideosrc loop muted playsinline poster preload src webkit-playsinline x-webkit-airplay".split(" "),
        jH = "autoplay buffered controls crossOrigin currentSrc currentTime defaultMuted defaultPlaybackRate disablePictureInPicture disableRemotePlayback duration ended loop muted networkState onerror onwaitingforkey paused played playsinline poster preload preservesPitch mozPreservesPitch webkitPreservesPitch readyState seekable videoWidth videoHeight volume textTracks canPlayType captureStream getVideoPlaybackQuality load pause play requestPictureInPicture setSinkId oncanplay oncanplaythrough onload onplay onpause onended onfullscreenchange onfullscreenerror addEventListener dispatchEvent removeEventListener requestFullscreen".split(
            " "
        ),
        kH = { childList: !0 },
        lH = !RegExp("^\\s*class\\s*\\{\\s*\\}\\s*$").test(function () {}.toString()),
        mH = HTMLElement;
    lH &&
        ((mH = function () {
            var a = Object.getPrototypeOf(this).constructor;
            return y.Reflect.construct(HTMLElement, [], a);
        }),
        Object.setPrototypeOf(mH, HTMLElement),
        Object.setPrototypeOf(mH.prototype, HTMLElement.prototype));
    var nH = function (a) {
            if (a !== null) {
                a = w(a);
                for (var b = a.next(); !b.done; b = a.next()) if (((b = b.value), b.nodeName === "TRACK".toString())) return b;
            }
            return null;
        },
        oH = function (a, b) {
            this.code = a;
            this.message = b === void 0 ? "" : b;
        },
        pH = function (a) {
            oH.call(this, MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED, a === void 0 ? "" : a);
        };
    x(pH, oH);
    var tH = function (a, b) {
        b = b === void 0 ? !1 : b;
        var c = mH.call(this) || this;
        L(K.getInstance(), "ulv", "1");
        c.th = b;
        c.sa = null;
        c.Xe = null;
        c.xe = null;
        c.T = gj("VIDEO");
        qH(c);
        c.Ab = a || new $G();
        rH(c);
        c.Bc = null;
        sH(c);
        c.attachShadow({ mode: "open" });
        c.shadowRoot.appendChild(c.T);
        hH(function () {
            L(K.getInstance(), "has", c.src || c.gb);
            L(K.getInstance(), "hat", String(c.T.currentTime));
        });
        c.dd = !1;
        c.bf = !1;
        c.fc = null;
        c.od = null;
        c.uh = !1;
        c.hf = !1;
        c.ij = null;
        c.Rb = null;
        return c;
    };
    x(tH, mH);
    var uH = function (a) {
        a.T.load();
        Wm(Bn) && a.T.dispatchEvent(new Event("canplaythrough"));
    };
    tH.prototype.attributeChangedCallback = function (a, b, c) {
        switch (a) {
            case "src":
                vH(this, c);
                break;
            case "demuxedaudiosrc":
            case "demuxedvideosrc":
                wH(this);
                break;
            case "muted":
                this.T[a] = c === "" ? !0 : !!c;
                xH(this, a, c);
                break;
            default:
                xH(this, a, c);
        }
    };
    tH.prototype.hd = function (a) {
        this.Rb = a;
        var b;
        (b = this.sa) == null || b.hd(a);
    };
    var xH = function (a, b, c) {
            c !== a.T.getAttribute(b) && (c === null ? a.T.removeAttribute(b) : a.T.setAttribute(b, c));
        },
        yH = function (a) {
            a.sa && (a.T.removeEventListener("timeupdate", a.fc), a.sa.dispose(), (a.sa = null));
        },
        zH = function (a, b) {
            a.xe = b;
            a.T.dispatchEvent(new Event("error"));
        },
        qH = function (a) {
            AH(a);
            BH(a);
            a.T.addEventListener("loadedmetadata", function () {
                a.od = ID(a);
                a.od.then(function (b) {
                    var c = a.T.videoWidth;
                    var d = a.T.videoHeight,
                        e = b.width,
                        f = b.height;
                    c > 0 && d > 0 && e > 0 && f > 0 ? ((b = b.width / b.height), (c /= d), (c = Math.min(c, b) / Math.max(c, b) >= 0.97 ? "cover" : "contain")) : (c = null);
                    c !== null && Eq(a.T, { "object-fit": c });
                });
            });
            a.T.addEventListener("play", function () {
                a.bf || (QG(a.T, "first_play"), (a.bf = !0));
            });
            a.T.addEventListener("pause", function () {
                a.dd || (QG(a.T, "first_pause"), SG(a.T), (a.dd = !0));
            });
            Zv(y, "pagehide", function () {
                a.dd || (QG(a.T, "first_pause"), SG(a.T), (a.dd = !0));
            });
            a.T.addEventListener("stalled", function () {
                L(K.getInstance(), "ves", "1");
            });
            new TD(a.T).listen("playbackStalled", function () {
                return L(K.getInstance(), "pbs", "1");
            });
            a.T.addEventListener("media_source_error", function (b) {
                yH(a);
                b = b.detail;
                zH(a, new oH(b.code, b.message));
            });
            CH(a);
        },
        sH = function (a) {
            var b = nH(a.childNodes);
            b && DH(a, b);
            a.Bc === null && EH(a);
        },
        EH = function (a) {
            if (y.MutationObserver) {
                var b = new MutationObserver(function (c) {
                    c = w(c);
                    for (var d = c.next(); !d.done; d = c.next())
                        if (((d = d.value), d.type === "childList" && (d = nH(d.addedNodes)))) {
                            DH(a, d);
                            b.disconnect();
                            break;
                        }
                });
                b.observe(a, kH);
            }
        },
        rH = function (a) {
            a.T.addEventListener("volumechange", function () {
                a.Ab.g.C(UG.toString(), a.T.muted);
                a.th || a.Ab.g.C(VG.toString(), a.T.muted);
            });
        },
        DH = function (a, b) {
            if (a.Bc === null && b.hasAttribute("src")) {
                var c = b.getAttribute("src");
                a.Bc = new fH(a.T, c, b.hasAttribute("default"));
                new cH(a.Bc, a.Ab);
                c.includes("kind=asr") && L(K.getInstance(), "act", "1");
            }
        },
        vH = function (a, b) {
            if (b !== a.Xe) {
                a.Xe = b;
                a.uh && b && vD(b) && (b = wD(b));
                var c = b ? WE(b) : null,
                    d = !!c && yG(c);
                L(K.getInstance(), "umsem", d ? "1" : "0");
                d
                    ? ((b = uC(RG, b, XE(c), OE[c] * 1e3, null)),
                      (a.sa = uC(GG, [b])),
                      a.Rb && a.sa.hd(a.Rb),
                      a.sa.listen("media_source_error", function (e) {
                          e = YE("media_source_error", e.detail);
                          a.T.dispatchEvent(e);
                      }),
                      (a.fc = function () {
                          var e = a.sa;
                          e.G = a.T.currentTime * 1e3;
                          IG(e);
                      }),
                      a.T.addEventListener("timeupdate", a.fc),
                      xH(a, "src", JG(a.sa)))
                    : (yH(a), xH(a, "src", b));
                a.hf || uH(a);
            }
        },
        wH = function (a) {
            a.src && zH(a, new oH(MediaError.MEDIA_ERR_ABORTED, "Setting demuxed src after src is already set."));
            if (!a.vb && !a.gb && a.sa) yH(a), xH(a, "src", null), uH(a);
            else if (a.vb && a.gb) {
                var b = WE(vD(a.gb) ? wD(a.gb) : a.gb),
                    c = WE(vD(a.vb) ? wD(a.vb) : a.vb);
                if (b && yG(b))
                    if (c && yG(c)) {
                        var d = !!b && yG(b) && !!c && yG(c);
                        L(K.getInstance(), "umsed", d ? "1" : "0");
                        b = uC(RG, a.gb, XE(b), -1, null);
                        c = uC(RG, a.vb, XE(c), -1, null);
                        a.sa = uC(GG, [b, c]);
                        a.Rb && a.sa.hd(a.Rb);
                        a.sa.listen("media_source_error", function (e) {
                            e = YE("media_source_error", e.detail);
                            a.T.dispatchEvent(e);
                        });
                        a.fc = function () {
                            var e = a.sa;
                            e.G = a.T.currentTime * 1e3;
                            IG(e);
                        };
                        a.T.addEventListener("timeupdate", a.fc);
                        xH(a, "src", JG(a.sa));
                        a.hf || uH(a);
                    } else zH(a, new pH('Audio itag "' + c + '" not supported.'));
                else zH(a, new pH('Video itag "' + b + '" not supported.'));
            }
        },
        AH = function (a) {
            for (var b = w(jH), c = b.next(), d = {}; !c.done; d = { Za: void 0, getValue: void 0 }, c = b.next())
                (d.Za = c.value),
                    d.Za in a.T &&
                        (typeof a.T[d.Za] === "function"
                            ? ((d.getValue = a.T[d.Za].bind(a.T)),
                              Object.defineProperty(a, d.Za, {
                                  set: (function (e) {
                                      return function (f) {
                                          a.T[e.Za] = f;
                                      };
                                  })(d),
                                  get: (function (e) {
                                      return function () {
                                          return e.getValue;
                                      };
                                  })(d),
                              }))
                            : Object.defineProperty(a, d.Za, {
                                  set: (function (e) {
                                      return function (f) {
                                          a.T[e.Za] = f;
                                      };
                                  })(d),
                                  get: (function (e) {
                                      return function () {
                                          return a.T[e.Za];
                                      };
                                  })(d),
                              }));
        },
        BH = function (a) {
            Object.defineProperty(a, "error", {
                set: function () {},
                get: function () {
                    return a.T.error ? a.T.error : a.xe;
                },
            });
        },
        CH = function (a) {
            a.T.style.width = Lq();
            a.T.style.height = Lq();
        };
    tH.prototype.disconnectedCallback = function () {
        this.od && JD(this.od);
        mH.prototype.disconnectedCallback && mH.prototype.disconnectedCallback.call(this);
    };
    ea.Object.defineProperties(tH.prototype, {
        vb: {
            configurable: !0,
            enumerable: !0,
            set: function (a) {
                this.setAttribute("demuxedaudiosrc", a);
            },
            get: function () {
                return this.getAttribute("demuxedaudiosrc");
            },
        },
        gb: {
            configurable: !0,
            enumerable: !0,
            set: function (a) {
                this.setAttribute("demuxedvideosrc", a);
            },
            get: function () {
                return this.getAttribute("demuxedvideosrc");
            },
        },
        src: {
            configurable: !0,
            enumerable: !0,
            set: function (a) {
                this.setAttribute("src", a);
            },
            get: function () {
                return this.getAttribute("src");
            },
        },
    });
    ea.Object.defineProperties(tH, {
        observedAttributes: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return iH;
            },
        },
    });
    y.customElements && (y.customElements.get("lima-video") || y.customElements.define("lima-video", tH));
    function FH() {
        var a = uC(iG);
        a.initialize().then(function () {
            var b = YE("initialized");
            a.dispatchEvent(b);
        });
        return a;
    }
    var HH = function (a, b, c, d, e) {
        Q.call(this);
        this.G = a;
        this.j = c;
        this.o = e;
        this.Z = this.U = this.Db = this.D = this.l = this.Ra = 0;
        this.C = [];
        this.M = !1;
        this.aa = this.ga = this.fa = null;
        this.oa = !1;
        this.Eb = this.K = this.A = this.wa = this.Qa = null;
        this.xa = !1;
        this.I = new T(b.url);
        this.Ja = b.Ja;
        this.ka = d;
        (this.P = b.g) || this.I.g.remove("alr");
        L(K.getInstance(), "sl_dv" + this.o, (this.P !== null).toString());
        this.V = !this.P;
        this.g = new XMLHttpRequest();
        this.W = 0.1;
        if ((this.B = mF() && !vD(this.I))) (this.A = FH()), Er(this, this.A);
        GH(this);
    };
    x(HH, Q);
    var IH = function (a, b) {
            b = YE("media_source_error", b);
            a.G.dispatchEvent(b);
        },
        JH = function (a, b) {
            IH(a, { code: a.l > 1 ? MediaError.MEDIA_ERR_NETWORK : MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED, message: b });
        },
        GH = function (a) {
            a.fa = function () {
                KH(a);
                if (a.V) {
                    var b = a.g.responseText;
                    a.M = !b || b.length < a.Ja;
                    a.U = 0;
                    Ol("sl_cc" + a.o + "_" + a.l);
                    a.D++;
                    LH(a);
                }
            };
            a.ga = function () {
                KH(a);
            };
            a.aa = function () {
                Ol("sl_ec" + a.o + "_" + a.l);
                JH(a, "Failed to load chunk " + a.l + " for stream " + a.o);
            };
            a.g.addEventListener("load", a.fa);
            a.g.addEventListener("progress", a.ga);
            a.g.addEventListener("error", a.aa);
            a.j.addEventListener("updateend", function () {
                a.j.buffered.length && ((a.Db = a.j.buffered.end(0)), a.B ? a.xa && !a.j.updating && a.l === a.D && (Ol("sl_lc" + a.o), a.ka()) : a.M && !a.j.updating && a.l === a.D && (Ol("sl_lc" + a.o), a.ka()));
                !a.oa && a.G.buffered.length > 1 && (L(K.getInstance(), "dbr", "1"), (a.oa = !0));
            });
            a.j.addEventListener("update", function () {
                a.C.length && !a.j.updating && a.j.appendBuffer(a.C.shift());
            });
            a.j.addEventListener("error", function () {
                Ol("msb_err" + a.o);
                IH(a, { code: MediaError.MEDIA_ERR_DECODE, message: "Error on SourceBuffer " + a.o });
            });
            a.B
                ? (a.A.Ua()
                      ? MH(a)
                      : (a.Qa = Zv(a.A, "initialized", function () {
                            MH(a);
                        })),
                  (a.wa = Zv(a.A, "get_video_succeeded", function () {
                      LH(a);
                  })))
                : MH(a);
        },
        OH = function (a) {
            Ol("sl_rc" + a.o + "_" + a.l);
            var b = NH(a);
            a.g.open("get", b);
            a.g.overrideMimeType("text/plain; charset=x-user-defined");
            a.g.send(null);
            a.B && ((a.K = null), (a.Eb = b));
        },
        KH = function (a) {
            if (a.g.status >= 400) JH(a, 'Response code "' + a.g.status + '" on loading chunk ' + a.l + " for stream " + a.o);
            else {
                if (!a.V) {
                    var b = a.g.getResponseHeader("content-type");
                    if (b && b.indexOf("text/plain") >= 0) {
                        a.g.readyState === XMLHttpRequest.DONE && ((a.I = new T(a.g.response)), (a.l = 0), (a.D = 0), a.Ra++, MH(a));
                        return;
                    }
                    a.V = !0;
                    Ol("sl_redc" + a.o);
                    L(K.getInstance(), "sl_tr" + a.o, a.Ra.toString());
                }
                a.I.g.remove("alr");
                if (a.g.readyState === XMLHttpRequest.LOADING || a.g.readyState === XMLHttpRequest.DONE) (b = PH(a, a.U)), (a.U = a.g.response.length), (a.Z += b.byteLength), QH(a, b);
                if (a.B && a.g.readyState === XMLHttpRequest.DONE && ((b = PH(a, 0)), b.byteLength > 0)) {
                    var c = a.g.responseText;
                    a.xa = !c || c.length < a.Ja;
                    a.A.wc(b, new T(a.Eb), 0, a.xa);
                }
            }
        },
        QH = function (a, b) {
            b.byteLength > 0 && (a.j.updating || a.C.length ? a.C.push(b) : a.j.appendBuffer(b));
        },
        PH = function (a, b) {
            a = a.g.response;
            for (var c = new Uint8Array(a.length - b), d = 0; d < c.length; d++) c[d] = a.charCodeAt(d + b) & 255;
            return c.buffer;
        },
        LH = function (a) {
            var b = xD;
            b !== -1 && b < a.Z + a.Ja ? (a.G.pause(), (xD = -1), (b = !1)) : ((b = a.D === a.l && !a.j.updating && !a.C.length), (b = a.B ? !a.xa && b && a.G.currentTime >= a.W : !a.M && b && a.G.currentTime >= a.W));
            b && ((a.W = a.Db + 0.1), MH(a));
        },
        NH = function (a) {
            var b = a.B && a.K ? a.K + 1 : a.l * a.Ja;
            return gD(a.I, "range", b + "-" + (b + a.Ja - 1)).toString();
        },
        MH = function (a) {
            if (a.B) {
                var b = new T(NH(a));
                a.A.Wb(b).then(function (c) {
                    c ? ((a.K = Number(c.Fc)), (a.xa = c.xa), QH(a, c.video), (c = YE("get_video_succeeded")), a.A.dispatchEvent(c), a.D++) : OH(a);
                    a.l++;
                });
            } else OH(a), a.l++;
        };
    HH.prototype.O = function () {
        this.B && this.A.Ua() && this.A.close();
        this.g.removeEventListener("load", this.fa);
        this.g.removeEventListener("progress", this.ga);
        this.g.removeEventListener("error", this.aa);
        gw(this.Qa);
        gw(this.wa);
        Q.prototype.O.call(this);
    };
    var SH = function (a, b) {
        Q.call(this);
        var c = this;
        this.A = a;
        this.G = b;
        this.g = new MediaSource();
        this.D = [];
        this.l = [];
        this.j = this.o = null;
        this.B = !1;
        this.C = function () {
            RH(c);
        };
        this.g.addEventListener("sourceopen", this.C);
    };
    x(SH, Q);
    var TH = function (a) {
            a.o && a.A.removeEventListener("timeupdate", a.o);
        },
        RH = function (a) {
            Ol("msmsw_oso");
            a.o = function () {
                if (!a.B) for (var e = w(a.l), f = e.next(); !f.done; f = e.next()) LH(f.value);
            };
            a.A.addEventListener("timeupdate", a.o);
            for (var b = 0; b < a.G.length; b++) {
                var c = a.G[b];
                L(K.getInstance(), "msmsw_mime" + b, c.mimeType);
                L(K.getInstance(), "msmsw_cs" + b, c.Ja.toString());
                var d = a.g.addSourceBuffer(c.mimeType);
                d
                    ? (a.D.push(d),
                      (c = uC(
                          HH,
                          a.A,
                          c,
                          d,
                          function () {
                              a: if (!a.B) {
                                  for (var e = w(a.l), f = e.next(); !f.done; f = e.next()) if (((f = f.value), f.B ? !f.xa || f.j.updating || f.C.length : !f.M || f.j.updating || f.C.length)) break a;
                                  a.g.endOfStream();
                                  a.B = !0;
                                  TH(a);
                              }
                          },
                          b
                      )),
                      a.l.push(c))
                    : Ol("msmsw_sbf" + b);
            }
            L(K.getInstance(), "msmsw_ns", a.D.length.toString());
        };
    SH.prototype.O = function () {
        this.j && window.URL.revokeObjectURL(this.j);
        for (var a = w(this.l), b = a.next(); !b.done; b = a.next()) b.value.dispose();
        TH(this);
        this.g.removeEventListener("sourceopen", this.C);
        Q.prototype.O.call(this);
    };
    RegExp.prototype.hasOwnProperty("sticky"); /*

Math.uuid.js (v1.4)
http://www.broofa.com
mailto:robert@broofa.com
Copyright (c) 2010 Robert Kieffer
Dual licensed under the MIT and GPL licenses.
*/
    var UH = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""),
        VH = function () {
            for (var a = Array(36), b = 0, c, d = 0; d < 36; d++)
                d == 8 || d == 13 || d == 18 || d == 23 ? (a[d] = "-") : d == 14 ? (a[d] = "4") : (b <= 2 && (b = (33554432 + Math.random() * 16777216) | 0), (c = b & 15), (b >>= 4), (a[d] = UH[d == 19 ? (c & 3) | 8 : c]));
            return a.join("");
        };
    var XH = function (a) {
        T.call(this, a);
        this.C = new Map();
        a = this.l;
        var b = a.indexOf(";"),
            c = null;
        b >= 0 ? ((this.l = a.substring(0, b)), (c = a.substring(b + 1))) : (this.l = a);
        WH(this, c);
    };
    x(XH, T);
    XH.prototype.toString = function () {
        return YH(this, T.prototype.toString.call(this));
    };
    XH.prototype.D = function () {
        return "";
    };
    var WH = function (a, b) {
            wb(Qi(b)) ||
                b.split(";").forEach(function (c) {
                    var d = c.indexOf("=");
                    if (!(d <= 0)) {
                        var e = Ni(c.substring(0, d));
                        c = Ni(c.substring(d + 1));
                        d = a.C.get(e);
                        d != null ? d.includes(c) || d.push(c) : (d = [Qi(c)]);
                        a.C.set(e, d);
                    }
                }, a);
        },
        ZH = function (a) {
            if (wb(Qi("ord"))) return null;
            a = a.C.get("ord");
            return a != null ? a : null;
        },
        $H = function (a, b) {
            wb(Qi("ord")) || ((b = b.map(Qi)), a.C.set("ord", b));
        },
        YH = function (a, b) {
            b = [Qi(b)];
            b.push.apply(b, la(aI(a)));
            return b.join(";");
        },
        aI = function (a) {
            var b = ZH(a);
            b == null ? (b = [Qi(Date.now())]) : wb(Qi("ord")) || a.C.delete("ord");
            var c = [];
            a.C.forEach(function (d, e) {
                d.forEach(function (f) {
                    c.push(e + "=" + f);
                });
            });
            c.push("ord=" + b[0]);
            $H(a, b);
            return c;
        };
    XH.prototype.G = function () {
        return new XH(this.toString());
    };
    var U = {
        DEPRECATED_ERROR_CODE: -1,
        VAST_MALFORMED_RESPONSE: 100,
        VAST_SCHEMA_VALIDATION_ERROR: 101,
        VAST_UNSUPPORTED_VERSION: 102,
        VAST_TRAFFICKING_ERROR: 200,
        VAST_UNEXPECTED_LINEARITY: 201,
        VAST_UNEXPECTED_DURATION_ERROR: 202,
        VAST_WRAPPER_ERROR: 300,
        VAST_LOAD_TIMEOUT: 301,
        VAST_TOO_MANY_REDIRECTS: 302,
        VAST_NO_ADS_AFTER_WRAPPER: 303,
        VIDEO_PLAY_ERROR: 400,
        VAST_MEDIA_LOAD_TIMEOUT: 402,
        VAST_LINEAR_ASSET_MISMATCH: 403,
        VAST_PROBLEM_DISPLAYING_MEDIA_FILE: 405,
        OVERLAY_AD_PLAYING_FAILED: 500,
        NONLINEAR_DIMENSIONS_ERROR: 501,
        OVERLAY_AD_LOADING_FAILED: 502,
        VAST_NONLINEAR_ASSET_MISMATCH: 503,
        COMPANION_REQUIRED_ERROR: 602,
        COMPANION_AD_LOADING_FAILED: 603,
        UNKNOWN_ERROR: 900,
        VPAID_ERROR: 901,
        FAILED_TO_REQUEST_ADS: 1005,
        VAST_ASSET_NOT_FOUND: 1007,
        VAST_EMPTY_RESPONSE: 1009,
        UNKNOWN_AD_RESPONSE: 1010,
        UNSUPPORTED_LOCALE: 1011,
        ADS_REQUEST_NETWORK_ERROR: 1012,
        INVALID_AD_TAG: 1013,
        PROTECTED_AUDIENCE_API_ERROR: 1014,
        STREAM_INITIALIZATION_FAILED: 1020,
        ASSET_FALLBACK_FAILED: 1021,
        UNSUPPORTED_URL: 1022,
        INVALID_ARGUMENTS: 1101,
        NATIVE_MESSAGE_ERROR: 1204,
        AUTOPLAY_DISALLOWED: 1205,
        CONSENT_MANAGEMENT_PROVIDER_NOT_READY: 1300,
        Mi: 2002,
    };
    U[-1] = "DEPRECATED_ERROR_CODE";
    U[100] = "VAST_MALFORMED_RESPONSE";
    U[101] = "VAST_SCHEMA_VALIDATION_ERROR";
    U[102] = "VAST_UNSUPPORTED_VERSION";
    U[200] = "VAST_TRAFFICKING_ERROR";
    U[201] = "VAST_UNEXPECTED_LINEARITY";
    U[202] = "VAST_UNEXPECTED_DURATION_ERROR";
    U[300] = "VAST_WRAPPER_ERROR";
    U[301] = "VAST_LOAD_TIMEOUT";
    U[302] = "VAST_TOO_MANY_REDIRECTS";
    U[303] = "VAST_NO_ADS_AFTER_WRAPPER";
    U[400] = "VIDEO_PLAY_ERROR";
    U[402] = "VAST_MEDIA_LOAD_TIMEOUT";
    U[403] = "VAST_LINEAR_ASSET_MISMATCH";
    U[405] = "VAST_PROBLEM_DISPLAYING_MEDIA_FILE";
    U[500] = "OVERLAY_AD_PLAYING_FAILED";
    U[501] = "NONLINEAR_DIMENSIONS_ERROR";
    U[502] = "OVERLAY_AD_LOADING_FAILED";
    U[503] = "VAST_NONLINEAR_ASSET_MISMATCH";
    U[602] = "COMPANION_REQUIRED_ERROR";
    U[603] = "COMPANION_AD_LOADING_FAILED";
    U[900] = "UNKNOWN_ERROR";
    U[901] = "VPAID_ERROR";
    U[1005] = "FAILED_TO_REQUEST_ADS";
    U[1007] = "VAST_ASSET_NOT_FOUND";
    U[1009] = "VAST_EMPTY_RESPONSE";
    U[1010] = "UNKNOWN_AD_RESPONSE";
    U[1011] = "UNSUPPORTED_LOCALE";
    U[1012] = "ADS_REQUEST_NETWORK_ERROR";
    U[1013] = "INVALID_AD_TAG";
    U[1014] = "PROTECTED_AUDIENCE_API_ERROR";
    U[1020] = "STREAM_INITIALIZATION_FAILED";
    U[1021] = "ASSET_FALLBACK_FAILED";
    U[1022] = "UNSUPPORTED_URL";
    U[1101] = "INVALID_ARGUMENTS";
    U[1204] = "NATIVE_MESSAGE_ERROR";
    U[1205] = "AUTOPLAY_DISALLOWED";
    U[1300] = "CONSENT_MANAGEMENT_PROVIDER_NOT_READY";
    U[2002] = "SUPPORTED_ADS_NOT_FOUND";
    var bI = function (a, b, c) {
        var d = Error.call(this);
        this.message = d.message;
        "stack" in d && (this.stack = d.stack);
        this.type = a;
        this.errorMessage = b;
        this.errorCode = c;
        this.ad = this.g = null;
    };
    x(bI, Error);
    l = bI.prototype;
    l.getAd = function () {
        return this.ad;
    };
    l.getInnerError = function () {
        return this.g;
    };
    l.getMessage = function () {
        return this.errorMessage;
    };
    l.getErrorCode = function () {
        return this.errorCode;
    };
    l.getVastErrorCode = function () {
        return this.errorCode < 1e3 ? this.errorCode : 900;
    };
    l.getType = function () {
        return this.type;
    };
    l.toString = function () {
        return "AdError " + this.getErrorCode() + ": " + this.getMessage() + (this.getInnerError() != null ? " Caused by: " + this.getInnerError() : "");
    };
    var cI = ka(["https://imasdk.googleapis.com/js/sdkloader/car.js"]);
    oi(cI);
    function dI(a) {
        return a ? ((a = /\/(\d+)(?:,\d+){0,2}\//.exec(a)) && a.length === 2 ? a[1] : null) : null;
    }
    function eI(a) {
        if (a === "") return null;
        a = new T(a);
        var b = a.g.get("slotname") || a.g.get("iu");
        if (!(b = b ? dI(b) : null)) {
            var c;
            b = (a = (c = a.g.get("client")) != null ? c : "") ? a : null;
        }
        return b;
    }
    function fI(a, b) {
        try {
            var c = new URL(a);
            return c.searchParams.get("slotname") || c.searchParams.get("iu") || "";
        } catch (d) {
            b == null || b(d);
        }
        return "";
    }
    var gI = function (a) {
        var b = {};
        b =
            ((b.IABUSPrivacy_String = "uspString"),
            (b.IABTCF_gdprApplies = "gdprApplies"),
            (b.IABTCF_TCString = "tcString"),
            (b.IABTCF_AddtlConsent = "addtlConsent"),
            (b.IABGPP_HDR_GppString = "gppString"),
            (b.IABGPP_GppSID = "gppSid"),
            b);
        for (var c in b) a[c] != null && ((a[b[c]] = a[c]), delete a[c]);
        c = a.uspString;
        this.uspString = typeof c === "string" ? c : "";
        c = a.gdprApplies;
        this.j = typeof c === "boolean" ? (c ? "1" : "0") : typeof c !== "number" || (c !== 1 && c !== 0) ? (typeof c !== "string" || (c !== "1" && c !== "0") ? "" : c === "1" ? "1" : "0") : c === 1 ? "1" : "0";
        c = a.tcString;
        this.g = typeof c === "string" ? c : "";
        /^[\.\w_-]*$/.test(this.g) || (this.g = encodeURIComponent(this.g));
        c = a.gppString;
        this.gppString = typeof c === "string" ? c : "";
        a = a.gppSid;
        this.l = typeof a === "string" ? a : "";
    };
    var hI = function (a) {
            this.g = a;
        },
        iI = function (a, b) {
            return Ai(a.g, b) && ((a = a.g[b]), typeof a === "boolean") ? a : !1;
        },
        jI = function (a) {
            return Ai(a.g, "videoElementFakeDuration") && ((a = a.g.videoElementFakeDuration), typeof a === "number") ? a : NaN;
        },
        kI = function (a) {
            if (Ai(a.g, "forceExperimentIds")) {
                a = a.g.forceExperimentIds;
                var b = [],
                    c = 0;
                Array.isArray(a) &&
                    a.forEach(function (d) {
                        typeof d === "number" && (b[c++] = d);
                    });
                return b;
            }
            return null;
        };
    var V = function () {
            this.G = "always";
            this.U = 4;
            this.L = null;
            this.A = 1;
            this.g = 0;
            this.o = !0;
            this.locale = "en";
            this.l = null;
            this.j = !1;
            this.Z = this.W = "";
            this.C = null;
            this.aa = this.V = -1;
            this.B = "";
            this.M = !1;
            this.fa = null;
            this.K = !0;
            this.D = VH();
            this.P = {};
            this.J = "";
            this.I = 0;
            try {
                this.fa = up()[0];
            } catch (a) {}
        },
        lI = function (a) {
            a = Qi(a);
            wb(a) || (a = a.substring(0, 20));
            return a;
        };
    l = V.prototype;
    l.setCompanionBackfill = function (a) {
        this.G = a;
    };
    l.getCompanionBackfill = function () {
        return this.G;
    };
    l.setNumRedirects = function (a) {
        this.U = a;
    };
    l.getNumRedirects = function () {
        return this.U;
    };
    l.setPpid = function (a) {
        this.L = a;
    };
    l.getPpid = function () {
        return this.L;
    };
    l.setVpaidAllowed = function (a) {
        typeof a === "boolean" && (this.A = a ? 1 : 0);
    };
    l.setVpaidMode = function (a) {
        this.A = a;
    };
    l.ug = function () {
        return this.A;
    };
    l.setAutoPlayAdBreaks = function (a) {
        this.o = a;
    };
    l.Hg = function () {
        return this.o;
    };
    l.hh = function (a) {
        this.j = a;
    };
    l.tg = function () {
        return this.j;
    };
    l.setLocale = function (a) {
        if ((a = aE(a))) this.locale = a;
    };
    l.getLocale = function () {
        return this.locale;
    };
    l.setPlayerType = function (a) {
        this.W = lI(a);
    };
    l.getPlayerType = function () {
        return this.W;
    };
    l.setPlayerVersion = function (a) {
        this.Z = lI(a);
    };
    l.getPlayerVersion = function () {
        return this.Z;
    };
    var mI = function (a) {
        if (a.C == null) {
            var b = {};
            var c = new T(dj().location.href).g;
            if (lD(c, "tcnfp"))
                try {
                    b = JSON.parse(c.get("tcnfp"));
                } catch (d) {}
            a.C = new hI(b);
        }
        return a.C;
    };
    l = V.prototype;
    l.ih = function (a) {
        this.V = a;
    };
    l.jh = function (a) {
        this.aa = a;
    };
    l.setDisableCustomPlaybackForIOS10Plus = function (a) {
        this.M = a;
    };
    l.getDisableCustomPlaybackForIOS10Plus = function () {
        return this.M;
    };
    l.isCookiesEnabled = function () {
        return this.K;
    };
    l.setCookiesEnabled = function (a) {
        a != null && (this.K = a);
    };
    l.setSessionId = function (a) {
        this.D = a;
    };
    l.gh = function () {};
    l.sg = function () {
        return !0;
    };
    l.setFeatureFlags = function (a) {
        this.P = a;
    };
    l.getFeatureFlags = function () {
        return this.P;
    };
    var nI = function (a, b) {
        b = b === void 0 ? null : b;
        var c = {};
        b != null && (c.activeViewPushUpdates = b);
        c.activityMonitorMode = a.g;
        c.adsToken = a.B;
        c.autoPlayAdBreaks = a.o;
        c.companionBackfill = a.getCompanionBackfill();
        c.cookiesEnabled = a.isCookiesEnabled();
        c.disableCustomPlaybackForIOS10Plus = a.getDisableCustomPlaybackForIOS10Plus();
        c.engagementDetection = !0;
        c.isFunctionalTest = !1;
        c.isVpaidAdapter = a.j;
        c["1pJar"] = "";
        c.numRedirects = a.getNumRedirects();
        c.pageCorrelator = a.V;
        c.persistentStateCorrelator = il();
        c.playerType = a.getPlayerType();
        c.playerVersion = a.getPlayerVersion();
        c.ppid = a.getPpid();
        c.privacyControls = "";
        c.reportMediaRequests = !1;
        c.sessionId = a.D;
        c.streamCorrelator = a.aa;
        c.testingConfig = mI(a).g;
        c.urlSignals = a.fa;
        c.vpaidMode = a.A;
        c.featureFlags = a.getFeatureFlags();
        c.cookieDeprecationLabel = a.J;
        c.cookieDeprecationLabelStatus = a.I;
        return c;
    };
    V.prototype.getFeatureFlags = V.prototype.getFeatureFlags;
    V.prototype.setFeatureFlags = V.prototype.setFeatureFlags;
    V.prototype.getDisableFlashAds = V.prototype.sg;
    V.prototype.setDisableFlashAds = V.prototype.gh;
    V.prototype.setSessionId = V.prototype.setSessionId;
    V.prototype.setCookiesEnabled = V.prototype.setCookiesEnabled;
    V.prototype.isCookiesEnabled = V.prototype.isCookiesEnabled;
    V.prototype.getDisableCustomPlaybackForIOS10Plus = V.prototype.getDisableCustomPlaybackForIOS10Plus;
    V.prototype.setDisableCustomPlaybackForIOS10Plus = V.prototype.setDisableCustomPlaybackForIOS10Plus;
    V.prototype.setStreamCorrelator = V.prototype.jh;
    V.prototype.setPageCorrelator = V.prototype.ih;
    V.prototype.getPlayerVersion = V.prototype.getPlayerVersion;
    V.prototype.setPlayerVersion = V.prototype.setPlayerVersion;
    V.prototype.getPlayerType = V.prototype.getPlayerType;
    V.prototype.setPlayerType = V.prototype.setPlayerType;
    V.prototype.getLocale = V.prototype.getLocale;
    V.prototype.setLocale = V.prototype.setLocale;
    V.prototype.getIsVpaidAdapter = V.prototype.tg;
    V.prototype.setIsVpaidAdapter = V.prototype.hh;
    V.prototype.isAutoPlayAdBreaks = V.prototype.Hg;
    V.prototype.setAutoPlayAdBreaks = V.prototype.setAutoPlayAdBreaks;
    V.prototype.getVpaidMode = V.prototype.ug;
    V.prototype.setVpaidMode = V.prototype.setVpaidMode;
    V.prototype.setVpaidAllowed = V.prototype.setVpaidAllowed;
    V.prototype.getPpid = V.prototype.getPpid;
    V.prototype.setPpid = V.prototype.setPpid;
    V.prototype.getNumRedirects = V.prototype.getNumRedirects;
    V.prototype.setNumRedirects = V.prototype.setNumRedirects;
    V.prototype.getCompanionBackfill = V.prototype.getCompanionBackfill;
    V.prototype.setCompanionBackfill = V.prototype.setCompanionBackfill;
    var oI = new V();
    var pI = function (a, b) {
            (0, a.__uspapi)("getUSPData", 1, function (c, d) {
                b.Ba({ De: c != null ? c : void 0, Ge: d ? void 0 : 2 });
            });
        },
        qI = {
            Nd: function (a) {
                return a.Ba;
            },
            Pc: function (a, b) {
                a = {};
                return (a.__uspapiCall = { callId: b, command: "getUSPData", version: 1 }), a;
            },
            ec: function (a, b) {
                b = b.__uspapiReturn;
                var c;
                a({ De: (c = b.returnValue) != null ? c : void 0, Ge: b.success ? void 0 : 2 });
            },
        };
    function rI(a) {
        var b = {};
        typeof a.data === "string" ? (b = JSON.parse(a.data)) : (b = a.data);
        return { payload: b, Ve: b.__uspapiReturn.callId };
    }
    var sI = function (a, b) {
        b = b === void 0 ? {} : b;
        Q.call(this);
        var c;
        this.timeoutMs = (c = b.timeoutMs) != null ? c : 500;
        this.caller = new vC(
            a,
            "__uspapiLocator",
            function (d) {
                return typeof d.__uspapi === "function";
            },
            rI
        );
        this.caller.A.set("getDataWithCallback", pI);
        this.caller.o.set("getDataWithCallback", qI);
    };
    x(sI, Q);
    sI.prototype.O = function () {
        this.caller.dispose();
        Q.prototype.O.call(this);
    };
    var tI = function (a, b) {
        var c = {};
        if (wC(a.caller)) {
            var d = Mh(function () {
                b(c);
            });
            yC(a.caller, "getDataWithCallback", {
                Ba: function (e) {
                    e.Ge || (c = e.De);
                    d();
                },
            });
            setTimeout(d, a.timeoutMs);
        } else b(c);
    };
    var uI = function (a) {
        this.F = B(a);
    };
    x(uI, H);
    function vI(a) {
        var b = {};
        new T(a).g.forEach(function (c, d) {
            b[d] = c;
        });
        return b;
    }
    function wI(a) {
        return a === "1" || a === "true";
    }
    var xI = function (a, b, c, d) {
            b = b === void 0 ? {} : b;
            c = c === void 0 ? {} : c;
            this.j = a === void 0 ? !1 : a;
            this.o = d === void 0 ? !1 : d;
            a = {};
            b = w(Object.entries(b));
            for (d = b.next(); !d.done; d = b.next()) {
                var e = w(d.value);
                d = e.next().value;
                e = e.next().value;
                e != null && (a[d] = String(e));
            }
            this.l = a;
            this.g = new gI(c);
        },
        yI = function (a, b) {
            var c = !1;
            c = c === void 0 ? !1 : c;
            var d = new T(a);
            var e = d.l;
            (d = vb(d.j, "googleads.g.doubleclick.net") && ZD("/pagead/(live/)?ads", e)) ||
                ((e = new XH(a)), (d = e.j), (e = YH(e, e.l)), (d = !vb(d, ".g.doubleclick.net") && (vb(d, "doubleclick.net") || vb(d, "pagead2.googlesyndication.com")) && ZD("/(ad|pfad)[x|i|j]?/", e)));
            d || ((d = new T(a)), (e = d.l), (d = vb(d.j, "doubleclick.net") && ZD("/gampad/(live/)?ads", e)));
            (d = d || new T(a).j == "bid.g.doubleclick.net") || ((d = new T(a)), (e = d.l), (d = d.j === "ad.doubleclick.net" && ZD("/dv3/adv", e)));
            d || ((d = new T(a)), (e = d.l), (d = d.j === "pubads.g.doubleclick.net" && (ZD("/ssai/", e) || ZD("/ondemand/", e))));
            return new xI(d, vI(a), b, c);
        },
        BI = function (a) {
            var b = a.g.g;
            var c = zI(a, "gdpr_consent");
            b = b && b !== "tcunavailable" ? b : b === "tcunavailable" ? c || b : c || "";
            if (b === "tcunavailable") return null;
            var d;
            return (d = gC(b, AI(a))) != null ? d : null;
        },
        zI = function (a, b) {
            if (a.l.hasOwnProperty(b)) return a.l[b];
        },
        DI = function (a) {
            var b;
            if (!(b = CI(a))) {
                if (AI(a)) {
                    a = BI(a);
                    if ((b = !!a)) {
                        var c = c === void 0 ? {} : c;
                        b = EC(a)
                            ? a.gdprApplies === !1
                                ? !0
                                : a.tcString === "tcunavailable"
                                ? !c.idpcApplies
                                : (c.idpcApplies || a.gdprApplies !== void 0 || c.kj) && (c.idpcApplies || (typeof a.tcString === "string" && a.tcString.length))
                                ? HC(a, "1", 0)
                                : !0
                            : !1;
                    }
                    c = b;
                } else c = !0;
                b = !c;
            }
            return b;
        },
        CI = function (a) {
            a = zI(a, "ltd");
            return wI(a);
        },
        AI = function (a) {
            var b = zI(a, "gdpr"),
                c = a.g.j;
            b = (c === "1" || c === "0" ? c : b !== void 0 ? b : "").toLowerCase();
            b = b === "true" || b === "1";
            return lo(jC) ? b || a.o : b;
        },
        EI = function (a) {
            var b = new uI();
            var c = !DI(a);
            c = zg(b, 5, c);
            AI(a) ? ((a = BI(a)), (a = !!a && !JC(a, ["2", "7", "9", "10"], 3))) : (a = !1);
            zg(c, 8, a);
            return b;
        },
        FI = function (a) {
            try {
                var b = a.g.gppString,
                    c = a.g.l.split("_").map(function (d) {
                        return Number(d);
                    });
                return TC(b, c);
            } catch (d) {
                return !1;
            }
        };
    var GI = function (a) {
        this.F = B(a);
    };
    x(GI, H);
    GI.prototype.getVersion = function () {
        return D(this, 2);
    };
    var HI = function (a) {
        this.F = B(a);
    };
    x(HI, H);
    var II = function (a, b) {
            return Eg(a, 2, b);
        },
        JI = function (a, b) {
            return Eg(a, 3, b);
        },
        KI = function (a, b) {
            return Eg(a, 4, b);
        },
        LI = function (a, b) {
            return Eg(a, 5, b);
        },
        MI = function (a, b) {
            return Eg(a, 9, b);
        },
        NI = function (a, b) {
            return ig(a, 10, b);
        },
        OI = function (a, b) {
            return zg(a, 11, b);
        },
        PI = function (a, b) {
            return Eg(a, 1, b);
        },
        QI = function (a, b) {
            return zg(a, 7, b);
        };
    var RI = "platform platformVersion architecture model uaFullVersion bitness fullVersionList wow64".split(" ");
    function SI(a) {
        var b;
        return (b = a.google_tag_data) != null ? b : (a.google_tag_data = {});
    }
    function TI(a) {
        var b, c;
        return typeof ((b = a.navigator) == null ? void 0 : (c = b.userAgentData) == null ? void 0 : c.getHighEntropyValues) === "function";
    }
    function UI() {
        var a = window;
        if (!TI(a)) return null;
        var b = SI(a);
        if (b.uach_promise) return b.uach_promise;
        a = a.navigator.userAgentData.getHighEntropyValues(RI).then(function (c) {
            b.uach != null || (b.uach = c);
            return c;
        });
        return (b.uach_promise = a);
    }
    function VI(a) {
        var b;
        return OI(
            NI(
                LI(II(PI(KI(QI(MI(JI(new HI(), a.architecture || ""), a.bitness || ""), a.mobile || !1), a.model || ""), a.platform || ""), a.platformVersion || ""), a.uaFullVersion || ""),
                ((b = a.fullVersionList) == null
                    ? void 0
                    : b.map(function (c) {
                          var d = new GI();
                          d = Eg(d, 1, c.brand);
                          return Eg(d, 2, c.version);
                      })) || []
            ),
            a.wow64 || !1
        );
    }
    function WI() {
        var a, b;
        return (b =
            (a = UI()) == null
                ? void 0
                : a.then(function (c) {
                      return VI(c);
                  })) != null
            ? b
            : null;
    }
    var YI = function () {
            this.appName = null;
            new xI();
            this.secureSignals = null;
            VH();
            this.deviceId = "";
            this.g = this.referrer = this.Se = null;
            new Ak();
            new yk();
            XI(this);
        },
        ZI = function () {
            YI.getInstance();
            var a = "h.3.668.1";
            oI.j && (a += "/vpaid_adapter");
            return a;
        },
        XI = function (a) {
            var b = WI();
            b &&
                b.then(function (c) {
                    if (c == null) c = null;
                    else {
                        c = Ig(c);
                        for (var d = [], e = 0, f = 0; f < c.length; f++) {
                            var g = c.charCodeAt(f);
                            g > 255 && ((d[e++] = g & 255), (g >>= 8));
                            d[e++] = g;
                        }
                        c = Sc(d, 3);
                    }
                    a.g = c;
                });
        };
    YI.getInstance = function () {
        return J(YI);
    };
    var aJ = function (a) {
            a = a === void 0 ? !1 : a;
            var b = mI(oI);
            if ((b && iI(b, "forceCustomPlayback")) || oI.j) return !0;
            if (QD() && a) return !1;
            a = a && (QD() || RD(10)) && oI.getDisableCustomPlaybackForIOS10Plus();
            return ((yc || Ac) && !a) || (xc && (!xc || !PD(OD, 4))) || $I() ? !0 : !1;
        },
        bJ = function (a) {
            return a === null ? !1 : oI.j ? !0 : Bc || QD() ? (SD(a) ? (QD() || (RD(10) && oI.getDisableCustomPlaybackForIOS10Plus()) ? !1 : !0) : !0) : (xc && (!xc || !PD(OD, 4))) || $I() ? !0 : !1;
        },
        cJ = function () {
            var a = mI(oI);
            return a && iI(a, "disableOnScreenDetection") ? !1 : !Yq();
        },
        $I = function () {
            return dJ() === 1 || dJ() === 2;
        },
        dJ = function () {
            switch ((YI.getInstance(), 0)) {
                case 1:
                    return 3;
                case 2:
                    return 1;
            }
            return (YI.getInstance(), YI.getInstance(), YI.getInstance().Se === "tvos") ? 1 : Zq() ? 2 : 0;
        };
    var eJ = function (a, b) {
        return a.indexOf(b) == 0 ? a.substr(b.length) : null;
    };
    function fJ() {
        if (Yq()) return window.location.href;
        var a = jp(),
            b = a.j,
            c = a.g;
        a = a.l;
        var d = null;
        if (a)
            try {
                var e = hD(a.url),
                    f = e.l,
                    g = eJ(f, "/v/");
                g || (g = eJ(f, "/a/"));
                if (!g) throw Error("Can not extract standalone amp url.");
                var h = eJ("/" + g, "/s/"),
                    k = XC(e.g);
                k.remove("amp_js_v");
                k.remove("amp_lite");
                var m = h ? hD("https://" + h) : hD("http://" + g);
                WC(m, k);
                d = m.toString();
            } catch (n) {
                d = null;
            }
        return d ? d : b && b.url ? b.url : c && c.url ? c.url : "";
    }
    function gJ() {
        var a = gp();
        a = w(a);
        for (var b = a.next(); !b.done; b = a.next()) if (((b = b.value), b.url && b.url.includes("amp=1"))) return !0;
        return window.context != null ? ((a = Number(window.context.ampcontextVersion)), isNaN(a) ? !1 : Math.floor(a) > 0) : jp().l != null;
    }
    function hJ() {
        var a = dj().location.ancestorOrigins;
        return a ? (a.length > 0 ? [].concat(la(a)).join(",") : "") : "";
    }
    function iJ() {
        var a = dj(),
            b = document;
        return new T(a.parent === a ? a.location.href : b.referrer);
    }
    function jJ(a, b) {
        gD(a, "url", "");
        try {
            var c = 2083 - a.toString().length - 1;
            if (c <= 0) return a.toString();
            for (var d = b.slice(0, c), e = encodeURIComponent(d), f = c; f > 0 && e.length > c; ) (d = b.slice(0, f--)), (e = encodeURIComponent(d));
            gD(a, "url", d);
        } catch (g) {}
        return a.toString();
    }
    var W = {},
        kJ =
            ((W.creativeView = "creativeview"),
            (W.start = "start"),
            (W.midpoint = "midpoint"),
            (W.firstQuartile = "firstquartile"),
            (W.thirdQuartile = "thirdquartile"),
            (W.complete = "complete"),
            (W.mute = "mute"),
            (W.unmute = "unmute"),
            (W.pause = "pause"),
            (W.rewind = "rewind"),
            (W.resume = "resume"),
            (W.fullscreen = "fullscreen"),
            (W.exitFullscreen = "exitfullscreen"),
            (W.expand = "expand"),
            (W.collapse = "collapse"),
            (W.close = "close"),
            (W.acceptInvitation = "acceptinvitation"),
            (W.adCanPlay = "adCanPlay"),
            (W.adStarted = "adStarted"),
            (W.abandon = "abandon"),
            (W.acceptInvitationLinear = "acceptinvitationlinear"),
            (W.engagedView = "engagedview"),
            (W.instreamAdComplete = "instreamAdComplete"),
            (W.skipShown = "skipshown"),
            (W.skippableStateChanged = "skippableStateChanged"),
            (W.skip = "skip"),
            (W.progress = "progress"),
            (W.publisher_invoked_skip = "PUBLISHER_INVOKED_SKIP"),
            (W.annotation_start = "annotation_start"),
            (W.annotation_click = "annotation_click"),
            (W.annotation_close = "annotation_close"),
            (W.cta_annotation_shown = "cta_annotation_shown"),
            (W.cta_annotation_clicked = "cta_annotation_clicked"),
            (W.cta_annotation_closed = "cta_annotation_closed"),
            (W.replay = "replay"),
            (W.stop = "stop"),
            (W.autoplayDisallowed = "autoplayDisallowed"),
            (W.error = "error"),
            (W.mediaLoadTimeout = "mediaLoadTimeout"),
            (W.linearChanged = "linearChanged"),
            (W.click = "click"),
            (W.contentPauseRequested = "contentPauseRequested"),
            (W.contentResumeRequested = "contentResumeRequested"),
            (W.discardAdBreak = "discardAdBreak"),
            (W.updateAdsRenderingSettings = "updateAdsRenderingSettings"),
            (W.durationChange = "durationChange"),
            (W.expandedChanged = "expandedChanged"),
            (W.autoClose = "autoClose"),
            (W.userClose = "userClose"),
            (W.userRecall = "userRecall"),
            (W.prefetched = "prefetched"),
            (W.loaded = "loaded"),
            (W.init = "init"),
            (W.allAdsCompleted = "allAdsCompleted"),
            (W.adMetadata = "adMetadata"),
            (W.adBreakReady = "adBreakReady"),
            (W.adBreakFetchError = "adBreakFetchError"),
            (W.log = "log"),
            (W.volumeChange = "volumeChange"),
            (W.companionBackfill = "companionBackfill"),
            (W.companionInitialized = "companionInitialized"),
            (W.companionImpression = "companionImpression"),
            (W.companionClick = "companionClick"),
            (W.impression = "impression"),
            (W.interaction = "interaction"),
            (W.adProgress = "adProgress"),
            (W.adBuffering = "adBuffering"),
            (W.trackingUrlPinged = "trackingUrlPinged"),
            (W.measurable_impression = "measurable_impression"),
            (W.custom_metric_viewable = "custom_metric_viewable"),
            (W.viewable_impression = "viewable_impression"),
            (W.fully_viewable_audible_half_duration_impression = "fully_viewable_audible_half_duration_impression"),
            (W.audio_audible = "audio_audible"),
            (W.audio_measurable = "audio_measurable"),
            (W.overlay_resize = "overlay_resize"),
            (W.overlay_unmeasurable_impression = "overlay_unmeasurable_impression"),
            (W.overlay_unviewable_impression = "overlay_unviewable_impression"),
            (W.overlay_viewable_immediate_impression = "overlay_viewable_immediate_impression"),
            (W.overlay_viewable_end_of_session_impression = "overlay_viewable_end_of_session_impression"),
            (W.externalActivityEvent = "externalActivityEvent"),
            (W.adEvent = "adEvent"),
            (W.configure = "configure"),
            (W.remainingTime = "remainingTime"),
            (W.destroy = "destroy"),
            (W.resize = "resize"),
            (W.volume = "volume"),
            (W.authorIconClicked = "videoAuthorIconClicked"),
            (W.authorNameClicked = "videoAuthorClicked"),
            (W.videoClicked = "videoClicked"),
            (W.videoIconClicked = "videoIconClicked"),
            (W.learnMoreClicked = "videoLearnMoreClicked"),
            (W.muteClicked = "videoMuteClicked"),
            (W.titleClicked = "videoTitleClicked"),
            (W.videoSkipClicked = "SKIPPED"),
            (W.unmuteClicked = "videoUnmuteClicked"),
            (W.vpaidEvent = "vpaidEvent"),
            (W.show_ad = "show_ad"),
            (W.video_card_endcap_collapse = "video_card_endcap_collapse"),
            (W.video_card_endcap_dismiss = "video_card_endcap_dismiss"),
            (W.video_card_endcap_impression = "video_card_endcap_impression"),
            (W.mediaUrlPinged = "mediaUrlPinged"),
            (W.breakStart = "breakstart"),
            (W.breakEnd = "breakend"),
            (W.omidReady = "omidReady"),
            (W.omidUnavailable = "omidUnavailable"),
            (W.omidAdSessionCompleted = "omidAdSessionCompleted"),
            (W.omidAdSessionAbandoned = "omidAdSessionAbandoned"),
            (W.verificationNotExecuted = "verificationNotExecuted"),
            (W.loadStart = "loadStart"),
            (W.seeked = "seeked"),
            (W.seeking = "seeking"),
            W);
    var lJ = new (function () {
        this.g = new Map();
        this.l = 0;
        this.j = window.fetch != null;
    })();
    function mJ(a) {
        var b = b === void 0 ? lJ : b;
        var c = c === void 0 ? null : c;
        a = new dE(a, c ? c : c);
        var d = d === void 0 ? !1 : d;
        var e = e === void 0 ? !1 : e;
        a.g != null || e ? JE(b, a.url, d, e, a.g) : JE(b, a.url, d);
    }
    var X = function () {
        this.l = Math.random() < 0.01;
        this.j = Math.floor(Math.random() * 4503599627370496);
        this.g = null;
    };
    X.prototype.report = function (a, b, c) {
        b = b === void 0 ? {} : b;
        if (y.G_testRunner == null && (this.l || (c === void 0 ? 0 : c))) {
            b.lid = a;
            ZI() && (b.sdkv = ZI());
            this.g && (b.palv = this.g);
            a = $m().sort().join(",");
            wb(Qi(a)) || (b.e = a);
            b = nJ(this, b);
            var d = new T("http://pagead2.googlesyndication.com/pagead/gen_204");
            ti(
                b,
                function (e, f) {
                    e != null && gD(d, f, e == null ? "" : typeof e === "boolean" ? (e ? "t" : "f") : "" + e);
                },
                this
            );
            b = iJ().o;
            (b !== "http" && b !== "https") || UC(d, b);
            b = d.toString();
            a = d.g.get("url");
            a != null && Mb() && b.length > 2083 && (b = jJ(d, a));
            mJ(b);
        }
    };
    var nJ = function (a, b) {
        b.id = "ima_html5";
        var c = iJ();
        b.c = a.j;
        b.domain = c.j;
        return b;
    };
    X.getInstance = function () {
        return J(X);
    };
    function oJ(a) {
        var b = Date.now(),
            c = {};
        a = ((c["x-afma-token-requester-type"] = a), c);
        c = "https://pubads.g.doubleclick.net/adsid/integrator.json?aos=" + encodeURIComponent(hJ());
        return new BE()
            .get({ url: c, withCredentials: !0, timeout: new bE(), headers: a })
            .then(function (d) {
                var e = Date.now();
                d = d.newToken || "";
                var f = {};
                X.getInstance().report(182, ((f.t = e - b), (f.aos = hJ()), f));
                return new pJ(d);
            })
            .catch(function (d) {
                var e = "not instanceof Error";
                d instanceof Error && (e = eE(Number(d.message)));
                d = Date.now();
                var f = {};
                X.getInstance().report(182, ((f.except = e), (f.t = d - b), f));
                return Promise.resolve(qJ);
            });
    }
    var rJ = function () {
        R.call(this);
        this.g = null;
        this.A = new gE(this);
        Er(this, this.A);
        this.j = new Ow(72e5);
        this.l = Promise.resolve(qJ);
    };
    x(rJ, R);
    var sJ = function (a) {
        var b = "requester_type_8";
        b = b === void 0 ? "requester_type_9" : b;
        var c = function (d) {
            a.g = d;
            return a.g;
        };
        a.l = oJ(b).then(c);
        a.j = new Ow(72e5);
        a.A.listen(a.j, "tick", function () {
            a.l = oJ(b).then(c);
        });
        a.j.start();
        Dr(a, function () {
            a.j.stop();
        });
    };
    rJ.prototype.getId = function () {
        var a = this;
        return La(function (b) {
            if (b.g == 1) return a.g != null && a.g !== qJ ? ((b.g = 2), (b = void 0)) : (b = Aa(b, a.l, 3)), b;
            b.g != 2 && (a.g = b.j);
            return b.return(a.g);
        });
    };
    var pJ = function (a) {
            this.id = a;
        },
        qJ = new pJ("");
    var tJ = function (a, b, c, d, e) {
            this.name = a;
            this.type = b;
            this.data = c;
            this.id = d;
            this.g = e;
        },
        uJ = function (a) {
            R.call(this);
            this.A = [];
            this.j = !1;
            this.l = a || "goog_" + Ri++;
        };
    x(uJ, R);
    uJ.prototype.connect = function () {
        for (this.j = !0; this.A.length !== 0; ) {
            var a = this.A.shift();
            a && this.sendMessage(a);
        }
    };
    var vJ = function (a, b, c, d, e, f) {
        a.j ? a.sendMessage(new tJ(b, c, d, e, f)) : a.A.push(new tJ(b, c, d, e, f));
    };
    uJ.prototype.sendMessage = function () {};
    var wJ = function (a, b, c, d, e, f) {
        e = e === void 0 ? "" : e;
        f = f === void 0 ? "" : f;
        Kv.call(this, a);
        this.messageType = b;
        this.na = c;
        this.sc = d;
        this.origin = e;
        this.id = f;
    };
    x(wJ, Kv);
    wJ.prototype.getId = function () {
        return this.id;
    };
    wJ.prototype.toString = function () {
        return "";
    };
    var xJ = { IMAGE: "Image", FLASH: "Flash", ALL: "All" },
        yJ = { HTML: "Html", IFRAME: "IFrame", STATIC: "Static", ALL: "All" },
        zJ = { IGNORE: "IgnoreSize", SELECT_EXACT_MATCH: "SelectExactMatch", SELECT_NEAR_MATCH: "SelectNearMatch", SELECT_FLUID: "SelectFluid" },
        AJ = function () {
            this.allowCustom = !0;
            this.creativeType = this.resourceType = "All";
            this.sizeCriteria = "SelectExactMatch";
            this.nearMatchPercent = 90;
            this.adSlotIds = [];
        };
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$companion_ad_selection_settings.CompanionAdSelectionSettings.CreativeType", xJ);
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$companion_ad_selection_settings.CompanionAdSelectionSettings.ResourceType", yJ);
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$companion_ad_selection_settings.CompanionAdSelectionSettings.SizeCriteria", zJ);
    var CJ = function (a, b) {
            b = b === void 0 ? new AJ() : b;
            this.g = a;
            this.settings = b ? b : new AJ();
            this.resourceType = BJ(yJ, this.settings.resourceType) ? this.settings.resourceType : "All";
            this.creativeType = BJ(xJ, this.settings.creativeType) ? this.settings.creativeType : "All";
            this.sizeCriteria = BJ(zJ, this.settings.sizeCriteria) ? this.settings.sizeCriteria : "SelectExactMatch";
            this.adSlotIds = this.settings.adSlotIds != null ? this.settings.adSlotIds : [];
            this.nearMatchPercent = typeof this.settings.nearMatchPercent === "number" && this.settings.nearMatchPercent > 0 && this.settings.nearMatchPercent <= 100 ? this.settings.nearMatchPercent : 90;
        },
        FJ = function (a, b) {
            var c = [];
            b.forEach(function (d) {
                a.settings.allowCustom &&
                    (!wb(d.getContent()) && (isNaN(d.data.sequenceNumber) || isNaN(d.data.mainAdSequenceNumber) || d.data.mainAdSequenceNumber === d.data.sequenceNumber) && DJ(a, d)
                        ? c.push(d)
                        : ((d = EJ(a, d)), d != null && !wb(d.getContent()) && c.push(d)));
            });
            return c;
        };
    CJ.prototype.Ke = function () {
        return this.resourceType;
    };
    var DJ = function (a, b) {
            var c;
            if ((c = b.getContentType() !== "Flash")) {
                if ((c = a.resourceType === "All" || a.resourceType === b.Ke())) (c = b.getContentType()), (c = c == null ? !0 : a.creativeType === "All" || a.creativeType === c);
                c && ((c = b.getAdSlotId()), (c = a.adSlotIds.length === 0 ? !0 : c != null ? a.adSlotIds.includes(c) : !1));
            }
            if (c)
                if (((c = b.getSize()), (b = !!b.data.fluidSize) || a.g.Ie)) a = b && a.g.Ie;
                else if (a.sizeCriteria === "IgnoreSize" || si(a.g.size, c)) a = !0;
                else {
                    if ((b = a.sizeCriteria === "SelectNearMatch"))
                        (b = c.width), (c = c.height), (b = b > a.g.size.width || c > a.g.size.height || b < (a.nearMatchPercent / 100) * a.g.size.width || c < (a.nearMatchPercent / 100) * a.g.size.height ? !1 : !0);
                    a = b;
                }
            else a = !1;
            return a;
        },
        EJ = function (a, b) {
            b = GJ(b);
            return b == null
                ? null
                : b.find(function (c) {
                      return DJ(a, c);
                  }) || null;
        },
        BJ = function (a, b) {
            return b != null && Bi(a, b);
        };
    function HJ(a) {
        var b = new yk();
        var c = a.jc;
        var d = c.clientWidth;
        var e = c.clientHeight;
        typeof c.getBoundingClientRect === "function" && ij(Xi(c), c) ? ((c = c.getBoundingClientRect()), (d = document.elementsFromPoint(c.x + 0.5 * d, c.y + 0.5 * e))) : (d = []);
        if ((d = IJ(d, a))) {
            a = new xk();
            c = d.getBoundingClientRect();
            e = c.y;
            c = c.x;
            var f = new vk();
            e = Cg(f, 1, e);
            e = Cg(e, 2, c);
            c = d.duration;
            var g = d.clientWidth;
            f = d.clientHeight;
            var h = new wk();
            g = Cg(h, 1, g);
            f = Cg(g, 2, f);
            c === Number.POSITIVE_INFINITY || isNaN(c) || ((g = new uk()), (c = Bg(g, 1, c)), C(a, 3, c));
            d = Number(window.getComputedStyle(d).opacity);
            e = C(a, 1, e);
            e = C(e, 2, f);
            Bg(e, 4, d);
            b = C(b, 2, a);
        } else (a = new xk()), (b = C(b, 2, a));
        return b;
    }
    function IJ(a, b) {
        if (a.length === 0) return null;
        var c = b.da.A.g,
            d,
            e,
            f = (e = (d = b.ya) == null ? void 0 : d.A.g) != null ? e : null;
        a = a.filter(function (g) {
            return g.tagName === "VIDEO" && !g.isEqualNode(c) && !g.isEqualNode(f);
        });
        return a.length > 0 ? a[0] : null;
    }
    var JJ = function (a, b) {
        this.message = a;
        this.errorCode = b;
    };
    JJ.prototype.getErrorCode = function () {
        return this.errorCode;
    };
    JJ.prototype.getMessage = function () {
        return this.message;
    };
    var KJ = new JJ("Failed to initialize ad playback element before starting ad playback.", 400),
        LJ = new JJ("The provided {0} information: {1} is invalid.", 1101);
    function MJ(a, b) {
        var c = b === void 0 ? null : b;
        var d = Ma.apply(2, arguments);
        if (!(c instanceof bI)) {
            var e = a.getErrorCode(),
                f = a.getMessage();
            if (d.length > 0) for (var g = 0; g < d.length; g++) f = f.replace(new RegExp("\\{" + g + "\\}", "ig"), d[g]);
            d = new bI("adPlayError", f, e);
            d.g = c;
            c = d;
        }
        return c;
    }
    var NJ = { fg: [], dg: 0, lg: [], uj: !1 };
    var OJ = function () {};
    OJ.getInstance = function () {
        throw Error("Must be overridden");
    };
    var PJ = function () {
        this.g = 0;
    };
    x(PJ, OJ);
    PJ.wb = void 0;
    PJ.getInstance = function () {
        return PJ.wb ? PJ.wb : (PJ.wb = new PJ());
    };
    function QJ(a, b, c, d) {
        c = c === void 0 ? null : c;
        d = d === void 0 ? {} : d;
        var e = PJ.getInstance();
        e.g === 0 && (e.g = Math.random() < 0.001 ? 2 : 1);
        e.g === 2 && ((e = {}), Mj(Object.assign({}, ((e.c = String(a)), (e.pc = String(Gj())), (e.em = c), (e.lid = b), (e.eids = J(Tm).g().join()), e), d), "esp"));
    }
    function RJ() {
        var a = window;
        var b = b === void 0 ? function () {} : b;
        return new Promise(function (c) {
            var d = function () {
                c(b());
                Rh(a, "load", d);
            };
            Qh(a, "load", d);
        });
    }
    var SJ = function () {
            this.cache = {};
        },
        UJ = function () {
            TJ || (TJ = new SJ());
            return TJ;
        },
        VJ = function (a) {
            if (a !== void 0)
                for (var b = w(Object.keys(a)), c = b.next(); !c.done; c = b.next())
                    if (((c = c.value), c.startsWith("_GESPSK")))
                        try {
                            a.removeItem(c);
                        } catch (d) {}
            TJ = new SJ();
        },
        WJ = function (a) {
            var b = mg(a, 3);
            if (!b) return 3;
            if (og(a, 2) === void 0) return 4;
            a = Date.now();
            return a > b + 2592e5 ? 2 : a > b + 432e5 ? 1 : 0;
        };
    SJ.prototype.get = function (a, b) {
        if (this.cache[a]) return { Lb: this.cache[a], success: !0 };
        var c = "";
        try {
            c = b.getItem("_GESPSK-" + a);
        } catch (g) {
            var d;
            QJ(6, a, (d = g) == null ? void 0 : d.message);
            return { Lb: null, success: !1 };
        }
        if (!c) return { Lb: null, success: !0 };
        try {
            var e = Xx(c);
            this.cache[a] = e;
            return { Lb: e, success: !0 };
        } catch (g) {
            var f;
            QJ(5, a, (f = g) == null ? void 0 : f.message);
            return { Lb: null, success: !1 };
        }
    };
    SJ.prototype.set = function (a, b) {
        var c = og(a, 1),
            d = "_GESPSK-" + c;
        Wx(a);
        try {
            b.setItem(d, Ig(a));
        } catch (f) {
            var e;
            QJ(7, c, (e = f) == null ? void 0 : e.message);
            return !1;
        }
        this.cache[c] = a;
        return !0;
    };
    SJ.prototype.remove = function (a, b) {
        a = og(a, 1);
        try {
            b.removeItem("_GESPSK-" + a), delete this.cache[a];
        } catch (d) {
            var c;
            QJ(8, a, (c = d) == null ? void 0 : c.message);
        }
    };
    var TJ = null;
    function XJ(a) {
        var b = new $x();
        QJ(56, "", null);
        if (a) {
            var c = [],
                d = RegExp("^_GESPSK-(.+)$");
            try {
                for (var e = 0; e < a.length; e++) {
                    var f = (d.exec(a.key(e)) || [])[1];
                    f && c.push(f);
                }
            } catch (k) {}
            c = w(c);
            e = c.next();
            for (d = {}; !e.done; d = { Yb: void 0 }, e = c.next())
                if (((d.Yb = e.value), (e = UJ().get(d.Yb, a).Lb) && !YJ(b, d.Yb) && ((f = WJ(e)), f !== 2 && f !== 3))) {
                    zg(e, 9, !1);
                    if ((f = og(e, 2)) && f.length > 1024) {
                        var g = {};
                        QJ(55, d.Yb, null, ((g.sl = String(f.length)), g));
                        f = e.ab(Sx(108));
                        If(f, 2);
                    }
                    lg(b, 2, Ux, e);
                    e = og(e, 2);
                    g = f = void 0;
                    var h = {};
                    QJ(19, d.Yb, null, ((h.hs = e ? "1" : "0"), (h.sl = String((g = (f = e) == null ? void 0 : f.length) != null ? g : -1)), h));
                }
        }
        if (!gg(b, Ux, 2, Jf()).length) return null;
        a = {};
        QJ(50, "", null, ((a.ns = String(gg(b, Ux, 2, Jf()).length)), a));
        return Sc(b.g(), 3);
    }
    function YJ(a, b) {
        return gg(a, Ux, 2, Jf()).some(function (c) {
            return og(c, 1) === b && og(c, 2) != null;
        });
    }
    var ZJ = function () {
        var a = this;
        this.promise = new Promise(function (b, c) {
            a.resolve = b;
            a.reject = c;
        });
    };
    var $J = function (a) {
        a = Error.call(this, a);
        this.message = a.message;
        "stack" in a && (this.stack = a.stack);
        Object.setPrototypeOf(this, $J.prototype);
        this.name = "InputError";
    };
    x($J, Error);
    var aK = function () {
            this.nb = !1;
        },
        bK = function () {
            aK.apply(this, arguments);
            this.cd = new ZJ();
        };
    x(bK, aK);
    var cK = function (a, b) {
        a.nb || ((a.nb = !0), (a.bd = b), a.cd.resolve(b));
    };
    ea.Object.defineProperties(bK.prototype, {
        promise: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return this.cd.promise;
            },
        },
        cf: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return this.nb;
            },
        },
        error: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return this.Td;
            },
        },
    });
    var dK = function () {
        bK.apply(this, arguments);
    };
    x(dK, bK);
    var eK = function (a, b) {
            cK(a, b);
        },
        fK = function (a, b) {
            b.then(function (c) {
                cK(a, c);
            });
        };
    dK.prototype.ab = function (a) {
        this.nb || ((this.nb = !0), (this.bd = null), (this.Td = a), this.cd.reject(a));
    };
    var gK = function (a) {
        this.nb = !1;
        this.g = a;
    };
    x(gK, aK);
    gK.prototype.cf = function () {
        return this.g.nb;
    };
    ea.Object.defineProperties(gK.prototype, {
        error: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return this.g.Td;
            },
        },
    });
    var hK = function (a) {
        gK.call(this, a);
        this.g = a;
    };
    x(hK, gK);
    ea.Object.defineProperties(hK.prototype, {
        value: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return this.g.bd;
            },
        },
    });
    var iK = function (a) {
        gK.call(this, a);
        this.g = a;
    };
    x(iK, gK);
    ea.Object.defineProperties(iK.prototype, {
        value: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                var a;
                return (a = this.g.bd) != null ? a : null;
            },
        },
    });
    var jK = function () {
        bK.apply(this, arguments);
    };
    x(jK, bK);
    jK.prototype.notify = function () {
        cK(this, null);
    };
    var kK = function () {
        Q.apply(this, arguments);
        this.g = [];
        this.j = [];
        this.l = [];
    };
    x(kK, Q);
    var lK = function (a, b) {
        a.j.push({ xc: !1, Bd: b });
    };
    kK.prototype.xc = function (a) {
        var b = this.j.find(function (c) {
            return c.Bd === a;
        });
        b && (b.xc = !0);
    };
    kK.prototype.O = function () {
        this.g.length = 0;
        this.l.length = 0;
        this.j.length = 0;
        Q.prototype.O.call(this);
    };
    function mK(a, b) {
        var c, d;
        return La(function (e) {
            if (e.g == 1)
                return (
                    (c = b
                        ? a.filter(function (f) {
                              return !f.xc;
                          })
                        : a),
                    Aa(
                        e,
                        Promise.all(
                            c.map(function (f) {
                                return f.Bd.promise;
                            })
                        ),
                        2
                    )
                );
            if (a.length === c.length) return e.return();
            d = a.filter(function (f) {
                return f.xc;
            });
            return Aa(
                e,
                Promise.race([
                    Promise.all(
                        d.map(function (f) {
                            return f.Bd.promise;
                        })
                    ),
                    new Promise(function (f) {
                        return void setTimeout(f, b);
                    }),
                ]),
                0
            );
        });
    }
    var nK = function (a, b) {
        Q.call(this);
        this.id = a;
        this.timeoutMs = b;
        this.A = !1;
        this.g = new kK();
        Er(this, this.g);
    };
    x(nK, Q);
    nK.prototype.start = function () {
        var a = this,
            b,
            c;
        return La(function (d) {
            if (d.g == 1) {
                if (a.A) return d.return();
                a.A = !0;
                d.l = 2;
                return Aa(d, mK(a.g.j, (b = a.K) != null ? b : a.timeoutMs), 4);
            }
            if (d.g != 2) {
                if (!a.Ea()) {
                    for (var e = 0, f = w(a.g.l), g = f.next(); !g.done; g = f.next()) {
                        if (g.value.g.bd == null) throw Error("missing input: " + a.id + "/" + e);
                        ++e;
                    }
                    a.j();
                }
                return Ca(d);
            }
            c = Da(d);
            if (a.Ea()) return d.return();
            if (!(c instanceof $J) && c instanceof Error && (a.D ? a.D(a.id, c) : a.B(a.id, c), a.g.g.length))
                for (e = new $J(c.message), f = w(a.g.g), g = f.next(); !g.done; g = f.next())
                    if (((g = g.value), !g.cf)) {
                        var h = e;
                        g.nb = !0;
                        g.Td = h;
                        g.cd.reject(h);
                    }
            d.g = 0;
        });
    };
    var oK = function (a) {
            var b = b === void 0 ? new dK() : b;
            a.g.g.push(b);
            return b;
        },
        pK = function (a) {
            var b = b === void 0 ? new jK() : b;
            a.g.g.push(b);
            return b;
        },
        qK = function (a, b) {
            lK(a.g, b);
            b = new hK(b);
            a.g.l.push(b);
            return b;
        },
        rK = function (a, b) {
            lK(a.g, b);
            return new iK(b);
        };
    var sK = function () {
        Q.call(this);
        this.o = [];
        this.B = [];
        this.A = {};
        this.g = [];
        this.j = new ZJ();
        this.l = {};
    };
    x(sK, Q);
    var tK = function (a, b) {
            Er(a, b);
            a.o.push(b);
        },
        uK = function (a, b) {
            b = w(b);
            for (var c = b.next(); !c.done; c = b.next()) tK(a, c.value);
        },
        vK = function (a) {
            var b, c, d, e, f, g, h, k, m, n, p, q;
            La(function (t) {
                switch (t.g) {
                    case 1:
                        if (!a.g.length) {
                            t.g = 2;
                            break;
                        }
                        return Aa(
                            t,
                            Promise.all(
                                a.g.map(function (u) {
                                    return u.j.promise;
                                })
                            ),
                            2
                        );
                    case 2:
                        b = w(a.o);
                        for (c = b.next(); !c.done; c = b.next()) (d = c.value), d.start();
                        e = w(a.B);
                        for (f = e.next(); !f.done; f = e.next()) (g = f.value), vK(g);
                        if (!a.l) {
                            t.g = 4;
                            break;
                        }
                        h = Object.keys(a.l);
                        if (!h.length) {
                            t.g = 4;
                            break;
                        }
                        return Aa(
                            t,
                            Promise.all(
                                Object.values(a.l).map(function (u) {
                                    return u.promise;
                                })
                            ),
                            6
                        );
                    case 6:
                        for (k = t.j, m = 0, n = w(h), p = n.next(); !p.done; p = n.next()) (q = p.value), (a.A[q] = k[m++]);
                    case 4:
                        return a.j.resolve(a.A), t.return(a.j.promise);
                }
            });
        };
    sK.prototype.O = function () {
        Q.prototype.O.call(this);
        this.o.length = 0;
        this.B.length = 0;
        this.g.length = 0;
    };
    var wK = function (a, b) {
        nK.call(this, a);
        this.id = a;
        this.B = b;
    };
    x(wK, nK);
    var xK = function (a, b, c, d) {
        wK.call(this, 1041, d);
        this.storage = b;
        this.o = qK(this, a);
        c && (this.l = rK(this, c));
    };
    x(xK, wK);
    xK.prototype.j = function () {
        var a = this.o.value,
            b,
            c,
            d = (c = this.storage) != null ? c : (b = this.l) == null ? void 0 : b.value;
        d && UJ().set(a, d) && og(a, 2) != null && QJ(27, og(a, 1));
    };
    var yK = function (a, b) {
        wK.call(this, 1094, b);
        this.l = pK(this);
        this.o = qK(this, a);
    };
    x(yK, wK);
    yK.prototype.j = function () {
        var a = this.o.value;
        a && (VJ(a), this.l.notify());
    };
    var zK = function (a, b) {
        wK.call(this, 1048, b);
        this.l = oK(this);
        this.o = oK(this);
        this.C = qK(this, a);
    };
    x(zK, wK);
    zK.prototype.j = function () {
        var a = this.C.value,
            b = function (c) {
                var d = {};
                QJ(c, og(a, 1), null, ((d.tic = String(Math.round((Date.now() - mg(a, 3)) / 6e4))), d));
            };
        switch (WJ(a)) {
            case 0:
                b(24);
                break;
            case 1:
                b(25);
                cK(this.o, a);
                break;
            case 2:
                b(26);
                cK(this.l, a);
                break;
            case 3:
                QJ(9, og(a, 1));
                cK(this.l, a);
                break;
            case 4:
                b(23), cK(this.l, a);
        }
    };
    var AK = function (a, b, c) {
        wK.call(this, 1027, c);
        this.Cc = a;
        this.storage = b;
        this.l = oK(this);
        this.o = oK(this);
    };
    x(AK, wK);
    AK.prototype.j = function () {
        var a = UJ().get(this.Cc, this.storage).Lb;
        if (!a) {
            a = Wx(Vx(this.Cc));
            var b = this.o,
                c = a.ab(Sx(100));
            cK(b, c);
        }
        cK(this.l, a);
    };
    var BK = function (a, b, c) {
        wK.call(this, 1046, c);
        this.output = pK(this);
        this.l = oK(this);
        this.o = qK(this, b);
        lK(this.g, a);
    };
    x(BK, wK);
    BK.prototype.j = function () {
        cK(this.l, this.o.value);
    };
    var CK = function (a, b, c) {
        wK.call(this, 1047, c);
        this.collectorFunction = a;
        this.l = oK(this);
        this.o = oK(this);
        this.C = oK(this);
        this.G = qK(this, b);
    };
    x(CK, wK);
    CK.prototype.j = function () {
        var a = this,
            b = this.G.value,
            c = og(b, 1);
        QJ(18, c);
        try {
            var d = ql();
            this.collectorFunction()
                .then(function (e) {
                    QJ(29, c, null, { delta: String(ql() - d) });
                    var f = a.l,
                        g = Eg(b, 2, e);
                    cK(f, g);
                    cK(a.C, e != null ? e : null);
                })
                .catch(function (e) {
                    QJ(28, c, DK(e));
                    e = a.o;
                    var f = b.ab(Sx(106));
                    cK(e, f);
                });
        } catch (e) {
            QJ(1, c, DK(e)), eK(this.o, b.ab(Sx(107)));
        }
    };
    function DK(a) {
        return typeof a === "string" ? a : a instanceof Error ? a.message : null;
    }
    var EK = function (a, b) {
        wK.call(this, 1028, b);
        this.l = oK(this);
        this.o = qK(this, a);
    };
    x(EK, wK);
    EK.prototype.j = function () {
        var a = this.o.value,
            b = og(a, 1);
        mg(a, 3) != null || QJ(35, b);
        cK(this.l, a);
    };
    var FK = function (a, b, c, d) {
        wK.call(this, 1050, d);
        this.C = c;
        this.l = oK(this);
        this.o = qK(this, a);
        this.G = rK(this, b);
    };
    x(FK, wK);
    FK.prototype.j = function () {
        var a = this.o.value,
            b = og(a, 1),
            c = this.G.value;
        if (c == null) QJ(41, b), a.ab(Sx(111)), cK(this.l, a);
        else if (typeof c !== "string") QJ(21, b), (b = this.l), (a = a.ab(Sx(113))), cK(b, a);
        else {
            if (c.length > this.C) {
                var d = {};
                QJ(12, b, null, ((d.sl = String(c.length)), d));
                b = a.ab(Sx(108));
                If(b, 2);
            } else c.length || QJ(20, b), If(a, 10);
            cK(this.l, a);
        }
    };
    var GK = function (a) {
        wK.call(this, 1046, a);
        this.output = pK(this);
    };
    x(GK, wK);
    GK.prototype.j = function () {
        var a = this;
        RJ().then(function () {
            a.output.notify();
        });
    };
    function HK(a, b, c, d, e) {
        var f, g, h, k, m, n, p, q, t, u, v, E, P;
        return La(function (S) {
            return S.g == 1
                ? ((f = new sK()),
                  (g = new AK(a, c, e)),
                  tK(f, g),
                  tK(f, new xK(g.o, void 0, d, e)),
                  (h = new EK(g.l, e)),
                  tK(f, h),
                  (k = new zK(h.l, e)),
                  tK(f, k),
                  (m = new CK(b, k.l, e)),
                  tK(f, m),
                  tK(f, new xK(m.o, void 0, d, e)),
                  (n = new FK(m.l, m.C, 1024, e)),
                  tK(f, n),
                  tK(f, new xK(n.l, void 0, d, e)),
                  (p = new GK(e)),
                  tK(f, p),
                  (q = new BK(p.output, k.o, e)),
                  tK(f, q),
                  (t = new CK(b, q.l, e)),
                  tK(f, t),
                  (u = new xK(t.l, void 0, d, e)),
                  tK(f, u),
                  vK(f),
                  (P = a),
                  Aa(S, n.l.promise, 2))
                : S.return({ id: P, collectorGeneratedData: (E = (v = S.j) == null ? void 0 : og(v, 2)) != null ? E : null });
        });
    }
    var IK = function (a, b, c, d) {
        wK.call(this, 1059, d);
        this.G = b;
        this.C = c;
        this.l = oK(this);
        this.I = qK(this, a);
        this.o = rK(this, c);
    };
    x(IK, wK);
    IK.prototype.j = function () {
        var a = this.o.value;
        if (a) {
            var b = this.I.value,
                c = b.id,
                d = b.collectorFunction,
                e;
            b = (e = b.networkCode) != null ? e : c;
            c = {};
            QJ(42, b, null, ((c.ea = String(Number(this.G))), c));
            fK(this.l, HK(b, d, a, this.C, this.B));
        }
    };
    var JK = function (a, b, c) {
        c = c === void 0 ? NJ : c;
        wK.call(this, 1057, b);
        this.l = a;
        this.G = c;
        this.o = oK(this);
        this.C = oK(this);
    };
    x(JK, wK);
    JK.prototype.j = function () {
        if (this.l)
            if (typeof this.l !== "object") QJ(46, "UNKNOWN_COLLECTOR_ID"), KK(this, "UNKNOWN_COLLECTOR_ID", 112);
            else {
                var a = this.l.id,
                    b = this.l.networkCode;
                a && b && (delete this.l.id, QJ(47, a + ";" + b));
                a = b != null ? b : a;
                typeof a !== "string"
                    ? ((b = {}), QJ(37, "INVALID_COLLECTOR_ID", null, ((b.ii = JSON.stringify(a)), b)), KK(this, "INVALID_COLLECTOR_ID", 102))
                    : typeof this.l.collectorFunction !== "function"
                    ? (QJ(14, a), KK(this, a, 105))
                    : this.G.lg.includes(a)
                    ? (QJ(22, a), KK(this, a, 104))
                    : cK(this.C, this.l);
            }
        else QJ(39, "UNKNOWN_COLLECTOR_ID"), KK(this, "UNKNOWN_COLLECTOR_ID", 110);
    };
    var KK = function (a, b, c) {
        a = a.o;
        b = Vx(b).ab(Sx(c));
        cK(a, b);
    };
    var LK = function (a, b, c, d, e) {
        var f = document;
        f = f === void 0 ? document : f;
        e = e === void 0 ? NJ : e;
        this.j = b;
        this.o = c;
        this.A = f;
        this.L = d;
        this.g = e;
        this.J = [];
        this.C = [];
        this.B = [];
        this.l = 0;
        a = w(a);
        for (b = a.next(); !b.done; b = a.next()) this.push(b.value);
    };
    LK.prototype.push = function (a) {
        var b = this;
        this.o || this.L();
        var c = function (f, g) {
            return void MK(b, f, g);
        };
        a = new JK(a, c, this.g);
        var d = new xK(a.o, void 0, this.j, c);
        c = new IK(a.C, this.o, this.j, c, this.g);
        var e = new sK();
        uK(e, [a, d, c]);
        vK(e);
        a = c.l.promise;
        this.J.push(a);
        d = w(this.C);
        for (c = d.next(); !c.done; c = d.next()) a.then(c.value);
    };
    LK.prototype.addOnSignalResolveCallback = function (a) {
        this.C.push(a);
        for (var b = w(this.J), c = b.next(); !c.done; c = b.next()) c.value.then(a);
    };
    LK.prototype.addErrorHandler = function (a) {
        this.B.push(a);
    };
    LK.prototype.clearAllCache = function () {
        var a = this,
            b = this.A.currentScript instanceof HTMLScriptElement ? this.A.currentScript.src : "";
        if (this.l === 1) {
            var c = {};
            QJ(49, "", null, ((c.url = b), c));
        } else if (this.g.fg.includes(String(zj(b != null ? b : "")))) (c = {}), QJ(48, "", null, ((c.url = b), c));
        else {
            var d = new sK();
            c = new yK(this.j, function (e, f) {
                return void MK(a, e, f);
            });
            tK(d, c);
            vK(d);
            this.l = 1;
            setTimeout(function () {
                a.l = 0;
            }, this.g.dg * 1e3);
            d = {};
            QJ(43, "", null, ((d.url = b), d));
            return c.l.promise;
        }
    };
    var MK = function (a, b, c) {
            a = w(a.B);
            for (var d = a.next(); !d.done; d = a.next()) (d = d.value), d(b, c);
        },
        NK = function (a) {
            this.push = function (b) {
                a.push(b);
            };
            this.addOnSignalResolveCallback = function (b) {
                a.addOnSignalResolveCallback(b);
            };
            this.addErrorHandler = function (b) {
                a.addErrorHandler(b);
            };
            this.clearAllCache = function () {
                a.clearAllCache();
            };
        };
    function OK(a, b, c, d, e, f) {
        f = f === void 0 ? NJ : f;
        vj() !== wj()
            ? QJ(16, "")
            : (PK(a, "encryptedSignalProviders", c, e) && PK(a, "secureSignalProviders", c, e)) || (QJ(38, ""), QK(a, "encryptedSignalProviders", b, f, c, d, e), QK(a, "secureSignalProviders", b, f, c, function () {}, e));
    }
    function PK(a, b, c, d) {
        if (a[b] === void 0 || a[b] instanceof Array) return !1;
        a = a[b];
        d && a.addOnSignalResolveCallback(d);
        a.addErrorHandler(c);
        return !0;
    }
    function QK(a, b, c, d, e, f, g) {
        var h,
            k = new LK((h = a[b]) != null ? h : [], c, b === "secureSignalProviders", f, d);
        a[b] = new NK(k);
        g && k.addOnSignalResolveCallback(g);
        k.addErrorHandler(e);
    }
    function EN(a, b, c, d, e) {
        var f = f === void 0 ? NJ : f;
        var g = new dK();
        cK(g, b);
        OK(a, g, c, d, e, f);
    }
    function FN(a, b, c, d) {
        var e = GN,
            f = new Map();
        b = b.map(function (g) {
            var h = g.Cc;
            return new Promise(function (k) {
                f.set(h, k);
            });
        });
        EN(a, c, d, e, function (g) {
            var h = g.collectorGeneratedData;
            g = g.id;
            var k;
            return void ((k = f.get(g)) == null ? void 0 : k({ collectorGeneratedData: h, id: g }));
        });
        return b;
    }
    function HN() {
        var a;
        return (a = y.googletag) != null ? a : (y.googletag = { cmd: [] });
    }
    function IN(a) {
        if (!a || DI(a)) return null;
        try {
            return window.localStorage;
        } catch (b) {
            return null;
        }
    }
    function JN(a, b) {
        (a = IN(a)) && EN(HN(), a, function () {}, GN, b);
    }
    function KN(a, b) {
        return (b = IN(b)) && a.length !== 0 ? FN(HN(), a, b, function () {}) : null;
    }
    function GN() {}
    function LN(a, b, c, d) {
        var e = new ZJ(),
            f = "",
            g = function (k) {
                try {
                    var m = typeof k.data === "object" ? k.data : JSON.parse(k.data);
                    f === m.paw_id && (Rh(a, "message", g), m.error ? e.reject(Error(m.error)) : e.resolve(d(m)));
                } catch (n) {}
            },
            h = MN(a);
        return h ? (Qh(a, "message", g), (f = c(h)), e.promise) : (c = NN(a)) ? ((f = String(Math.floor(xj() * 2147483647))), Qh(a, "message", g), b(c, f), e.promise) : null;
    }
    function ON(a) {
        return LN(
            a,
            function (b, c) {
                var d, e;
                return void ((d = (e = b.getGmaQueryInfo) != null ? e : b.getGmaSig) == null ? void 0 : d.postMessage(c));
            },
            function (b) {
                return b.getQueryInfo();
            },
            function (b) {
                return b.signal;
            }
        );
    }
    function PN() {
        var a = window;
        return !!MN(a) || !!NN(a);
    }
    function MN(a) {
        var b;
        if (typeof ((b = a.gmaSdk) == null ? void 0 : b.getQueryInfo) === "function") return a.gmaSdk;
    }
    function NN(a) {
        var b, c, d, e, f, g;
        if (
            typeof ((b = a.webkit) == null ? void 0 : (c = b.messageHandlers) == null ? void 0 : (d = c.getGmaQueryInfo) == null ? void 0 : d.postMessage) === "function" ||
            typeof ((e = a.webkit) == null ? void 0 : (f = e.messageHandlers) == null ? void 0 : (g = f.getGmaSig) == null ? void 0 : g.postMessage) === "function"
        )
            return a.webkit.messageHandlers;
    }
    (function (a) {
        return Dd(function (b) {
            if (!Hd(b)) return !1;
            for (var c = w(Object.entries(a)), d = c.next(); !d.done; d = c.next()) {
                var e = w(d.value);
                d = e.next().value;
                e = e.next().value;
                if (!(d in b)) {
                    if (e.Kg === !0) continue;
                    return !1;
                }
                if (!e(b[d])) return !1;
            }
            return !0;
        });
    })(
        {
            vc: Fd,
            pn: Fd,
            eid: Fd,
            vnm: (function (a) {
                return Id(
                    Dd(function (b, c) {
                        return b === void 0 ? !0 : a(b, c);
                    })
                );
            })(Fd),
            js: Fd,
        },
        "RawGmaSdkStaticSignalObject"
    );
    var QN = function () {
            this.timeoutMs = 500;
            this.j = ON;
            this.signal = null;
            this.g = 0;
        },
        RN = function (a) {
            if (Wm(sn) || !PN()) return Promise.resolve(null);
            var b;
            return ((b = a.j(window)) != null ? b : Promise.resolve(null)).catch(function () {
                return "0";
            });
        },
        TN = function (a) {
            var b;
            return La(function (c) {
                if (c.g == 1) return (b = Date.now() - a.g), !a.signal || b > 3e5 ? (c = Aa(c, SN(a), 3)) : ((c.g = 2), (c = void 0)), c;
                c.g != 2 && ((a.signal = c.j), (a.g = Date.now()));
                return c.return(a.signal);
            });
        },
        SN = function (a) {
            return Promise.race([
                RN(a).then(function (b) {
                    if (b == null) return null;
                    a.signal = b.length > 1e4 ? "0" : b;
                    a.g = Date.now();
                    return a.signal;
                }),
                Qw(a.timeoutMs, "0"),
            ]);
        };
    function Rl(a, b) {
        return b instanceof RegExp ? "__REGEXP" + b.toString() : b;
    }
    function UN(a, b) {
        return b && b.toString().indexOf("__REGEXP") === 0 ? ((a = b.split("__REGEXP")[1].match(/\/(.*)\/(.*)?/)), new RegExp(a[1], a[2] || "")) : b;
    }
    var VN = function (a, b) {
        uJ.call(this, b);
        this.B = a;
        this.g = null;
        this.C = new gE(this);
        this.C.listen(dj(), "message", this.D);
    };
    x(VN, uJ);
    var WN = function (a) {
        if (a == null || typeof a !== "string" || !a.startsWith("ima://")) return null;
        a = a.substr(6);
        try {
            return JSON.parse(a, UN);
        } catch (b) {
            return null;
        }
    };
    VN.prototype.sendMessage = function (a) {
        if (this.g != null && this.g.postMessage != null) {
            var b = this.g,
                c = b.postMessage,
                d = {};
            d.name = a.name;
            d.type = a.type;
            a.data != null && (d.data = a.data);
            a.id && (d.id = a.id);
            a.g && (d.replyToMessageId = a.g);
            d.sid = this.l;
            d.channel = this.B;
            a = [];
            Tl(new Sl(), d, a);
            c.call(b, "ima://" + a.join(""), "*");
        }
        this.g != null && this.g.postMessage == null && X.getInstance().report(11);
    };
    VN.prototype.O = function () {
        Cr(this.C);
        this.g = null;
        uJ.prototype.O.call(this);
    };
    VN.prototype.D = function (a) {
        a = a.g;
        var b = WN(a.data);
        if (XN(this, b)) {
            if (this.g === null) (this.g = a.source), this.j || this.connect();
            else if (this.g !== a.source) return;
            XN(this, b) && this.dispatchEvent(new wJ(b.name, b.type, b.data || {}, b.sid, a.origin, b.id, b.replyToMessageId));
        }
    };
    var XN = function (a, b) {
        if (b == null) return !1;
        var c = b.channel;
        if (c == null || c !== a.B) return !1;
        b = b.sid;
        return b == null || (a.l !== "*" && b !== a.l) ? !1 : !0;
    };
    var YN = function () {
        R.call(this);
        this.G = !1;
        this.g = null;
        this.B = this.D = this.M = !1;
        this.j = 0;
        this.A = [];
        this.C = !1;
        this.U = this.P = Infinity;
        this.l = 0;
        this.I = {};
        this.K = new gE(this);
        Er(this, this.K);
    };
    x(YN, R);
    var $N = function (a, b) {
            b == null || a.G || ((a.g = b), ZN(a), (a.G = !0));
        },
        bO = function (a) {
            a.g != null && a.G && (aO(a), (a.G = !1), (a.D = !1), (a.B = !1), (a.j = 0), (a.A = []), (a.C = !1));
        },
        ZN = function (a) {
            aO(a);
            !(a.g instanceof R) && "ontouchstart" in document.documentElement && Bc
                ? ((a.I = {
                      touchstart: function (b) {
                          a.D = !0;
                          a.j = b.touches.length;
                          a.l && (window.clearTimeout(a.l), (a.l = 0), (a.M = !0));
                          a.C = cO(a, b.touches) || b.touches.length !== 1;
                          a.C ? ((a.P = Infinity), (a.U = Infinity)) : ((a.P = b.touches[0].clientX), (a.U = b.touches[0].clientY));
                          b = b.touches;
                          a.A = [];
                          for (var c = 0; c < b.length; c++) a.A.push(b[c].identifier);
                      },
                      touchmove: function (b) {
                          a.j = b.touches.length;
                          if (!RD(8) || Math.pow(b.changedTouches[0].clientX - a.P, 2) + Math.pow(b.changedTouches[0].clientY - a.U, 2) > 25) a.B = !0;
                      },
                      touchend: function (b) {
                          return void dO(a, b);
                      },
                  }),
                  ti(a.I, function (b, c) {
                      a.g.addEventListener(c, b, !1);
                  }))
                : a.K.listen(a.g, "click", a.V);
        },
        aO = function (a) {
            a.K.sb(a.g, "click", a.V);
            ti(
                a.I,
                function (b, c) {
                    this.g.removeEventListener(c, b, !1);
                },
                a
            );
            a.I = {};
        },
        dO = function (a, b) {
            !a.D ||
                a.j !== 1 ||
                a.B ||
                a.M ||
                a.C ||
                !cO(a, b.changedTouches) ||
                (a.l = window.setTimeout(function () {
                    return void eO(a);
                }, 300));
            a.j = b.touches.length;
            a.j === 0 && ((a.D = !1), (a.B = !1), (a.A = []));
            a.M = !1;
        };
    YN.prototype.V = function () {
        eO(this);
    };
    var cO = function (a, b) {
            for (var c = 0; c < b.length; c++) if (a.A.includes(b[c].identifier)) return !0;
            return !1;
        },
        eO = function (a) {
            a.l = 0;
            a.dispatchEvent(new Kv("click"));
        };
    YN.prototype.O = function () {
        bO(this);
        R.prototype.O.call(this);
    };
    var gO = function () {
            var a = fO;
            return La(function (b) {
                return b.g == 1 ? Aa(b, a.g.promise, 2) : b.return({ serializedConfig: a.serializedConfig, errorMessage: a.j, latencyMs: a.l });
            });
        },
        kO = function () {
            var a = hO,
                b = iO,
                c = Date.now(),
                d = a.o();
            d.timeout = 6e4;
            d.open("GET", b, !0);
            d.onload = function () {
                a.l = Date.now() - c;
                d.status < 200 || d.status >= 300 ? jO(a, Error("status: " + d.status)) : ((a.j = null), (a.serializedConfig = d.responseText), a.g.resolve());
            };
            d.onerror = function () {
                a.l = Date.now() - c;
                jO(a, Error("status: " + d.status));
            };
            d.send();
        },
        jO = function (a, b) {
            a.serializedConfig = null;
            a.j = b.message;
            a.g.resolve();
        },
        fO = new (function () {
            this.o = function () {
                return new XMLHttpRequest();
            };
            this.g = new ZJ();
            this.j = this.serializedConfig = null;
            this.l = 0;
        })();
    function lO() {
        var a = mO;
        var b = a.appName;
        var c = a.Se;
        a = a.pageUrl;
        var d = new URL("https://securepubads.g.doubleclick.net/pagead/ima_ppub_config");
        return b && c ? (c === "android" ? d.searchParams.set("msid", b) : c === "ios" && d.searchParams.set("an", b), d.toString()) : a ? (d.searchParams.set("ippd", a), d.toString()) : null;
    }
    function nO(a, b, c) {
        var d, e, f;
        a = ((f =
            (d = eg(a, Nx, 2)) == null
                ? void 0
                : (e = gg(d, Mx, 1, Jf())) == null
                ? void 0
                : e.map(function (g) {
                      return D(g, 1);
                  })) != null
            ? f
            : []
        ).some(function (g) {
            return g === b;
        });
        X.getInstance().report(190, { fm: a, fl: c });
    }
    function oO(a, b) {
        if (!a || !b) return !1;
        var c;
        return !(
            (c = eg(a, Lx, 5)) == null ||
            !gg(c, Kx, 1, Jf()).find(function (d) {
                return (d == null ? void 0 : D(d, 1)) === b && (d == null ? void 0 : pg(d, 2));
            })
        );
    }
    var pO = function (a, b) {
        Q.call(this);
        var c = this;
        this.g = a;
        this.j = new Map();
        this.l = function (d) {
            var e = c.j.get(d.messageType);
            if (e) {
                var f = "goog_" + Ri++,
                    g = d.getId();
                e(d.na).then(function (h) {
                    vJ(c.g, d.type, d.messageType, h, f, g);
                });
            }
        };
        this.g.listen(b, this.l);
        Dr(this, function () {
            c.j.clear();
            c.g.sb(b, c.l);
        });
    };
    x(pO, Q);
    var qO = "abort canplay canplaythrough durationchange emptied loadstart loadeddata loadedmetadata progress ratechange seeked seeking stalled suspend waiting".split(" ");
    var rO = function (a, b) {
        Q.call(this);
        this.g = a;
        this.timeoutMs = b;
        Er(this, this.g);
    };
    x(rO, Q);
    var tO = function (a) {
            if (!wC(a.g.caller)) return Promise.resolve(null);
            var b = new ZJ(),
                c = null;
            a.g.addEventListener(function (e) {
                if (e.pingData.internalErrorState === 1) b.resolve(null);
                else if (e.eventName === "listenerRegistered") (c = e.listenerId), e.pingData.applicableSections.length === 1 && e.pingData.applicableSections[0] === -1 && b.resolve(new sO("", "-1"));
                else if (e.eventName === "signalStatus" && e.data === "ready") {
                    e = e.pingData;
                    var f,
                        g = ((f = e.applicableSections) != null ? f : []).join("_");
                    b.resolve(new sO(e.gppString, g));
                }
            });
            var d = new Promise(function (e) {
                setTimeout(function () {
                    e(null);
                }, a.timeoutMs);
            });
            d = Promise.race([b.promise, d]);
            d.then(function () {
                c !== null && a.g.removeEventListener(c);
            });
            return d;
        },
        sO = function (a, b) {
            this.gppString = a;
            this.sid = b;
        };
    var uO = ka(["https://pagead2.googlesyndication.com/omsdk/releases/live/omweb-v1.js"]),
        vO = ka(["https://pagead2.googlesyndication.com/omsdk/releases/control/omweb-v1.js"]),
        wO = ka(["https://pagead2.googlesyndication.com/omsdk/releases/canary/omweb-v1.js"]),
        xO = ka(["https://pagead2.googlesyndication.com/omsdk/releases/experimental/omweb-v1.js"]),
        yO = oi(uO),
        zO = oi(vO),
        AO = oi(wO),
        BO = oi(xO);
    function CO(a) {
        var b;
        return (b = a.omidSessionInterface) != null ? b : null;
    }
    function DO(a) {
        var b, c, d, e, f, g;
        return La(function (h) {
            if (h.g == 1)
                return (
                    (b = gj("IFRAME", { style: "display: none", title: "Advertisement" })),
                    (c = new Promise(function (k) {
                        b.addEventListener("load", function () {
                            k();
                        });
                    })),
                    a.appendChild(b),
                    Aa(h, c, 2)
                );
            d = gj("SCRIPT");
            e = EO();
            Ki(d, e);
            f = new Promise(function (k, m) {
                d.addEventListener("load", function () {
                    var n = jj(b);
                    n && CO(n) ? k(b) : m();
                });
            });
            g = b.contentDocument || b.contentWindow.document;
            g.head.appendChild(d);
            return h.return(f);
        });
    }
    function FO() {
        var a, b, c, d, e, f;
        return La(function (g) {
            a = window;
            if (CO(a)) return g.return(a);
            b = document.head.querySelector('script[src*="omweb-v1.js"');
            d = (c = b) != null ? c : ej(document, "SCRIPT");
            e = new Promise(function (h, k) {
                d.addEventListener("load", function () {
                    CO(a) ? h(a) : k();
                });
            });
            b || ((f = EO()), Ki(d, f), document.head.appendChild(d));
            return g.return(e);
        });
    }
    function EO() {
        switch (J(ko).j(lC.g, lC.defaultValue)) {
            case 0:
                return yO;
            case 1:
                return zO;
            case 2:
                return AO;
            case 3:
                return BO;
            default:
                return yO;
        }
    }
    var GO = function (a, b) {
        R.call(this);
        this.j = b;
        this.g = CO(a);
    };
    x(GO, R);
    var IO = function (a) {
            try {
                a.g &&
                    a.g.registerSessionObserver(function (b) {
                        b.type === "sessionStart" ? HO(a, a.j) : b.type === "sessionFinish" && IO(a);
                    });
            } catch (b) {
                a.dispatchEvent(new Event("error"));
            }
        },
        HO = function (a, b) {
            b instanceof tH && (b = b.T);
            var c;
            if (((c = b.tagName) == null ? void 0 : c.toUpperCase()) !== "AUDIO")
                try {
                    a.g && a.g.setVideoElement(b);
                } catch (d) {
                    a.dispatchEvent(new Event("error"));
                }
        };
    var JO = function (a) {
        this.data = a;
    };
    l = JO.prototype;
    l.getTotalAds = function () {
        return this.data.totalAds;
    };
    l.getMaxDuration = function () {
        return this.data.maxDuration;
    };
    l.getAdPosition = function () {
        return this.data.adPosition;
    };
    l.getPodIndex = function () {
        return this.data.podIndex;
    };
    l.getTimeOffset = function () {
        return this.data.timeOffset;
    };
    l.getIsBumper = function () {
        return this.data.isBumper;
    };
    JO.prototype.getIsBumper = JO.prototype.getIsBumper;
    JO.prototype.getTimeOffset = JO.prototype.getTimeOffset;
    JO.prototype.getPodIndex = JO.prototype.getPodIndex;
    JO.prototype.getAdPosition = JO.prototype.getAdPosition;
    JO.prototype.getMaxDuration = JO.prototype.getMaxDuration;
    JO.prototype.getTotalAds = JO.prototype.getTotalAds;
    var KO = function (a) {
        this.data = a;
    };
    l = KO.prototype;
    l.getContent = function () {
        return this.data.content;
    };
    l.getContentType = function () {
        return this.data.contentType;
    };
    l.getWidth = function () {
        return this.getSize().width;
    };
    l.getHeight = function () {
        return this.getSize().height;
    };
    l.getAdSlotId = function () {
        return this.data.adSlotId;
    };
    l.getSize = function () {
        return this.data.size;
    };
    l.Ke = function () {
        return this.data.resourceType;
    };
    var GJ = function (a) {
        return (a = a.data.backupCompanions)
            ? a.map(function (b) {
                  return new KO(b);
              })
            : [];
    };
    KO.prototype.getAdSlotId = KO.prototype.getAdSlotId;
    KO.prototype.getHeight = KO.prototype.getHeight;
    KO.prototype.getWidth = KO.prototype.getWidth;
    KO.prototype.getContentType = KO.prototype.getContentType;
    KO.prototype.getContent = KO.prototype.getContent;
    var LO = function (a, b) {
        this.j = a;
        this.g = b;
    };
    LO.prototype.getAdIdValue = function () {
        return this.j;
    };
    LO.prototype.getAdIdRegistry = function () {
        return this.g;
    };
    LO.prototype.getAdIdRegistry = LO.prototype.getAdIdRegistry;
    LO.prototype.getAdIdValue = LO.prototype.getAdIdValue;
    var Y = function (a) {
        this.data = a;
    };
    Y.prototype.getAdId = function () {
        return this.data.adId;
    };
    Y.prototype.getCreativeAdId = function () {
        return this.data.creativeAdId;
    };
    Y.prototype.getCreativeId = function () {
        return this.data.creativeId;
    };
    var MO = function (a) {
        return a.data.adQueryId;
    };
    l = Y.prototype;
    l.getAdSystem = function () {
        return this.data.adSystem;
    };
    l.getAdvertiserName = function () {
        return this.data.advertiserName;
    };
    l.getApiFramework = function () {
        return this.data.apiFramework;
    };
    l.getWrapperAdIds = function () {
        return this.data.adWrapperIds;
    };
    l.getWrapperCreativeIds = function () {
        return this.data.adWrapperCreativeIds;
    };
    l.getWrapperAdSystems = function () {
        return this.data.adWrapperSystems;
    };
    l.isLinear = function () {
        return this.data.linear;
    };
    l.isSkippable = function () {
        return this.data.skippable;
    };
    l.getContentType = function () {
        return this.data.contentType;
    };
    l.getDescription = function () {
        return this.data.description;
    };
    l.getTitle = function () {
        return this.data.title;
    };
    l.getDuration = function () {
        return this.data.duration;
    };
    l.getVastMediaWidth = function () {
        return this.data.vastMediaWidth;
    };
    l.getVastMediaHeight = function () {
        return this.data.vastMediaHeight;
    };
    l.getWidth = function () {
        return this.data.width;
    };
    l.getHeight = function () {
        return this.data.height;
    };
    l.getUiElements = function () {
        return this.data.uiElements;
    };
    l.getMinSuggestedDuration = function () {
        return this.data.minSuggestedDuration;
    };
    l.getAdPodInfo = function () {
        return new JO(this.data.adPodInfo);
    };
    l.getCompanionAds = function (a, b, c) {
        if (!this.data.companions) return [];
        var d = this.data.companions.map(function (e) {
            return new KO(e);
        });
        return FJ(new CJ({ size: new ri(a, b), Ie: c ? c.sizeCriteria === "SelectFluid" : !1 }, c), d);
    };
    l.getTraffickingParameters = function () {
        return $D(Qi(this.data.traffickingParameters));
    };
    l.getTraffickingParametersString = function () {
        return this.data.traffickingParameters;
    };
    l.getVastMediaBitrate = function () {
        return this.data.vastMediaBitrate;
    };
    l.getMediaUrl = function () {
        return this.data.mediaUrl;
    };
    l.getSurveyUrl = function () {
        return this.data.surveyUrl;
    };
    l.getDealId = function () {
        return this.data.dealId;
    };
    l.getUniversalAdIds = function () {
        return (this.data.universalAdIds || []).map(function (a) {
            return new LO(a.adIdValue, a.adIdRegistry);
        });
    };
    l.getUniversalAdIdValue = function () {
        return this.data.universalAdIdValue;
    };
    l.getUniversalAdIdRegistry = function () {
        return this.data.universalAdIdRegistry;
    };
    l.getSkipTimeOffset = function () {
        return this.data.skipTimeOffset;
    };
    l.Oe = function () {
        return this.data.disableUi;
    };
    Y.prototype.isUiDisabled = Y.prototype.Oe;
    Y.prototype.getSkipTimeOffset = Y.prototype.getSkipTimeOffset;
    Y.prototype.getUniversalAdIdRegistry = Y.prototype.getUniversalAdIdRegistry;
    Y.prototype.getUniversalAdIdValue = Y.prototype.getUniversalAdIdValue;
    Y.prototype.getUniversalAdIds = Y.prototype.getUniversalAdIds;
    Y.prototype.getDealId = Y.prototype.getDealId;
    Y.prototype.getSurveyUrl = Y.prototype.getSurveyUrl;
    Y.prototype.getMediaUrl = Y.prototype.getMediaUrl;
    Y.prototype.getVastMediaBitrate = Y.prototype.getVastMediaBitrate;
    Y.prototype.getTraffickingParametersString = Y.prototype.getTraffickingParametersString;
    Y.prototype.getTraffickingParameters = Y.prototype.getTraffickingParameters;
    Y.prototype.getCompanionAds = Y.prototype.getCompanionAds;
    Y.prototype.getAdPodInfo = Y.prototype.getAdPodInfo;
    Y.prototype.getMinSuggestedDuration = Y.prototype.getMinSuggestedDuration;
    Y.prototype.getUiElements = Y.prototype.getUiElements;
    Y.prototype.getHeight = Y.prototype.getHeight;
    Y.prototype.getWidth = Y.prototype.getWidth;
    Y.prototype.getVastMediaHeight = Y.prototype.getVastMediaHeight;
    Y.prototype.getVastMediaWidth = Y.prototype.getVastMediaWidth;
    Y.prototype.getDuration = Y.prototype.getDuration;
    Y.prototype.getTitle = Y.prototype.getTitle;
    Y.prototype.getDescription = Y.prototype.getDescription;
    Y.prototype.getContentType = Y.prototype.getContentType;
    Y.prototype.isSkippable = Y.prototype.isSkippable;
    Y.prototype.isLinear = Y.prototype.isLinear;
    Y.prototype.getWrapperAdSystems = Y.prototype.getWrapperAdSystems;
    Y.prototype.getWrapperCreativeIds = Y.prototype.getWrapperCreativeIds;
    Y.prototype.getWrapperAdIds = Y.prototype.getWrapperAdIds;
    Y.prototype.getApiFramework = Y.prototype.getApiFramework;
    Y.prototype.getAdvertiserName = Y.prototype.getAdvertiserName;
    Y.prototype.getAdSystem = Y.prototype.getAdSystem;
    Y.prototype.getCreativeId = Y.prototype.getCreativeId;
    Y.prototype.getCreativeAdId = Y.prototype.getCreativeAdId;
    Y.prototype.getAdId = Y.prototype.getAdId;
    var NO = function (a) {
        this.g = a;
    };
    NO.prototype.getCuePoints = function () {
        return this.g;
    };
    NO.prototype.getCuePoints = NO.prototype.getCuePoints;
    var OO = function () {
            this.useLearnMoreButton = this.disableUi = this.disableClickThrough = !1;
            this.autoAlign = this.useVideoAdUi = !0;
            this.bitrate = -1;
            this.enablePreloading = !1;
            this.loadVideoTimeout = 8e3;
            this.mimeTypes = null;
            this.playAdsAfterTime = -1;
            this.restoreCustomPlaybackStateOnAdBreakComplete = !1;
            this.uiElements = null;
            this.useStyledNonLinearAds = this.useStyledLinearAds = !1;
        },
        PO = function (a, b) {
            var c = {};
            Object.assign(c, a);
            b && (c.disableClickThrough = !0);
            return c;
        };
    OO.prototype.append = function (a) {
        if (a) {
            var b = a.autoAlign;
            b != null && (this.autoAlign = b);
            b = Vi(a.bitrate);
            typeof b === "number" && !isNaN(b) && b > 0 && (this.bitrate = b);
            this.disableClickThrough = a.disableClickThrough || this.disableClickThrough;
            this.disableUi = a.disableUi || this.disableUi;
            this.enablePreloading = a.enablePreloading || this.enablePreloading;
            (b = a.mimeTypes) && b.length !== 0 && (this.mimeTypes = b);
            b = Vi(a.playAdsAfterTime);
            typeof b === "number" && !isNaN(b) && b > 0 && (this.playAdsAfterTime = b);
            this.restoreCustomPlaybackStateOnAdBreakComplete = a.restoreCustomPlaybackStateOnAdBreakComplete || this.restoreCustomPlaybackStateOnAdBreakComplete;
            b = Vi(a.loadVideoTimeout);
            typeof b === "number" && !isNaN(b) && b > 0 && (this.loadVideoTimeout = b);
            this.uiElements = a.uiElements || this.uiElements;
            this.useLearnMoreButton = a.useLearnMoreButton || this.useLearnMoreButton;
            this.useStyledLinearAds = a.useStyledLinearAds || this.useStyledLinearAds;
            this.useStyledNonLinearAds = a.useStyledNonLinearAds || this.useStyledNonLinearAds;
            this.useVideoAdUi = a.useVideoAdUi === !1 ? !1 : this.useVideoAdUi;
        }
    };
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$ads_rendering_settings.AdsRenderingSettings.AUTO_SCALE", -1);
    var Tf = function (a) {
        this.F = B(a);
    };
    x(Tf, H);
    var QO = function (a) {
        this.F = B(a);
    };
    x(QO, H);
    var RO = function (a) {
        this.F = B(a);
    };
    x(RO, H);
    var SO = function (a) {
        this.F = B(a);
    };
    x(SO, H);
    var TO = function (a) {
        this.F = B(a);
    };
    x(TO, H);
    var UO = function (a) {
        return dg(a, Dk, 5);
    };
    TO.prototype.getWidth = function () {
        return qg(this, 9);
    };
    TO.prototype.getHeight = function () {
        return qg(this, 10);
    };
    var VO = Gh(TO);
    function WO(a) {
        var b;
        return (b = new Map([
            ["https://googleads.g.doubleclick.net", BigInt(200)],
            ["https://td.doubleclick.net", BigInt(300)],
            ["https://f.creativecdn.com", BigInt(400)],
            ["https://fledge.us.criteo.com", BigInt(500)],
            ["https://fledge.eu.criteo.com", BigInt(600)],
            ["https://fledge.as.criteo.com", BigInt(700)],
            ["https://fledge-buyer-testing-1.uc.r.appspot.com", BigInt(800)],
        ]).get(a)) != null
            ? b
            : BigInt(100);
    }
    function XO(a) {
        var b = a.sh,
            c = a.fj,
            d = a.rj,
            e = a.auctionNonce,
            f = a.Zi,
            g = a.sj;
        a = !pg(b, 14);
        for (var h = {}, k = w(gg(b, QO, 7, Jf())), m = k.next(); !m.done; m = k.next()) {
            m = m.value;
            var n = {},
                p = void 0,
                q = (p = d) == null ? void 0 : p.Pg.nh.rh.cg;
            p = D(m, 1);
            if (D(m, 2).length)
                try {
                    if (((n = JSON.parse(D(m, 2))), xj() * 100 < 1)) {
                        var t = void 0;
                        (t = q) == null || Ik(t, { rd: p, status: "SUCCESS", he: 100 });
                    }
                } catch (Qa) {
                    (t = void 0), (t = q) == null || Ik(t, { rd: p, status: "ERROR", he: 1 });
                }
            else (t = void 0), (t = q) == null || Ik(t, { rd: p, status: "EMPTY", he: 1 });
            h[D(m, 1)] = n;
        }
        if ((d = eg(b, Bk, 6))) (h["https://googleads.g.doubleclick.net"] = Hg(d)), (h["https://td.doubleclick.net"] = Hg(d));
        d = {};
        k = gg(b, SO, 11, Jf());
        k = w(k);
        for (m = k.next(); !m.done; m = k.next()) (m = m.value), (d[D(m, 1)] = qg(m, 2));
        m = {};
        qg(b, 21) !== 0 && (m["*"] = qg(b, 21));
        if (gg(b, RO, 32, Jf()).length > 0) {
            var u = {};
            k = w(gg(b, RO, 32, Jf()));
            for (n = k.next(); !n.done; n = k.next()) (n = n.value), (u[D(n, 1)] = qg(n, 2));
        }
        n = {};
        le(Ff(b, 18)) != null && ((n["https://googleads.g.doubleclick.net"] = rg(b, 18)), (n["https://td.doubleclick.net"] = rg(b, 18)));
        k = w(Sf(b));
        for (q = k.next(); !q.done; q = k.next()) (p = w(q.value)), (q = p.next().value), (p = p.next().value), rg(p, 4) && (n[q] = rg(p, 4));
        q = {};
        k = w(Sf(b));
        for (p = k.next(); !p.done; p = k.next()) (t = w(p.value)), (p = t.next().value), (t = t.next().value), (t = D(t, 5)), t.length && (q[p] = { type: t });
        k = D(b, 1).split("/td/")[0];
        (p = eg(b, Dk, 5)) == null ? (p = void 0) : ((t = p.F), (p = Bf(p, t, md(t), !1)));
        var v;
        p != null && (v = eg(p, Ck, 5)) != null && If(v, 2);
        v = Object;
        t = v.assign;
        var E = D(b, 1),
            P = D(b, 2);
        var S = wg(b, 3, Jf(Bd));
        u = t.call(
            v,
            {},
            {
                seller: k,
                decisionLogicUrl: E,
                trustedScoringSignalsUrl: P,
                interestGroupBuyers: S,
                sellerExperimentGroupId: rg(b, 17),
                auctionSignals: JSON.parse(D(b, 4) || "{}"),
                sellerSignals: (p == null ? void 0 : Hg(p)) || [],
                sellerTimeout: qg(b, 15) || 50,
                perBuyerExperimentGroupIds: n,
                perBuyerSignals: h,
                perBuyerTimeouts: d,
                perBuyerCumulativeTimeouts: m,
                perBuyerRealTimeReportingConfig: q,
                reportingTimeout: 5e3,
            },
            u ? { perBuyerGroupLimits: u } : {},
            a ? { resolveToConfig: a } : {}
        );
        if (b == null ? 0 : pg(UO(b), 25)) (u.sellerCurrency = "USD"), (u.perBuyerCurrencies = Object.fromEntries(Rf(b, 22, De)));
        D(b, 28) && (u.directFromSellerSignalsHeaderAdSlot = D(b, 28));
        if (YO(u.interestGroupBuyers, f)) {
            u.auctionReportBuyerKeys = u.interestGroupBuyers.map(WO);
            f = { interestGroupCount: { bucket: BigInt(0), scale: 1 }, bidCount: { bucket: BigInt(1), scale: 1 } };
            g || ((f.totalGenerateBidLatency = { bucket: BigInt(2), scale: 1 }), (f.totalSignalsFetchLatency = { bucket: BigInt(3), scale: 1 }));
            u.auctionReportBuyers = f;
            var ca = ca === void 0 ? BigInt(0) : ca;
            u.auctionReportBuyerDebugModeConfig = { enabled: !0, debugKey: ca };
        }
        e && ((u.auctionNonce = e), (u.additionalBids = Promise.resolve()));
        Rf(b, 33, De).size &&
            ((u.deprecatedRenderURLReplacements = Object.fromEntries(Rf(b, 33, De).entries())), (e = u.deprecatedRenderURLReplacements["${RENDER_DATA_td.doubleclick.net_GDA}"]) && (u.deprecatedRenderURLReplacements["${RENDER_DATA}"] = e));
        e = Object;
        ca = e.assign;
        f = D(b, 1);
        g = rg(b, 17);
        h = new Dk();
        v = UO(b);
        cg(v, Ck, 5) !== void 0 && ((v = new Ck()), (d = ug(dg(UO(b), Ck, 5), 2)), (v = Vf(v, 2, re(d), "0")), (d = ug(dg(UO(b), Ck, 5), 4)), (v = Vf(v, 4, re(d), "0")), C(h, 5, v));
        UO(b).getEscapedQemQueryId() && ((v = UO(b).getEscapedQemQueryId()), Vf(h, 2, ye(v), ""));
        D(UO(b), 6) && ((v = D(UO(b), 6)), Vf(h, 6, ye(v), ""));
        pg(UO(b), 21) && Ag(h, 21, !0);
        pg(UO(b), 4) && Ag(h, 4, !0);
        D(UO(b), 11) && ((v = D(UO(b), 11)), Vf(h, 11, ye(v), ""));
        pg(UO(b), 32) && Ag(h, 32, !0);
        h = Hg(h);
        v = qg(b, 15) || 50;
        if (pg(b, 30)) {
            if (c == null || !c.length) throw Error("top_td_without_component_auction");
        } else c = [u].concat(la(c != null ? c : []));
        c = ca.call(
            e,
            {},
            {
                seller: k,
                decisionLogicUrl: f,
                sellerExperimentGroupId: g,
                sellerSignals: h,
                sellerTimeout: v,
                interestGroupBuyers: [],
                auctionSignals: {},
                perBuyerExperimentGroupIds: {},
                perBuyerSignals: {},
                perBuyerTimeouts: {},
                perBuyerCumulativeTimeouts: {},
                componentAuctions: c,
            },
            a ? { resolveToConfig: a } : {}
        );
        D(b, 28) && (c.directFromSellerSignalsHeaderAdSlot = D(b, 28));
        return c;
    }
    function YO(a, b) {
        return (
            a.some(function (c) {
                return WO(c) !== BigInt(100);
            }) && (b != null ? b : !1)
        );
    }
    var $O = function (a, b) {
        Q.call(this);
        var c = this;
        this.navigator = b;
        this.j = function (d) {
            var e = Date.now();
            try {
                var f = ZO(c, d.tdconfig);
            } catch (g) {
                f = Promise.resolve({ Jb: !1, result: null });
            }
            return f.then(function (g) {
                var h = new zk();
                h = Dg(h, 1, e);
                h = Dg(h, 2, Date.now());
                var k = g.result;
                g = g.Jb;
                var m;
                k = typeof k === "string" ? k : (m = k == null ? void 0 : k.url) != null ? m : "";
                m = {};
                return (m.ffconfig = k), (m.timeout = 500), (m.auctioninterval = Ig(h)), (m.isauctiontimeout = g), m;
            });
        };
        this.g = new pO(a, "fledge");
        Er(this, this.g);
    };
    x($O, Q);
    var ZO = function (a, b) {
        b = VO(b);
        var c = XO({ sh: b });
        b = Qw(500, null).then(function () {
            return { Jb: !0, result: null };
        });
        a = a.navigator.runAdAuction(c).then(function (d) {
            return { Jb: !1, result: d };
        });
        return Promise.race([b, a]);
    };
    var cP = function (a, b, c) {
        Q.call(this);
        this.C = a;
        this.A = b;
        this.B = c;
        this.g = this.j = this.o = null;
        this.l = 0;
        a = new gE(this);
        Er(this, a);
        lo(mC) ? aP(this) : bP(this);
        a.listen(this.A, "adsManager", this.D);
    };
    x(cP, Q);
    var aP = function (a) {
            FO()
                .then(function (b) {
                    dP(a, b);
                })
                .catch(function () {
                    return void eP(a);
                });
        },
        bP = function (a) {
            DO(a.C)
                .then(function (b) {
                    a.j = b;
                    dP(a, jj(b));
                })
                .catch(function () {
                    return void eP(a);
                });
        };
    cP.prototype.D = function (a) {
        if (!lo(mC) && ["complete", "skip", "error"].includes(a.messageType)) {
            this.l++;
            if (this.l === 10) {
                this.l = 0;
                var b;
                (b = this.g) == null || b.dispose();
                bP(this);
            }
            a = jj(this.j);
            var c;
            (a && ((c = a.frames) == null ? 0 : c.omid_v1_present)) || X.getInstance().report(188, {});
        }
    };
    var fP = function (a) {
            if (a.g && a.o) {
                var b = a.g;
                try {
                    b.g && b.g.setSessionClientWindow(a.o);
                } catch (c) {
                    b.dispatchEvent(new Event("error"));
                }
            }
        },
        dP = function (a, b) {
            a.g = new GO(b, a.B);
            a.g.listen("error", function () {
                return void eP(a);
            });
            IO(a.g);
            fP(a);
        },
        eP = function (a) {
            vJ(a.A, "omid", "iframeFailed");
            a.dispose();
        };
    cP.prototype.O = function () {
        this.j && (hj(this.j), (this.j = null));
        Q.prototype.O.call(this);
    };
    var gP = function (a, b, c, d) {
        Q.call(this);
        this.o = a;
        this.l = b;
        this.g = c;
        this.C = d;
        this.j = new gE(this);
        Er(this, this.j);
        this.j.listen(this.o, d, this.B);
    };
    x(gP, Q);
    var hP = function (a, b) {
        var c = b.na;
        switch (b.messageType) {
            case "showVideo":
                a.l.kd();
                break;
            case "hide":
                a.l.lb();
                break;
            case "resizeAndPositionVideo":
                b = c.resizeAndPositionVideo;
                a.l.ae(new Rk(b.x, b.y, b.width, b.height));
                break;
            case "restoreSizeAndPositionVideo":
                a.l.be();
        }
    };
    gP.prototype.B = function (a) {
        var b = a.na;
        switch (a.messageType) {
            case "activate":
                this.l.uc(this.g);
                break;
            case "startTracking":
                a = this.g;
                var c = this.A;
                this.j.listen(a, xi(LE), c);
                this.j.listen(a, qO, c);
                a = this.g;
                iP(a);
                a.j.listen(a.g, qO, a.Qa);
                a.j.listen(a.g, "ended", a.Sg);
                a.j.listen(a.g, "webkitbeginfullscreen", a.Ra);
                a.j.listen(a.g, "webkitendfullscreen", a.ga);
                a.j.listen(a.g, "loadedmetadata", a.Ug);
                a.j.listen(a.g, "pause", a.Wg);
                a.j.listen(a.g, "playing", a.Ue);
                a.j.listen(a.g, "timeupdate", a.Xg);
                a.j.listen(a.g, "volumechange", a.Zg);
                a.j.listen(a.g, "error", a.W);
                a.j.listen(a.g, Nc || (Bc && !RD(8)) ? "loadeddata" : "canplay", a.Tg);
                a.B = new YN();
                a.j.listen(a.B, "click", a.ka);
                $N(a.B, a.g);
                a.I = new Ow(1e3);
                a.j.listen(a.I, "tick", a.wa);
                a.I.start();
                break;
            case "stopTracking":
                a = this.g;
                c = this.A;
                this.j.sb(a, xi(LE), c);
                this.j.sb(a, qO, c);
                iP(this.g);
                break;
            case "exitFullscreen":
                a = this.g;
                (yc || Ac) && a.g.webkitDisplayingFullscreen && a.g.webkitExitFullscreen();
                break;
            case "play":
                jP(this.g);
                break;
            case "pause":
                this.g.pause();
                break;
            case "load":
                a = this.g;
                c = b.videoUrl;
                var d = b.muxedMediaUrl,
                    e = b.muxedMimeType,
                    f = b.muxedAudioCodec,
                    g = b.muxedVideoCodec,
                    h = b.demuxedAudioUrl,
                    k = b.demuxedVideoUrl,
                    m = b.demuxedAudioMimeType,
                    n = b.demuxedVideoMimeType,
                    p = b.demuxedAudioCodec,
                    q = b.demuxedVideoCodec;
                b = b.mseCompatible;
                var t = null;
                k && h && b && n && m && q && p && (t = new sC({ yh: k, bg: h, wj: null, bj: null, xh: n, ag: m, tb: q, bb: p, height: null, width: null, Ga: b, vj: null, aj: null }));
                h = null;
                d && e && g && f && (h = new tC({ Og: d, yb: null, mimeType: e, tb: g, bb: f, height: null, width: null, Ga: b, hj: null }));
                t ? a.load(c, t) : h ? a.load(c, h) : a.load(c, null);
                break;
            case "unload":
                a = this.g;
                kP(a);
                a.U = !1;
                "removeAttribute" in a.g ? a.g.removeAttribute("src") : (a.g.src = "");
                a.g.load();
                break;
            case "setCurrentTime":
                this.g.g.currentTime = b.currentTime;
                break;
            case "setVolume":
                this.g.setVolume(b.volume);
        }
    };
    gP.prototype.A = function (a) {
        var b = {};
        switch (a.type) {
            case "autoplayDisallowed":
                a = "autoplayDisallowed";
                break;
            case "beginFullscreen":
                a = "fullscreen";
                break;
            case "endFullscreen":
                a = "exitFullscreen";
                break;
            case "click":
                a = "click";
                break;
            case "end":
                a = "end";
                break;
            case "error":
                a = "error";
                break;
            case "loaded":
                a = "loaded";
                break;
            case "mediaLoadTimeout":
                a = "mediaLoadTimeout";
                break;
            case "pause":
                a = "pause";
                b.ended = this.g.g.ended;
                break;
            case "play":
                a = "play";
                break;
            case "skip":
                a = "skip";
                break;
            case "start":
                a = "start";
                b.volume = this.g.getVolume();
                break;
            case "timeUpdate":
                a = "timeupdate";
                b.currentTime = this.g.getCurrentTime();
                b.duration = this.g.getDuration();
                break;
            case "volumeChange":
                a = "volumeChange";
                b.volume = this.g.getVolume();
                break;
            case "loadedmetadata":
                a = a.type;
                b.duration = this.g.getDuration();
                break;
            case "abort":
            case "canplay":
            case "canplaythrough":
            case "durationchange":
            case "emptied":
            case "loadstart":
            case "loadeddata":
            case "progress":
            case "ratechange":
            case "seeked":
            case "seeking":
            case "stalled":
            case "suspend":
            case "waiting":
                a = a.type;
                break;
            default:
                return;
        }
        vJ(this.o, this.C, a, b);
    };
    var lP = function (a, b) {
        Q.call(this);
        this.j = b;
        this.g = null;
        this.l = new gP(a, b, this.j.da, "videoDisplay1");
        Er(this, this.l);
        var c = this.j.ya;
        c != null && ((this.g = new gP(a, b, c, "videoDisplay2")), Er(this, this.g));
    };
    x(lP, Q);
    function mP(a, b, c, d) {
        var e = Hj("IFRAME");
        e.id = b;
        e.name = b;
        e.width = String(c);
        e.height = String(d);
        e.allowTransparency = "true";
        e.scrolling = "no";
        e.marginWidth = "0";
        e.marginHeight = "0";
        e.frameBorder = "0";
        e.style.border = "0";
        e.style.verticalAlign = "bottom";
        e.src = "about:blank";
        e.setAttribute("aria-label", "Advertisement");
        e.title = "3rd party ad content";
        e.tabIndex = 0;
        a.appendChild(e);
        return e;
    }
    function nP() {
        var a,
            b,
            c,
            d = dj();
        d = d === void 0 ? window : d;
        d = ((c = d === void 0 ? null : d) != null ? c : window).googletag;
        c = (d == null ? 0 : d.apiReady) ? d : void 0;
        return (b = c == null ? void 0 : (a = c.companionAds) == null ? void 0 : a.call(c)) != null ? b : null;
    }
    function oP(a) {
        var b = {};
        b.slotId = a.getSlotId().getId();
        var c = [];
        a = w(a.getSizes() || []);
        for (var d = a.next(); !d.done; d = a.next())
            if (((d = d.value), typeof d !== "string")) {
                var e = {};
                c.push(((e.adWidth = d.getWidth()), (e.adHeight = d.getHeight()), e));
            } else d === "fluid" && ((d = {}), c.push(((d.fluidSize = !0), d)));
        return (b.adSizes = c), b;
    }
    function pP(a) {
        var b = nP();
        if (b && a && Array.isArray(a)) {
            var c = new Map(
                b.getSlots().map(function (q) {
                    return [q.getSlotId().getId(), q];
                })
            );
            a = w(a);
            for (var d = a.next(); !d.done; d = a.next()) {
                var e = d.value,
                    f = c.get(e.slotId);
                if (f && !b.isSlotAPersistentRoadblock(f)) {
                    var g = e.adContent;
                    if (g && (d = Zi(f.getSlotId().getDomId()))) {
                        d.style.display = "";
                        var h = e.adWidth,
                            k = e.adHeight;
                        e.fluidSize && ((k = Oq(d)), (h = k.width), (k = k.height));
                        d.textContent = "";
                        if (e.friendlyIframeRendering)
                            try {
                                var m = "google_companion_" + f.getSlotId().getId(),
                                    n = mP(d, m, h, k),
                                    p = n.contentWindow ? n.contentWindow.document : n.contentDocument;
                                tc && p.open("text/html", "replace");
                                Mi(p, Bl(g));
                                p.close();
                            } catch (q) {}
                        else Ji(d, Bl(g)), (d.style.width = h + "px"), (d.style.height = k + "px");
                        b.slotRenderEnded(f, h, k);
                        (e = e.onAdContentSet) && e(d);
                    }
                }
            }
        }
    }
    var qP = function (a, b, c, d, e, f) {
        wJ.call(this, a, b, c, d, e);
        this.g = f;
    };
    x(qP, wJ);
    var rP = function (a, b) {
        R.call(this);
        this.B = a;
        this.A = b;
        this.g = {};
        this.j = new gE(this);
        Er(this, this.j);
        this.j.listen(dj(), "message", this.l);
    };
    x(rP, R);
    var sP = function (a, b) {
            var c = b.g;
            a.g.hasOwnProperty(c) && vJ(a.g[c], b.type, b.messageType, b.na);
        },
        tP = function (a, b, c, d) {
            a.g.hasOwnProperty(b) ||
                ((c = new VN(b, c)),
                a.j.listen(c, a.B, function (e) {
                    this.dispatchEvent(new qP(e.type, e.messageType, e.na, e.sc, e.origin, b));
                }),
                (c.g = d),
                c.connect(),
                (a.g[b] = c));
        };
    rP.prototype.O = function () {
        for (var a = w(Object.values(this.g)), b = a.next(); !b.done; b = a.next()) Cr(b.value);
        R.prototype.O.call(this);
    };
    rP.prototype.l = function (a) {
        a = a.g;
        var b = WN(a.data);
        if (b != null) {
            var c = b.channel;
            if (this.A && !this.g.hasOwnProperty(c)) {
                var d = b.sid;
                tP(this, c, d, a.source);
                this.dispatchEvent(new qP(b.name, b.type, b.data || {}, d, a.origin, c));
            }
        }
    };
    function uP() {
        return !!Ta("googletag.cmd", dj());
    }
    function vP() {
        var a = Ta("googletag.console", dj());
        return a != null ? a : null;
    }
    var wP = function () {
        gE.call(this);
        this.g = null;
        this.l = new rP("gpt", !0);
        Er(this, this.l);
        this.listen(this.l, "gpt", this.B);
        uP() || dj().top === dj() || ((this.g = new rP("gpt", !1)), Er(this, this.g), this.listen(this.g, "gpt", this.A));
    };
    x(wP, gE);
    wP.prototype.B = function (a) {
        var b = a.origin,
            c = "//imasdk.googleapis.com".match(nj);
        b = b.match(nj);
        if (c[3] == b[3] && c[4] == b[4])
            if (this.g != null) tP(this.g, a.g, a.sc, dj().parent), this.g != null && sP(this.g, a);
            else if (((c = a.na), c != null && c.scope !== void 0)) {
                b = c.scope;
                c = c.args;
                var d;
                if (b === "proxy") {
                    var e = a.messageType;
                    e === "isGptPresent" ? (d = uP()) : e === "isConsolePresent" && (d = vP() != null);
                } else if (uP())
                    if (b === "pubads" || b === "companionAds") {
                        d = a.messageType;
                        var f = dj().googletag;
                        if (f != null && f[b] != null && ((b = f[b]()), b != null && ((d = b[d]), d != null)))
                            try {
                                e = d.apply(b, c);
                            } catch (g) {}
                        d = e;
                    } else if (b === "console") {
                        if (((e = vP()), e != null && ((b = e[a.messageType]), b != null)))
                            try {
                                b.apply(e, c);
                            } catch (g) {}
                    } else
                        b === null &&
                            ((e = a.messageType),
                            e === "googleGetCompanionAdSlots" ? ((e = nP()) ? ((e = e.getSlots().map(oP)), (d = e.length ? e : null)) : (d = null)) : (e === "googleSetCompanionAdContents" && pP(c == null ? void 0 : c[0]), (d = null)));
                d !== void 0 && ((a.na.returnValue = d), sP(this.l, a));
            }
    };
    wP.prototype.A = function (a) {
        sP(this.l, a);
    };
    var xP = function (a, b) {
        if (a.g) {
            var c = a.g;
            Cr(c.g[b]);
            delete c.g[b];
        }
        a.l && ((a = a.l), Cr(a.g[b]), delete a.g[b]);
    };
    var zP = function (a, b) {
            var c = Array.prototype.slice.call(arguments),
                d = c.shift();
            if (typeof d == "undefined") throw Error("[goog.string.format] Template required");
            return d.replace(/%([0\- \+]*)(\d+)?(\.(\d+))?([%sfdiu])/g, function (e, f, g, h, k, m, n, p) {
                if (m == "%") return "%";
                var q = c.shift();
                if (typeof q == "undefined") throw Error("[goog.string.format] Not enough arguments");
                arguments[0] = q;
                return yP[m].apply(null, arguments);
            });
        },
        yP = {
            s: function (a, b, c) {
                return isNaN(c) || c == "" || a.length >= Number(c) ? a : (a = b.indexOf("-", 0) > -1 ? a + Pi(" ", Number(c) - a.length) : Pi(" ", Number(c) - a.length) + a);
            },
            f: function (a, b, c, d, e) {
                d = a.toString();
                isNaN(e) || e == "" || (d = parseFloat(a).toFixed(e));
                var f = Number(a) < 0 ? "-" : b.indexOf("+") >= 0 ? "+" : b.indexOf(" ") >= 0 ? " " : "";
                Number(a) >= 0 && (d = f + d);
                if (isNaN(c) || d.length >= Number(c)) return d;
                d = isNaN(e) ? Math.abs(Number(a)).toString() : Math.abs(Number(a)).toFixed(e);
                a = Number(c) - d.length - f.length;
                return (d = b.indexOf("-", 0) >= 0 ? f + d + Pi(" ", a) : f + Pi(b.indexOf("0", 0) >= 0 ? "0" : " ", a) + d);
            },
            d: function (a, b, c, d, e, f, g, h) {
                return yP.f(parseInt(a, 10), b, c, d, 0, f, g, h);
            },
        };
    yP.i = yP.d;
    yP.u = yP.d;
    function AP() {
        return ["autoplay", "attribution-reporting"]
            .filter(function (a) {
                var b = document.featurePolicy;
                return b !== void 0 && typeof b.allowedFeatures == "function" && typeof b.allowedFeatures() == "object" && b.allowedFeatures().includes(a);
            })
            .join(";");
    }
    var CP = function (a, b, c) {
        c = c === void 0 ? !1 : c;
        R.call(this);
        this.D = b;
        this.W = c;
        this.M = this.K = null;
        this.I = !1;
        this.G = "goog_" + Ri++;
        this.B = new Map();
        this.j = null;
        c = dj();
        var d = Ta("google.ima.gptProxyInstance", c);
        d != null ? (c = d) : ((d = new wP()), z("google.ima.gptProxyInstance", d, c), (c = d));
        this.Z = c;
        this.C = null;
        this.A = new gE(this);
        Er(this, this.A);
        c = this.G;
        d = this.W ? "?gdpr=1" : "";
        d = (Bj() ? "https:" : "http:") + zP("//imasdk.googleapis.com/js/core/bridge3.668.1_%s.html", oI.getLocale()) + d;
        a: {
            var e = window;
            try {
                do {
                    try {
                        if (e.location.href.indexOf(d) === 0 || e.document.referrer.indexOf(d) === 0) {
                            var f = !0;
                            break a;
                        }
                    } catch (k) {}
                    e = e.parent;
                } while (e !== e.top);
            } catch (k) {}
            f = !1;
        }
        f && (d += "?f=" + c);
        f = window.document;
        if (Pn.length && f.head) {
            e = w(Pn);
            for (var g = e.next(); !g.done; g = e.next())
                if ((g = g.value) && f.head) {
                    var h = Hj("META");
                    f.head.appendChild(h);
                    h.httpEquiv = "origin-trial";
                    h.content = g;
                }
        }
        f = AP();
        c = gj("IFRAME", { src: d + "#" + c, allowFullscreen: !0, allow: f, id: c, style: "border:0; opacity:0; margin:0; padding:0; position:relative; color-scheme: light;", title: "Advertisement" });
        this.A.dc(c, "load", this.ka);
        a.appendChild(c);
        this.g = c;
        this.l = BP(this);
        this.P = new $O(this.l, navigator);
        Er(this, this.P);
        c = this.P;
        c.g.j.set("auction", c.j);
        this.U = new lP(this.l, this.D);
        Er(this, this.U);
        this.D.da && this.A.listen(this.l, "displayContainer", this.V);
        this.A.listen(this.l, "mouse", this.aa);
        this.A.listen(this.l, "touch", this.ga);
        $I() || ((this.C = new cP(a, this.l, b.da.A.g)), Er(this, this.C));
    };
    x(CP, R);
    var BP = function (a, b) {
        b = b === void 0 ? "*" : b;
        var c = a.B.get(b);
        c == null && ((c = new VN(a.G, b)), a.I && ((c.g = jj(a.g)), c.connect()), a.B.set(b, c));
        return c;
    };
    CP.prototype.uc = function (a) {
        var b;
        (b = this.C) != null && ((a = a.A.g), (b.B = a), b.g && ((b = b.g), (b.j = a), HO(b, a)));
    };
    CP.prototype.O = function () {
        this.j !== null && (this.j.dispose(), (this.j = null));
        this.B.forEach(function (a) {
            Cr(a);
        });
        this.B.clear();
        xP(this.Z, this.G);
        hj(this.g);
        R.prototype.O.call(this);
    };
    CP.prototype.aa = function (a) {
        var b = a.na,
            c = Jq(this.g),
            d = document.createEvent("MouseEvent");
        d.initMouseEvent(a.messageType, !0, !0, window, b.detail, b.screenX, b.screenY, b.clientX + c.x, b.clientY + c.y, b.ctrlKey, b.altKey, b.shiftKey, b.metaKey, b.button, null);
        this.g.dispatchEvent(d);
    };
    var DP = function (a, b) {
        var c = Jq(a.g),
            d = !!("TouchEvent" in window && TouchEvent.length > 0);
        b = b.map(function (f) {
            return d
                ? new Touch({ identifier: f.identifier, target: a.g, clientX: f.clientX, clientY: f.clientY, screenX: f.screenX, screenY: f.screenY, pageX: f.pageX + c.x, pageY: f.pageY + c.y })
                : document.createTouch(window, a.g, f.identifier, f.pageX + c.x, f.pageY + c.y, f.screenX, f.screenY);
        });
        if (d) return b;
        var e;
        return (e = document.createTouchList) == null ? void 0 : e.apply(document, b);
    };
    CP.prototype.ga = function (a) {
        var b = a.na,
            c = Jq(this.g);
        if ("TouchEvent" in window && TouchEvent.length > 0)
            (b = {
                bubbles: !0,
                cancelable: !0,
                view: window,
                detail: b.detail,
                ctrlKey: b.ctrlKey,
                altKey: b.altKey,
                shiftKey: b.shiftKey,
                metaKey: b.metaKey,
                touches: DP(this, b.touches),
                targetTouches: DP(this, b.targetTouches),
                changedTouches: DP(this, b.changedTouches),
            }),
                (a = new TouchEvent(a.messageType, b)),
                this.g.dispatchEvent(a);
        else {
            var d = document.createEvent("TouchEvent");
            d.initTouchEvent(
                a.messageType,
                !0,
                !0,
                window,
                b.detail,
                b.screenX,
                b.screenY,
                b.clientX + c.x,
                b.clientY + c.y,
                b.ctrlKey,
                b.altKey,
                b.shiftKey,
                b.metaKey,
                DP(this, b.touches),
                DP(this, b.targetTouches),
                DP(this, b.changedTouches),
                b.scale,
                b.rotation
            );
            this.g.dispatchEvent(d);
        }
    };
    CP.prototype.V = function (a) {
        switch (a.messageType) {
            case "showVideo":
                this.j == null ? ((this.j = new YN()), this.A.listen(this.j, "click", this.oa)) : bO(this.j);
                $N(this.j, this.D.Ub());
                break;
            case "hide":
                this.j !== null && (this.j.dispose(), (this.j = null));
        }
        var b = this.U;
        hP(b.l, a);
        b.g && hP(b.g, a);
    };
    CP.prototype.oa = function () {
        vJ(this.l, "displayContainer", "videoClick");
    };
    CP.prototype.ka = function () {
        this.K = tl();
        this.M = ql();
        var a = jj(this.g);
        this.B.forEach(function (c) {
            c.g = a;
            c.connect();
        });
        var b;
        (b = this.C) != null && ((b.o = a), fP(b));
        this.I = !0;
    };
    var EP = ka(["https://s0.2mdn.net/instream/video/client.js"]),
        FP = null,
        GP = function () {
            R.call(this);
            this.g = null;
            this.j = new Map();
            this.l = new Map();
            this.va = this.C = !1;
            this.A = null;
            this.B = new gE(this);
            Er(this, this.B);
        };
    x(GP, R);
    var HP = function () {
            FP == null && (FP = new GP());
            return FP;
        },
        Cv = function (a, b, c) {
            var d = {};
            d.queryId = b;
            d.viewabilityData = c;
            a.g && vJ(a.g, "activityMonitor", "viewabilityMeasurement", d);
        };
    GP.prototype.destroy = function () {
        this.B.sb(this.g, "activityMonitor", this.D);
        this.va = !1;
        this.j.clear();
    };
    GP.prototype.O = function () {
        this.destroy();
        R.prototype.O.call(this);
    };
    GP.prototype.init = function (a) {
        if (!this.va) {
            if ((this.g = a || null)) this.B.listen(this.g, "activityMonitor", this.D), IP(this);
            if (!(y.ima && y.ima.video && y.ima.video.client && y.ima.video.client.tagged)) {
                z("ima.video.client.sdkTag", !0);
                var b = y.document;
                a = ej(document, "SCRIPT");
                var c = oi(EP);
                Ki(a, c);
                a.async = !0;
                a.type = "text/javascript";
                b = b.getElementsByTagName("script")[0];
                b.parentNode.insertBefore(a, b);
            }
            Xo();
            J(rv).I = oI.g;
            this.C = !0;
            J(rv).l = !0;
            this.A = null;
            a = J(rv);
            b = cv(a) == "h" || cv(a) == "b";
            c = !(N(), !1);
            b && c && ((a.L = !0), (a.G = new wt()));
            this.va = !0;
        }
    };
    var KP = function (a) {
            if (a == null) return !1;
            if ((yc || Ac) && a.webkitDisplayingFullscreen !== null) return a.webkitDisplayingFullscreen;
            a = JP(a);
            var b = window.screen.availHeight || window.screen.height;
            return (window.screen.availWidth || window.screen.width) - a.width <= 0 && b - a.height <= 42;
        },
        JP = function (a) {
            var b = { left: a.offsetLeft, top: a.offsetTop, width: a.offsetWidth, height: a.offsetHeight };
            try {
                typeof a.getBoundingClientRect === "function" && ij(Xi(a), a) && (b = a.getBoundingClientRect());
            } catch (c) {}
            return b;
        },
        LP = function (a, b, c, d, e) {
            e = e === void 0 ? {} : e;
            if (a.va) {
                d && e.opt_osdId == null && (e.opt_osdId = d);
                if (a.A) return a.A(b, c, e);
                if ((a = d ? a.l.get(d) : oI.l)) e.opt_fullscreen == null && (e.opt_fullscreen = KP(a)), e.opt_adElement == null && (e.opt_adElement = a);
                return hy.zb(469, ib(Ev, b, c, e)) || {};
            }
            return {};
        },
        MP = function (a) {
            var b;
            oI.g !== 0 ? (b = J(rv).l) : (b = a.C);
            return b;
        },
        NP = function (a, b) {
            var c = String(Math.floor(Math.random() * 1e9));
            a.l.set(c, b);
            oI.g !== 0 && (J(rv).o[c] = a);
            return c;
        },
        OP = function (a, b, c) {
            if (c) a.j.get(c) === b && a.j.delete(c);
            else {
                var d = [];
                a.j.forEach(function (e, f) {
                    e === b && d.push(f);
                });
                d.forEach(a.j.delete, a.j);
            }
        },
        yv = function (a, b) {
            a = a.j.get(b);
            return typeof a === "function" ? a() : {};
        },
        IP = function (a) {
            if (typeof window.Goog_AdSense_Lidar_getUrlSignalsArray === "function") {
                var b = {};
                b.pageSignals = window.Goog_AdSense_Lidar_getUrlSignalsArray();
                var c;
                (c = a.g) == null || vJ(c, "activityMonitor", "pageSignals", b);
            }
        };
    GP.prototype.D = function (a) {
        var b = a.na,
            c = b.queryId,
            d = {},
            e = null;
        d.eventId = b.eventId;
        switch (a.messageType) {
            case "getPageSignals":
                IP(this);
                break;
            case "reportVastEvent":
                e = b.vastEvent;
                a = b.osdId;
                var f = {};
                f.opt_fullscreen = b.isFullscreen;
                b.isOverlay && (f.opt_bounds = b.overlayBounds);
                d.viewabilityData = LP(this, e, c, a, f);
                var g;
                (g = this.g) == null || vJ(g, "activityMonitor", "viewability", d);
                break;
            case "fetchAdTagUrl":
                (c = {}),
                    (c.eventId = b.eventId),
                    (a = b.osdId),
                    Ai(b, "isFullscreen") && (e = b.isFullscreen),
                    Ai(b, "loggingId") && ((b = b.loggingId), (c.loggingId = b), X.getInstance().report(43, { step: "beforeLookup", logid: b, time: Date.now() })),
                    (c.engagementString = PP(this, a, e)),
                    this.g && vJ(this.g, "activityMonitor", "engagement", c);
        }
    };
    var PP = function (a, b, c) {
        var d,
            e = b ? ((d = a.l.get(b)) != null ? d : null) : oI.l;
        a = {};
        c != null && (a.fullscreen = c);
        c = "";
        try {
            c = fx(function () {
                return e;
            }, a);
        } catch (f) {
            (c = f), (c = "sdktle;" + Oi(c.name, 12) + ";" + Oi(c.message, 40));
        }
        return c;
    };
    z("ima.common.getVideoMetadata", function (a) {
        return yv(HP(), a);
    });
    z("ima.common.triggerViewabilityMeasurementUpdate", function (a, b) {
        Cv(HP(), a, b);
    });
    var QP = function (a) {
            this.g = a;
            this.l = "";
            this.j = -1;
            this.o = !1;
        },
        SP = function (a, b) {
            if (a.j >= 0) {
                var c = b == null ? function () {} : b,
                    d = function () {
                        RP(a, c);
                        a.g.removeEventListener("loadedmetadata", d, !1);
                    };
                a.g.addEventListener("loadedmetadata", d, !1);
                a.g.src = a.l;
                a.g.load();
            } else b != null && b();
        },
        RP = function (a, b) {
            var c = a.g.seekable.length > 0;
            a.o
                ? c
                    ? ((a.g.currentTime = a.j), TP(a), b())
                    : setTimeout(function () {
                          return void RP(a, b);
                      }, 100)
                : (TP(a), b());
        },
        TP = function (a) {
            a.j = -1;
            a.l = "";
            a.o = !1;
        };
    var UP = new ri(5, 5),
        VP = function (a) {
            R.call(this);
            this.g = a;
            this.B = this.aa = null;
            this.D = 0;
            this.M = this.G = this.U = this.loaded = this.K = !1;
            this.V = this.I = this.P = this.l = null;
            this.Z = !1;
            this.C = null;
            this.A = new QP(a);
            this.j = new gE(this);
            Er(this, this.j);
            this.size = this.getSize();
            this.fullscreen = KP(this.g);
        };
    x(VP, R);
    l = VP.prototype;
    l.te = function () {
        var a = this.A;
        a.l = a.g.currentSrc;
        a.o = a.g.seekable.length > 0;
        a.j = a.g.ended ? -1 : a.g.currentTime;
    };
    l.tc = function (a) {
        SP(this.A, a);
    };
    l.load = function (a, b) {
        var c = K.getInstance().g;
        c.P = !0;
        El(c);
        Ol("hvd_lc");
        kP(this);
        this.U = !1;
        if (b)
            if ((Ol("hvd_ad"), b instanceof tC)) {
                if ((Ol("hvd_mad"), (c = b.getMediaUrl()))) {
                    Ol("hvd_admu");
                    Ol("hvd_src");
                    this.g.src = c;
                    this.g.load();
                    return;
                }
            } else if (b instanceof sC) {
                Ol("hvd_dad");
                c = b.o;
                var d = b.j,
                    e = b.l,
                    f = b.g,
                    g = b.tb,
                    h = b.bb;
                if (c && d && e && f && g && h && (Ol("hvd_addu"), b.Ga)) {
                    Ol("hvd_admse");
                    b = e + '; codecs="' + g + '"';
                    f = f + '; codecs="' + h + '"';
                    if (xG() && xG() && MediaSource.isTypeSupported(b) && xG() && MediaSource.isTypeSupported(f)) {
                        Ol("hvd_ymse");
                        Ol("hvd_mse");
                        a = !1;
                        try {
                            window.location.search.indexOf("goog_limavideo=true") !== -1 && (a = !0);
                        } catch (k) {}
                        y.customElements ? (a ? (a = !0) : (lo(kC) && X.getInstance().report(153, { limvid: "vd" }), (a = lo(kC) ? !0 : !1))) : (a = !1);
                        a && this.g instanceof tH
                            ? ((this.g.gb = c), (this.g.vb = d))
                            : ((this.aa = new SH(this.g, [new RG(c, b, 35e4, new kF()), new RG(d, f, 82e3, new kF())])), Er(this, this.aa), (a = this.g), (c = this.aa), c.j || (c.j = ji(c.g).toString()), (c = c.j), (a.src = c));
                        this.g.load();
                        return;
                    }
                    Ol("hvd_nmse");
                }
            } else Ol("hvd_uad");
        a ? (Ol("hvd_src"), (this.g.src = a)) : Ol("hvd_vn");
        this.g.load();
    };
    l.setVolume = function (a) {
        this.g.volume = Math.max(a, 0);
        this.g.muted = a === 0 ? !0 : !1;
    };
    l.ae = function (a) {
        this.g.style.left = String(a.left) + "px";
        this.g.style.top = String(a.top) + "px";
        this.g.style.width = String(a.width) + "px";
        this.g.style.height = String(a.height) + "px";
    };
    l.be = function () {
        this.g.style.width = "100%";
        this.g.style.height = "100%";
        this.g.style.left = "0";
        this.g.style.right = "0";
    };
    l.getVolume = function () {
        return this.g.muted ? 0 : this.g.volume;
    };
    var jP = function (a) {
        a.Z = !1;
        a.U || Mb()
            ? ((a.M = !1),
              (a.l = a.g.play()),
              a.l != null &&
                  ((a.P = null),
                  a.l
                      .then(function () {
                          a.l = null;
                          a.Ue(a.P);
                          a.P = null;
                      })
                      .catch(function (b) {
                          a.l = null;
                          var c = "";
                          b != null && b.name != null && (c = b.name);
                          c === "AbortError" || c === "NotAllowedError" ? a.dispatchEvent("autoplayDisallowed") : a.W();
                      })))
            : (a.M = !0);
    };
    l = VP.prototype;
    l.pause = function () {
        this.l == null && ((this.Z = !0), this.g.pause());
    };
    l.getCurrentTime = function () {
        return this.g.currentTime;
    };
    l.getDuration = function () {
        return isNaN(this.g.duration) ? -1 : this.g.duration;
    };
    l.getSize = function () {
        return new ri(this.g.offsetWidth, this.g.offsetHeight);
    };
    l.O = function () {
        this.V && JD(this.V);
        iP(this);
        R.prototype.O.call(this);
    };
    var iP = function (a) {
            a.B != null && (bO(a.B), (a.B = null));
            a.I != null && a.I.dispose();
            kE(a.j);
            kP(a);
        },
        kP = function (a) {
            a.loaded = !1;
            a.G = !1;
            a.K = !1;
            a.M = !1;
            a.D = 0;
            a.l = null;
            a.P = null;
            Cr(a.C);
        };
    VP.prototype.Qa = function (a) {
        this.dispatchEvent(a.type);
    };
    var XP = function (a) {
        if (!a.G) {
            a.G = !0;
            a.dispatchEvent("start");
            try {
                if (lo(kC) && y.customElements) {
                    var b = y.customElements.get("lima-video");
                    a.g instanceof b ? X.getInstance().report(153, { limvid: "limastart" }) : X.getInstance().report(153, { limvid: "videostart" });
                }
            } catch (c) {
                X.getInstance().report(153, { limvid: "startfail" });
            }
            b = typeof a.g.getAttribute === "function" && a.g.getAttribute("playsinline") != null;
            b = b === void 0 ? !1 : b;
            ((!QD() && !RD(10)) || (!b && (YI.getInstance(), !1)) ? (YI.getInstance(), zb(Gb(), "Xbox")) || (yc || Ac ? 0 : (!xc || (xc && PD(OD, 4))) && (Yq() ? (YI.getInstance(), !1) : !$I())) : 1) ||
                !xc ||
                (xc && PD(OD, 3)) ||
                ((yc || Ac) && !RD(4)) ||
                WP(a);
        }
    };
    l = VP.prototype;
    l.Ug = function () {
        this.U = !0;
        this.M && jP(this);
        this.M = !1;
        YP(this);
    };
    l.Tg = function () {
        this.loaded || ((this.loaded = !0), this.dispatchEvent("loaded"));
    };
    l.Ue = function (a) {
        this.l != null ? (this.P = a) : (this.dispatchEvent("play"), Bc || QD() || Nc || XP(this));
    };
    l.Xg = function (a) {
        if (!this.G && (Bc || QD() || Nc)) {
            if (this.getCurrentTime() <= 0) return;
            if (Nc && this.g.ended && this.getDuration() === 1) {
                this.W(a);
                return;
            }
            XP(this);
        }
        if (Bc || zb(Gb(), "Nintendo WiiU")) {
            if (this.getCurrentTime() - this.D > 1.5) {
                this.K = !0;
                this.g.currentTime = this.D;
                return;
            }
            this.K = !1;
            this.getCurrentTime() > this.D && (this.D = this.getCurrentTime());
        }
        this.dispatchEvent("timeUpdate");
    };
    l.Zg = function () {
        this.dispatchEvent("volumeChange");
    };
    l.Wg = function () {
        if (this.G && Bc && !this.Z && (ZP(this) < 2 || this.K)) {
            this.C = new Ow(250);
            this.j.listen(this.C, "tick", this.oa);
            this.C.start();
            var a = !0;
        } else a = !1;
        a || this.l || this.dispatchEvent("pause");
    };
    l.Sg = function () {
        var a = !0;
        if (Bc || zb(Gb(), "Nintendo WiiU")) a = this.D >= this.g.duration - 1.5;
        !this.K && a && this.dispatchEvent("end");
    };
    var WP = function (a) {
        a.dispatchEvent("beginFullscreen");
    };
    VP.prototype.ga = function () {
        this.dispatchEvent("endFullscreen");
    };
    VP.prototype.W = function () {
        this.dispatchEvent("error");
    };
    VP.prototype.ka = function () {
        this.dispatchEvent("click");
    };
    var YP = function (a) {
        a.g instanceof HTMLElement &&
            ((a.V = ID(a.g, UP)),
            a.V.then(function (b) {
                a.Ea() || L(K.getInstance(), "ps", b.width + "x" + b.height);
            }));
    };
    VP.prototype.wa = function () {
        var a = this.getSize(),
            b = KP(this.g);
        if (a.width !== this.size.width || a.height !== this.size.height) !this.fullscreen && b ? WP(this) : this.fullscreen && !b && this.ga(), (this.size = a), (this.fullscreen = b);
    };
    VP.prototype.oa = function () {
        if (!this.g.ended && this.g.paused && (Bc || Oc ? this.g.currentTime < this.g.duration : 1)) {
            var a = this.g.duration - this.g.currentTime,
                b = ZP(this);
            b > 0 && (b >= 2 || a < 2) && (Cr(this.C), jP(this));
        } else Cr(this.C);
    };
    var ZP = function (a) {
        var b;
        a: {
            for (b = a.g.buffered.length - 1; b >= 0; ) {
                if (a.g.buffered.start(b) <= a.g.currentTime) {
                    b = a.g.buffered.end(b);
                    break a;
                }
                b--;
            }
            b = 0;
        }
        return b - a.g.currentTime;
    };
    VP.prototype.Ra = function () {
        X.getInstance().report(139);
        WP(this);
    };
    var cQ = function (a) {
            if (a instanceof $P || a instanceof aQ || a instanceof bQ) return a;
            if (typeof a.next == "function")
                return new $P(function () {
                    return a;
                });
            if (typeof a[Symbol.iterator] == "function")
                return new $P(function () {
                    return a[Symbol.iterator]();
                });
            if (typeof a.Cb == "function")
                return new $P(function () {
                    return a.Cb();
                });
            throw Error("Not an iterator or iterable.");
        },
        $P = function (a) {
            this.g = a;
        };
    $P.prototype.Cb = function () {
        return new aQ(this.g());
    };
    $P.prototype[Symbol.iterator] = function () {
        return new bQ(this.g());
    };
    $P.prototype.j = function () {
        return new bQ(this.g());
    };
    var aQ = function (a) {
        this.g = a;
    };
    x(aQ, qs);
    aQ.prototype.next = function () {
        return this.g.next();
    };
    aQ.prototype[Symbol.iterator] = function () {
        return new bQ(this.g);
    };
    aQ.prototype.j = function () {
        return new bQ(this.g);
    };
    var bQ = function (a) {
        $P.call(this, function () {
            return a;
        });
        this.l = a;
    };
    x(bQ, $P);
    bQ.prototype.next = function () {
        return this.l.next();
    };
    var dQ = function (a, b) {
        this.j = {};
        this.g = [];
        this.l = this.size = 0;
        var c = arguments.length;
        if (c > 1) {
            if (c % 2) throw Error("Uneven number of arguments");
            for (var d = 0; d < c; d += 2) this.set(arguments[d], arguments[d + 1]);
        } else if (a)
            if (a instanceof dQ) for (c = a.Hc(), d = 0; d < c.length; d++) this.set(c[d], a.get(c[d]));
            else for (d in a) this.set(d, a[d]);
    };
    l = dQ.prototype;
    l.Gb = function () {
        eQ(this);
        for (var a = [], b = 0; b < this.g.length; b++) a.push(this.j[this.g[b]]);
        return a;
    };
    l.Hc = function () {
        eQ(this);
        return this.g.concat();
    };
    l.has = function (a) {
        return fQ(this.j, a);
    };
    l.isEmpty = function () {
        return this.size == 0;
    };
    l.clear = function () {
        this.j = {};
        this.l = this.size = this.g.length = 0;
    };
    l.remove = function (a) {
        return this.delete(a);
    };
    l.delete = function (a) {
        return fQ(this.j, a) ? (delete this.j[a], --this.size, this.l++, this.g.length > 2 * this.size && eQ(this), !0) : !1;
    };
    var eQ = function (a) {
        if (a.size != a.g.length) {
            for (var b = 0, c = 0; b < a.g.length; ) {
                var d = a.g[b];
                fQ(a.j, d) && (a.g[c++] = d);
                b++;
            }
            a.g.length = c;
        }
        if (a.size != a.g.length) {
            var e = {};
            for (c = b = 0; b < a.g.length; ) (d = a.g[b]), fQ(e, d) || ((a.g[c++] = d), (e[d] = 1)), b++;
            a.g.length = c;
        }
    };
    l = dQ.prototype;
    l.get = function (a, b) {
        return fQ(this.j, a) ? this.j[a] : b;
    };
    l.set = function (a, b) {
        fQ(this.j, a) || ((this.size += 1), this.g.push(a), this.l++);
        this.j[a] = b;
    };
    l.forEach = function (a, b) {
        for (var c = this.Hc(), d = 0; d < c.length; d++) {
            var e = c[d],
                f = this.get(e);
            a.call(b, f, e, this);
        }
    };
    l.keys = function () {
        return cQ(this.Cb(!0)).j();
    };
    l.values = function () {
        return cQ(this.Cb(!1)).j();
    };
    l.entries = function () {
        var a = this;
        return BD(this.keys(), function (b) {
            return [b, a.get(b)];
        });
    };
    l.Cb = function (a) {
        eQ(this);
        var b = 0,
            c = this.l,
            d = this,
            e = new qs();
        e.next = function () {
            if (c != d.l) throw Error("The map has changed since the iterator was created");
            if (b >= d.g.length) return rs;
            var f = d.g[b++];
            return { value: a ? f : d.j[f], done: !1 };
        };
        return e;
    };
    var fQ = function (a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    };
    var hQ = function () {
        R.call(this);
        this.currentTime = 0;
        this.duration = NaN;
        this.l = !0;
        this.volume = 1;
        this.muted = !1;
        this.C = 1;
        this.playbackRate = 0;
        this.j = this.g = this.G = null;
        this.buffered = new gQ();
        this.D = new gQ();
        this.B = "";
        this.tagName = "VIDEO";
        this.height = this.width = 0;
        this.canPlayType = function () {
            return "";
        };
        this.A = new gE(this);
        Er(this, this.A);
        var a = mI(oI);
        a && (this.duration = jI(a));
    };
    x(hQ, R);
    var iQ = function () {
        var a = ["video/mp4"],
            b = ["video/ogg"],
            c = new hQ();
        c.canPlayType = function (d) {
            return a.includes(d) ? "probably" : b.includes(d) ? "maybe" : "";
        };
        return c;
    };
    l = hQ.prototype;
    l.pause = function () {
        if (!this.l) {
            var a;
            (a = this.G) == null || a.stop();
            this.l = !0;
            this.dispatchEvent("timeupdate");
            this.dispatchEvent("pause");
        }
    };
    l.load = function () {
        this.l = !0;
        this.dispatchEvent("loadstart");
        var a;
        isNaN(this.duration) ? (a = 10 + Math.random() * 20) : (a = this.duration);
        this.duration = Number(a);
        this.dispatchEvent("durationchange");
        a = this.D;
        a.g.push(new jQ(this.duration));
        a.length = a.g.length;
        a = this.buffered;
        a.g.push(new jQ(this.duration));
        a.length = a.g.length;
        this.dispatchEvent("loadedmetadata");
        this.currentTime > 0 && this.dispatchEvent("timeupdate");
        this.dispatchEvent("loadeddata");
        this.dispatchEvent("canplay");
        this.dispatchEvent("canplaythrough");
        this.dispatchEvent("progress");
        this.playbackRate = this.C;
    };
    l.setVolume = function (a) {
        this.volume = a;
        this.dispatchEvent("volumechange");
    };
    l.setAttribute = function (a, b) {
        a != null && kQ.set(a, b);
    };
    l.getAttribute = function (a) {
        return kQ.get(a);
    };
    l.Yg = function (a) {
        var b = null,
            c = null;
        switch (a.type) {
            case "loadeddata":
                b = "Loaded";
                break;
            case "playing":
                b = "Playing";
                c = "#00f";
                break;
            case "pause":
                b = "Paused";
                break;
            case "ended":
                (b = "Ended"), (c = "#000");
        }
        b && this.j && (this.j.innerText = b);
        c && this.g && (this.g.style.backgroundColor = c);
    };
    ea.Object.defineProperties(hQ.prototype, {
        src: {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return this.B;
            },
            set: function (a) {
                this.B = a;
            },
        },
    });
    var kQ = new dQ(),
        jQ = function (a) {
            this.startTime = 0;
            this.endTime = a;
        },
        gQ = function () {
            this.length = 0;
            this.g = [];
        };
    gQ.prototype.start = function (a) {
        return this.g[a].startTime;
    };
    gQ.prototype.end = function (a) {
        return this.g[a].endTime;
    };
    var mQ = function (a) {
        Q.call(this);
        this.o = a;
        this.l = this.g = null;
        this.j = lQ(this);
        this.g = gj("DIV", { style: "display:none;" });
        this.o.appendChild(this.g);
        this.g.appendChild(this.j);
        this.l = gj("DIV", { style: "position:absolute;width:100%;height:100%;left:0px;top:0px" });
        this.g.appendChild(this.l);
        hH(function () {
            L(K.getInstance(), "haob", "1");
        });
    };
    x(mQ, Q);
    mQ.prototype.initialize = function () {
        this.j && this.j.load();
    };
    mQ.prototype.O = function () {
        hj(this.g);
        Q.prototype.O.call(this);
    };
    var lQ = function (a) {
            var b = mI(oI);
            if (iI(b, "useVideoElementFake"))
                (a = iQ()),
                    (b = gj("DIV", { style: "position:absolute;width:100%;height:100%;top:0px;left:0px;" })),
                    Object.assign(b, a),
                    (a.g = gj("DIV", { style: "position:absolute;width:100%;height:100%;top:0px;left:0px;background-color:#000" })),
                    (a.j = gj("P", { style: "position:absolute;top:25%;margin-left:10px;font-size:24px;color:#fff;" })),
                    a.g.appendChild(a.j),
                    b.appendChild(a.g),
                    a.A.listen(a, ["loadeddata", "playing", "pause", "ended"], a.Yg),
                    (a = b);
            else {
                b = !1;
                try {
                    window.location.search.indexOf("goog_limavideo=true") !== -1 && (b = !0);
                } catch (c) {}
                if (nQ(a, b)) {
                    b && console.log("force lima video in wrapper");
                    a = null;
                    try {
                        a = new tH();
                    } catch (c) {
                        (a = gj("lima-video")), lo(kC) && X.getInstance().report(153, { limvid: "firefail" });
                    }
                    a.style.backgroundColor = "#000";
                    a.style.height = "100%";
                    a.style.width = "100%";
                    a.style.position = "absolute";
                    a.style.left = "0";
                    a.style.top = "0";
                } else a = gj("VIDEO", { style: "background-color:#000;position:absolute;width:100%;height:100%;left:0;top:0;", title: "Advertisement".toString() });
            }
            a.setAttribute("webkit-playsinline", "true");
            a.setAttribute("playsinline", "true");
            return a;
        },
        nQ = function (a, b) {
            if (!y.customElements) return !1;
            if (b) return !0;
            if (Nb() && Xi(a.o) !== document) return !1;
            lo(kC) && X.getInstance().report(153, { limvid: "vw" });
            return lo(kC) ? !0 : !1;
        };
    mQ.prototype.Ub = function () {
        return this.l;
    };
    mQ.prototype.lb = function () {
        var a = this.g;
        a != null && (a.style.display = "none");
    };
    var rQ = function (a, b, c) {
        var d = a && a.getRootNode ? a.getRootNode({ composed: !0 }) : a;
        if (a == null || !ij(Xi(d), d)) throw MJ(LJ, null, "containerElement", "element");
        this.j = b;
        this.P = bJ(this.j || null);
        this.M = SD(this.j || null);
        this.K = String(Math.floor(Math.random() * 1e9));
        this.D = !1;
        this.jc = a;
        this.I = b != null;
        oI.g = 2;
        this.J = oQ(b ? b : null);
        d = gj("DIV", { style: "position:absolute" });
        a.insertBefore(d, a.firstChild);
        this.o = d;
        this.g = null;
        pQ(this) && b ? (a = new VP(b)) : ((this.g = new mQ(this.o)), (a = new VP(this.g.j)));
        this.da = a;
        this.ya = this.l = null;
        if ((a = this.g && oI.o)) a = !(pQ(this) || yc || Ac || Zq() || (xc && (!xc || !PD(OD, 4))));
        a && ((this.l = new mQ(this.o)), (this.ya = new VP(this.l.j)));
        this.A = c || null;
        this.G = this.A != null;
        pQ(this) && b ? (typeof b.getBoundingClientRect !== "function" ? ((c = this.o), (oI.l = c)) : (c = b)) : (c = this.o);
        this.C = c;
        this.B = new CP(this.o, this, !1);
        this.size = new ri(0, 0);
        this.L = "";
        b && ((b = hD(b.src || b.currentSrc)), b.toString().length < 200 ? (this.L = b.toString()) : b.j.length < 200 && (this.L = b.j));
        this.oe = new Map();
        this.oe.set("videoDisplay1", this.da);
        this.ya && this.oe.set("videoDisplay2", this.ya);
        qQ(this) && !oI.j && console.warn("Custom media element must be a <video> or <audio> element. Viewability/audibility measurement will fail.");
    };
    l = rQ.prototype;
    l.initialize = function () {
        this.D = !0;
        this.g != null && this.g.initialize();
        this.l != null && this.l.initialize();
    };
    l.va = function () {
        return this.D;
    };
    l.destroy = function () {
        var a = this;
        this.j = null;
        Cr(this.g);
        Cr(this.l);
        Cr(this.B);
        this.da.tc(function () {
            return Cr(a.da);
        });
        this.ya != null &&
            this.ya.tc(function () {
                return Cr(a.ya);
            });
        hj(this.o);
    };
    l.kd = function () {
        if (this.g != null) {
            var a = this.g.g;
            a != null && (a.style.display = "block");
        }
    };
    l.uc = function (a) {
        this.da !== a && this.g && this.l && this.ya && (a.setVolume(this.da.getVolume()), (a = this.da), (this.da = this.ya), (this.ya = a), (a = this.g), (this.g = this.l), (this.l = a), this.l.lb(), this.B.uc(this.da));
    };
    l.lb = function () {
        this.g != null && this.g.lb();
    };
    l.Ub = function () {
        return this.G && this.A ? this.A : this.g != null ? this.g.Ub() : null;
    };
    var pQ = function (a) {
            return aJ(a.J) && a.I;
        },
        qQ = function (a) {
            var b = ["VIDEO", "AUDIO"],
                c;
            return pQ(a) && !!a.j && !b.includes((c = a.j.tagName) == null ? void 0 : c.toUpperCase());
        };
    rQ.prototype.getSize = function () {
        return this.size;
    };
    var oQ = function (a) {
        return a != null && typeof a.getAttribute === "function" && a.getAttribute("playsinline") != null ? !0 : !1;
    };
    rQ.prototype.ae = function (a) {
        this.da.ae(a);
    };
    rQ.prototype.be = function () {
        this.da.be();
    };
    rQ.prototype.destroy = rQ.prototype.destroy;
    rQ.prototype.initialize = rQ.prototype.initialize;
    var sQ = { AD_LOAD: "adLoadError", AD_PLAY: "adPlayError" },
        tQ = function (a) {
            var b = Error.call(this);
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.data = a;
        };
    x(tQ, Error);
    l = tQ.prototype;
    l.getInnerError = function () {
        var a = this.data.innerError;
        return a instanceof Object ? new tQ(a) : a != null ? Error(a) : null;
    };
    l.getMessage = function () {
        return this.data.errorMessage;
    };
    l.getErrorCode = function () {
        return this.data.errorCode;
    };
    l.getVastErrorCode = function () {
        var a = this.getErrorCode();
        return a < 1e3 ? a : 900;
    };
    l.getType = function () {
        return this.data.type;
    };
    l.toString = function () {
        return "AdError " + this.getErrorCode() + ": " + this.getMessage() + (this.getInnerError() != null ? " Caused by: " + this.getInnerError() : "");
    };
    tQ.prototype.getType = tQ.prototype.getType;
    tQ.prototype.getVastErrorCode = tQ.prototype.getVastErrorCode;
    tQ.prototype.getErrorCode = tQ.prototype.getErrorCode;
    tQ.prototype.getMessage = tQ.prototype.getMessage;
    tQ.prototype.getInnerError = tQ.prototype.getInnerError;
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$ad_error.AdError.Type", sQ);
    var uQ = { AD_ERROR: "adError" },
        vQ = function (a, b) {
            b = b === void 0 ? null : b;
            Kv.call(this, "adError");
            this.error = a;
            this.g = b;
        };
    x(vQ, Kv);
    vQ.prototype.getError = function () {
        return this.error;
    };
    vQ.prototype.getUserRequestContext = function () {
        return this.g;
    };
    vQ.prototype.getUserRequestContext = vQ.prototype.getUserRequestContext;
    vQ.prototype.getError = vQ.prototype.getError;
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$ad_error_event.AdErrorEvent.Type", uQ);
    var wQ = {
            AD_CAN_PLAY: "adCanPlay",
            Ch: "adStarted",
            CONTENT_PAUSE_REQUESTED: "contentPauseRequested",
            CONTENT_RESUME_REQUESTED: "contentResumeRequested",
            CLICK: "click",
            VIDEO_CLICKED: "videoClicked",
            VIDEO_ICON_CLICKED: "videoIconClicked",
            pe: "engagedView",
            EXPANDED_CHANGED: "expandedChanged",
            STARTED: "start",
            AD_PROGRESS: "adProgress",
            AD_BUFFERING: "adBuffering",
            IMPRESSION: "impression",
            ue: "measurable_impression",
            VIEWABLE_IMPRESSION: "viewable_impression",
            qe: "fully_viewable_audible_half_duration_impression",
            Jf: "overlay_resize",
            Kf: "overlay_unmeasurable_impression",
            Lf: "overlay_unviewable_impression",
            Nf: "overlay_viewable_immediate_impression",
            Mf: "overlay_viewable_end_of_session_impression",
            Th: "externalActivityEvent",
            PAUSED: "pause",
            RESUMED: "resume",
            FIRST_QUARTILE: "firstQuartile",
            MIDPOINT: "midpoint",
            THIRD_QUARTILE: "thirdQuartile",
            COMPLETE: "complete",
            DURATION_CHANGE: "durationChange",
            USER_CLOSE: "userClose",
            Si: "userRecall",
            Gi: "prefetched",
            LOADED: "loaded",
            ALL_ADS_COMPLETED: "allAdsCompleted",
            SKIPPED: "skip",
            Rf: "skipShown",
            LINEAR_CHANGED: "linearChanged",
            SKIPPABLE_STATE_CHANGED: "skippableStateChanged",
            AD_METADATA: "adMetadata",
            AD_BREAK_FETCH_ERROR: "adBreakFetchError",
            AD_BREAK_READY: "adBreakReady",
            LOG: "log",
            VOLUME_CHANGED: "volumeChange",
            VOLUME_MUTED: "mute",
            INTERACTION: "interaction",
            Hh: "companionBackfill",
            Qi: "trackingUrlPinged",
            Ti: "video_card_endcap_collapse",
            Ui: "video_card_endcap_dismiss",
            Vi: "video_card_endcap_impression",
            Kh: "companionInitialized",
            Jh: "companionImpression",
            Ih: "companionClick",
            Ai: "mediaUrlPinged",
            LOAD_START: "loadStart",
            Ci: "navigationRequested",
        },
        xQ = function (a, b, c) {
            b = b === void 0 ? null : b;
            c = c === void 0 ? null : c;
            Kv.call(this, a);
            this.ad = b;
            this.l = c;
        };
    x(xQ, Kv);
    xQ.prototype.getAd = function () {
        return this.ad;
    };
    xQ.prototype.getAdData = function () {
        return this.l;
    };
    xQ.prototype.getAdData = xQ.prototype.getAdData;
    xQ.prototype.getAd = xQ.prototype.getAd;
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$ad_event.AdEvent.Type", wQ);
    var yQ = function (a, b) {
        b = b === void 0 ? null : b;
        xQ.call(this, "adMetadata", a);
        this.g = b;
    };
    x(yQ, xQ);
    yQ.prototype.qg = function () {
        return this.g;
    };
    yQ.prototype.getAdCuePoints = yQ.prototype.qg;
    var zQ = function (a) {
        this.adBreakDuration = a.adBreakDuration;
        this.adPosition = a.adPosition;
        this.currentTime = a.currentTime;
        this.duration = a.duration;
        this.totalAds = a.totalAds;
    };
    var AQ = function (a, b) {
        R.call(this);
        this.l = a;
        this.B = b;
        this.j = this.l.currentTime;
        this.g = new Ow(250);
        Er(this, this.g);
        this.A = new gE(this);
        Er(this, this.A);
        iE(this.A, this.g, "tick", this.C, !1, this);
    };
    x(AQ, R);
    AQ.prototype.jb = function () {
        return this.j;
    };
    AQ.prototype.start = function () {
        BQ(this);
        this.g.start();
    };
    AQ.prototype.stop = function () {
        this.g.stop();
    };
    AQ.prototype.C = function () {
        var a = this.l.currentTime;
        a !== this.jb() && ((this.j = a), BQ(this));
    };
    var BQ = function (a) {
        var b = {};
        b.currentTime = a.jb();
        vJ(a.B, "contentTimeUpdate", "contentTimeUpdate", b);
    };
    var CQ = vc && "srcdoc" in ej(document, "IFRAME"),
        DQ = function (a, b) {
            a.open("text/html", "replace");
            Mi(a, Bl(String(b)));
            a.close();
        };
    var EQ = {
            rgb: !0,
            rgba: !0,
            alpha: !0,
            rect: !0,
            image: !0,
            "linear-gradient": !0,
            "radial-gradient": !0,
            "repeating-linear-gradient": !0,
            "repeating-radial-gradient": !0,
            "cubic-bezier": !0,
            matrix: !0,
            perspective: !0,
            rotate: !0,
            rotate3d: !0,
            rotatex: !0,
            rotatey: !0,
            steps: !0,
            rotatez: !0,
            scale: !0,
            scale3d: !0,
            scalex: !0,
            scaley: !0,
            scalez: !0,
            skew: !0,
            skewx: !0,
            skewy: !0,
            translate: !0,
            translate3d: !0,
            translatex: !0,
            translatey: !0,
            translatez: !0,
        },
        FQ = function (a) {
            a = xb(a);
            if (a == "") return null;
            var b = String(a.slice(0, 4)).toLowerCase();
            if (("url(" < b ? -1 : "url(" == b ? 0 : 1) == 0) return null;
            if (a.indexOf("(") > 0) {
                if (/"|'/.test(a)) return null;
                b = /([\-\w]+)\(/g;
                for (var c; (c = b.exec(a)); ) if (!(c[1].toLowerCase() in EQ)) return null;
            }
            return a;
        };
    function GQ(a, b) {
        a = y[a];
        return a && a.prototype ? ((b = Object.getOwnPropertyDescriptor(a.prototype, b)) && b.get) || null : null;
    }
    function HQ(a) {
        var b = y.CSSStyleDeclaration;
        return (b && b.prototype && b.prototype[a]) || null;
    }
    GQ("Element", "attributes") || GQ("Node", "attributes");
    GQ("Element", "innerHTML") || GQ("HTMLElement", "innerHTML");
    GQ("Node", "nodeName");
    GQ("Node", "nodeType");
    GQ("Node", "parentNode");
    GQ("Node", "childNodes");
    GQ("HTMLElement", "style") || GQ("Element", "style");
    GQ("HTMLStyleElement", "sheet");
    var IQ = HQ("getPropertyValue"),
        JQ = HQ("setProperty");
    GQ("Element", "namespaceURI") || GQ("Node", "namespaceURI");
    function KQ(a, b, c, d) {
        if (a) return a.apply(b, d);
        if (rc && document.documentMode < 10) {
            if (!b[c].call) throw Error("IE Clobbering detected");
        } else if (typeof b[c] != "function") throw Error("Clobbering detected");
        return b[c].apply(b, d);
    }
    var LQ = ka([""]),
        MQ = { "-webkit-border-horizontal-spacing": !0, "-webkit-border-vertical-spacing": !0 },
        OQ = function (a) {
            if (!a) return pi(LQ);
            var b = document.createElement("div").style;
            NQ(a).forEach(function (c) {
                var d = vc && c in MQ ? c : c.replace(/^-(?:apple|css|epub|khtml|moz|mso?|o|rim|wap|webkit|xv)-(?=[a-z])/i, "");
                d.lastIndexOf("--", 0) != 0 &&
                    d.lastIndexOf("var", 0) != 0 &&
                    ((c = KQ(IQ, a, a.getPropertyValue ? "getPropertyValue" : "getAttribute", [c]) || ""), (c = FQ(c)), c != null && KQ(JQ, b, b.setProperty ? "setProperty" : "setAttribute", [d, c]));
            });
            return new ni(b.cssText || "");
        },
        NQ = function (a) {
            Xa(a) ? (a = hc(a)) : ((a = yi(a)), dc(a, "cssText"));
            return a;
        };
    var PQ = ka([""]),
        QQ = function (a, b, c) {
            R.call(this);
            this.j = a;
            this.A = b;
            this.D = c;
            this.g = null;
            this.G = "";
            this.I = pi(PQ);
            this.K = 0;
            this.B = this.slot = this.l = null;
            this.C = "";
        };
    x(QQ, R);
    QQ.prototype.init = function (a) {
        this.C = a;
        a = "about:blank";
        rc && (a = "");
        this.l = gj("IFRAME", { src: a, allowtransparency: !0, background: "transparent", title: "Advertisement" });
        Eq(this.l, { display: "none", width: "0", height: "0" });
        a = this.j.jc;
        a.appendChild(this.l);
        a = a.ownerDocument;
        a = a.defaultView || a.parentWindow;
        this.B == null && (this.B = new gE(this));
        this.B.listen(a, "message", this.M);
        a = '<body><script src="//imasdk.googleapis.com/js/sdkloader/loader.js">\x3c/script><script>loader = new VPAIDLoader(false, "' + (this.C + '");\x3c/script></body>');
        if (Oc || Jc || sc) {
            var b = this.l.contentWindow;
            b && DQ(b.document, a);
        } else (b = this.l), CQ ? ((a = Bl(a)), (b.srcdoc = mi(a))) : (b = b.contentWindow) && DQ(b.document, a);
    };
    QQ.prototype.M = function (a) {
        try {
            var b = a.g.data;
            try {
                var c = JSON.parse(b);
            } catch (t) {
                return;
            }
            var d = c.session;
            if (d != null && this.C === d)
                switch (c.type) {
                    case "friendlyReady":
                        var e = RQ(this);
                        if (e != null) {
                            this.g = e;
                            this.G = e.currentSrc;
                            var f = e.style.cssText,
                                g = document.implementation.createHTMLDocument("").createElement("DIV");
                            g.style.cssText = f;
                            this.I = OQ(g.style);
                            this.K = e.currentTime;
                        } else {
                            var h = this.j.jc,
                                k = "border: 0; margin: 0; padding: 0; position: absolute; ",
                                m = this.j.getSize();
                            k += "width:" + m.width + "px;";
                            k += "height:" + m.height + "px;";
                            this.g = gj("VIDEO", { style: k, autoplay: !0 });
                            h.appendChild(this.g);
                        }
                        var n = this.j.jc;
                        h = "border: 0; margin: 0; padding: 0;position: absolute; ";
                        var p = Nq(this.g);
                        h += "width:" + p.width + "px;";
                        h += "height:" + p.height + "px;";
                        this.slot = gj("DIV", { style: h });
                        n.appendChild(this.slot);
                        try {
                            this.l.contentWindow.loader.initFriendly(this.g, this.slot);
                        } catch (t) {
                            SQ(this);
                        }
                        vJ(this.A, "vpaid", "", b);
                        break;
                    case "becameLinear":
                        this.g && !mj() && !lj() && Eq(this.g, { visibility: "visible" });
                        vJ(this.A, "vpaid", "", b);
                        break;
                    case "becameNonlinear":
                        TQ(this);
                        vJ(this.A, "vpaid", "", b);
                        break;
                    case "startAd":
                        n = {};
                        if (this.g) {
                            k = this.g.paused;
                            var q = this.g.currentTime > 0;
                            n.apl = q && !k ? "1" : "0";
                            n.ip = k ? "1" : "0";
                            n.iavp = q ? "1" : "0";
                        } else n.apl = "n";
                        X.getInstance().report(99, n);
                        vJ(this.A, "vpaid", "", b);
                        this.kd();
                        break;
                    default:
                        vJ(this.A, "vpaid", "", b);
                }
        } catch (t) {
            SQ(this);
        }
    };
    var SQ = function (a) {
        var b = { type: "error" };
        b.session = a.C;
        b = JSON.stringify(b);
        a.postMessage(b);
    };
    QQ.prototype.postMessage = function (a) {
        window.postMessage(a, "*");
    };
    var RQ = function (a) {
        return (a.D === "videoDisplayUnknown" ? a.j.da : a.j.oe.get(a.D)).A.g;
    };
    QQ.prototype.kd = function () {
        RQ(this) != null && this.j.kd();
    };
    var TQ = function (a) {
        a.g && !mj() && !lj() && Eq(a.g, { visibility: "hidden" });
    };
    QQ.prototype.O = function () {
        Cr(this.B);
        this.B = null;
        hj(this.slot);
        this.slot = null;
        hj(this.l);
        this.l = null;
        var a = RQ(this);
        if (a != null) {
            var b = a.style;
            var c = this.I;
            if (c instanceof ni) c = c.g;
            else throw Error("");
            b.cssText = c;
            mj() || lj() ? ((a.src = this.G), (a.currentTime = this.K)) : (a.removeAttribute("src"), this.j.lb());
        } else hj(this.g), (this.g = null);
        R.prototype.O.call(this);
    };
    var UQ = function (a, b) {
        Q.call(this);
        this.j = a;
        this.l = b;
        this.g = new Map();
    };
    x(UQ, Q);
    var VQ = function (a, b) {
        try {
            var c = b.na,
                d = c.session;
            switch (c.vpaidEventType) {
                case "createFriendlyIframe":
                    b = "videoDisplayUnknown";
                    c.videoDisplayName && (b = c.videoDisplayName);
                    var e = c.session,
                        f = new QQ(a.j, a.l, b);
                    a.g.set(e, f);
                    f.init(e);
                    break;
                case "vpaidNonLinear":
                    var g = a.g.get(d);
                    g && TQ(g);
                    break;
                case "destroyFriendlyIframe":
                    var h = a.g.get(d);
                    h && (h.dispose(), a.g.delete(d));
            }
        } catch (k) {
            X.getInstance().report(125, { msg: k.message });
        }
    };
    UQ.prototype.O = function () {
        this.g.forEach(function (a) {
            a.dispose();
        });
    };
    var WQ = function (a) {
        this.F = B(a);
    };
    x(WQ, H);
    WQ.prototype.getValue = function () {
        return D(this, 1);
    };
    WQ.prototype.getVersion = function () {
        return F(this, 5);
    };
    var XQ = Gh(WQ);
    var YQ = function () {
            this.g = window;
        },
        ZQ = function (a, b, c, d) {
            if (d) {
                var e = sg(c, 2) - Date.now() / 1e3;
                e = { Qc: Math.max(e, 0), path: D(c, 3), domain: D(c, 4), ed: !1 };
                c = c.getValue();
                a = a.g;
                pg(d, 5) && im(b, c, e, a);
            }
        },
        $Q = function (a, b, c) {
            if (c && dm(b, c, a.g)) {
                var d = a.g.location.hostname;
                if (d === "localhost") d = ["localhost"];
                else if (((d = d.split(".")), d.length < 2)) d = [];
                else {
                    for (var e = [], f = 0; f < d.length - 1; ++f) e.push(d.slice(f).join("."));
                    d = e;
                }
                d = w(d);
                for (var g = d.next(); !g.done; g = d.next()) (e = b), (f = a.g), (g = g.value), pg(c, 5) && f.origin !== "null" && new bm(f.document).remove(e, "/", g);
            }
        };
    var aR = function () {
        this.g = [];
        this.j = [];
    };
    l = aR.prototype;
    l.isEmpty = function () {
        return this.g.length === 0 && this.j.length === 0;
    };
    l.clear = function () {
        this.g = [];
        this.j = [];
    };
    l.contains = function (a) {
        return cc(this.g, a) || cc(this.j, a);
    };
    l.remove = function (a) {
        var b = this.g;
        b: {
            var c = b.length - 1;
            c < 0 && (c = Math.max(0, b.length + c));
            if (typeof b === "string") c = typeof a !== "string" || a.length != 1 ? -1 : b.lastIndexOf(a, c);
            else {
                for (; c >= 0; c--) if (c in b && b[c] === a) break b;
                c = -1;
            }
        }
        c >= 0 ? (ec(b, c), (b = !0)) : (b = !1);
        return b || dc(this.j, a);
    };
    l.Gb = function () {
        for (var a = [], b = this.g.length - 1; b >= 0; --b) a.push(this.g[b]);
        var c = this.j.length;
        for (b = 0; b < c; ++b) a.push(this.j[b]);
        return a;
    };
    var Z = function (a, b, c, d, e, f, g, h) {
        R.call(this);
        var k = this;
        this.I = a;
        this.g = b;
        this.adTagUrl = c;
        this.ga = d;
        this.Ra = e;
        this.D = g;
        this.Qa = h;
        this.A = new OO();
        this.M = !1;
        this.volume = 1;
        this.ga = d;
        this.aa = -1;
        this.C = this.l = this.j = null;
        this.B = new AQ({ currentTime: 0 }, this.D);
        this.G = new aR();
        this.ka = this.V = !1;
        this.W = new Map();
        this.Z = this.oa = !1;
        this.wa = new UQ(b, g);
        Er(this, this.wa);
        this.K = f && this.g.A != null;
        this.P = function () {
            var m = k.g.da,
                n = m.getCurrentTime();
            m = m.getDuration();
            return { currentTime: n, duration: m, isPlaying: !0, volume: k.volume };
        };
        this.U = new gE(this);
        this.U.listen(this.D, "adsManager", this.Eb);
    };
    x(Z, R);
    Z.prototype.Eb = function (a) {
        var b = this,
            c = a.messageType,
            d = a.na,
            e = {};
        switch (c) {
            case "error":
                bR(this);
                cR(this, d);
                break;
            case "contentPauseRequested":
                X.getInstance().report(130);
                dR(this);
                this.B.stop();
                eR(this, c, d);
                break;
            case "contentResumeRequested":
                fR(this, function () {
                    eR(b, c, d);
                });
                break;
            case "remainingTime":
                this.aa = d.remainingTime;
                break;
            case "skip":
                eR(this, c, d);
                break;
            case "log":
                eR(this, c, d, d.logData);
                break;
            case "companionBackfill":
                a = Ta("window.google_show_companion_ad");
                a != null && a();
                break;
            case "skipShown":
                this.M = !0;
                eR(this, c, d);
                break;
            case "interaction":
                eR(this, c, d, d.interactionData);
                break;
            case "vpaidEvent":
                VQ(this.wa, a);
                break;
            case "skippableStateChanged":
                e = d.adData;
                e.skippable != null && (this.M = e.skippable);
                eR(this, c, d);
                break;
            case "volumeChange":
                e = d.adData;
                e != null && typeof e.volume === "number" && (this.volume = e.volume);
                eR(this, c, d);
                break;
            case "firstQuartile":
                eR(this, kJ.firstQuartile, d);
                eR(this, c, d);
                break;
            case "thirdQuartile":
                eR(this, kJ.thirdQuartile, d);
                eR(this, c, d);
                break;
            case "updateGfpCookie":
                gR(this, d);
                break;
            default:
                eR(this, c, d);
        }
    };
    var eR = function (a, b, c, d) {
            if (c.companions == null) {
                var e = a.W.get(c.adId);
                c.companions = e != null ? e : [];
            }
            var f = c.adData;
            if ((e = f == null ? null : new Y(f))) a.j = e;
            switch (b) {
                case "adBreakReady":
                case "mediaUrlPinged":
                    b = new xQ(b, null, c);
                    break;
                case "adMetadata":
                    b = null;
                    c.adCuePoints != null && (b = new NO(c.adCuePoints));
                    b = new yQ(e, b);
                    break;
                case "allAdsCompleted":
                    a.j = null;
                    a.oa = !0;
                    b = new xQ(b, e);
                    break;
                case "contentPauseRequested":
                    a.Z = !1;
                    b = new xQ(b, e);
                    break;
                case "contentResumeRequested":
                    a.j = null;
                    a.Z = !0;
                    b = new xQ(b, e);
                    break;
                case "loaded":
                    a.aa = e.getDuration();
                    a.M = !1;
                    cJ() && ((d = a.I), (c = a.Ra), d.j.set(MO(e), a.P), MP(d) && LP(d, "loaded", MO(e), c));
                    b = new xQ(b, e, f);
                    break;
                case "start":
                    a.W.set(c.adId, c.companions);
                    a.g.Ub() != null && (a.l == null ? ((a.l = new YN()), a.U.listen(a.l, "click", a.Vg)) : bO(a.l), $N(a.l, a.g.Ub()));
                    b = new xQ(b, e);
                    break;
                case "complete":
                    a.l != null && bO(a.l);
                    cJ() && OP(a.I, a.P, MO(e));
                    a.j = null;
                    a.W.delete(c.adId);
                    b = new xQ(b, e);
                    break;
                case "log":
                    c = null;
                    d != null && d.type != null ? ((f = d.type), (f = f === "adLoadError" || f === "adPlayError")) : (f = !1);
                    f && (c = { adError: new tQ(d) });
                    b = new xQ(b, e, c);
                    break;
                case "interaction":
                    b = new xQ(b, e, d);
                    break;
                case "adProgress":
                    b = new xQ(b, e, new zQ(c));
                    break;
                default:
                    b = new xQ(b, e);
            }
            a.dispatchEvent(b);
            a.oa && a.Z && a.destroy();
        },
        cR = function (a, b) {
            var c = new vQ(new tQ(b));
            a.V ? (a.dispatchEvent(c), cJ() && a.j && OP(a.I, a.P, MO(a.j)), (a.j = null)) : a.G.j.push(c);
            a = { error: b.errorCode, vis: ml(document) };
            X.getInstance().report(7, a);
        },
        hR = function (a, b, c) {
            vJ(a.D, "adsManager", b, c);
        },
        fR = function (a, b) {
            X.getInstance().report(131);
            bR(a, b);
            a.Ea() || a.B.start();
        },
        dR = function (a) {
            var b = a.g.da;
            pQ(a.g) && a.A.restoreCustomPlaybackStateOnAdBreakComplete && b.te != null && b.te();
        },
        bR = function (a, b) {
            var c = a.g.da;
            pQ(a.g) && a.A.restoreCustomPlaybackStateOnAdBreakComplete && c.tc != null ? c.tc(b) : b && b();
        };
    l = Z.prototype;
    l.configureAdsManager = function (a, b) {
        this.C = a;
        a.currentTime != null && ((this.B = new AQ(a, this.D)), this.B.start());
        b != null && (this.A = iR(b));
    };
    l.init = function (a, b, c, d) {
        if (this.G.isEmpty()) {
            var e = this.g,
                f = null;
            e.j && d == null && (f = { vd: "setnull" });
            e.j && e.j === d && (f = { vd: "match" });
            if (e.j && e.j !== d) {
                f = bJ(d || null);
                var g = SD(d || null);
                f = { vd: "diff", oc: e.P, nc: f, oi: e.M, ni: g };
            }
            !e.j && d && (f = { vd: "new" });
            f && ((f.custVid = e.K), X.getInstance().report(93, f));
            d != null &&
                ((e.J = oQ(d)),
                aJ(e.J) &&
                    ((e.I = !0), Cr(e.g), Cr(e.l), Cr(e.ya), (e.g = null), (e.l = null), (e.ya = null), Cr(e.da), (e.da = new VP(d)), typeof d.getBoundingClientRect !== "function" ? ((e.C = e.o), (oI.l = e.C)) : (e.C = d), e.B.uc(e.da)));
            this.V = !0;
            this.resize(a, b, c);
            d = PO(this.A, this.K);
            e = {};
            a = ((e.adsRenderingSettings = d), (e.width = a), (e.height = b), (e.viewMode = c), e);
            hR(this, "init", a);
        } else {
            for (; !this.G.isEmpty(); ) (b = a = this.G), b.g.length === 0 && ((b.g = b.j), b.g.reverse(), (b.j = [])), (a = a.g.pop()), this.dispatchEvent(a);
            this.dispose();
        }
    };
    l.isCustomPlaybackUsed = function () {
        return pQ(this.g);
    };
    l.isCustomClickTrackingUsed = function () {
        return this.K;
    };
    l.getRemainingTime = function () {
        return this.aa;
    };
    l.getAdSkippableState = function () {
        return this.M;
    };
    l.discardAdBreak = function () {
        hR(this, "discardAdBreak");
    };
    l.updateAdsRenderingSettings = function (a) {
        if (a != null) {
            a = iR(a);
            var b = this.A.bitrate,
                c = a.bitrate;
            X.getInstance().report(96, { init: this.V ? "1" : "0", start: this.ka ? "1" : "0", old: b, new: c, changed: b !== c ? "1" : "0" });
            this.A = a;
            a = PO(this.A, this.K);
            b = {};
            a = ((b.adsRenderingSettings = a), b);
            hR(this, "updateAdsRenderingSettings", a);
        }
    };
    l.skip = function () {
        hR(this, "skip");
    };
    l.start = function () {
        if (this.adTagUrl) {
            (yc || Ac) && X.getInstance().report(50, { customPlayback: pQ(this.g) });
            this.g.va() || X.getInstance().report(26, { adtagurl: this.adTagUrl, customPlayback: pQ(this.g) });
            Tq(this.g.o) && X.getInstance().report(30, { adtagurl: this.adTagUrl, customPlayback: pQ(this.g) });
            var a = this.g.A,
                b = this.g.o,
                c;
            if ((c = a && b && !Tq(a)))
                (a = JP(a)), (b = JP(b)), (c = a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0 && a.left <= b.left + b.width && b.left <= a.left + a.width && a.top <= b.top + b.height && b.top <= a.top + a.height);
            b = c;
            X.getInstance().report(31, { adtagurl: this.adTagUrl, customPlayback: pQ(this.g), covers: b });
        }
        if (!this.g.va() && !pQ(this.g)) throw MJ(KJ);
        b = this.g;
        b.G = this.K && b.A != null;
        this.g.B.g.style.opacity = "1";
        if (this.C != null && this.getVolume() === 1) {
            var d, e;
            if (typeof ((d = this.C) == null ? void 0 : d.muted) === "boolean" && ((e = this.C) == null ? 0 : e.muted)) this.setVolume(0);
            else {
                var f;
                if (typeof ((f = this.C) == null ? void 0 : f.volume) === "number") {
                    var g;
                    d = (g = this.C) == null ? void 0 : g.volume;
                    if (d >= 0 && d <= 1) {
                        var h;
                        this.setVolume((h = this.C) == null ? void 0 : h.volume);
                    }
                }
            }
        }
        this.ka = !0;
        hR(this, "start");
    };
    l.Vg = function () {
        if (!this.A.disableClickThrough && this.j != null) {
            var a = this.j.data.clickThroughUrl;
            a != null && yD(a, this.j.data.attributionParams);
        }
    };
    l.resize = function (a, b, c) {
        var d = this.g,
            e = d.o;
        e != null && (a === -1 ? ((e.style.right = "0"), (e.style.left = "0")) : (e.style.width = a + "px"), b === -1 ? ((e.style.bottom = "0"), (e.style.top = "0")) : (e.style.height = b + "px"));
        e = d.B;
        e.g.width = a === -1 ? "100%" : String(a);
        e.g.height = b === -1 ? "100%" : String(b);
        try {
            e.g.offsetTop = e.g.offsetTop;
        } catch (f) {}
        d.size = new ri(a, b);
        d = {};
        a = ((d.width = a), (d.height = b), (d.viewMode = c), d);
        hR(this, "resize", a);
    };
    l.stop = function () {
        hR(this, "stop");
    };
    l.expand = function () {
        hR(this, "expand");
    };
    l.collapse = function () {
        hR(this, "collapse");
    };
    l.getVolume = function () {
        return this.volume;
    };
    l.setVolume = function (a) {
        this.volume = a;
        this.g.da.setVolume(a);
        var b = {};
        a = ((b.volume = a), b);
        hR(this, "volume", a);
    };
    l.pause = function () {
        hR(this, "pause");
    };
    l.resume = function () {
        hR(this, "resume");
    };
    l.destroy = function () {
        this.dispose();
    };
    l.getCuePoints = function () {
        return this.ga;
    };
    l.rg = function () {
        return this.j;
    };
    l.O = function () {
        hR(this, "destroy");
        this.l != null && this.l.dispose();
        this.U.dispose();
        this.G.clear();
        this.B && (this.B.stop(), this.B.dispose());
        cJ() && OP(this.I, this.P);
        R.prototype.O.call(this);
    };
    l.gg = function () {
        X.getInstance().report(124, { api: "clicked" });
        var a = this.j && this.j.data.clickThroughUrl,
            b;
        if (a && ((b = this.j) == null ? 0 : b.Oe())) {
            var c;
            yD(a, (c = this.j) == null ? void 0 : c.data.attributionParams);
        }
        hR(this, "click");
    };
    l.focus = function () {
        vJ(this.D, "userInteraction", "focusUiElement");
    };
    var gR = function (a, b) {
        var c = b.gfpCookieUserEnabled;
        b = b.gfpCookieClearData;
        var d = new WQ();
        d = Eg(d, 1, c ? "0" : "1");
        d = If(d, 2, re(2147483647));
        d = Eg(d, 3, "/");
        d = Eg(d, 4, window.location.hostname);
        var e = new YQ(),
            f,
            g;
        a = (g = (f = a.Qa) == null ? void 0 : EI(f)) != null ? g : null;
        ZQ(e, "__gpi_opt_out", d, a);
        if (!c || b) $Q(e, "__gads", a), $Q(e, "__gpi", a);
    };
    Z.prototype.clicked = Z.prototype.gg;
    Z.prototype.getCurrentAd = Z.prototype.rg;
    Z.prototype.getCuePoints = Z.prototype.getCuePoints;
    Z.prototype.destroy = Z.prototype.destroy;
    Z.prototype.resume = Z.prototype.resume;
    Z.prototype.pause = Z.prototype.pause;
    Z.prototype.setVolume = Z.prototype.setVolume;
    Z.prototype.getVolume = Z.prototype.getVolume;
    Z.prototype.collapse = Z.prototype.collapse;
    Z.prototype.expand = Z.prototype.expand;
    Z.prototype.stop = Z.prototype.stop;
    Z.prototype.resize = Z.prototype.resize;
    Z.prototype.start = Z.prototype.start;
    Z.prototype.skip = Z.prototype.skip;
    Z.prototype.updateAdsRenderingSettings = Z.prototype.updateAdsRenderingSettings;
    Z.prototype.discardAdBreak = Z.prototype.discardAdBreak;
    Z.prototype.getAdSkippableState = Z.prototype.getAdSkippableState;
    Z.prototype.getRemainingTime = Z.prototype.getRemainingTime;
    Z.prototype.isCustomClickTrackingUsed = Z.prototype.isCustomClickTrackingUsed;
    Z.prototype.isCustomPlaybackUsed = Z.prototype.isCustomPlaybackUsed;
    Z.prototype.init = Z.prototype.init;
    function iR(a) {
        if (a instanceof OO) return X.getInstance().report(174, { valid: !0 }), a;
        X.getInstance().report(174, { valid: !1 });
        var b = new OO();
        b.append(a);
        return b;
    }
    var jR = { ADS_MANAGER_LOADED: "adsManagerLoaded" },
        kR = function (a, b) {
            Kv.call(this, "adsManagerLoaded");
            this.g = a;
            this.l = b;
        };
    x(kR, Kv);
    kR.prototype.getAdsManager = function (a, b) {
        a = a || { currentTime: null };
        this.g.configureAdsManager(a, b);
        return this.g;
    };
    kR.prototype.getUserRequestContext = function () {
        return this.l;
    };
    kR.prototype.getUserRequestContext = kR.prototype.getUserRequestContext;
    kR.prototype.getAdsManager = kR.prototype.getAdsManager;
    z("module$exports$google3$javascript$ads$interactivemedia$sdk$clientside$api$ads_manager_loaded_event.AdsManagerLoadedEvent.Type", jR);
    var lR = function () {
        this.g = window;
    };
    function mR() {
        var a = window,
            b,
            c;
        return (c = ["pbjs"]
            .concat((b = a._pbjsGlobals) != null ? b : [])
            .map(function (d) {
                return a[d];
            })
            .find(function (d) {
                return Array.isArray(d == null ? void 0 : d.que);
            })) != null
            ? c
            : null;
    }
    function nR(a, b) {
        var c, d, e;
        b == null ? (e = void 0) : (e = b.get.call(b, a));
        return (d = (c = e) != null ? c : b == null ? void 0 : b.get(zj(a))) != null ? d : 0;
    }
    var oR = /^v?\d{1,3}(\.\d{1,3}){0,2}(-pre)?$/,
        pR = new Map(),
        qR = function (a, b) {
            var c = {};
            this.pbjs = a;
            this.slot = b;
            var d;
            this.ld = (d = c == null ? void 0 : c.ld) != null ? d : {};
            this.Cd = !(c == null || !c.Cd);
            var e;
            this.Fd = (e = c == null ? void 0 : c.Fd) != null ? e : new Map();
            var f;
            this.We = (f = c == null ? void 0 : c.We) != null ? f : new Map();
            var g;
            this.ye = (g = c == null ? void 0 : c.ye) != null ? g : new Ax();
            this.Te = c == null ? void 0 : c.Te;
            this.g = c;
        },
        tR = function (a, b, c) {
            var d = a.pbjs.getBidResponsesForAdUnitCode;
            if (d) {
                var e,
                    f,
                    g,
                    h,
                    k,
                    m = (k = (e = d((g = a.slot.Sb) != null ? g : "")) == null ? void 0 : e.bids) != null ? k : (f = d((h = a.slot.adUnitCode) != null ? h : "")) == null ? void 0 : f.bids;
                if (
                    m != null &&
                    m.length &&
                    ((e = m.filter(function (q) {
                        var t = q.auctionId;
                        var u = q.adId;
                        return (
                            t !== c &&
                            Object.values(a.ld).some(function (v) {
                                return v.includes(u);
                            })
                        );
                    })),
                    e.length)
                ) {
                    var n, p;
                    d =
                        (n = a.pbjs.adUnits) == null
                            ? void 0
                            : (p = n.find(function (q) {
                                  q = q.code;
                                  return q === a.slot.Sb || q === a.slot.adUnitCode;
                              })) == null
                            ? void 0
                            : p.mediaTypes;
                    n = w(e);
                    for (p = n.next(); !p.done; p = n.next())
                        (p = p.value), (e = rR(a, p, d)), (e = Cx(b, wx(zg(xx(vx(new ux(), p.bidder), 1), 6, !0), e))), sR(a, p.bidder, e), typeof p.timeToRespond === "number" && If(e, 2, re(Math.round(p.timeToRespond)));
                }
            }
        },
        sR = function (a, b, c) {
            for (var d = []; b && !d.includes(b); ) {
                d.unshift(b);
                var e = void 0,
                    f = void 0;
                b = (e = a.pbjs) == null ? void 0 : (f = e.aliasRegistry) == null ? void 0 : f[b];
            }
            Uf(c, 10, d, xe);
        },
        uR = function (a, b, c) {
            he(Ff(b, 3)) != null || (c === a.slot.adUnitCode ? Fg(b, 3, 1) : c === a.slot.Sb && Fg(b, 3, 2));
        },
        vR = function (a, b, c, d, e) {
            e = a.We.get(
                e != null
                    ? e
                    : function () {
                          return null;
                      }
            );
            (e == null ? void 0 : F(e, 1)) !== 1 && C(c, 5, e);
            cg(b, qx, 5) !== void 0 || (e ? (F(e, 1) === 1 ? Dx(b, e) : Dx(b, tx(rx(sx(new qx(), a.Cd), 1), nR(d, a.Fd)))) : Dx(b, rx(sx(new qx(), a.Cd), nR(d, a.Fd) ? 2 : 3)));
        },
        rR = function (a, b, c) {
            var d = b.cpm,
                e = b.originalCpm,
                f = b.currency,
                g = b.originalCurrency,
                h = b.dealId,
                k = b.adserverTargeting,
                m = b.bidder,
                n = b.adId,
                p = b.mediaType,
                q = b.height,
                t = b.width,
                u = b.meta,
                v = new ox();
            typeof d === "number" && (If(v, 2, re(Math.round(d * 1e6))), (g && g !== f) || ((d = Math.round(Number(e) * 1e6)), isNaN(d) || d === sg(v, 2) || If(v, 8, re(d))));
            typeof f === "string" && Eg(v, 3, f);
            ["string", "number"].includes(typeof h) && ((f = new gx()), (h = Eg(f, 1, String(h))), C(v, 6, h));
            if (typeof k === "object")
                for (h = w(["", "_" + m]), f = h.next(); !f.done; f = h.next()) {
                    d = f.value;
                    f = [];
                    e = w(Object.entries(k));
                    for (g = e.next(); !g.done; g = e.next()) {
                        g = w(g.value);
                        var E = g.next().value;
                        g = g.next().value;
                        E = ("" + E + d).slice(0, 20);
                        var P = void 0;
                        if ((P = a.ld[E]) != null && P.length)
                            if (a.ld[E][0] === String(g)) f.push(E);
                            else {
                                f = [];
                                break;
                            }
                    }
                    d = wg(v, 4, Jf());
                    Uf(v, 4, d.concat(f), xe);
                }
            switch (p || "banner") {
                case "banner":
                    Fg(v, 5, 1);
                    break;
                case "native":
                    Fg(v, 5, 2);
                    break;
                case "video":
                    Fg(v, 5, 3);
                    p = new mx();
                    var S;
                    if ((c == null ? void 0 : (S = c.video) == null ? void 0 : S.context) === "adpod") {
                        var ca,
                            Qa = c == null ? void 0 : (ca = c.video) == null ? void 0 : ca.adPodDurationSec;
                        If(p, 1, re(Qa));
                    } else (ca = c == null ? void 0 : (Qa = c.video) == null ? void 0 : Qa.maxduration), If(p, 1, re(ca));
                    var ra;
                    if (typeof (c == null ? void 0 : (ra = c.video) == null ? void 0 : ra.skip) === "number") {
                        var rb;
                        c = !!(c == null ? 0 : (rb = c.video) == null ? 0 : rb.skip);
                        zg(p, 2, c);
                    }
                    var Ab;
                    rb = (Ab = b.meta) == null ? void 0 : Ab.adServerCatId;
                    Ab = Eg(p, 3, rb);
                    if (typeof k !== "object") k = null;
                    else {
                        var db, uc;
                        rb = String((uc = (db = k["hb_pb_cat_dur_" + m]) != null ? db : k.hb_pb_cat_dur) != null ? uc : "");
                        var Ba, Kc, fa, Ja;
                        db = String((Ja = (fa = (Kc = (Ba = k["hb_cache_id_" + m]) != null ? Ba : k["hb_uuid_" + m]) != null ? Kc : k.hb_cache_id) != null ? fa : k.hb_uuid) != null ? Ja : "");
                        k = rb && db ? rb + "_" + db : db ? db : null;
                    }
                    Eg(Ab, 4, k);
                    C(v, 9, p);
            }
            Number.isFinite(q) && Number.isFinite(t) && ((k = new kx()), (t = Bg(k, 1, Math.round(t))), (q = Bg(t, 2, Math.round(q))), C(v, 7, q));
            typeof n === "string" && Eg(v, 1, n);
            var Lc, Mc;
            if (((Lc = a.g) == null ? 0 : Lc.Vf) && Array.isArray(u == null ? void 0 : u.advertiserDomains) && (u == null ? 0 : (Mc = u.advertiserDomains[0]) == null ? 0 : Mc.length)) {
                var ke;
                n = u.advertiserDomains[0].substring(0, (ke = a.g) == null ? void 0 : ke.Vf);
                Eg(v, 10, n);
            }
            if (b.meta && a.g) {
                var eb, Xh;
                a.g.Xf && typeof b.meta.agencyId === "string" && ((Xh = b.meta.agencyId) == null ? 0 : Xh.length) && (eb != null || (eb = new ix()), Eg(eb, 1, b.meta.agencyId.substring(0, a.g.Xf)));
                var Yh;
                a.g.Yf && typeof b.meta.agencyId === "string" && ((Yh = b.meta.agencyName) == null ? 0 : Yh.length) && (eb != null || (eb = new ix()), Eg(eb, 2, b.meta.agencyName.substring(0, a.g.Yf)));
                var Zh;
                a.g.ng && typeof b.meta.networkId === "string" && ((Zh = b.meta.networkId) == null ? 0 : Zh.length) && (eb != null || (eb = new ix()), Eg(eb, 3, b.meta.networkId.substring(0, a.g.ng)));
                var $h;
                a.g.og && typeof b.meta.networkId === "string" && (($h = b.meta.networkName) == null ? 0 : $h.length) && (eb != null || (eb = new ix()), Eg(eb, 4, b.meta.networkName.substring(0, a.g.og)));
                eb && C(v, 11, eb);
            }
            return v;
        },
        wR = function (a, b) {
            var c = new Map(),
                d = function (k) {
                    var m = c.get(k);
                    m || ((m = {}), c.set(k, m));
                    return m;
                },
                e = [];
            a = w(a);
            for (var f = a.next(); !f.done; f = a.next()) {
                f = f.value;
                var g = f.args,
                    h = f.eventType;
                f = f.elapsedTime;
                h === "bidTimeout" && e.push.apply(e, la(g));
                switch (h) {
                    case "bidRequested":
                        if (g.auctionId !== b) continue;
                        if (!Array.isArray(g.bids)) continue;
                        g = w(g.bids);
                        for (h = g.next(); !h.done; h = g.next()) if ((h = h.value.bidId)) d(h).requestTime = f;
                        break;
                    case "noBid":
                        g.auctionId === b && g.bidId && (d(g.bidId).eh = f);
                }
            }
            d = new Map();
            a = w(c.entries());
            for (f = a.next(); !f.done; f = a.next()) (g = w(f.value)), (f = g.next().value), (h = g.next().value), (g = h.requestTime), (h = h.eh), g && h && d.set(f, { latency: h - g, Jb: !1 });
            e = w(e);
            for (a = e.next(); !a.done; a = e.next()) if (((f = a.value), (a = f.bidId), (f = f.auctionId), a && f === b && (a = d.get(a)))) a.Jb = !0;
            return d;
        },
        xR = function (a) {
            var b = new Map(),
                c,
                d,
                e = ((d = (c = a.pbjs) == null ? void 0 : c.getEvents) != null
                    ? d
                    : function () {
                          return [];
                      })();
            d = e.filter(function (fa) {
                var Ja = fa.eventType;
                fa = fa.args;
                return Ja === "auctionEnd" && fa.auctionId;
            });
            c = new Hx();
            var f = function (fa) {
                    return fa === a.slot.Sb || fa === a.slot.adUnitCode;
                },
                g,
                h,
                k,
                m = (k = pR.get(((g = a.slot.Sb) != null ? g : "") + ((h = a.slot.adUnitCode) != null ? h : ""))) != null ? k : 0,
                n;
            g =
                (n = d.filter(function (fa) {
                    var Ja, Lc, Mc;
                    return Number((Ja = fa.args) == null ? void 0 : Ja.timestamp) > m && ((Lc = fa.args) == null ? void 0 : (Mc = Lc.adUnitCodes) == null ? void 0 : Mc.find(f));
                })) != null
                    ? n
                    : [];
            if (!g.length) return null;
            var p;
            if (
                (n =
                    (p = g.reduce(function (fa, Ja) {
                        return Number(Ja.args.timestamp) > Number(fa.args.timestamp) ? Ja : fa;
                    })) == null
                        ? void 0
                        : p.args)
            ) {
                g = n.bidderRequests === void 0 ? [] : n.bidderRequests;
                p = n.bidsReceived === void 0 ? [] : n.bidsReceived;
                var q = n.auctionId;
                h = n.timestamp;
                if (q && h != null && g.length) {
                    var t, u;
                    pR.set(((t = a.slot.Sb) != null ? t : "") + ((u = a.slot.adUnitCode) != null ? u : ""), h);
                    t = Ix(c);
                    a.pbjs.version && oR.test(a.pbjs.version) && Eg(t, 6, a.pbjs.version);
                    var v, E, P, S;
                    if ((E = (v = a.pbjs).getConfig) == null ? 0 : (P = E.call(v).cache) == null ? 0 : (S = P.url) == null ? 0 : S.length) {
                        var ca, Qa, ra;
                        Ex(t, (Qa = (ca = a.pbjs).getConfig) == null ? void 0 : (ra = Qa.call(ca).cache) == null ? void 0 : ra.url);
                    }
                    C(t, 9, a.ye);
                    v = Lh(function () {
                        return wR(e, q);
                    });
                    var rb;
                    E = w(g);
                    S = E.next();
                    for (P = {}; !S.done; P = { bidderCode: void 0, jf: void 0 }, S = E.next())
                        for (ca = S.value, P.bidderCode = ca.bidderCode, Qa = ca.bids, S = ca.timeout, P.jf = ca.src, ca = ca.auctionStart, Qa = w(Qa), ra = Qa.next(), u = {}; !ra.done; u = { yc: void 0 }, ra = Qa.next())
                            if (((d = ra.value), (u.yc = d.bidId), (k = d.transactionId), (g = d.adUnitCode), (h = d.getFloor), (ra = d.mediaTypes), (d = d.ortb2Imp), u.yc && f(g))) {
                                uR(a, t, g);
                                var Ab = void 0,
                                    db = void 0,
                                    uc = void 0;
                                ((Ab = a.g) == null ? 0 : Ab.vg) &&
                                    og(t, 11) == null &&
                                    typeof ((db = d) == null ? void 0 : (uc = db.ext) == null ? void 0 : uc.gpid) === "string" &&
                                    ((Ab = void 0), Fx(t, d.ext.gpid.substring(0, (Ab = a.g) == null ? void 0 : Ab.vg)));
                                k && (rb != null || (rb = k), og(t, 4) != null || Eg(t, 4, k), b.has(k) || b.set(k, ca));
                                je(Ff(t, 8)) == null && Number.isFinite(S) && Bg(t, 8, S);
                                d = p.find(
                                    (function (fa) {
                                        return function (Ja) {
                                            return Ja.requestId === fa.yc;
                                        };
                                    })(u)
                                );
                                k = Cx(
                                    t,
                                    (function (fa) {
                                        return function () {
                                            var Ja = vx(new ux(), fa.bidderCode);
                                            sR(a, fa.bidderCode, Ja);
                                            switch (fa.jf) {
                                                case null:
                                                case void 0:
                                                case "client":
                                                    Fg(Ja, 7, 1);
                                                    break;
                                                case "s2s":
                                                    Fg(Ja, 7, 2);
                                            }
                                            return Ja;
                                        };
                                    })(P)()
                                );
                                vR(a, t, k, g, h);
                                if (d) {
                                    xx(k, 1);
                                    typeof d.timeToRespond === "number" && Number.isFinite(d.timeToRespond) && If(k, 2, re(Math.round(d.timeToRespond)));
                                    try {
                                        (g = u = void 0), (g = (u = a).Te) == null || g.call(u, d);
                                    } catch (fa) {}
                                    ra = rR(a, d, ra);
                                    wx(k, ra);
                                } else (ra = v().get(u.yc)) && !ra.Jb ? (xx(k, 2), Number.isFinite(ra.latency) && If(k, 2, re(Math.round(ra.latency)))) : ((ra = xx(k, 3)), Number.isFinite(S) && If(ra, 2, re(Math.round(S))));
                            }
                    var Ba, Kc;
                    ((Kc = (Ba = a.pbjs).getConfig) == null ? 0 : Kc.call(Ba).useBidCache) && tR(a, t, q);
                    return { Gg: c, transactionId: rb, arg: n };
                }
            }
        };
    function yR(a, b) {
        return xR(new qR(a, b));
    }
    var zR = function (a) {
        R.call(this);
        var b = this,
            c = kI(mI(this.getSettings()));
        c && c.length > 0 && (Zm.reset(), an(new en(c)));
        this.C = new YQ();
        this.B = null;
        this.j = a;
        this.G = new Map();
        this.A = this.j.B;
        this.K = new gE(this);
        Er(this, this.K);
        this.U = new AC(window, { timeoutMs: 500 });
        this.V = new sI(window, { timeoutMs: 500 });
        this.M = new QN();
        TN(this.M);
        a = new PC(window, { timeoutMs: 500 });
        this.P = new rO(a, 500);
        Er(this, this.P);
        this.g = null;
        this.I = {};
        oI.g !== 0 ? ((this.l = new GP()), Er(this, this.l)) : (this.l = HP());
        cJ() &&
            (this.l.init(BP(this.A)),
            (this.D = NP(this.l, this.j.C)),
            Dr(this, function () {
                var d = b.D;
                b.l.l.delete(d);
                oI.g !== 0 && (J(rv).o[d] = null);
            }));
    };
    x(zR, R);
    zR.prototype.destroy = function () {
        this.dispose();
    };
    zR.prototype.getVersion = function () {
        return "h.3.668.1";
    };
    zR.prototype.requestAds = function (a, b) {
        var c = this,
            d = [],
            e = null;
        CC(this.U) &&
            d.push(
                new Promise(function (h) {
                    FC(c.U, function (k) {
                        e = k;
                        h();
                    });
                })
            );
        var f = null;
        wC(this.V.caller) &&
            d.push(
                new Promise(function (h) {
                    tI(c.V, function (k) {
                        f = k;
                        h();
                    });
                })
            );
        var g = null;
        d.push(
            tO(this.P).then(function (h) {
                g = h;
            })
        );
        Promise.all(d).then(function () {
            AR(c, a, b, { ie: e, me: f, Hd: g });
        });
    };
    var AR = function (a, b, c, d) {
        var e = b.adTagUrl,
            f = "goog_" + Ri++;
        a.G.set(f, c || null);
        var g = BR({ adTagUrl: e, ie: d.ie, me: d.me, Hd: d.Hd });
        a.g = yI(e, g || {});
        JN(a.g, function () {
            CR(a);
        });
        var h,
            k = (h = b.adTagUrl) == null ? void 0 : h.includes("GOOGLE_INSTREAM_VIDEO_NONCE"),
            m = DI(a.g);
        c = DR(a, m, k);
        d = TN(a.M);
        var n = e ? eI(e) : null;
        e = gO()
            .then(function (p) {
                var q = p.serializedConfig;
                var t = p.errorMessage;
                if (q) q = Qx(q);
                else throw Error(t != null ? t : "Unknown PPC error");
                nO(q, n, p.latencyMs);
                return q;
            })
            .catch(function (p) {
                X.getInstance().report(189, { message: p.message });
                return null;
            });
        e = Promise.race([e, Qw(500, null)]);
        Promise.all([c, d, e]).then(function (p) {
            var q = w(p);
            q.next();
            p = q.next().value;
            q = q.next().value;
            var t = {};
            X.getInstance().report(182, ((t.aid = !!oI.B), (t.aidf = !!a.B), (t.hsc = !m && k), t));
            q = ER(a, b, g, p, q);
            t = BP(a.A, f);
            a.K.listen(t, "adsLoader", a.W);
            vJ(t, "adsLoader", "requestAds", q);
            q = {};
            X.getInstance().report(155, ((q.ws = PN()), (q.blob = p != null ? p : "undef"), q));
        });
    };
    zR.prototype.getSettings = function () {
        return oI;
    };
    zR.prototype.contentComplete = function () {
        vJ(BP(this.A), "adsLoader", "contentComplete");
    };
    zR.prototype.W = function (a) {
        var b = a.messageType;
        switch (b) {
            case "adsLoaded":
                b = a.na;
                a = a.sc;
                b = new Z(this.l, this.j, b.adTagUrl || "", b.adCuePoints, this.D, b.isCustomClickTrackingAllowed, BP(this.A, a), this.g);
                this.dispatchEvent(new kR(b, FR(this, a)));
                break;
            case "error":
                b = a.na;
                this.dispatchEvent(new vQ(new tQ(b), FR(this, a.sc)));
                a = { error: b.errorCode, vis: ml(document) };
                X.getInstance().report(7, a);
                break;
            case "cookieUpdate":
                a = a.na;
                if (a == null) break;
                if (oI.isCookiesEnabled()) {
                    b = new uI();
                    b = zg(b, 5, !0);
                    var c = a.gfpCookie;
                    c && ZQ(this.C, "__gads", XQ(c), b);
                    (c = a.gfpCookieV2) && ZQ(this.C, "__gpi", XQ(c), b);
                }
                if ((c = a.eoidCookie)) {
                    b = new lR();
                    c = XQ(c);
                    var d = sg(c, 2) - Date.now() / 1e3;
                    d = { Qc: Math.max(d, 0), path: D(c, 3), domain: D(c, 4), ed: !1 };
                    im("__eoi", c.getValue(), d, b.g);
                }
                GR(this, a.encryptedSignalBidderIds || []);
                break;
            case "trackingUrlPinged":
                this.dispatchEvent(new xQ(b, null, a.na));
        }
    };
    var GR = function (a, b) {
            b.length !== 0 &&
                (b = KN(
                    b.map(function (c) {
                        return { Cc: c };
                    }),
                    a.g
                )) &&
                b.forEach(function (c) {
                    c.then(function (d) {
                        d && CR(a);
                    });
                });
        },
        CR = function (a) {
            var b = XJ(IN(a.g));
            b && ((a.I.espSignals = b), vJ(BP(a.A), "adsLoader", "signalsRefresh", a.I));
        },
        FR = function (a, b) {
            var c = a.G.get(b);
            a.G.delete(b);
            return c != null ? c : null;
        },
        BR = function (a) {
            var b = a.ie,
                c = a.me;
            a = a.Hd;
            var d,
                e,
                f,
                g,
                h,
                k,
                m = {};
            var n = n === void 0 ? y : n;
            return (
                (m.gfcLoaded = Dj(n.top, "googlefcLoaded")),
                (m.addtlConsent = (d = b == null ? void 0 : b.addtlConsent) != null ? d : null),
                (m.gdprApplies = (e = b == null ? void 0 : b.gdprApplies) != null ? e : null),
                (m.tcString = (f = b == null ? void 0 : b.tcString) != null ? f : null),
                (m.uspString = (g = c == null ? void 0 : c.uspString) != null ? g : null),
                (m.gppString = (h = a == null ? void 0 : a.gppString) != null ? h : null),
                (m.gppSid = (k = a == null ? void 0 : a.sid) != null ? k : null),
                m
            );
        },
        HR = function (a, b) {
            var c = {};
            c.contentMediaUrl = a.j.L;
            c.customClickTrackingProvided = a.j.A != null;
            c.isAmp = gJ();
            a: {
                try {
                    var d = window.top.location.href;
                } catch (E) {
                    d = 2;
                    break a;
                }
                d = d == null ? 2 : d == window.document.location.href ? 0 : 1;
            }
            c.iframeState = d;
            c.imaHostingDomain = window.document.domain;
            c.imaHostingPageUrl = window.document.URL;
            c.topAccessiblePageUrl = fJ();
            c.referrer = window.document.referrer;
            c.domLoadTime = a.A.K;
            c.sdkImplLoadTime = a.A.M;
            c.supportsResizing = !pQ(a.j);
            d = dj().location.ancestorOrigins;
            c.topOrigin = d ? (d.length > 0 && d[d.length - 1].length < 200 ? d[d.length - 1] : "") : null;
            c.osdId = a.D;
            c.usesCustomVideoPlayback = pQ(a.j);
            c.usesProxyMediaElement = qQ(a.j);
            c.usesInlinePlayback = a.j.J;
            d = a.j.jc;
            a = [];
            var e = "",
                f = "";
            if (d != null) {
                e = d;
                f = !0;
                f = f === void 0 ? !1 : f;
                for (var g = [], h = 0; e && h < 25; ++h) {
                    var k = "";
                    (f !== void 0 && f) || (k = (k = e.nodeType !== 9 && e.id) ? "/" + k : "");
                    a: {
                        if (e && e.nodeName && e.parentElement) {
                            var m = e.nodeName.toString().toLowerCase();
                            for (var n = e.parentElement.childNodes, p = 0, q = 0; q < n.length; ++q) {
                                var t = n[q];
                                if (t.nodeName && t.nodeName.toString().toLowerCase() === m) {
                                    if (e === t) {
                                        m = "." + p;
                                        break a;
                                    }
                                    ++p;
                                }
                            }
                        }
                        m = "";
                    }
                    g.push((e.nodeName && e.nodeName.toString().toLowerCase()) + k + m);
                    e = e.parentElement;
                }
                e = g.join();
                if (d) {
                    d = ((d = d.ownerDocument) && (d.defaultView || d.parentWindow)) || null;
                    f = [];
                    if (d)
                        try {
                            var u = d.parent;
                            for (g = 0; u && u !== d && g < 25; ++g) {
                                var v = u.frames;
                                for (h = 0; h < v.length; ++h)
                                    if (d === v[h]) {
                                        f.push(h);
                                        break;
                                    }
                                d = u;
                                u = d.parent;
                            }
                        } catch (E) {}
                    f = f.join();
                } else f = "";
            }
            a.push(e, f);
            if (b != null) {
                for (u = 0; u < qC.length - 1; ++u) a.push(rj(b, qC[u]) || "");
                b = rj(b, "videoad_start_delay");
                u = "";
                b && ((b = parseInt(b, 10)), (u = b < 0 ? "postroll" : b == 0 ? "preroll" : "midroll"));
                a.push(u);
            } else for (b = 0; b < qC.length; ++b) a.push("");
            return (c.videoAdKey = zj(a.join(":")).toString()), c;
        },
        IR = function (a, b, c) {
            a = CI(a);
            b = b.adTagUrl ? eI(b.adTagUrl) : null;
            var d;
            c && b ? ((c = eg(c, Jx, 3)), (c = !!b && (c == null ? void 0 : (d = Rf(c, 1, Ce)) == null ? void 0 : d.get(b))), X.getInstance().report(196, { status: c, network: b }), (d = c != null ? c : !1)) : (d = !1);
            return { Ye: a, Ze: !d };
        },
        JR = function (a, b, c) {
            var d = EI(a);
            c = IR(a, b, c);
            a = new lR();
            b = c.Ye;
            c = c.Ze;
            return !gm(a.g) || pg(d, 8) || ((b || !pg(d, 5)) && c) ? !1 : !0;
        },
        KR = function (a, b, c) {
            var d = EI(a);
            c = IR(a, b, c);
            a = new lR();
            b = c.Ye;
            c = c.Ze;
            if (pg(d, 8) || ((b || !pg(d, 5)) && c)) d = void 0;
            else {
                var e;
                d = (e = em("__eoi", a.g)) != null ? e : void 0;
            }
            return d;
        },
        LR = function (a, b, c) {
            if (Pb() && Cj(window.fetch) && Cj(window.AbortController))
                try {
                    var d = window.isSecureContext && !["localhost", "127.0.0.1"].includes(window.location.hostname),
                        e = window.document;
                    var f = !!(d && "browsingTopics" in e && e.browsingTopics instanceof Function && Rn("browsing-topics", e));
                    if (a.j) {
                        var g = zI(a, "rdp");
                        var h = wI(g) ? "1" : "";
                    } else h = "";
                    d = h === "1";
                    var k,
                        m = zI(a, "us_privacy"),
                        n = a.g.uspString || m || "";
                    n = n.toUpperCase();
                    m = n;
                    if (m.length == 4 && (m.indexOf("-") == -1 || m.substring(1) === "---") && m[0] >= "1" && m[0] <= "9" && jy.hasOwnProperty(m[1]) && jy.hasOwnProperty(m[2]) && jy.hasOwnProperty(m[3])) {
                        var p = new iy();
                        var q = Cg(p, 1, parseInt(n[0], 10));
                        var t = G(q, 2, jy[n[1]]);
                        var u = G(t, 3, jy[n[2]]);
                        var v = G(u, 4, jy[n[3]]);
                    } else v = null;
                    var E = v;
                    var P;
                    if (!(P = (E == null ? void 0 : F(E, 3)) === 2 || FI(a)))
                        if (AI(a)) {
                            var S = BI(a);
                            P = S ? !JC(S, ["3", "4"], 0) : !0;
                        } else P = !1;
                    if (!(k = P)) {
                        var ca = zI(a, "npa"),
                            Qa = wI(ca);
                        k = (a.j && Qa ? "1" : "") === "1";
                    }
                    var ra;
                    if (!(ra = k || d || DI(a))) {
                        if (a.j) {
                            var rb = zI(a, "tfcd");
                            var Ab = rb === "0" || rb === "false" ? (0).toString() : wI(rb) ? (1).toString() : "";
                        } else Ab = "";
                        var db;
                        if (!(db = Ab === (1).toString())) {
                            if (a.j) {
                                var uc = zI(a, "tfua");
                                var Ba = uc === "0" || uc === "false" ? (0).toString() : wI(uc) ? (1).toString() : "";
                            } else Ba = "";
                            db = Ba === (1).toString();
                        }
                        ra = db;
                    }
                    a = !ra;
                    var Kc = b.adTagUrl ? eI(b.adTagUrl) : null;
                    if (c && Kc) {
                        var fa, Ja, Lc;
                        var Mc = (Lc = (fa = eg(c, Ox, 4)) == null ? void 0 : (Ja = Rf(fa, 1, Ce)) == null ? void 0 : Ja.get(Kc)) != null ? Lc : !0;
                    } else Mc = !0;
                    return f && a && Mc;
                } catch (eb) {
                    var ke;
                    X.getInstance().report(209, { message: (ke = eb) == null ? void 0 : ke.message });
                }
            return !1;
        },
        DR = function (a, b, c) {
            if (b) return (a.B = null), Promise.resolve([]);
            b = [];
            b.push(MR());
            c && b.push(NR(a));
            return Promise.all(b);
        },
        NR = function (a) {
            var b;
            return La(function (c) {
                if (c.g == 1) return a.B || ((a.B = new rJ()), sJ(a.B)), Aa(c, a.B.getId(), 2);
                b = c.j;
                oI.B = b.id || "";
                c.g = 0;
            });
        },
        MR = function () {
            return Pb() && (Wm(zn) || Wm(yn))
                ? Wm(yn)
                    ? new Promise(function (a) {
                          setTimeout(function () {
                              a();
                          }, 50);
                      })
                    : OR().then(function (a) {
                          var b,
                              c = (b = a.label) != null ? b : "";
                          oI.J = c;
                          oI.I = a.status;
                      })
                : Promise.resolve();
        },
        OR = function () {
            if (navigator.cookieDeprecationLabel) {
                var a = navigator.cookieDeprecationLabel
                        .getValue()
                        .then(function (c) {
                            return { label: c, status: 1 };
                        })
                        .catch(function () {
                            return { label: "", status: 2 };
                        }),
                    b = new Promise(function (c) {
                        setTimeout(function () {
                            c({ label: "", status: 5 });
                        }, 50);
                    });
                return Promise.race([b, a]);
            }
            return Promise.resolve({ label: "", status: 3 });
        },
        ER = function (a, b, c, d, e) {
            var f = {};
            f = ((f.limaExperimentIds = $m().sort().join(",")), f);
            var g = Gj(),
                h = On(),
                k = {};
            h = ((k.experimentStateProto = Ig(h)), k);
            k = nI(a.getSettings(), MP(a.l));
            var m = HR(a, b.adTagUrl),
                n = Sn(),
                p = {};
            c = ((p.consentSettings = c), (p.imalibExperiments = f), (p.genotypeExperimentData = h), (p.settings = k), (p.videoEnvironment = m), (p.isFledgeEligible = n), (p.pvsid = g), p);
            Object.assign(c, PR(b));
            a.g &&
                oI.isCookiesEnabled() &&
                ((f = EI(a.g)),
                (c.isBrowserCookieEnabled = gm(a.C.g) ? !!pg(f, 5) : !1),
                (g = f ? dm("__gads", f, a.C.g) : null),
                g !== null && (c.gfpCookieValue = g),
                (g = f ? dm("__gpi", f, a.C.g) : null),
                g !== null && (c.gfpCookieV2Id = g),
                (f = f ? dm("__gpi_opt_out", f, a.C.g) : null),
                f !== null && (c.gfpCookieV2OptOut = f));
            a.g && ((f = JR(a.g, b, e)), (c.eoidCookieEnabled = f), (f = KR(a.g, b, e)) && (c.eoidCookieValue = f));
            if ((f = XJ(IN(a.g)))) (a.I.espSignals = f), (c.espSignals = f);
            d && (c.gmaSignals = d);
            c.isEapLoader = !1;
            if (Wm(Cn) || lo(iC)) {
                d = function (P) {
                    X.getInstance().report(195, { message: P == null ? void 0 : P.message });
                };
                try {
                    var q = mR();
                    if (q) {
                        var t = fI(b.adTagUrl, d);
                        if (t && (Wm(Cn) || oO(e, dI(t)))) {
                            var u,
                                v = (u = yR(q, { adUnitCode: t })) == null ? void 0 : u.Gg;
                            c.clientBidsProto = v ? Sc(v.g(), 3) : void 0;
                        }
                    }
                } catch (P) {
                    d(P);
                }
            }
            a.g && (c.topicsEnabled = LR(a.g, b, e));
            try {
                c.quicksilverSignals = Ig(HJ(a.j));
            } catch (P) {
                var E;
                X.getInstance().report(212, { message: (E = P) == null ? void 0 : E.message }, !0);
            }
            return c;
        };
    zR.prototype.contentComplete = zR.prototype.contentComplete;
    zR.prototype.getSettings = zR.prototype.getSettings;
    zR.prototype.requestAds = zR.prototype.requestAds;
    zR.prototype.getVersion = zR.prototype.getVersion;
    zR.prototype.destroy = zR.prototype.destroy;
    var QR = function () {
            this.l = this.j = "unknown";
            this.g = "0";
            this.adsResponse = null;
            this.adTagUrl = "";
            this.contentTitle = this.contentKeywords = this.contentDuration = null;
            this.forceNonLinearFullSlot = !1;
            this.nonLinearAdSlotWidth = this.nonLinearAdSlotHeight = this.liveStreamPrefetchSeconds = this.linearAdSlotWidth = this.linearAdSlotHeight = 0;
            this.omidAccessModeRules = {};
            this.pageUrl = null;
            this.vastLoadTimeout = 5e3;
        },
        PR = function (a) {
            var b = {};
            b.adsResponse = a.adsResponse;
            b.videoPlayActivation = a.j;
            b.videoPlayMuted = a.l;
            b.videoContinuousPlay = a.g;
            b.adTagUrl = a.adTagUrl;
            b.contentDuration = a.contentDuration;
            b.contentKeywords = a.contentKeywords;
            b.contentTitle = a.contentTitle;
            b.linearAdSlotWidth = a.linearAdSlotWidth;
            b.linearAdSlotHeight = a.linearAdSlotHeight;
            b.nonLinearAdSlotWidth = a.nonLinearAdSlotWidth;
            b.nonLinearAdSlotHeight = a.nonLinearAdSlotHeight;
            b.forceNonLinearFullSlot = a.forceNonLinearFullSlot;
            b.liveStreamPrefetchSeconds = a.liveStreamPrefetchSeconds;
            b.vastLoadTimeout = a.vastLoadTimeout;
            b.omidAccessModeRules = a.omidAccessModeRules;
            b.pageUrl = a.pageUrl;
            return b;
        };
    QR.prototype.setAdWillAutoPlay = function (a) {
        this.j = a ? "auto" : "click";
    };
    QR.prototype.setAdWillPlayMuted = function (a) {
        this.l = a ? "muted" : "unmuted";
    };
    QR.prototype.setContinuousPlayback = function (a) {
        this.g = a ? "2" : "1";
    };
    QR.prototype.setContinuousPlayback = QR.prototype.setContinuousPlayback;
    QR.prototype.setAdWillPlayMuted = QR.prototype.setAdWillPlayMuted;
    QR.prototype.setAdWillAutoPlay = QR.prototype.setAdWillAutoPlay;
    z("google.ima.AdCuePoints.POSTROLL", -1, window);
    z("google.ima.AdCuePoints.PREROLL", 0, window);
    z("google.ima.AdDisplayContainer", rQ, window);
    z("google.ima.AdError.ErrorCode", U, window);
    z("google.ima.AdError.ErrorCode.VIDEO_ELEMENT_USED", -1, window);
    z("google.ima.AdError.ErrorCode.VIDEO_ELEMENT_REQUIRED", -1, window);
    z("google.ima.AdError.ErrorCode.VAST_MEDIA_ERROR", -1, window);
    z("google.ima.AdError.ErrorCode.ADSLOT_NOT_VISIBLE", -1, window);
    z("google.ima.AdError.ErrorCode.OVERLAY_AD_LOADING_FAILED", -1, window);
    z("google.ima.AdError.ErrorCode.VAST_MALFORMED_RESPONSE", -1, window);
    z("google.ima.AdError.ErrorCode.COMPANION_AD_LOADING_FAILED", -1, window);
    z("google.ima.AdError.Type", sQ, window);
    z("google.ima.AdErrorEvent.Type", uQ, window);
    z("google.ima.AdEvent.Type", wQ, window);
    z("google.ima.AdsLoader", zR, window);
    z("google.ima.AdsManagerLoadedEvent.Type", jR, window);
    z("google.ima.CompanionAdSelectionSettings", AJ, window);
    z("google.ima.CompanionAdSelectionSettings.CreativeType", xJ);
    z("google.ima.CompanionAdSelectionSettings.ResourceType", yJ);
    z("google.ima.CompanionAdSelectionSettings.SizeCriteria", zJ);
    z("google.ima.CustomContentLoadedEvent.Type.CUSTOM_CONTENT_LOADED", "deprecated-event", window);
    z("ima.ImaSdkSettings", V, window);
    z("google.ima.settings", oI, window);
    z("google.ima.ImaSdkSettings.CompanionBackfillMode", { ALWAYS: "always", ON_MASTER_AD: "on_master_ad" });
    z("google.ima.ImaSdkSettings.VpaidMode", { DISABLED: 0, ENABLED: 1, INSECURE: 2, 0: "DISABLED", 1: "ENABLED", 2: "INSECURE" });
    z("google.ima.AdsRenderingSettings", OO, window);
    z("google.ima.AdsRenderingSettings.AUTO_SCALE", -1, window);
    z("google.ima.AdsRequest", QR, window);
    z("google.ima.VERSION", "3.668.1");
    z("google.ima.OmidAccessMode", { LIMITED: "limited", DOMAIN: "domain", FULL: "full" });
    z("google.ima.OmidVerificationVendor", {
        COMSCORE: 7,
        DOUBLEVERIFY: 3,
        GOOGLE: 9,
        INTEGRAL_AD_SCIENCE: 4,
        MEETRICS: 8,
        MOAT: 2,
        NIELSEN: 6,
        PIXELATE: 5,
        OTHER: 1,
        7: "COMSCORE",
        3: "DOUBLEVERIFY",
        9: "GOOGLE",
        4: "INTEGRAL_AD_SCIENCE",
        8: "MEETRICS",
        2: "MOAT",
        6: "NIELSEN",
        5: "PIXELATE",
        1: "OTHER",
    });
    z("google.ima.UiElements", { AD_ATTRIBUTION: "adAttribution", COUNTDOWN: "countdown" });
    z("google.ima.ViewMode", { NORMAL: "normal", FULLSCREEN: "fullscreen" });
    z("google.ima.secureSignals", {
        clearAllCache: function () {
            VJ(window.localStorage);
        },
    });
    var RR = function (a, b, c) {
            this.j = c;
            b.length === 0 && (b = [[]]);
            this.g = b.map(function (d) {
                d = a.concat(d);
                for (var e = [], f = 0, g = 0; f < d.length; ) {
                    var h = d[f++];
                    if (h < 128) e[g++] = String.fromCharCode(h);
                    else if (h > 191 && h < 224) {
                        var k = d[f++];
                        e[g++] = String.fromCharCode(((h & 31) << 6) | (k & 63));
                    } else if (h > 239 && h < 365) {
                        k = d[f++];
                        var m = d[f++],
                            n = d[f++];
                        h = (((h & 7) << 18) | ((k & 63) << 12) | ((m & 63) << 6) | (n & 63)) - 65536;
                        e[g++] = String.fromCharCode(55296 + (h >> 10));
                        e[g++] = String.fromCharCode(56320 + (h & 1023));
                    } else (k = d[f++]), (m = d[f++]), (e[g++] = String.fromCharCode(((h & 15) << 12) | ((k & 63) << 6) | (m & 63)));
                }
                return new RegExp(e.join(""));
            });
        },
        SR = function (a, b) {
            return b
                ? a.g.some(function (c) {
                      c = b.match(c);
                      return c == null ? !1 : !a.j || (c.length >= 1 && c[1] === "3.668.1") || (c.length >= 2 && c[2] === "3.668.1") ? !0 : !1;
                  })
                : !1;
        },
        TR = [
            94,
            40,
            63,
            58,
            104,
            116,
            116,
            112,
            115,
            63,
            58,
            41,
            63,
            47,
            47,
            105,
            109,
            97,
            115,
            100,
            107,
            92,
            46,
            103,
            111,
            111,
            103,
            108,
            101,
            97,
            112,
            105,
            115,
            92,
            46,
            99,
            111,
            109,
            47,
            106,
            115,
            47,
            40,
            115,
            100,
            107,
            108,
            111,
            97,
            100,
            101,
            114,
            124,
            99,
            111,
            114,
            101,
            41,
            47,
        ],
        UR = [94, 40, 63, 58, 104, 116, 116, 112, 115, 63, 58, 41, 63, 47, 47, 115, 48, 92, 46, 50, 109, 100, 110, 92, 46, 110, 101, 116, 47, 105, 110, 115, 116, 114, 101, 97, 109, 47, 104, 116, 109, 108, 53, 47],
        VR = [
            94,
            40,
            63,
            58,
            104,
            116,
            116,
            112,
            115,
            63,
            58,
            41,
            63,
            47,
            47,
            105,
            109,
            97,
            115,
            100,
            107,
            92,
            46,
            103,
            111,
            111,
            103,
            108,
            101,
            97,
            112,
            105,
            115,
            92,
            46,
            99,
            111,
            109,
            47,
            112,
            97,
            108,
            47,
            115,
            100,
            107,
            108,
            111,
            97,
            100,
            101,
            114,
            47,
        ],
        WR = [
            [105, 109, 97, 51, 92, 46, 106, 115],
            [105, 109, 97, 51, 95, 100, 101, 98, 117, 103, 92, 46, 106, 115],
            [105, 109, 97, 51, 95, 101, 97, 112, 46, 106, 115],
        ],
        YR = [
            [98, 114, 105, 100, 103, 101, 40, 91, 48, 45, 57, 93, 43, 92, 46, 91, 48, 45, 57, 92, 46, 93, 43, 41, 40, 95, 40, 91, 97, 45, 122, 48, 45, 57, 93, 41, 123, 50, 44, 51, 125, 41, 123, 48, 44, 50, 125, 92, 46, 104, 116, 109, 108],
            [
                98,
                114,
                105,
                100,
                103,
                101,
                40,
                91,
                48,
                45,
                57,
                93,
                43,
                92,
                46,
                91,
                48,
                45,
                57,
                92,
                46,
                93,
                43,
                41,
                95,
                100,
                101,
                98,
                117,
                103,
                40,
                95,
                40,
                91,
                97,
                45,
                122,
                48,
                45,
                57,
                93,
                41,
                123,
                50,
                44,
                51,
                125,
                41,
                123,
                48,
                44,
                50,
                125,
                92,
                46,
                104,
                116,
                109,
                108,
            ],
            [98, 114, 105, 100, 103, 101, 40, 95, 40, 91, 97, 45, 122, 48, 45, 57, 93, 41, 123, 50, 44, 51, 125, 41, 123, 48, 44, 50, 125, 92, 46, 104, 116, 109, 108],
        ],
        ZR = [
            [111, 117, 116, 115, 116, 114, 101, 97, 109, 92, 46, 106, 115],
            [111, 117, 116, 115, 116, 114, 101, 97, 109, 95, 100, 101, 98, 117, 103, 92, 46, 106, 115],
        ],
        $R = new RR(TR, WR, !1);
    new RR(TR, YR, !0);
    var aS = new RR(UR, WR, !1);
    new RR(UR, YR, !0);
    var bS = new RR(
            [
                94,
                40,
                63,
                58,
                104,
                116,
                116,
                112,
                115,
                63,
                58,
                41,
                63,
                47,
                47,
                105,
                109,
                97,
                115,
                100,
                107,
                92,
                46,
                103,
                111,
                111,
                103,
                108,
                101,
                97,
                112,
                105,
                115,
                92,
                46,
                99,
                111,
                109,
                47,
                112,
                114,
                101,
                114,
                101,
                108,
                101,
                97,
                115,
                101,
                47,
                106,
                115,
                47,
                91,
                48,
                45,
                57,
                93,
                43,
                46,
                91,
                48,
                45,
                57,
                46,
                93,
                43,
                47,
            ],
            WR,
            !1
        ),
        cS = new RR(
            [
                94,
                40,
                63,
                58,
                104,
                116,
                116,
                112,
                115,
                63,
                58,
                41,
                63,
                47,
                47,
                40,
                112,
                97,
                103,
                101,
                97,
                100,
                50,
                124,
                116,
                112,
                99,
                41,
                92,
                46,
                103,
                111,
                111,
                103,
                108,
                101,
                115,
                121,
                110,
                100,
                105,
                99,
                97,
                116,
                105,
                111,
                110,
                92,
                46,
                99,
                111,
                109,
                47,
                112,
                97,
                103,
                101,
                97,
                100,
                47,
                40,
                103,
                97,
                100,
                103,
                101,
                116,
                115,
                124,
                106,
                115,
                41,
                47,
            ],
            [],
            !1
        );
    new RR(
        TR,
        [
            [
                100,
                97,
                105,
                95,
                105,
                102,
                114,
                97,
                109,
                101,
                40,
                91,
                48,
                45,
                57,
                93,
                43,
                92,
                46,
                91,
                48,
                45,
                57,
                92,
                46,
                93,
                43,
                41,
                40,
                95,
                40,
                91,
                97,
                45,
                122,
                48,
                45,
                57,
                93,
                41,
                123,
                50,
                44,
                51,
                125,
                41,
                123,
                48,
                44,
                50,
                125,
                92,
                46,
                104,
                116,
                109,
                108,
            ],
            [
                100,
                97,
                105,
                95,
                105,
                102,
                114,
                97,
                109,
                101,
                40,
                91,
                48,
                45,
                57,
                93,
                43,
                92,
                46,
                91,
                48,
                45,
                57,
                92,
                46,
                93,
                43,
                41,
                95,
                100,
                101,
                98,
                117,
                103,
                40,
                95,
                40,
                91,
                97,
                45,
                122,
                48,
                45,
                57,
                93,
                41,
                123,
                50,
                44,
                51,
                125,
                41,
                123,
                48,
                44,
                50,
                125,
                92,
                46,
                104,
                116,
                109,
                108,
            ],
            [100, 97, 105, 95, 105, 102, 114, 97, 109, 101, 40, 95, 40, 91, 97, 45, 122, 48, 45, 57, 93, 41, 123, 50, 44, 51, 125, 41, 123, 48, 44, 50, 125, 92, 46, 104, 116, 109, 108],
        ],
        !0
    );
    var dS = new RR(TR, ZR, !1),
        eS = new RR(TR, ZR, !1);
    new RR(VR, [[112, 97, 108, 46, 106, 115]], !1);
    new RR(VR, [[99, 97, 115, 116, 95, 112, 97, 108, 46, 106, 115]], !1);
    new RR(VR, [[99, 116, 118, 95, 112, 97, 108, 46, 106, 115]], !1);
    function fS(a, b) {
        for (var c = {}, d = 0; d < b.length; c = { ce: void 0 }, d++)
            if (
                ((c.ce = b[d]),
                a.some(
                    (function (e) {
                        return function (f) {
                            return SR(f, e.ce.src);
                        };
                    })(c)
                ))
            )
                return c.ce;
        return null;
    }
    if (
        !(function (a) {
            if (
                a.some(function (c) {
                    return SR(c, dj().location.href);
                })
            )
                return !0;
            var b = fS(a, document.querySelectorAll && document.querySelector ? document.querySelectorAll("SCRIPT") : document.getElementsByTagName("SCRIPT"));
            b == null && document.querySelectorAll && (b = fS(a, document.querySelectorAll("script")));
            return b != null;
        })([$R, bS, aS, cS, dS, eS])
    )
        throw Error("IMA SDK is either not loaded from a google domain or is not a supported version.");
    var hO = fO,
        mO = { pageUrl: fJ() };
    try {
        var iO = lO();
        if (!iO) throw Error("Could not generate config URL");
        kO();
    } catch (a) {
        jO(hO, a);
    }
})();
